function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $parcel$defineInteropFlag(a) {
    Object.defineProperty(a, '__esModule', {
        value: true,
        configurable: true
    });
}
var $parcel$global = globalThis;
var $parcel$modules = {};
var $parcel$inits = {};
var parcelRequire = $parcel$global["parcelRequire94c2"];
if (parcelRequire == null) {
    parcelRequire = function(id) {
        if (id in $parcel$modules) {
            return $parcel$modules[id].exports;
        }
        if (id in $parcel$inits) {
            var init = $parcel$inits[id];
            delete $parcel$inits[id];
            var module = {
                id: id,
                exports: {}
            };
            $parcel$modules[id] = module;
            init.call(module.exports, module, module.exports);
            return module.exports;
        }
        var err = new Error("Cannot find module '" + id + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
    };
    parcelRequire.register = function register(id, init) {
        $parcel$inits[id] = init;
    };
    $parcel$global["parcelRequire94c2"] = parcelRequire;
}
var parcelRegister = parcelRequire.register;
if (!$parcel$global.lb) {
    $parcel$global.lb = new Set();
    $parcel$global.bq = [];
    $parcel$global.rlb = (bundle)=>{
        $parcel$global.lb.add(bundle);
        $parcel$global.pq();
    };
    $parcel$global.rwr = (b, r, d)=>{
        $parcel$global.bq.push({
            b,
            r,
            d
        });
        $parcel$global.pq();
    };
    $parcel$global.pq = ()=>{
        var runnableEntry = $parcel$global.bq.find((i)=>{
            return i.d.every((dep)=>{
                return $parcel$global.lb.has(dep);
            });
        });
        if (runnableEntry) {
            $parcel$global.bq = $parcel$global.bq.filter((i)=>{
                return i.b !== runnableEntry.b;
            });
            runnableEntry.r();
            $parcel$global.pq();
        }
    };
}
parcelRegister("flzCf", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $b2c471bd22a08ea2$var$_react = $b2c471bd22a08ea2$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $ewCKl = parcelRequire("ewCKl");
    var $b2c471bd22a08ea2$var$_peopleGroup = $b2c471bd22a08ea2$var$_interopRequireDefault((parcelRequire("2pRai")));
    function $b2c471bd22a08ea2$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $b2c471bd22a08ea2$var$PeopleGroupIcon = (props)=>$b2c471bd22a08ea2$var$_react.default.createElement($ewCKl.IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M8.13 10H4a2 2 0 0 0-2 2v3.73c0 1.31 1.87 2.05 4 2.23V15a3 3 0 0 1 3-3h.35a4 4 0 0 1-1.23-2m7.75 0H20c1.11 0 2 .89 2 2v3.73c0 1.31-1.87 2.05-4 2.23V15a3 3 0 0 0-3-3h-.35a4 4 0 0 0 1.23-2M9.97 5.55a3 3 0 1 0-1.96 3.27 4 4 0 0 1 1.96-3.27M16 8.83a3 3 0 1 0-1.96-3.28A4 4 0 0 1 16 8.83"/><path d="M7 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><circle cx="12" cy="9" r="3"/></g></svg>`
        }, props, {
            newIcon: $b2c471bd22a08ea2$var$_peopleGroup.default
        }));
    $b2c471bd22a08ea2$var$PeopleGroupIcon.displayName = 'PeopleGroupIcon';
    var $b2c471bd22a08ea2$var$_default = module.exports.default = $b2c471bd22a08ea2$var$PeopleGroupIcon;
});
parcelRegister("2pRai", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $1c27280ec284bc14$var$_react = $1c27280ec284bc14$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $1c27280ec284bc14$var$_UNSAFE_baseNew = $1c27280ec284bc14$var$_interopRequireDefault((parcelRequire("ay9aj")));
    function $1c27280ec284bc14$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1c27280ec284bc14$var$PeopleGroupIcon = (props)=>$1c27280ec284bc14$var$_react.default.createElement($1c27280ec284bc14$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M5 9.75H2.625C1.59 9.75.75 10.59.75 11.625V13m14.5 1v-1.5a2.75 2.75 0 0 0-2.75-2.75h-3a2.75 2.75 0 0 0-2.75 2.75V14m7-9.5a2.75 2.75 0 1 1-5.5 0 2.75 2.75 0 0 1 5.5 0Zm-8 1a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z"/>`
        }, props));
    $1c27280ec284bc14$var$PeopleGroupIcon.displayName = 'PeopleGroupIcon';
    var $1c27280ec284bc14$var$_default = module.exports.default = $1c27280ec284bc14$var$PeopleGroupIcon;
});
parcelRegister("9XKJm", function(module, exports) {
    $parcel$export(module.exports, "JiraIcon", ()=>$53e879026ffee615$export$c4b5b1f965d8b3eb);
    var $eUqFw = parcelRequire("eUqFw");
    var $fjjRQ = parcelRequire("fjjRQ");
    var $gT5pi = parcelRequire("gT5pi");
    var $fxki0 = parcelRequire("fxki0");
    var $3Dx41 = parcelRequire("3Dx41");
    const $53e879026ffee615$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
        let colors = {
            iconColor: iconColor
        };
        if (appearance) colors = (0, $fxki0.getColorsFromAppearance)(appearance, colorMode);
        return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M11.034 21.99h-2.22c-3.346 0-5.747-2.05-5.747-5.052h11.932c.619 0 1.019.44 1.019 1.062v12.007c-2.983 0-4.984-2.416-4.984-5.784zm5.893-5.967h-2.219c-3.347 0-5.748-2.013-5.748-5.015h11.933c.618 0 1.055.402 1.055 1.025V24.04c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.219c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.018.439 1.018 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z"/>
    </svg>`;
    };
    const $53e879026ffee615$export$c4b5b1f965d8b3eb = ({ appearance: appearance, label: label = 'Jira', size: size = (0, $gT5pi.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $gT5pi.defaultLogoParams).textColor, iconColor: iconColor = (0, $gT5pi.defaultLogoParams).iconColor })=>{
        const { colorMode: colorMode } = (0, $fjjRQ.default)();
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $3Dx41.default), {
            appearance: appearance,
            label: label,
            svg: $53e879026ffee615$var$svg({
                appearance: appearance,
                iconColor: iconColor
            }, colorMode),
            iconColor: iconColor,
            size: size,
            testId: testId,
            textColor: textColor
        });
    };
});
parcelRegister("fjjRQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2b87aa5dc485b3b9$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $exMfg = parcelRequire("exMfg");
    var $cUR6b = parcelRequire("cUR6b");
    const $2b87aa5dc485b3b9$var$useThemeObserver = ()=>{
        const [theme, setTheme] = (0, $eUqFw.useState)((0, $exMfg.default)());
        (0, $eUqFw.useEffect)(()=>{
            const observer = new (0, $cUR6b.default)((theme)=>setTheme(theme));
            observer.observe();
            return ()=>observer.disconnect();
        }, []);
        return theme;
    };
    var $2b87aa5dc485b3b9$export$2e2bcd8739ae039 = $2b87aa5dc485b3b9$var$useThemeObserver;
});
parcelRegister("exMfg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9e245fc922b9fa9a$export$2e2bcd8739ae039);
    var $1e6Pr = parcelRequire("1e6Pr");
    var $5BDgX = parcelRequire("5BDgX");
    var $1VCZT = parcelRequire("1VCZT");
    const $9e245fc922b9fa9a$var$isThemeColorMode = (colorMode)=>{
        return (0, $5BDgX.themeColorModes).find((mode)=>mode === colorMode) !== undefined;
    };
    const $9e245fc922b9fa9a$var$getGlobalTheme = ()=>{
        if (typeof document === 'undefined') return {};
        const element = document.documentElement;
        const colorMode = element.getAttribute((0, $1e6Pr.COLOR_MODE_ATTRIBUTE)) || '';
        const theme = element.getAttribute((0, $1e6Pr.THEME_DATA_ATTRIBUTE)) || '';
        return {
            ...(0, $1VCZT.themeStringToObject)(theme),
            ...$9e245fc922b9fa9a$var$isThemeColorMode(colorMode) && {
                colorMode: colorMode
            }
        };
    };
    var $9e245fc922b9fa9a$export$2e2bcd8739ae039 = $9e245fc922b9fa9a$var$getGlobalTheme;
});
parcelRegister("5BDgX", function(module, exports) {
    $parcel$export(module.exports, "themeColorModes", ()=>$aed854c3b59076ba$export$83993de8eb66733);
    $parcel$export(module.exports, "themeIds", ()=>$aed854c3b59076ba$export$7d43e72a58e3283f);
    $parcel$export(module.exports, "themeIdsWithOverrides", ()=>$aed854c3b59076ba$export$92ba366331403db2);
    $parcel$export(module.exports, "themeStateDefaults", ()=>$aed854c3b59076ba$export$9aedcfa7336a207);
    $parcel$export(module.exports, "default", ()=>$aed854c3b59076ba$export$2e2bcd8739ae039);
    const $aed854c3b59076ba$export$83993de8eb66733 = [
        'light',
        'dark',
        'auto'
    ];
    const $aed854c3b59076ba$export$8ce7e340c74e86c5 = [
        'more',
        'no-preference',
        'auto'
    ];
    const $aed854c3b59076ba$export$7d43e72a58e3283f = [
        'light-increased-contrast',
        'light',
        'light-future',
        'light-brand-refresh',
        'dark',
        'dark-future',
        'dark-increased-contrast',
        'dark-brand-refresh',
        'legacy-light',
        'legacy-dark',
        'spacing',
        'shape',
        'typography-adg3',
        'typography-modernized',
        'typography-refreshed'
    ];
    const $aed854c3b59076ba$export$ba8a43b83ecc69f8 = [];
    const $aed854c3b59076ba$export$92ba366331403db2 = [
        ...$aed854c3b59076ba$export$7d43e72a58e3283f,
        ...$aed854c3b59076ba$export$ba8a43b83ecc69f8
    ];
    const $aed854c3b59076ba$var$themeConfig = {
        'atlassian-light': {
            id: 'light',
            displayName: 'Light Theme',
            palette: 'defaultPalette',
            attributes: {
                type: 'color',
                mode: 'light'
            }
        },
        'atlassian-light-future': {
            id: 'light-future',
            displayName: 'Future Light Theme',
            palette: 'defaultPalette',
            attributes: {
                type: 'color',
                mode: 'light'
            },
            override: 'light'
        },
        'atlassian-light-increased-contrast': {
            id: 'light-increased-contrast',
            displayName: 'Light Theme (increased contrast)',
            palette: 'defaultPalette',
            attributes: {
                type: 'color',
                mode: 'light'
            },
            extends: 'light',
            increasesContrastFor: 'light'
        },
        'atlassian-dark': {
            id: 'dark',
            displayName: 'Dark Theme',
            palette: 'defaultPalette',
            attributes: {
                type: 'color',
                mode: 'dark'
            }
        },
        'atlassian-dark-future': {
            id: 'dark-future',
            displayName: 'Future Dark Theme',
            palette: 'defaultPalette',
            attributes: {
                type: 'color',
                mode: 'dark'
            },
            override: 'light'
        },
        'atlassian-dark-increased-contrast': {
            id: 'dark-increased-contrast',
            displayName: 'Dark Theme (increased contrast)',
            palette: 'defaultPalette',
            attributes: {
                type: 'color',
                mode: 'dark'
            },
            extends: 'dark',
            increasesContrastFor: 'dark'
        },
        'atlassian-legacy-light': {
            id: 'legacy-light',
            displayName: 'Light Theme (legacy)',
            palette: 'legacyPalette',
            attributes: {
                type: 'color',
                mode: 'light'
            }
        },
        'atlassian-legacy-dark': {
            id: 'legacy-dark',
            displayName: 'Dark Theme (legacy)',
            palette: 'legacyPalette',
            attributes: {
                type: 'color',
                mode: 'dark'
            }
        },
        'atlassian-spacing': {
            id: 'spacing',
            displayName: 'Atlassian Spacing',
            palette: 'spacingScale',
            attributes: {
                type: 'spacing'
            }
        },
        'atlassian-typography-adg3': {
            id: 'typography-adg3',
            displayName: 'ADG3 Typography',
            palette: 'typographyPalette',
            attributes: {
                type: 'typography'
            }
        },
        'atlassian-shape': {
            id: 'shape',
            displayName: 'Atlassian Shape',
            palette: 'shapePalette',
            attributes: {
                type: 'shape'
            }
        },
        'atlassian-typography-modernized': {
            id: 'typography-modernized',
            displayName: 'Atlassian Typography (Modernized)',
            palette: 'typographyPalette',
            attributes: {
                type: 'typography'
            }
        },
        'atlassian-typography-refreshed': {
            id: 'typography-refreshed',
            displayName: 'Atlassian Typography (Refreshed)',
            palette: 'typographyPalette',
            attributes: {
                type: 'typography'
            }
        },
        'atlassian-light-brand-refresh': {
            id: 'light-brand-refresh',
            displayName: 'Light theme (Brand refresh)',
            palette: 'brandRefreshPalette',
            attributes: {
                type: 'color',
                mode: 'light'
            }
        },
        'atlassian-dark-brand-refresh': {
            id: 'dark-brand-refresh',
            displayName: 'Dark theme (Brand refresh)',
            palette: 'brandRefreshPalette',
            attributes: {
                type: 'color',
                mode: 'dark'
            }
        }
    };
    const $aed854c3b59076ba$export$9aedcfa7336a207 = {
        colorMode: 'auto',
        contrastMode: 'auto',
        dark: 'dark',
        light: 'light',
        shape: undefined,
        spacing: 'spacing',
        typography: undefined,
        UNSAFE_themeOptions: undefined
    };
    var $aed854c3b59076ba$export$2e2bcd8739ae039 = $aed854c3b59076ba$var$themeConfig;
});
parcelRegister("1VCZT", function(module, exports) {
    $parcel$export(module.exports, "themeStringToObject", ()=>$e34e475bcd390353$export$f19b488f7c0547ee);
    $parcel$export(module.exports, "themeObjectToString", ()=>$e34e475bcd390353$export$62c37ab81302621a);
    var $5BDgX = parcelRequire("5BDgX");
    const $e34e475bcd390353$var$themeKinds = [
        'light',
        'dark',
        'spacing',
        'typography',
        'shape'
    ];
    const $e34e475bcd390353$var$customThemeOptions = 'UNSAFE_themeOptions';
    const $e34e475bcd390353$var$isThemeKind = (themeKind)=>{
        return $e34e475bcd390353$var$themeKinds.find((kind)=>kind === themeKind) !== undefined;
    };
    const $e34e475bcd390353$var$isThemeIds = (themeId)=>{
        return (0, $5BDgX.themeIds).find((id)=>id === themeId) !== undefined;
    };
    const $e34e475bcd390353$var$isColorMode = (modeId)=>{
        return [
            'light',
            'dark',
            'auto'
        ].includes(modeId);
    };
    const $e34e475bcd390353$export$f19b488f7c0547ee = (themeState)=>{
        return themeState.split(' ').map((theme)=>theme.split(/:(.*)/s)).reduce((themeObject, [kind, id])=>{
            if (kind === 'colorMode' && $e34e475bcd390353$var$isColorMode(id)) themeObject[kind] = id;
            if ($e34e475bcd390353$var$isThemeKind(kind) && $e34e475bcd390353$var$isThemeIds(id)) themeObject[kind] = id;
            if (kind === $e34e475bcd390353$var$customThemeOptions) try {
                themeObject[$e34e475bcd390353$var$customThemeOptions] = JSON.parse(id);
            } catch (e) {
                new Error('Invalid custom theme string');
            }
            return themeObject;
        }, {});
    };
    const $e34e475bcd390353$export$62c37ab81302621a = (themeState)=>Object.entries(themeState).reduce((themeString, [kind, id])=>{
            if (kind === 'colorMode' && typeof id === 'string' && $e34e475bcd390353$var$isColorMode(id) || kind === $e34e475bcd390353$var$customThemeOptions && typeof id === 'object' || $e34e475bcd390353$var$isThemeKind(kind) && typeof id === 'string' && $e34e475bcd390353$var$isThemeIds(id)) return themeString + `${themeString ? ' ' : ''}` + `${kind}:${typeof id === 'object' ? JSON.stringify(id) : id}`;
            return themeString;
        }, '');
});
parcelRegister("cUR6b", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5f9a3cef5a905504$export$2e2bcd8739ae039);
    var $1e6Pr = parcelRequire("1e6Pr");
    var $exMfg = parcelRequire("exMfg");
    class $5f9a3cef5a905504$export$2e2bcd8739ae039 {
        static{
            this.observer = null;
        }
        static{
            this.callbacks = new Set();
        }
        constructor(callback){
            this.legacyObserver = null;
            this.callback = callback;
            $5f9a3cef5a905504$export$2e2bcd8739ae039.callbacks.add(callback);
        }
        observe() {
            if (!$5f9a3cef5a905504$export$2e2bcd8739ae039.observer) {
                $5f9a3cef5a905504$export$2e2bcd8739ae039.observer = new MutationObserver(()=>{
                    const theme = (0, $exMfg.default)();
                    $5f9a3cef5a905504$export$2e2bcd8739ae039.callbacks.forEach((callback)=>callback(theme));
                });
                $5f9a3cef5a905504$export$2e2bcd8739ae039.observer.observe(document.documentElement, {
                    attributeFilter: [
                        (0, $1e6Pr.THEME_DATA_ATTRIBUTE),
                        (0, $1e6Pr.COLOR_MODE_ATTRIBUTE)
                    ]
                });
            }
        }
        disconnect() {
            if (this.callback) $5f9a3cef5a905504$export$2e2bcd8739ae039.callbacks.delete(this.callback);
            if ($5f9a3cef5a905504$export$2e2bcd8739ae039.callbacks.size === 0 && $5f9a3cef5a905504$export$2e2bcd8739ae039.observer) {
                $5f9a3cef5a905504$export$2e2bcd8739ae039.observer.disconnect();
                $5f9a3cef5a905504$export$2e2bcd8739ae039.observer = null;
            }
        }
    }
});
parcelRegister("gT5pi", function(module, exports) {
    $parcel$export(module.exports, "defaultLogoParams", ()=>$c84f7906aa4712d3$export$438460117ae6b7ee);
    $parcel$export(module.exports, "legacyDefaultLogoParams", ()=>$c84f7906aa4712d3$export$793fba32aed8942a);
    $parcel$export(module.exports, "sizes", ()=>$c84f7906aa4712d3$export$c647cb0ee6e282fe);
    const $c84f7906aa4712d3$export$438460117ae6b7ee = {
        iconColor: 'inherit',
        label: '',
        size: 'medium',
        textColor: 'currentColor'
    };
    const $c84f7906aa4712d3$export$793fba32aed8942a = {
        iconGradientStart: 'inherit',
        iconGradientStop: 'inherit'
    };
    const $c84f7906aa4712d3$export$c647cb0ee6e282fe = {
        xsmall: 16,
        small: 24,
        medium: 32,
        large: 40,
        xlarge: 48
    };
    const $c84f7906aa4712d3$export$31d7044b7540a6d8 = $c84f7906aa4712d3$export$438460117ae6b7ee;
});
parcelRegister("fxki0", function(module, exports) {
    $parcel$export(module.exports, "getColorsFromAppearanceOldLogos", ()=>$9efe92df985c52ce$export$362a25f017e2bc8a);
    $parcel$export(module.exports, "getColorsFromAppearance", ()=>$9efe92df985c52ce$export$bbacc3980e0f3029);
    const $9efe92df985c52ce$export$362a25f017e2bc8a = (appearance, colorMode)=>{
        let iconGradientStart, iconGradientStop, iconColor, textColor, atlassianLogoTextColor;
        switch(appearance){
            case 'brand':
                iconGradientStart = (0, $207acf722dcd432b$export$b3de0ae08da2ce64);
                iconGradientStop = (0, $207acf722dcd432b$export$215b7063051591f1);
                iconColor = (0, $207acf722dcd432b$export$215b7063051591f1);
                textColor = `var(--ds-text, ${0, $207acf722dcd432b$export$7d61b15e0da132af})`;
                atlassianLogoTextColor = (0, $207acf722dcd432b$export$b3de0ae08da2ce64);
                break;
            case 'neutral':
                iconGradientStart = (0, $207acf722dcd432b$export$7090862dc3038a9f);
                iconGradientStop = (0, $207acf722dcd432b$export$d6447c357493214f);
                iconColor = (0, $207acf722dcd432b$export$d6447c357493214f);
                textColor = (0, $207acf722dcd432b$export$eece5f492e429f08);
                atlassianLogoTextColor = (0, $207acf722dcd432b$export$eece5f492e429f08);
                break;
            case 'inverse':
                iconGradientStart = '#FFFFFF66';
                iconGradientStop = '#FFFFFF';
                iconColor = '#FFFFFF';
                textColor = '#FFFFFF';
                atlassianLogoTextColor = '#FFFFFF';
                break;
        }
        if (colorMode === 'dark' && appearance === 'inverse') {
            iconGradientStart = '#161A1D66';
            iconGradientStop = '#161A1D';
            iconColor = '#161A1D';
            textColor = '#161A1D';
            atlassianLogoTextColor = '#161A1D';
        }
        return {
            iconGradientStart: iconGradientStart,
            iconGradientStop: iconGradientStop,
            iconColor: iconColor,
            textColor: textColor,
            atlassianLogoTextColor: atlassianLogoTextColor
        };
    };
    const $9efe92df985c52ce$export$bbacc3980e0f3029 = (appearance, colorMode)=>{
        let iconColor, textColor, atlassianLogoTextColor;
        if (colorMode === 'dark') switch(appearance){
            case 'brand':
                iconColor = '#357DE8';
                textColor = '#E2E3E4';
                atlassianLogoTextColor = '#357DE8';
                break;
            case 'neutral':
                iconColor = '#96999E';
                textColor = '#BFC1C4';
                atlassianLogoTextColor = '#96999E';
                break;
            case 'inverse':
                iconColor = '#101214';
                textColor = '#101214';
                atlassianLogoTextColor = '#101214';
                break;
        }
        else switch(appearance){
            case 'brand':
                iconColor = '#1868DB';
                textColor = '#101214';
                atlassianLogoTextColor = '#1868DB';
                break;
            case 'neutral':
                iconColor = '#6C6F77';
                textColor = '#3B3D42';
                atlassianLogoTextColor = '#6C6F77';
                break;
            case 'inverse':
                iconColor = (0, $207acf722dcd432b$export$29a4f05edc054374);
                textColor = (0, $207acf722dcd432b$export$29a4f05edc054374);
                atlassianLogoTextColor = (0, $207acf722dcd432b$export$29a4f05edc054374);
                break;
        }
        return {
            iconColor: iconColor,
            textColor: textColor,
            atlassianLogoTextColor: atlassianLogoTextColor
        };
    };
    const $9efe92df985c52ce$export$7818df200941dbbf = (appearance, colorMode)=>{
        let iconColor = $9efe92df985c52ce$export$bbacc3980e0f3029(appearance, colorMode).iconColor;
        let textColor = $9efe92df985c52ce$export$bbacc3980e0f3029(appearance, colorMode).textColor;
        if (colorMode === 'dark') switch(appearance){
            case 'brand':
                iconColor = '#625DF5';
                textColor = '#EFF0FF';
                break;
        }
        else switch(appearance){
            case 'brand':
                iconColor = '#625DF5';
                textColor = '#252434';
                break;
        }
        return {
            iconColor: iconColor,
            textColor: textColor
        };
    };
});
var $207acf722dcd432b$exports = {};
$parcel$export($207acf722dcd432b$exports, "R50", ()=>$207acf722dcd432b$export$4b84fd0e2c617bd);
$parcel$export($207acf722dcd432b$exports, "R75", ()=>$207acf722dcd432b$export$b34b069eff244586);
$parcel$export($207acf722dcd432b$exports, "R100", ()=>$207acf722dcd432b$export$be802dd0d8b57f35);
$parcel$export($207acf722dcd432b$exports, "R200", ()=>$207acf722dcd432b$export$60847d42f9da92a6);
$parcel$export($207acf722dcd432b$exports, "R300", ()=>$207acf722dcd432b$export$4a7404f376229999);
$parcel$export($207acf722dcd432b$exports, "R400", ()=>$207acf722dcd432b$export$2010d0fb4295b346);
$parcel$export($207acf722dcd432b$exports, "R500", ()=>$207acf722dcd432b$export$2837b5a1a71d5c02);
$parcel$export($207acf722dcd432b$exports, "Y50", ()=>$207acf722dcd432b$export$8d9596b529bbb9cf);
$parcel$export($207acf722dcd432b$exports, "Y75", ()=>$207acf722dcd432b$export$41060a744ab0b7ae);
$parcel$export($207acf722dcd432b$exports, "Y100", ()=>$207acf722dcd432b$export$1cc05bbbf340e559);
$parcel$export($207acf722dcd432b$exports, "Y200", ()=>$207acf722dcd432b$export$5aae31392d72caaa);
$parcel$export($207acf722dcd432b$exports, "Y300", ()=>$207acf722dcd432b$export$c6930421db9fa514);
$parcel$export($207acf722dcd432b$exports, "Y400", ()=>$207acf722dcd432b$export$59619663aa6500fb);
$parcel$export($207acf722dcd432b$exports, "Y500", ()=>$207acf722dcd432b$export$874739ea9e379ab6);
$parcel$export($207acf722dcd432b$exports, "G50", ()=>$207acf722dcd432b$export$8a6341c32b6a3ee6);
$parcel$export($207acf722dcd432b$exports, "G75", ()=>$207acf722dcd432b$export$69a3bf21b9686c2b);
$parcel$export($207acf722dcd432b$exports, "G100", ()=>$207acf722dcd432b$export$afbce1382ec95f73);
$parcel$export($207acf722dcd432b$exports, "G200", ()=>$207acf722dcd432b$export$747d86715d4175de);
$parcel$export($207acf722dcd432b$exports, "G300", ()=>$207acf722dcd432b$export$940e1f69e873f202);
$parcel$export($207acf722dcd432b$exports, "G400", ()=>$207acf722dcd432b$export$a49394138f7b8e85);
$parcel$export($207acf722dcd432b$exports, "G500", ()=>$207acf722dcd432b$export$6fa04827ac68a4fb);
$parcel$export($207acf722dcd432b$exports, "B50", ()=>$207acf722dcd432b$export$226de0355ed012f8);
$parcel$export($207acf722dcd432b$exports, "B75", ()=>$207acf722dcd432b$export$8c13c2ee36917869);
$parcel$export($207acf722dcd432b$exports, "B100", ()=>$207acf722dcd432b$export$ecfc1dff386a3e7a);
$parcel$export($207acf722dcd432b$exports, "B200", ()=>$207acf722dcd432b$export$215b7063051591f1);
$parcel$export($207acf722dcd432b$exports, "B300", ()=>$207acf722dcd432b$export$e62e8919cca44969);
$parcel$export($207acf722dcd432b$exports, "B400", ()=>$207acf722dcd432b$export$b3de0ae08da2ce64);
$parcel$export($207acf722dcd432b$exports, "B500", ()=>$207acf722dcd432b$export$a6ee3d71bc067634);
$parcel$export($207acf722dcd432b$exports, "B600", ()=>$207acf722dcd432b$export$67f15409e87642a1);
$parcel$export($207acf722dcd432b$exports, "B700", ()=>$207acf722dcd432b$export$f0539dbc42dbb067);
$parcel$export($207acf722dcd432b$exports, "P50", ()=>$207acf722dcd432b$export$363e4475840015bb);
$parcel$export($207acf722dcd432b$exports, "P75", ()=>$207acf722dcd432b$export$4b0a4417ed59760f);
$parcel$export($207acf722dcd432b$exports, "P100", ()=>$207acf722dcd432b$export$6011520a64d9a187);
$parcel$export($207acf722dcd432b$exports, "P200", ()=>$207acf722dcd432b$export$a7175d4e9206bc80);
$parcel$export($207acf722dcd432b$exports, "P300", ()=>$207acf722dcd432b$export$b48405b95304b5a1);
$parcel$export($207acf722dcd432b$exports, "P400", ()=>$207acf722dcd432b$export$c71e4279dd54a18d);
$parcel$export($207acf722dcd432b$exports, "P500", ()=>$207acf722dcd432b$export$147899de772240ec);
$parcel$export($207acf722dcd432b$exports, "T50", ()=>$207acf722dcd432b$export$2cf711fe14c66f06);
$parcel$export($207acf722dcd432b$exports, "T75", ()=>$207acf722dcd432b$export$7a8f4d33f6f9772c);
$parcel$export($207acf722dcd432b$exports, "T100", ()=>$207acf722dcd432b$export$776c9c497ef08533);
$parcel$export($207acf722dcd432b$exports, "T200", ()=>$207acf722dcd432b$export$69cb3ca10c1e330e);
$parcel$export($207acf722dcd432b$exports, "T300", ()=>$207acf722dcd432b$export$9dc1ef0f3f48059b);
$parcel$export($207acf722dcd432b$exports, "T400", ()=>$207acf722dcd432b$export$7c835c78b6fcdef8);
$parcel$export($207acf722dcd432b$exports, "T500", ()=>$207acf722dcd432b$export$6036577f95c3877e);
$parcel$export($207acf722dcd432b$exports, "N0", ()=>$207acf722dcd432b$export$29a4f05edc054374);
$parcel$export($207acf722dcd432b$exports, "N10", ()=>$207acf722dcd432b$export$e655ef011c4aa1a2);
$parcel$export($207acf722dcd432b$exports, "N20", ()=>$207acf722dcd432b$export$9fdfb749e33cdf97);
$parcel$export($207acf722dcd432b$exports, "N30", ()=>$207acf722dcd432b$export$3e51e8f1440314ba);
$parcel$export($207acf722dcd432b$exports, "N40", ()=>$207acf722dcd432b$export$1ce2d1575d444ceb);
$parcel$export($207acf722dcd432b$exports, "N50", ()=>$207acf722dcd432b$export$8754fc7e6d8b3000);
$parcel$export($207acf722dcd432b$exports, "N60", ()=>$207acf722dcd432b$export$c2e91cbeada39b8b);
$parcel$export($207acf722dcd432b$exports, "N70", ()=>$207acf722dcd432b$export$5f71e19f3a7ad9de);
$parcel$export($207acf722dcd432b$exports, "N80", ()=>$207acf722dcd432b$export$eaa8c8a70ac22806);
$parcel$export($207acf722dcd432b$exports, "N90", ()=>$207acf722dcd432b$export$7c87d337fb91a97d);
$parcel$export($207acf722dcd432b$exports, "N100", ()=>$207acf722dcd432b$export$d6447c357493214f);
$parcel$export($207acf722dcd432b$exports, "N200", ()=>$207acf722dcd432b$export$f563ee71e9ee74cd);
$parcel$export($207acf722dcd432b$exports, "N300", ()=>$207acf722dcd432b$export$e2ef2124cf4024b1);
$parcel$export($207acf722dcd432b$exports, "N400", ()=>$207acf722dcd432b$export$eece5f492e429f08);
$parcel$export($207acf722dcd432b$exports, "N500", ()=>$207acf722dcd432b$export$c39c0fe0f26207ae);
$parcel$export($207acf722dcd432b$exports, "N600", ()=>$207acf722dcd432b$export$7090862dc3038a9f);
$parcel$export($207acf722dcd432b$exports, "N700", ()=>$207acf722dcd432b$export$ad0bacf983b7ddaa);
$parcel$export($207acf722dcd432b$exports, "N800", ()=>$207acf722dcd432b$export$7d61b15e0da132af);
$parcel$export($207acf722dcd432b$exports, "N900", ()=>$207acf722dcd432b$export$fbda843f0a27fe96);
$parcel$export($207acf722dcd432b$exports, "N10A", ()=>$207acf722dcd432b$export$791e57b27ca738ef);
$parcel$export($207acf722dcd432b$exports, "N20A", ()=>$207acf722dcd432b$export$8d43898f60b96a82);
$parcel$export($207acf722dcd432b$exports, "N30A", ()=>$207acf722dcd432b$export$920c0d5c49070351);
$parcel$export($207acf722dcd432b$exports, "N40A", ()=>$207acf722dcd432b$export$46987b49aab6d1a8);
$parcel$export($207acf722dcd432b$exports, "N50A", ()=>$207acf722dcd432b$export$7d3359664e8bb0e5);
$parcel$export($207acf722dcd432b$exports, "N60A", ()=>$207acf722dcd432b$export$d2d3bedfb276cac0);
$parcel$export($207acf722dcd432b$exports, "N70A", ()=>$207acf722dcd432b$export$6e5e7499ff054f6d);
$parcel$export($207acf722dcd432b$exports, "N80A", ()=>$207acf722dcd432b$export$59264b346c877fa7);
$parcel$export($207acf722dcd432b$exports, "N90A", ()=>$207acf722dcd432b$export$d092757d7c64925c);
$parcel$export($207acf722dcd432b$exports, "N100A", ()=>$207acf722dcd432b$export$486ab785e4bac3c6);
$parcel$export($207acf722dcd432b$exports, "N200A", ()=>$207acf722dcd432b$export$fba592bbc6419fea);
$parcel$export($207acf722dcd432b$exports, "N300A", ()=>$207acf722dcd432b$export$13609db0e6812ab8);
$parcel$export($207acf722dcd432b$exports, "N400A", ()=>$207acf722dcd432b$export$fbae4efaa892d883);
$parcel$export($207acf722dcd432b$exports, "N500A", ()=>$207acf722dcd432b$export$f13946d26f440ce6);
$parcel$export($207acf722dcd432b$exports, "N600A", ()=>$207acf722dcd432b$export$19f58225ac52a306);
$parcel$export($207acf722dcd432b$exports, "N700A", ()=>$207acf722dcd432b$export$6384f09da70e7b62);
$parcel$export($207acf722dcd432b$exports, "N800A", ()=>$207acf722dcd432b$export$d0dccc730683edc2);
$parcel$export($207acf722dcd432b$exports, "DN900", ()=>$207acf722dcd432b$export$2f6319cf7d736c2a);
$parcel$export($207acf722dcd432b$exports, "DN800", ()=>$207acf722dcd432b$export$95126bc8884d6634);
$parcel$export($207acf722dcd432b$exports, "DN700", ()=>$207acf722dcd432b$export$8338d8c35d44ff1);
$parcel$export($207acf722dcd432b$exports, "DN600", ()=>$207acf722dcd432b$export$5368d76ae4fbbda7);
$parcel$export($207acf722dcd432b$exports, "DN500", ()=>$207acf722dcd432b$export$9f0a771d16ec8d36);
$parcel$export($207acf722dcd432b$exports, "DN400", ()=>$207acf722dcd432b$export$abcf8c38338b4aa5);
$parcel$export($207acf722dcd432b$exports, "DN300", ()=>$207acf722dcd432b$export$97e81faa16a182c7);
$parcel$export($207acf722dcd432b$exports, "DN200", ()=>$207acf722dcd432b$export$bfe21c59123ecf33);
$parcel$export($207acf722dcd432b$exports, "DN100", ()=>$207acf722dcd432b$export$ee82aa2ea6a1558);
$parcel$export($207acf722dcd432b$exports, "DN90", ()=>$207acf722dcd432b$export$682927c6ed76be02);
$parcel$export($207acf722dcd432b$exports, "DN80", ()=>$207acf722dcd432b$export$91fd9994c5be9757);
$parcel$export($207acf722dcd432b$exports, "DN70", ()=>$207acf722dcd432b$export$d281fbfe3cff2df6);
$parcel$export($207acf722dcd432b$exports, "DN60", ()=>$207acf722dcd432b$export$3902c91d8b98a753);
$parcel$export($207acf722dcd432b$exports, "DN50", ()=>$207acf722dcd432b$export$8e8133c1ba5845b5);
$parcel$export($207acf722dcd432b$exports, "DN40", ()=>$207acf722dcd432b$export$33ff357f6620b39);
$parcel$export($207acf722dcd432b$exports, "DN30", ()=>$207acf722dcd432b$export$633847cf062b69e0);
$parcel$export($207acf722dcd432b$exports, "DN20", ()=>$207acf722dcd432b$export$9776a6e503bdbf76);
$parcel$export($207acf722dcd432b$exports, "DN10", ()=>$207acf722dcd432b$export$6c813d5160dff5db);
$parcel$export($207acf722dcd432b$exports, "DN0", ()=>$207acf722dcd432b$export$3d4f271a500072a);
$parcel$export($207acf722dcd432b$exports, "DN800A", ()=>$207acf722dcd432b$export$fe151285c22759ec);
$parcel$export($207acf722dcd432b$exports, "DN700A", ()=>$207acf722dcd432b$export$a101c6190d0da34);
$parcel$export($207acf722dcd432b$exports, "DN600A", ()=>$207acf722dcd432b$export$4b16f52932fda51);
$parcel$export($207acf722dcd432b$exports, "DN500A", ()=>$207acf722dcd432b$export$a74bcd7b9845b0d8);
$parcel$export($207acf722dcd432b$exports, "DN400A", ()=>$207acf722dcd432b$export$9209c179316d1751);
$parcel$export($207acf722dcd432b$exports, "DN300A", ()=>$207acf722dcd432b$export$88f55133f636c8dd);
$parcel$export($207acf722dcd432b$exports, "DN200A", ()=>$207acf722dcd432b$export$51126f85d1009512);
$parcel$export($207acf722dcd432b$exports, "DN100A", ()=>$207acf722dcd432b$export$a069b547bd23af78);
$parcel$export($207acf722dcd432b$exports, "DN90A", ()=>$207acf722dcd432b$export$40cce05af3b2600a);
$parcel$export($207acf722dcd432b$exports, "DN80A", ()=>$207acf722dcd432b$export$b78942185925a0d);
$parcel$export($207acf722dcd432b$exports, "DN70A", ()=>$207acf722dcd432b$export$e058fb44b8eaafca);
$parcel$export($207acf722dcd432b$exports, "DN60A", ()=>$207acf722dcd432b$export$92b0b8de26920c18);
$parcel$export($207acf722dcd432b$exports, "DN50A", ()=>$207acf722dcd432b$export$67564f7459d3fc9e);
$parcel$export($207acf722dcd432b$exports, "DN40A", ()=>$207acf722dcd432b$export$77868e1ca884ffa3);
$parcel$export($207acf722dcd432b$exports, "DN30A", ()=>$207acf722dcd432b$export$2afd71d7d3ea2cd5);
$parcel$export($207acf722dcd432b$exports, "DN20A", ()=>$207acf722dcd432b$export$f2a0acaab9972c70);
$parcel$export($207acf722dcd432b$exports, "DN10A", ()=>$207acf722dcd432b$export$9ab70e67d6475361);
$parcel$export($207acf722dcd432b$exports, "T30", ()=>$207acf722dcd432b$export$d2adc5dedf09fced);
$parcel$export($207acf722dcd432b$exports, "L50", ()=>$207acf722dcd432b$export$f51762073d2bb381);
$parcel$export($207acf722dcd432b$exports, "L75", ()=>$207acf722dcd432b$export$95e26d54def96891);
const $207acf722dcd432b$export$4b84fd0e2c617bd = '#FFEBE6';
const $207acf722dcd432b$export$b34b069eff244586 = '#FFBDAD';
const $207acf722dcd432b$export$be802dd0d8b57f35 = '#FF8F73';
const $207acf722dcd432b$export$60847d42f9da92a6 = '#FF7452';
const $207acf722dcd432b$export$4a7404f376229999 = '#FF5630';
const $207acf722dcd432b$export$2010d0fb4295b346 = '#DE350B';
const $207acf722dcd432b$export$2837b5a1a71d5c02 = '#BF2600';
const $207acf722dcd432b$export$8d9596b529bbb9cf = '#FFFAE6';
const $207acf722dcd432b$export$41060a744ab0b7ae = '#FFF0B3';
const $207acf722dcd432b$export$1cc05bbbf340e559 = '#FFE380';
const $207acf722dcd432b$export$5aae31392d72caaa = '#FFC400';
const $207acf722dcd432b$export$c6930421db9fa514 = '#FFAB00';
const $207acf722dcd432b$export$59619663aa6500fb = '#FF991F';
const $207acf722dcd432b$export$874739ea9e379ab6 = '#FF8B00';
const $207acf722dcd432b$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $207acf722dcd432b$export$69a3bf21b9686c2b = '#ABF5D1';
const $207acf722dcd432b$export$afbce1382ec95f73 = '#79F2C0';
const $207acf722dcd432b$export$747d86715d4175de = '#57D9A3';
const $207acf722dcd432b$export$940e1f69e873f202 = '#36B37E';
const $207acf722dcd432b$export$a49394138f7b8e85 = '#00875A';
const $207acf722dcd432b$export$6fa04827ac68a4fb = '#006644';
const $207acf722dcd432b$export$226de0355ed012f8 = '#DEEBFF';
const $207acf722dcd432b$export$8c13c2ee36917869 = '#B3D4FF';
const $207acf722dcd432b$export$ecfc1dff386a3e7a = '#4C9AFF';
const $207acf722dcd432b$export$215b7063051591f1 = '#2684FF';
const $207acf722dcd432b$export$e62e8919cca44969 = '#0065FF';
const $207acf722dcd432b$export$b3de0ae08da2ce64 = '#0052CC';
const $207acf722dcd432b$export$a6ee3d71bc067634 = '#0747A6';
const $207acf722dcd432b$export$67f15409e87642a1 = '#669DF1';
const $207acf722dcd432b$export$f0539dbc42dbb067 = '#8FB8F6';
const $207acf722dcd432b$export$363e4475840015bb = '#EAE6FF';
const $207acf722dcd432b$export$4b0a4417ed59760f = '#C0B6F2';
const $207acf722dcd432b$export$6011520a64d9a187 = '#998DD9';
const $207acf722dcd432b$export$a7175d4e9206bc80 = '#8777D9';
const $207acf722dcd432b$export$b48405b95304b5a1 = '#6554C0';
const $207acf722dcd432b$export$c71e4279dd54a18d = '#5243AA';
const $207acf722dcd432b$export$147899de772240ec = '#403294';
const $207acf722dcd432b$export$2cf711fe14c66f06 = '#E6FCFF';
const $207acf722dcd432b$export$7a8f4d33f6f9772c = '#B3F5FF';
const $207acf722dcd432b$export$776c9c497ef08533 = '#79E2F2';
const $207acf722dcd432b$export$69cb3ca10c1e330e = '#00C7E6';
const $207acf722dcd432b$export$9dc1ef0f3f48059b = '#00B8D9';
const $207acf722dcd432b$export$7c835c78b6fcdef8 = '#00A3BF';
const $207acf722dcd432b$export$6036577f95c3877e = '#008DA6';
const $207acf722dcd432b$export$29a4f05edc054374 = '#FFFFFF';
const $207acf722dcd432b$export$e655ef011c4aa1a2 = '#FAFBFC';
const $207acf722dcd432b$export$9fdfb749e33cdf97 = '#F4F5F7';
const $207acf722dcd432b$export$3e51e8f1440314ba = '#EBECF0';
const $207acf722dcd432b$export$1ce2d1575d444ceb = '#DFE1E6';
const $207acf722dcd432b$export$8754fc7e6d8b3000 = '#C1C7D0';
const $207acf722dcd432b$export$c2e91cbeada39b8b = '#B3BAC5';
const $207acf722dcd432b$export$5f71e19f3a7ad9de = '#A5ADBA';
const $207acf722dcd432b$export$eaa8c8a70ac22806 = '#97A0AF';
const $207acf722dcd432b$export$7c87d337fb91a97d = '#8993A4';
const $207acf722dcd432b$export$d6447c357493214f = '#7A869A';
const $207acf722dcd432b$export$f563ee71e9ee74cd = '#6B778C';
const $207acf722dcd432b$export$e2ef2124cf4024b1 = '#5E6C84';
const $207acf722dcd432b$export$eece5f492e429f08 = '#505F79';
const $207acf722dcd432b$export$c39c0fe0f26207ae = '#42526E';
const $207acf722dcd432b$export$7090862dc3038a9f = '#344563';
const $207acf722dcd432b$export$ad0bacf983b7ddaa = '#253858';
const $207acf722dcd432b$export$7d61b15e0da132af = '#172B4D';
const $207acf722dcd432b$export$fbda843f0a27fe96 = '#091E42';
const $207acf722dcd432b$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $207acf722dcd432b$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $207acf722dcd432b$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $207acf722dcd432b$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $207acf722dcd432b$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $207acf722dcd432b$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $207acf722dcd432b$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $207acf722dcd432b$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $207acf722dcd432b$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $207acf722dcd432b$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $207acf722dcd432b$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $207acf722dcd432b$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $207acf722dcd432b$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $207acf722dcd432b$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $207acf722dcd432b$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $207acf722dcd432b$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $207acf722dcd432b$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $207acf722dcd432b$export$2f6319cf7d736c2a = '#E6EDFA';
const $207acf722dcd432b$export$95126bc8884d6634 = '#DCE5F5';
const $207acf722dcd432b$export$8338d8c35d44ff1 = '#CED9EB';
const $207acf722dcd432b$export$5368d76ae4fbbda7 = '#B8C7E0';
const $207acf722dcd432b$export$9f0a771d16ec8d36 = '#ABBBD6';
const $207acf722dcd432b$export$abcf8c38338b4aa5 = '#9FB0CC';
const $207acf722dcd432b$export$97e81faa16a182c7 = '#8C9CB8';
const $207acf722dcd432b$export$bfe21c59123ecf33 = '#7988A3';
const $207acf722dcd432b$export$ee82aa2ea6a1558 = '#67758F';
const $207acf722dcd432b$export$682927c6ed76be02 = '#56637A';
const $207acf722dcd432b$export$91fd9994c5be9757 = '#455166';
const $207acf722dcd432b$export$d281fbfe3cff2df6 = '#3B475C';
const $207acf722dcd432b$export$3902c91d8b98a753 = '#313D52';
const $207acf722dcd432b$export$8e8133c1ba5845b5 = '#283447';
const $207acf722dcd432b$export$33ff357f6620b39 = '#202B3D';
const $207acf722dcd432b$export$633847cf062b69e0 = '#1B2638';
const $207acf722dcd432b$export$9776a6e503bdbf76 = '#121A29';
const $207acf722dcd432b$export$6c813d5160dff5db = '#0E1624';
const $207acf722dcd432b$export$3d4f271a500072a = '#0D1424';
const $207acf722dcd432b$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $207acf722dcd432b$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $207acf722dcd432b$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $207acf722dcd432b$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $207acf722dcd432b$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $207acf722dcd432b$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $207acf722dcd432b$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $207acf722dcd432b$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $207acf722dcd432b$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $207acf722dcd432b$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $207acf722dcd432b$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $207acf722dcd432b$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $207acf722dcd432b$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $207acf722dcd432b$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $207acf722dcd432b$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $207acf722dcd432b$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $207acf722dcd432b$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $207acf722dcd432b$export$d2adc5dedf09fced = '#292A2E';
const $207acf722dcd432b$export$f51762073d2bb381 = '#94C748';
const $207acf722dcd432b$export$95e26d54def96891 = '#B3DF72';
parcelRegister("3Dx41", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$79dfee17fe4568ac$export$2e2bcd8739ae039);
    var $byn9U = parcelRequire("byn9U");
    var $gT5pi = parcelRequire("gT5pi");
    function $79dfee17fe4568ac$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $79dfee17fe4568ac$var$CSS_VAR_COLOR = '--logo-color';
    const $79dfee17fe4568ac$var$CSS_VAR_FILL = '--logo-fill';
    const $79dfee17fe4568ac$var$baseWrapperStyles = (0, $byn9U.css)({
        display: 'inline-block',
        position: 'relative',
        color: `var(${$79dfee17fe4568ac$var$CSS_VAR_COLOR})`,
        fill: `var(${$79dfee17fe4568ac$var$CSS_VAR_FILL})`,
        lineHeight: 1,
        userSelect: 'none',
        whiteSpace: 'normal',
        '> svg': {
            height: '100%',
            fill: 'inherit'
        }
    });
    const $79dfee17fe4568ac$var$stopColorStyles = {
        name: "1hl44m8",
        styles: "stop{stop-color:currentColor;}"
    };
    const $79dfee17fe4568ac$var$sizeStyles = Object.entries((0, $gT5pi.sizes)).reduce((acc, [key, val])=>{
        acc[key] = (0, $byn9U.css)({
            height: `${val}px`
        });
        return acc;
    }, {});
    const $79dfee17fe4568ac$var$Wrapper = ({ label: label, svg: svg, size: size, appearance: appearance, iconColor: iconColor, textColor: textColor, testId: userDefinedTestId, ...rest })=>{
        const shouldApplyStopColor = appearance === undefined;
        const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
        return (0, $byn9U.jsx)("span", {
            css: [
                $79dfee17fe4568ac$var$baseWrapperStyles,
                shouldApplyStopColor && $79dfee17fe4568ac$var$stopColorStyles,
                size && $79dfee17fe4568ac$var$sizeStyles[size]
            ],
            "data-testid": testId,
            style: {
                [$79dfee17fe4568ac$var$CSS_VAR_COLOR]: iconColor,
                [$79dfee17fe4568ac$var$CSS_VAR_FILL]: textColor
            },
            "aria-label": label ? label : undefined,
            role: label ? 'img' : undefined,
            dangerouslySetInnerHTML: {
                __html: svg
            },
            ...rest
        });
    };
    var $79dfee17fe4568ac$export$2e2bcd8739ae039 = $79dfee17fe4568ac$var$Wrapper;
});
parcelRegister("hCaWp", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $cd2e78eee655aeae$var$_react = $cd2e78eee655aeae$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $ewCKl = parcelRequire("ewCKl");
    var $cd2e78eee655aeae$var$_error = $cd2e78eee655aeae$var$_interopRequireDefault((parcelRequire("1jDKU")));
    function $cd2e78eee655aeae$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $cd2e78eee655aeae$var$ErrorIcon = (props)=>$cd2e78eee655aeae$var$_react.default.createElement($ewCKl.IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
        }, props, {
            newIcon: $cd2e78eee655aeae$var$_error.default
        }));
    $cd2e78eee655aeae$var$ErrorIcon.displayName = 'ErrorIcon';
    var $cd2e78eee655aeae$var$_default = module.exports.default = $cd2e78eee655aeae$var$ErrorIcon;
});
parcelRegister("1jDKU", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $0f566773177f05ba$var$_react = $0f566773177f05ba$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $0f566773177f05ba$var$_UNSAFE_baseNew = $0f566773177f05ba$var$_interopRequireDefault((parcelRequire("ay9aj")));
    function $0f566773177f05ba$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $0f566773177f05ba$var$ErrorIcon = (props)=>$0f566773177f05ba$var$_react.default.createElement($0f566773177f05ba$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.604a2 2 0 0 1 2.828 0l5.982 5.982a2 2 0 0 1 0 2.828l-5.982 5.983a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM7.25 9V3.75h1.5V9zM8 12.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
        }, props));
    $0f566773177f05ba$var$ErrorIcon.displayName = 'ErrorIcon';
    var $0f566773177f05ba$var$_default = module.exports.default = $0f566773177f05ba$var$ErrorIcon;
});
parcelRegister("lp3nw", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $f94e8da98ef0241d$var$_react = $f94e8da98ef0241d$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $ewCKl = parcelRequire("ewCKl");
    var $f94e8da98ef0241d$var$_dashboard = $f94e8da98ef0241d$var$_interopRequireDefault((parcelRequire("5sYNt")));
    function $f94e8da98ef0241d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $f94e8da98ef0241d$var$ActivityIcon = (props)=>$f94e8da98ef0241d$var$_react.default.createElement($ewCKl.IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M19.004 17C19 17 19 7.006 19 7.006 19 7 4.996 7 4.996 7 5 7 5 16.994 5 16.994 5 17 19.004 17 19.004 17M3 7.006A2 2 0 0 1 4.995 5h14.01A2 2 0 0 1 21 7.006v9.988A2 2 0 0 1 19.005 19H4.995A2 2 0 0 1 3 16.994z"/><path d="M4 6h16v5H4zm5 2c0 .556.446 1 .995 1h8.01c.54 0 .995-.448.995-1 0-.556-.446-1-.995-1h-8.01C9.455 7 9 7.448 9 8M5 8c0 .556.448 1 1 1 .556 0 1-.448 1-1 0-.556-.448-1-1-1-.556 0-1 .448-1 1"/></g></svg>`
        }, props, {
            newIcon: $f94e8da98ef0241d$var$_dashboard.default
        }));
    $f94e8da98ef0241d$var$ActivityIcon.displayName = 'ActivityIcon';
    var $f94e8da98ef0241d$var$_default = module.exports.default = $f94e8da98ef0241d$var$ActivityIcon;
});
parcelRegister("5sYNt", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $3faeba4ee30e559c$var$_react = $3faeba4ee30e559c$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $3faeba4ee30e559c$var$_UNSAFE_baseNew = $3faeba4ee30e559c$var$_interopRequireDefault((parcelRequire("ay9aj")));
    function $3faeba4ee30e559c$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3faeba4ee30e559c$var$DashboardIcon = (props)=>$3faeba4ee30e559c$var$_react.default.createElement($3faeba4ee30e559c$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M8 1.75H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h5m0-12.5h5c.69 0 1.25.56 1.25 1.25v5M8 1.75V8m0 6.25h5c.69 0 1.25-.56 1.25-1.25V8M8 14.25V8m0 0h6.25"/>`
        }, props));
    $3faeba4ee30e559c$var$DashboardIcon.displayName = 'DashboardIcon';
    var $3faeba4ee30e559c$var$_default = module.exports.default = $3faeba4ee30e559c$var$DashboardIcon;
});
parcelRegister("403qy", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2e99d21c1749002c$var$_react = $2e99d21c1749002c$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $ewCKl = parcelRequire("ewCKl");
    var $2e99d21c1749002c$var$_app = $2e99d21c1749002c$var$_interopRequireDefault((parcelRequire("5Yxi0")));
    function $2e99d21c1749002c$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $2e99d21c1749002c$var$AddonIcon = (props)=>$2e99d21c1749002c$var$_react.default.createElement($ewCKl.IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m5.376 6.455 5.248-3.104c.792-.469 1.963-.467 2.752 0l5.248 3.104C19.416 6.923 20 7.962 20 8.895v6.21c0 .936-.587 1.973-1.376 2.44l-5.248 3.104c-.792.469-1.963.467-2.752 0l-5.248-3.104C4.584 17.077 4 16.038 4 15.105v-6.21c0-.936.587-1.973 1.376-2.44m6.99-1.314c-.165-.098-.566-.098-.733 0L6.385 8.245c-.166.098-.367.454-.367.65v6.21c0 .195.2.551.367.65l5.248 3.104c.166.098.567.098.734 0l5.248-3.104c.166-.098.367-.454.367-.65v-6.21c0-.195-.2-.551-.367-.65z"/><path d="M12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8m0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></g></svg>`
        }, props, {
            newIcon: $2e99d21c1749002c$var$_app.default
        }));
    $2e99d21c1749002c$var$AddonIcon.displayName = 'AddonIcon';
    var $2e99d21c1749002c$var$_default = module.exports.default = $2e99d21c1749002c$var$AddonIcon;
});
parcelRegister("5Yxi0", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $459c60f114edbb28$var$_react = $459c60f114edbb28$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $459c60f114edbb28$var$_UNSAFE_baseNew = $459c60f114edbb28$var$_interopRequireDefault((parcelRequire("ay9aj")));
    function $459c60f114edbb28$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $459c60f114edbb28$var$AppIcon = (props)=>$459c60f114edbb28$var$_react.default.createElement($459c60f114edbb28$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m2.357 4.136 5-3a1.25 1.25 0 0 1 1.286 0l5 3c.377.226.607.633.607 1.072v5.584c0 .44-.23.846-.607 1.072l-5 3a1.25 1.25 0 0 1-1.286 0l-5-3a1.25 1.25 0 0 1-.607-1.072V5.208c0-.44.23-.846.607-1.072Z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.25 8a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"/>`
        }, props));
    $459c60f114edbb28$var$AppIcon.displayName = 'AppIcon';
    var $459c60f114edbb28$var$_default = module.exports.default = $459c60f114edbb28$var$AppIcon;
});
parcelRegister("6hBRO", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $4931b42fd26bb602$var$_react = $4931b42fd26bb602$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $ewCKl = parcelRequire("ewCKl");
    var $4931b42fd26bb602$var$_appSwitcher = $4931b42fd26bb602$var$_interopRequireDefault((parcelRequire("fJz5M")));
    function $4931b42fd26bb602$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $4931b42fd26bb602$var$AppSwitcherIcon = (props)=>$4931b42fd26bb602$var$_react.default.createElement($ewCKl.IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4 5.01C4 4.451 4.443 4 5.01 4h1.98C7.549 4 8 4.443 8 5.01v1.98C8 7.549 7.557 8 6.99 8H5.01C4.451 8 4 7.557 4 6.99zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C8 13.549 7.557 14 6.99 14H5.01C4.451 14 4 13.557 4 12.99zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C14 7.549 13.557 8 12.99 8h-1.98C10.451 8 10 7.557 10 6.99zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C20 7.549 19.557 8 18.99 8h-1.98C16.451 8 16 7.557 16 6.99zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01zm-12 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C8 19.549 7.557 20 6.99 20H5.01C4.451 20 4 19.557 4 18.99zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01z"/></svg>`
        }, props, {
            newIcon: $4931b42fd26bb602$var$_appSwitcher.default
        }));
    $4931b42fd26bb602$var$AppSwitcherIcon.displayName = 'AppSwitcherIcon';
    var $4931b42fd26bb602$var$_default = module.exports.default = $4931b42fd26bb602$var$AppSwitcherIcon;
});
parcelRegister("fJz5M", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $02f4bf16e66e7c69$var$_react = $02f4bf16e66e7c69$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $02f4bf16e66e7c69$var$_UNSAFE_baseNew = $02f4bf16e66e7c69$var$_interopRequireDefault((parcelRequire("ay9aj")));
    function $02f4bf16e66e7c69$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $02f4bf16e66e7c69$var$AppSwitcherIcon = (props)=>$02f4bf16e66e7c69$var$_react.default.createElement($02f4bf16e66e7c69$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 3c0-.69.56-1.25 1.25-1.25h2c.69 0 1.25.56 1.25 1.25v2c0 .69-.56 1.25-1.25 1.25H3c-.69 0-1.25-.56-1.25-1.25zm8 0c0-.69.56-1.25 1.25-1.25h2c.69 0 1.25.56 1.25 1.25v2c0 .69-.56 1.25-1.25 1.25h-2c-.69 0-1.25-.56-1.25-1.25zm-8 8c0-.69.56-1.25 1.25-1.25h2c.69 0 1.25.56 1.25 1.25v2c0 .69-.56 1.25-1.25 1.25H3c-.69 0-1.25-.56-1.25-1.25zm8 0c0-.69.56-1.25 1.25-1.25h2c.69 0 1.25.56 1.25 1.25v2c0 .69-.56 1.25-1.25 1.25h-2c-.69 0-1.25-.56-1.25-1.25z"/>`
        }, props));
    $02f4bf16e66e7c69$var$AppSwitcherIcon.displayName = 'AppSwitcherIcon';
    var $02f4bf16e66e7c69$var$_default = module.exports.default = $02f4bf16e66e7c69$var$AppSwitcherIcon;
});
parcelRegister("4BPmG", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $35b276229d2e3adc$var$_react = $35b276229d2e3adc$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $ewCKl = parcelRequire("ewCKl");
    function $35b276229d2e3adc$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $35b276229d2e3adc$var$BillingIcon = (props)=>$35b276229d2e3adc$var$_react.default.createElement($ewCKl.IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M7 4v16h10V4zm-2-.01C5 2.892 5.897 2 7.006 2h9.988C18.102 2 19 2.898 19 3.99v16.02c0 1.099-.897 1.99-2.006 1.99H7.006A2.003 2.003 0 0 1 5 20.01z"/><rect width="8" height="2" x="8" y="6" rx="1"/><rect width="5" height="2" x="8" y="9" rx="1"/><rect width="5" height="2" x="8" y="12" rx="1"/><rect width="5" height="2" x="8" y="15" rx="1"/><rect width="2" height="2" x="14" y="12" rx="1"/><rect width="2" height="2" x="14" y="15" rx="1"/><rect width="2" height="2" x="14" y="9" rx="1"/></g></svg>`
        }, props));
    $35b276229d2e3adc$var$BillingIcon.displayName = 'BillingIcon';
    var $35b276229d2e3adc$var$_default = module.exports.default = $35b276229d2e3adc$var$BillingIcon;
});
parcelRegister("186Wd", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $0d2beb8a94144a73$var$_react = $0d2beb8a94144a73$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $ewCKl = parcelRequire("ewCKl");
    var $0d2beb8a94144a73$var$_chevronDown = $0d2beb8a94144a73$var$_interopRequireDefault((parcelRequire("eRXEa")));
    function $0d2beb8a94144a73$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $0d2beb8a94144a73$var$ChevronDownIcon = (props)=>$0d2beb8a94144a73$var$_react.default.createElement($ewCKl.IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></svg>`
        }, props, {
            newIcon: $0d2beb8a94144a73$var$_chevronDown.default,
            iconType: "utility"
        }));
    $0d2beb8a94144a73$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
    var $0d2beb8a94144a73$var$_default = module.exports.default = $0d2beb8a94144a73$var$ChevronDownIcon;
});
parcelRegister("bsCiU", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $8580059551f11a20$var$_react = $8580059551f11a20$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $ewCKl = parcelRequire("ewCKl");
    var $8580059551f11a20$var$_chevronRight = $8580059551f11a20$var$_interopRequireDefault((parcelRequire("8cNUp")));
    function $8580059551f11a20$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $8580059551f11a20$var$ChevronRightIcon = (props)=>$8580059551f11a20$var$_react.default.createElement($ewCKl.IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M10.294 9.698a.99.99 0 0 1 0-1.407 1.01 1.01 0 0 1 1.419 0l2.965 2.94a1.09 1.09 0 0 1 0 1.548l-2.955 2.93a1.01 1.01 0 0 1-1.42 0 .99.99 0 0 1 0-1.407l2.318-2.297z"/></svg>`
        }, props, {
            newIcon: $8580059551f11a20$var$_chevronRight.default,
            iconType: "utility"
        }));
    $8580059551f11a20$var$ChevronRightIcon.displayName = 'ChevronRightIcon';
    var $8580059551f11a20$var$_default = module.exports.default = $8580059551f11a20$var$ChevronRightIcon;
});
parcelRegister("8cNUp", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $5f962898e1453cd0$var$_react = $5f962898e1453cd0$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $5f962898e1453cd0$var$_UNSAFE_baseNew = $5f962898e1453cd0$var$_interopRequireDefault((parcelRequire("ay9aj")));
    function $5f962898e1453cd0$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $5f962898e1453cd0$var$ChevronRightIcon = (props)=>$5f962898e1453cd0$var$_react.default.createElement($5f962898e1453cd0$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4.5 10.5 9 6 4.5 1.5"/>`,
            type: 'utility'
        }, props));
    $5f962898e1453cd0$var$ChevronRightIcon.displayName = 'ChevronRightIcon';
    var $5f962898e1453cd0$var$_default = module.exports.default = $5f962898e1453cd0$var$ChevronRightIcon;
});
parcelRegister("2R3Y3", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $21439be6a127e811$var$_react = $21439be6a127e811$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $ewCKl = parcelRequire("ewCKl");
    var $21439be6a127e811$var$_creditCard = $21439be6a127e811$var$_interopRequireDefault((parcelRequire("jyPwc")));
    function $21439be6a127e811$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $21439be6a127e811$var$CreditcardFilledIcon = (props)=>$21439be6a127e811$var$_react.default.createElement($ewCKl.IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M3 10.99h18V17c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2zM6.01 16h2v-2h-2zM21 8.99V7c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v1.99"/></svg>`
        }, props, {
            newIcon: $21439be6a127e811$var$_creditCard.default
        }));
    $21439be6a127e811$var$CreditcardFilledIcon.displayName = 'CreditcardFilledIcon';
    var $21439be6a127e811$var$_default = module.exports.default = $21439be6a127e811$var$CreditcardFilledIcon;
});
parcelRegister("jyPwc", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $e3d927be8a687af9$var$_react = $e3d927be8a687af9$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $e3d927be8a687af9$var$_UNSAFE_baseNew = $e3d927be8a687af9$var$_interopRequireDefault((parcelRequire("ay9aj")));
    function $e3d927be8a687af9$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $e3d927be8a687af9$var$CreditCardIcon = (props)=>$e3d927be8a687af9$var$_react.default.createElement($e3d927be8a687af9$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M.75 6.25V12c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25V6.25m-14.5 0V4c0-.69.56-1.25 1.25-1.25h12c.69 0 1.25.56 1.25 1.25v2.25m-14.5 0h14.5m-2.25 4H9"/>`
        }, props));
    $e3d927be8a687af9$var$CreditCardIcon.displayName = 'CreditCardIcon';
    var $e3d927be8a687af9$var$_default = module.exports.default = $e3d927be8a687af9$var$CreditCardIcon;
});
parcelRegister("icLJK", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $d40e608c785417e7$var$_react = $d40e608c785417e7$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $ewCKl = parcelRequire("ewCKl");
    var $d40e608c785417e7$var$_dashboard = $d40e608c785417e7$var$_interopRequireDefault((parcelRequire("5sYNt")));
    function $d40e608c785417e7$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $d40e608c785417e7$var$DashboardIcon = (props)=>$d40e608c785417e7$var$_react.default.createElement($ewCKl.IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M4 18h16.008C20 18 20 6 20 6H3.992C4 6 4 18 4 18M2 5.994C2 4.893 2.898 4 3.99 4h16.02C21.108 4 22 4.895 22 5.994v12.012A1.997 1.997 0 0 1 20.01 20H3.99A1.994 1.994 0 0 1 2 18.006z"/><path d="M7 5v14h2V5z"/><path d="M7 11h14V9H7z"/></g></svg>`
        }, props, {
            newIcon: $d40e608c785417e7$var$_dashboard.default
        }));
    $d40e608c785417e7$var$DashboardIcon.displayName = 'DashboardIcon';
    var $d40e608c785417e7$var$_default = module.exports.default = $d40e608c785417e7$var$DashboardIcon;
});
parcelRegister("8ek9z", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $5fdf4396edc227aa$var$_react = $5fdf4396edc227aa$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $ewCKl = parcelRequire("ewCKl");
    var $5fdf4396edc227aa$var$_add = $5fdf4396edc227aa$var$_interopRequireDefault((parcelRequire("dDoXb")));
    function $5fdf4396edc227aa$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $5fdf4396edc227aa$var$EditorAddIcon = (props)=>$5fdf4396edc227aa$var$_react.default.createElement($ewCKl.IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13 11V7a1 1 0 0 0-2 0v4H7a1 1 0 0 0 0 2h4v4a1 1 0 0 0 2 0v-4h4a1 1 0 0 0 0-2z"/></svg>`
        }, props, {
            newIcon: $5fdf4396edc227aa$var$_add.default
        }));
    $5fdf4396edc227aa$var$EditorAddIcon.displayName = 'EditorAddIcon';
    var $5fdf4396edc227aa$var$_default = module.exports.default = $5fdf4396edc227aa$var$EditorAddIcon;
});
parcelRegister("dDoXb", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $9ed246289525ce66$var$_react = $9ed246289525ce66$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $9ed246289525ce66$var$_UNSAFE_baseNew = $9ed246289525ce66$var$_interopRequireDefault((parcelRequire("ay9aj")));
    function $9ed246289525ce66$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $9ed246289525ce66$var$AddIcon = (props)=>$9ed246289525ce66$var$_react.default.createElement($9ed246289525ce66$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M8 8h7M8 8H1m7 0V1m0 7v7"/>`
        }, props));
    $9ed246289525ce66$var$AddIcon.displayName = 'AddIcon';
    var $9ed246289525ce66$var$_default = module.exports.default = $9ed246289525ce66$var$AddIcon;
});
parcelRegister("4n0Ni", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $32e9ed1f49d25ad3$var$_react = $32e9ed1f49d25ad3$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $ewCKl = parcelRequire("ewCKl");
    function $32e9ed1f49d25ad3$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $32e9ed1f49d25ad3$var$EmojiAtlassianIcon = (props)=>$32e9ed1f49d25ad3$var$_react.default.createElement($ewCKl.IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M8.7 11.48c-.24-.25-.61-.24-.77.09l-3.88 7.76a.46.46 0 0 0 .42.67h5.41a.45.45 0 0 0 .42-.26c1.17-2.41.46-6.08-1.59-8.27m2.84-7.06c-2.17 3.44-2.03 7.26-.6 10.12l2.61 5.22c.08.16.24.26.42.26h5.41a.46.46 0 0 0 .42-.67S12.53 4.77 12.35 4.41c-.17-.32-.58-.33-.79 0"/></svg>`
        }, props));
    $32e9ed1f49d25ad3$var$EmojiAtlassianIcon.displayName = 'EmojiAtlassianIcon';
    var $32e9ed1f49d25ad3$var$_default = module.exports.default = $32e9ed1f49d25ad3$var$EmojiAtlassianIcon;
});
parcelRegister("2S3o6", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $217340acd0ce49f0$var$_react = $217340acd0ce49f0$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $ewCKl = parcelRequire("ewCKl");
    var $217340acd0ce49f0$var$_filter = $217340acd0ce49f0$var$_interopRequireDefault((parcelRequire("2rj72")));
    function $217340acd0ce49f0$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $217340acd0ce49f0$var$FilterIcon = (props)=>$217340acd0ce49f0$var$_react.default.createElement($ewCKl.IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 13h10l1-2H6zM3.99 6c-.55 0-.79.41-.55.9L4 8h16l.55-1.1c.25-.5.01-.9-.54-.9zm6.79 11.56a.87.87 0 0 0 .73.44h.99c.28 0 .61-.2.73-.44L14 16h-4z"/></svg>`
        }, props, {
            newIcon: $217340acd0ce49f0$var$_filter.default
        }));
    $217340acd0ce49f0$var$FilterIcon.displayName = 'FilterIcon';
    var $217340acd0ce49f0$var$_default = module.exports.default = $217340acd0ce49f0$var$FilterIcon;
});
parcelRegister("2rj72", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $1c6cedb73658e140$var$_react = $1c6cedb73658e140$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $1c6cedb73658e140$var$_UNSAFE_baseNew = $1c6cedb73658e140$var$_interopRequireDefault((parcelRequire("ay9aj")));
    function $1c6cedb73658e140$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1c6cedb73658e140$var$FilterIcon = (props)=>$1c6cedb73658e140$var$_react.default.createElement($1c6cedb73658e140$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M3 8h10M1 2.75h14M5 13.25h6"/>`
        }, props));
    $1c6cedb73658e140$var$FilterIcon.displayName = 'FilterIcon';
    var $1c6cedb73658e140$var$_default = module.exports.default = $1c6cedb73658e140$var$FilterIcon;
});
parcelRegister("hsdxw", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $cb4f8de6031fd12b$var$_react = $cb4f8de6031fd12b$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $ewCKl = parcelRequire("ewCKl");
    var $cb4f8de6031fd12b$var$_folderClosed = $cb4f8de6031fd12b$var$_interopRequireDefault((parcelRequire("2EvtT")));
    function $cb4f8de6031fd12b$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $cb4f8de6031fd12b$var$FolderIcon = (props)=>$cb4f8de6031fd12b$var$_react.default.createElement($ewCKl.IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M20 19V8h-9.154l-.503-1.258-.455-1.136C9.778 5.33 9.291 5 9.003 5H3.997C4.002 5 4 19 4 19zM12.2 6h7.809C21.109 6 22 6.893 22 7.992v11.016c0 1.1-.898 1.992-1.991 1.992H3.991C2.891 21 2 20.107 2 19.008V5.006C2 3.898 2.896 3 3.997 3h5.006c1.103 0 2.327.826 2.742 1.862z"/></svg>`
        }, props, {
            newIcon: $cb4f8de6031fd12b$var$_folderClosed.default
        }));
    $cb4f8de6031fd12b$var$FolderIcon.displayName = 'FolderIcon';
    var $cb4f8de6031fd12b$var$_default = module.exports.default = $cb4f8de6031fd12b$var$FolderIcon;
});
parcelRegister("2EvtT", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $1ee7bcb73149c8d9$var$_react = $1ee7bcb73149c8d9$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $1ee7bcb73149c8d9$var$_UNSAFE_baseNew = $1ee7bcb73149c8d9$var$_interopRequireDefault((parcelRequire("ay9aj")));
    function $1ee7bcb73149c8d9$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1ee7bcb73149c8d9$var$FolderClosedIcon = (props)=>$1ee7bcb73149c8d9$var$_react.default.createElement($1ee7bcb73149c8d9$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 6.75V13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V6.75m-12.5 0V3c0-.69.56-1.25 1.25-1.25h3.25L8 3.5h5c.69 0 1.25.56 1.25 1.25v2m-12.5 0h12.5"/>`
        }, props));
    $1ee7bcb73149c8d9$var$FolderClosedIcon.displayName = 'FolderClosedIcon';
    var $1ee7bcb73149c8d9$var$_default = module.exports.default = $1ee7bcb73149c8d9$var$FolderClosedIcon;
});
parcelRegister("baUf2", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $822c41494fd30273$var$_react = $822c41494fd30273$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $ewCKl = parcelRequire("ewCKl");
    var $822c41494fd30273$var$_issues = $822c41494fd30273$var$_interopRequireDefault((parcelRequire("cH8qt")));
    function $822c41494fd30273$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $822c41494fd30273$var$IssuesIcon = (props)=>$822c41494fd30273$var$_react.default.createElement($ewCKl.IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 12.99C5 13 19.01 13 19.01 13 19 13 19 5.01 19 5.01 19 5 5 5 5 5zM3 5.01C3 3.9 3.89 3 5 3h14.01A2 2 0 0 1 21 5.01v7.98A2 2 0 0 1 19.01 15H5a2 2 0 0 1-2-2.01zM19 19c0 1.11-.9 2-2.01 2H7.01A2.01 2.01 0 0 1 5 19zm1-3a2 2 0 0 1-1.99 2H5.99A2 2 0 0 1 4 16z"/><path d="M10.674 11.331c.36.36.941.36 1.3 0l2.758-2.763a.92.92 0 0 0-1.301-1.298l-2.108 2.11-.755-.754a.92.92 0 0 0-1.3 1.3z"/></g></svg>`
        }, props, {
            newIcon: $822c41494fd30273$var$_issues.default
        }));
    $822c41494fd30273$var$IssuesIcon.displayName = 'IssuesIcon';
    var $822c41494fd30273$var$_default = module.exports.default = $822c41494fd30273$var$IssuesIcon;
});
parcelRegister("cH8qt", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $93e00966c2292627$var$_react = $93e00966c2292627$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $93e00966c2292627$var$_UNSAFE_baseNew = $93e00966c2292627$var$_interopRequireDefault((parcelRequire("ay9aj")));
    function $93e00966c2292627$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $93e00966c2292627$var$IssuesIcon = (props)=>$93e00966c2292627$var$_react.default.createElement($93e00966c2292627$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m4.125 7 1.583 1.875 3.167-3.75M.75 10V4c0-.69.56-1.25 1.25-1.25h9c.69 0 1.25.56 1.25 1.25v6c0 .69-.56 1.25-1.25 1.25H2c-.69 0-1.25-.56-1.25-1.25Z"/><path stroke="currentcolor" stroke-width="1.5" d="M5 14.25h7.75a2.5 2.5 0 0 0 2.5-2.5V7"/>`
        }, props));
    $93e00966c2292627$var$IssuesIcon.displayName = 'IssuesIcon';
    var $93e00966c2292627$var$_default = module.exports.default = $93e00966c2292627$var$IssuesIcon;
});
parcelRegister("d92KR", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $991e40afd4a2eb51$var$_react = $991e40afd4a2eb51$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $ewCKl = parcelRequire("ewCKl");
    var $991e40afd4a2eb51$var$_showMoreHorizontal = $991e40afd4a2eb51$var$_interopRequireDefault((parcelRequire("l0n7F")));
    function $991e40afd4a2eb51$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $991e40afd4a2eb51$var$MoreIcon = (props)=>$991e40afd4a2eb51$var$_react.default.createElement($ewCKl.IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="5" cy="12" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="19" cy="12" r="2"/></g></svg>`
        }, props, {
            newIcon: $991e40afd4a2eb51$var$_showMoreHorizontal.default
        }));
    $991e40afd4a2eb51$var$MoreIcon.displayName = 'MoreIcon';
    var $991e40afd4a2eb51$var$_default = module.exports.default = $991e40afd4a2eb51$var$MoreIcon;
});
parcelRegister("l0n7F", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $f4ab88beef856695$var$_react = $f4ab88beef856695$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $f4ab88beef856695$var$_UNSAFE_baseNew = $f4ab88beef856695$var$_interopRequireDefault((parcelRequire("ay9aj")));
    function $f4ab88beef856695$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $f4ab88beef856695$var$ShowMoreHorizontalIcon = (props)=>$f4ab88beef856695$var$_react.default.createElement($f4ab88beef856695$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" d="M2.25 8a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m6.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m6.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"/><path stroke="currentcolor" stroke-width="1.5" d="M2.25 8a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm6.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm6.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"/>`
        }, props));
    $f4ab88beef856695$var$ShowMoreHorizontalIcon.displayName = 'ShowMoreHorizontalIcon';
    var $f4ab88beef856695$var$_default = module.exports.default = $f4ab88beef856695$var$ShowMoreHorizontalIcon;
});
parcelRegister("6BrIh", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $4cebb20d6ea669ea$var$_react = $4cebb20d6ea669ea$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $ewCKl = parcelRequire("ewCKl");
    var $4cebb20d6ea669ea$var$_notification = $4cebb20d6ea669ea$var$_interopRequireDefault((parcelRequire("crTNR")));
    function $4cebb20d6ea669ea$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $4cebb20d6ea669ea$var$NotificationIcon = (props)=>$4cebb20d6ea669ea$var$_react.default.createElement($ewCKl.IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6.49 17.67a2 2 0 0 0 2.83 0l-2.83-2.83a2 2 0 0 0 0 2.83m4.89-12.19-.72.73c-.78.78-2.21 1.81-3.21 2.31l-3.02 1.51c-.49.25-.58.77-.19 1.17l8.56 8.56c.4.4.92.31 1.17-.19l1.51-3.02c.49-.99 1.53-2.42 2.31-3.21l.73-.73a5.05 5.05 0 0 0 .64-6.36 1.01 1.01 0 1 0-1.35-1.49q-.04.04-.07.08A5.04 5.04 0 0 0 14.95 4a5.04 5.04 0 0 0-3.57 1.48"/></svg>`
        }, props, {
            newIcon: $4cebb20d6ea669ea$var$_notification.default
        }));
    $4cebb20d6ea669ea$var$NotificationIcon.displayName = 'NotificationIcon';
    var $4cebb20d6ea669ea$var$_default = module.exports.default = $4cebb20d6ea669ea$var$NotificationIcon;
});
parcelRegister("crTNR", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $91034b0718fa5a93$var$_react = $91034b0718fa5a93$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $91034b0718fa5a93$var$_UNSAFE_baseNew = $91034b0718fa5a93$var$_interopRequireDefault((parcelRequire("ay9aj")));
    function $91034b0718fa5a93$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $91034b0718fa5a93$var$NotificationIcon = (props)=>$91034b0718fa5a93$var$_react.default.createElement($91034b0718fa5a93$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.5 12.75a2.5 2.5 0 0 1-5 0m6.75-4.114V5a4.25 4.25 0 0 0-8.5 0v3.636a.4.4 0 0 1-.06.21l-1.842 2.948a.625.625 0 0 0 .53.956h11.244c.491 0 .79-.54.53-.956l-1.841-2.947a.4.4 0 0 1-.061-.211Z"/>`
        }, props));
    $91034b0718fa5a93$var$NotificationIcon.displayName = 'NotificationIcon';
    var $91034b0718fa5a93$var$_default = module.exports.default = $91034b0718fa5a93$var$NotificationIcon;
});
parcelRegister("buAHJ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $85def7c48e7c76a9$var$_react = $85def7c48e7c76a9$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $ewCKl = parcelRequire("ewCKl");
    var $85def7c48e7c76a9$var$_notification = $85def7c48e7c76a9$var$_interopRequireDefault((parcelRequire("crTNR")));
    function $85def7c48e7c76a9$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $85def7c48e7c76a9$var$NotificationDirectIcon = (props)=>$85def7c48e7c76a9$var$_react.default.createElement($ewCKl.IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6.59 17.83a2 2 0 0 0 2.83 0L6.59 15a2 2 0 0 0 0 2.83m4.79-12.35A5.04 5.04 0 0 1 14.95 4c.97 0 1.95.28 2.79.84q.03-.04.07-.07a1.01 1.01 0 1 1 1.35 1.49 5.05 5.05 0 0 1-.64 6.36l-.72.73c-.78.78-1.81 2.21-2.31 3.21l-1.51 3.02c-.25.5-.77.58-1.17.19l-8.56-8.55c-.4-.4-.31-.92.19-1.17l3.02-1.51c.99-.49 2.42-1.53 3.21-2.31zm2.74 9.63c.52-.97 1.57-2.4 2.35-3.18l.73-.73a3.05 3.05 0 0 0 .39-3.83c-.19-.29-.72-.77-.86-.86A3.04 3.04 0 0 0 15.05 6c-.8 0-1.57.31-2.16.89l-.95.95c-.78.79-2.22 1.82-3.2 2.31L7 11.02l6.07 6.07z"/></svg>`
        }, props, {
            newIcon: $85def7c48e7c76a9$var$_notification.default
        }));
    $85def7c48e7c76a9$var$NotificationDirectIcon.displayName = 'NotificationDirectIcon';
    var $85def7c48e7c76a9$var$_default = module.exports.default = $85def7c48e7c76a9$var$NotificationDirectIcon;
});
parcelRegister("aBv70", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $7b857e4d440c8a58$var$_react = $7b857e4d440c8a58$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $ewCKl = parcelRequire("ewCKl");
    var $7b857e4d440c8a58$var$_arrowUpRight = $7b857e4d440c8a58$var$_interopRequireDefault((parcelRequire("RCdIT")));
    function $7b857e4d440c8a58$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $7b857e4d440c8a58$var$OpenIcon = (props)=>$7b857e4d440c8a58$var$_react.default.createElement($ewCKl.IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11.031 7A1.03 1.03 0 0 0 10 8.036a1.05 1.05 0 0 0 1.044 1.045l3.121.014.014 3.121a1.05 1.05 0 0 0 1.045 1.044 1.03 1.03 0 0 0 1.036-1.035l-.019-4.161a1.053 1.053 0 0 0-1.045-1.045L11.035 7z"/><path d="m13.364 8.292-7.071 7.071a1 1 0 0 0 0 1.415 1 1 0 0 0 1.414 0l7.071-7.071A1.002 1.002 0 0 0 14.071 8a1 1 0 0 0-.707.292"/></g></svg>`
        }, props, {
            newIcon: $7b857e4d440c8a58$var$_arrowUpRight.default
        }));
    $7b857e4d440c8a58$var$OpenIcon.displayName = 'OpenIcon';
    var $7b857e4d440c8a58$var$_default = module.exports.default = $7b857e4d440c8a58$var$OpenIcon;
});
parcelRegister("RCdIT", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $0a12991d72bf67ef$var$_react = $0a12991d72bf67ef$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $0a12991d72bf67ef$var$_UNSAFE_baseNew = $0a12991d72bf67ef$var$_interopRequireDefault((parcelRequire("ay9aj")));
    function $0a12991d72bf67ef$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $0a12991d72bf67ef$var$ArrowUpRightIcon = (props)=>$0a12991d72bf67ef$var$_react.default.createElement($0a12991d72bf67ef$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m3 13 9.25-9.25m-6.5-.5h7v7"/>`
        }, props));
    $0a12991d72bf67ef$var$ArrowUpRightIcon.displayName = 'ArrowUpRightIcon';
    var $0a12991d72bf67ef$var$_default = module.exports.default = $0a12991d72bf67ef$var$ArrowUpRightIcon;
});
parcelRegister("bepFn", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $82d4e94e53bf25ab$var$_react = $82d4e94e53bf25ab$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $ewCKl = parcelRequire("ewCKl");
    var $82d4e94e53bf25ab$var$_person = $82d4e94e53bf25ab$var$_interopRequireDefault((parcelRequire("90vbB")));
    function $82d4e94e53bf25ab$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $82d4e94e53bf25ab$var$PersonIcon = (props)=>$82d4e94e53bf25ab$var$_react.default.createElement($ewCKl.IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M6 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0z"/><circle cx="12" cy="7" r="4"/></g></svg>`
        }, props, {
            newIcon: $82d4e94e53bf25ab$var$_person.default
        }));
    $82d4e94e53bf25ab$var$PersonIcon.displayName = 'PersonIcon';
    var $82d4e94e53bf25ab$var$_default = module.exports.default = $82d4e94e53bf25ab$var$PersonIcon;
});
parcelRegister("90vbB", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $68ec4e0d44de0a73$var$_react = $68ec4e0d44de0a73$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $68ec4e0d44de0a73$var$_UNSAFE_baseNew = $68ec4e0d44de0a73$var$_interopRequireDefault((parcelRequire("ay9aj")));
    function $68ec4e0d44de0a73$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $68ec4e0d44de0a73$var$PersonIcon = (props)=>$68ec4e0d44de0a73$var$_react.default.createElement($68ec4e0d44de0a73$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M13.25 15v-2.25a3 3 0 0 0-3-3h-4.5a3 3 0 0 0-3 3V15m8.5-11a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0Z"/>`
        }, props));
    $68ec4e0d44de0a73$var$PersonIcon.displayName = 'PersonIcon';
    var $68ec4e0d44de0a73$var$_default = module.exports.default = $68ec4e0d44de0a73$var$PersonIcon;
});
parcelRegister("dfMUn", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $9a629d437206e282$var$_react = $9a629d437206e282$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $ewCKl = parcelRequire("ewCKl");
    var $9a629d437206e282$var$_personAvatar = $9a629d437206e282$var$_interopRequireDefault((parcelRequire("9dxCg")));
    function $9a629d437206e282$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $9a629d437206e282$var$PersonCircleIcon = (props)=>$9a629d437206e282$var$_react.default.createElement($ewCKl.IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M14.5 13.009h-5c-1.38 0-2.5 1.12-2.5 2.503v3.978a8.95 8.95 0 0 0 5 1.519 8.95 8.95 0 0 0 5-1.519v-3.978a2.5 2.5 0 0 0-2.5-2.503"/><circle cx="12" cy="9" r="3"/><path fill-rule="nonzero" d="M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16m0 2C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10"/></g></svg>`
        }, props, {
            newIcon: $9a629d437206e282$var$_personAvatar.default
        }));
    $9a629d437206e282$var$PersonCircleIcon.displayName = 'PersonCircleIcon';
    var $9a629d437206e282$var$_default = module.exports.default = $9a629d437206e282$var$PersonCircleIcon;
});
parcelRegister("9dxCg", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $6b5f676fd444cc21$var$_react = $6b5f676fd444cc21$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $6b5f676fd444cc21$var$_UNSAFE_baseNew = $6b5f676fd444cc21$var$_interopRequireDefault((parcelRequire("ay9aj")));
    function $6b5f676fd444cc21$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $6b5f676fd444cc21$var$PersonAvatarIcon = (props)=>$6b5f676fd444cc21$var$_react.default.createElement($6b5f676fd444cc21$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 .75a7.25 7.25 0 1 0 0 14.5A7.25 7.25 0 0 0 8 .75Z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4.5 14.35v-.6a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v.6m-.75-7.85a2.75 2.75 0 1 1-5.5 0 2.75 2.75 0 0 1 5.5 0Z"/>`
        }, props));
    $6b5f676fd444cc21$var$PersonAvatarIcon.displayName = 'PersonAvatarIcon';
    var $6b5f676fd444cc21$var$_default = module.exports.default = $6b5f676fd444cc21$var$PersonAvatarIcon;
});
parcelRegister("lXVht", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ffdb8a6dddee8aab$var$_react = $ffdb8a6dddee8aab$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $ewCKl = parcelRequire("ewCKl");
    var $ffdb8a6dddee8aab$var$_premium = $ffdb8a6dddee8aab$var$_interopRequireDefault((parcelRequire("3Vzhu")));
    function $ffdb8a6dddee8aab$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ffdb8a6dddee8aab$var$PremiumIcon = (props)=>$ffdb8a6dddee8aab$var$_react.default.createElement($ewCKl.IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M9.276 4.382 7.357 9.247l-4.863 1.917a.78.78 0 0 0 0 1.45l4.863 1.918 1.919 4.863a.78.78 0 0 0 1.45 0h-.001l1.918-4.863 4.864-1.919a.781.781 0 0 0 0-1.45l-4.864-1.916-1.918-4.865a.78.78 0 0 0-.44-.438.78.78 0 0 0-1.01.438m8.297-2.03-.743 1.886-1.884.743a.56.56 0 0 0 0 1.038l1.884.743.743 1.886a.558.558 0 0 0 1.038 0l.745-1.886 1.883-.743a.557.557 0 0 0 0-1.038l-1.883-.743-.745-1.885a.55.55 0 0 0-.314-.314.56.56 0 0 0-.724.314m-.704 13.003-.744 1.883-1.883.744a.55.55 0 0 0-.316.314.56.56 0 0 0 .316.724l1.883.743.744 1.884c.057.144.17.258.314.315a.56.56 0 0 0 .724-.315l.744-1.884 1.883-.743a.557.557 0 0 0 0-1.038l-1.883-.744-.744-1.883a.55.55 0 0 0-.315-.316.56.56 0 0 0-.723.316"/></svg>`
        }, props, {
            newIcon: $ffdb8a6dddee8aab$var$_premium.default
        }));
    $ffdb8a6dddee8aab$var$PremiumIcon.displayName = 'PremiumIcon';
    var $ffdb8a6dddee8aab$var$_default = module.exports.default = $ffdb8a6dddee8aab$var$PremiumIcon;
});
parcelRegister("3Vzhu", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2dc21009e0a6ee04$var$_react = $2dc21009e0a6ee04$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $2dc21009e0a6ee04$var$_UNSAFE_baseNew = $2dc21009e0a6ee04$var$_interopRequireDefault((parcelRequire("ay9aj")));
    function $2dc21009e0a6ee04$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $2dc21009e0a6ee04$var$PremiumIcon = (props)=>$2dc21009e0a6ee04$var$_react.default.createElement($2dc21009e0a6ee04$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M11.5 13.75h2.25m0 0H16m-2.25 0V11.5m0 2.25V16M0 2.25h2.25m0 0H4.5m-2.25 0V0m0 2.25V4.5M8 1.75l1.75 4.5L14.25 8l-4.5 1.75L8 14.25l-1.75-4.5L1.75 8l4.5-1.75z"/>`
        }, props));
    $2dc21009e0a6ee04$var$PremiumIcon.displayName = 'PremiumIcon';
    var $2dc21009e0a6ee04$var$_default = module.exports.default = $2dc21009e0a6ee04$var$PremiumIcon;
});
parcelRegister("8F3fz", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $64e4ac77e3febb71$var$_react = $64e4ac77e3febb71$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $ewCKl = parcelRequire("ewCKl");
    var $64e4ac77e3febb71$var$_questionCircle = $64e4ac77e3febb71$var$_interopRequireDefault((parcelRequire("aruFE")));
    function $64e4ac77e3febb71$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $64e4ac77e3febb71$var$QuestionCircleIcon = (props)=>$64e4ac77e3febb71$var$_react.default.createElement($ewCKl.IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><circle cx="12" cy="18" r="1" fill="inherit"/><path fill="inherit" d="M15.89 9.05a3.98 3.98 0 0 0-2.957-2.942C10.321 5.514 8.017 7.446 8 9.95l.005.147a.99.99 0 0 0 .982.904c.552 0 1-.447 1.002-.998a2.004 2.004 0 0 1 4.007-.002c0 1.102-.898 2-2.003 2H12a1 1 0 0 0-1 .987v2.014a1.001 1.001 0 0 0 2.004 0v-.782c0-.217.145-.399.35-.472A3.99 3.99 0 0 0 15.89 9.05"/></g></svg>`
        }, props, {
            newIcon: $64e4ac77e3febb71$var$_questionCircle.default
        }));
    $64e4ac77e3febb71$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
    var $64e4ac77e3febb71$var$_default = module.exports.default = $64e4ac77e3febb71$var$QuestionCircleIcon;
});
parcelRegister("aruFE", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $79a437942df49fe5$var$_react = $79a437942df49fe5$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $79a437942df49fe5$var$_UNSAFE_baseNew = $79a437942df49fe5$var$_interopRequireDefault((parcelRequire("ay9aj")));
    function $79a437942df49fe5$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $79a437942df49fe5$var$QuestionCircleIcon = (props)=>$79a437942df49fe5$var$_react.default.createElement($79a437942df49fe5$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.25 6C6.25 5 7 4.25 8 4.25S9.75 5 9.75 6C9.75 7.5 8 7.5 8 8.75v.75M15.25 8A7.25 7.25 0 1 1 .75 8a7.25 7.25 0 0 1 14.5 0Z"/><path fill="currentcolor" d="M9 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
        }, props));
    $79a437942df49fe5$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
    var $79a437942df49fe5$var$_default = module.exports.default = $79a437942df49fe5$var$QuestionCircleIcon;
});
parcelRegister("hDv8G", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $cd6e3bc2906caa0d$var$_react = $cd6e3bc2906caa0d$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $ewCKl = parcelRequire("ewCKl");
    var $cd6e3bc2906caa0d$var$_clock = $cd6e3bc2906caa0d$var$_interopRequireDefault((parcelRequire("9uiJD")));
    function $cd6e3bc2906caa0d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $cd6e3bc2906caa0d$var$RecentIcon = (props)=>$cd6e3bc2906caa0d$var$_react.default.createElement($ewCKl.IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11 8.002v4.002c0 .28.116.53.301.712l2.47 2.47a1.003 1.003 0 0 0 1.414 0 1.003 1.003 0 0 0 0-1.415L13 11.586V6a1 1 0 0 0-2 0zM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10"/></svg>`
        }, props, {
            newIcon: $cd6e3bc2906caa0d$var$_clock.default
        }));
    $cd6e3bc2906caa0d$var$RecentIcon.displayName = 'RecentIcon';
    var $cd6e3bc2906caa0d$var$_default = module.exports.default = $cd6e3bc2906caa0d$var$RecentIcon;
});
parcelRegister("9uiJD", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $6e8572c88c7eee84$var$_react = $6e8572c88c7eee84$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $6e8572c88c7eee84$var$_UNSAFE_baseNew = $6e8572c88c7eee84$var$_interopRequireDefault((parcelRequire("ay9aj")));
    function $6e8572c88c7eee84$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $6e8572c88c7eee84$var$ClockIcon = (props)=>$6e8572c88c7eee84$var$_react.default.createElement($6e8572c88c7eee84$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M8 3.25V8l2.5 2m4.75-2A7.25 7.25 0 1 1 .75 8a7.25 7.25 0 0 1 14.5 0Z"/>`
        }, props));
    $6e8572c88c7eee84$var$ClockIcon.displayName = 'ClockIcon';
    var $6e8572c88c7eee84$var$_default = module.exports.default = $6e8572c88c7eee84$var$ClockIcon;
});
parcelRegister("1MXep", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $14d838456438cb75$var$_react = $14d838456438cb75$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $ewCKl = parcelRequire("ewCKl");
    var $14d838456438cb75$var$_screen = $14d838456438cb75$var$_interopRequireDefault((parcelRequire("k2wrN")));
    function $14d838456438cb75$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $14d838456438cb75$var$ScreenIcon = (props)=>$14d838456438cb75$var$_react.default.createElement($ewCKl.IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M3 6.009C3 4.899 3.893 4 4.995 4h14.01C20.107 4 21 4.902 21 6.009v7.982c0 1.11-.893 2.009-1.995 2.009H4.995A2.004 2.004 0 0 1 3 13.991zM5 14h14V6H5z"/><path d="M10 17h4v3h-4zm-1 3.5a.5.5 0 0 1 .49-.5h5.02a.5.5 0 0 1 .49.5v.5H9z"/></g></svg>`
        }, props, {
            newIcon: $14d838456438cb75$var$_screen.default
        }));
    $14d838456438cb75$var$ScreenIcon.displayName = 'ScreenIcon';
    var $14d838456438cb75$var$_default = module.exports.default = $14d838456438cb75$var$ScreenIcon;
});
parcelRegister("k2wrN", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $e96d29e4c2de0ea6$var$_react = $e96d29e4c2de0ea6$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $e96d29e4c2de0ea6$var$_UNSAFE_baseNew = $e96d29e4c2de0ea6$var$_interopRequireDefault((parcelRequire("ay9aj")));
    function $e96d29e4c2de0ea6$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $e96d29e4c2de0ea6$var$ScreenIcon = (props)=>$e96d29e4c2de0ea6$var$_react.default.createElement($e96d29e4c2de0ea6$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 11.25h5c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v7c0 .69.56 1.25 1.25 1.25zm0 0v3m0 0h4m-4 0H4"/>`
        }, props));
    $e96d29e4c2de0ea6$var$ScreenIcon.displayName = 'ScreenIcon';
    var $e96d29e4c2de0ea6$var$_default = module.exports.default = $e96d29e4c2de0ea6$var$ScreenIcon;
});
parcelRegister("2wRVM", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $1d786779c7cc308f$var$_react = $1d786779c7cc308f$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $ewCKl = parcelRequire("ewCKl");
    var $1d786779c7cc308f$var$_search = $1d786779c7cc308f$var$_interopRequireDefault((parcelRequire("cDj3C")));
    function $1d786779c7cc308f$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1d786779c7cc308f$var$SearchIcon = (props)=>$1d786779c7cc308f$var$_react.default.createElement($ewCKl.IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m16.436 15.085 3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406M10.5 16a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11"/></svg>`
        }, props, {
            newIcon: $1d786779c7cc308f$var$_search.default
        }));
    $1d786779c7cc308f$var$SearchIcon.displayName = 'SearchIcon';
    var $1d786779c7cc308f$var$_default = module.exports.default = $1d786779c7cc308f$var$SearchIcon;
});
parcelRegister("cDj3C", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $9327e8f5b58b2cae$var$_react = $9327e8f5b58b2cae$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $9327e8f5b58b2cae$var$_UNSAFE_baseNew = $9327e8f5b58b2cae$var$_interopRequireDefault((parcelRequire("ay9aj")));
    function $9327e8f5b58b2cae$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $9327e8f5b58b2cae$var$SearchIcon = (props)=>$9327e8f5b58b2cae$var$_react.default.createElement($9327e8f5b58b2cae$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m14.5 14.5-3.788-3.788m0 0a5.25 5.25 0 1 0-7.425-7.425 5.25 5.25 0 0 0 7.425 7.425Z"/>`
        }, props));
    $9327e8f5b58b2cae$var$SearchIcon.displayName = 'SearchIcon';
    var $9327e8f5b58b2cae$var$_default = module.exports.default = $9327e8f5b58b2cae$var$SearchIcon;
});
parcelRegister("iu60k", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $d74fafa9e3c3d3e3$var$_react = $d74fafa9e3c3d3e3$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $ewCKl = parcelRequire("ewCKl");
    var $d74fafa9e3c3d3e3$var$_settings = $d74fafa9e3c3d3e3$var$_interopRequireDefault((parcelRequire("6BgCA")));
    function $d74fafa9e3c3d3e3$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $d74fafa9e3c3d3e3$var$SettingsIcon = (props)=>$d74fafa9e3c3d3e3$var$_react.default.createElement($ewCKl.IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.701 16.7a5.002 5.002 0 1 1 0-10.003 5.002 5.002 0 0 1 0 10.004m8.368-3.117a1.995 1.995 0 0 1-1.346-1.885c0-.876.563-1.613 1.345-1.885a.48.48 0 0 0 .315-.574 9 9 0 0 0-.836-1.993.48.48 0 0 0-.598-.195 2.04 2.04 0 0 1-1.29.08 1.99 1.99 0 0 1-1.404-1.395 2.04 2.04 0 0 1 .076-1.297.48.48 0 0 0-.196-.597 9 9 0 0 0-1.975-.826.48.48 0 0 0-.574.314 1.995 1.995 0 0 1-1.885 1.346 1.99 1.99 0 0 1-1.884-1.345.48.48 0 0 0-.575-.315c-.708.2-1.379.485-2.004.842a.47.47 0 0 0-.198.582A2.002 2.002 0 0 1 4.445 7.06a.48.48 0 0 0-.595.196 9 9 0 0 0-.833 1.994.48.48 0 0 0 .308.572 1.995 1.995 0 0 1 1.323 1.877c0 .867-.552 1.599-1.324 1.877a.48.48 0 0 0-.308.57 9 9 0 0 0 .723 1.79.477.477 0 0 0 .624.194c.595-.273 1.343-.264 2.104.238.117.077.225.185.302.3.527.8.512 1.58.198 2.188a.473.473 0 0 0 .168.628 9 9 0 0 0 2.11.897.474.474 0 0 0 .57-.313 1.995 1.995 0 0 1 1.886-1.353c.878 0 1.618.567 1.887 1.353a.475.475 0 0 0 .57.313 9 9 0 0 0 2.084-.883.473.473 0 0 0 .167-.631c-.318-.608-.337-1.393.191-2.195.077-.116.185-.225.302-.302.772-.511 1.527-.513 2.125-.23a.477.477 0 0 0 .628-.19 9 9 0 0 0 .728-1.793.48.48 0 0 0-.314-.573"/></svg>`
        }, props, {
            newIcon: $d74fafa9e3c3d3e3$var$_settings.default
        }));
    $d74fafa9e3c3d3e3$var$SettingsIcon.displayName = 'SettingsIcon';
    var $d74fafa9e3c3d3e3$var$_default = module.exports.default = $d74fafa9e3c3d3e3$var$SettingsIcon;
});
parcelRegister("6BgCA", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $4ce317740f2acba5$var$_react = $4ce317740f2acba5$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $4ce317740f2acba5$var$_UNSAFE_baseNew = $4ce317740f2acba5$var$_interopRequireDefault((parcelRequire("ay9aj")));
    function $4ce317740f2acba5$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $4ce317740f2acba5$var$SettingsIcon = (props)=>$4ce317740f2acba5$var$_react.default.createElement($4ce317740f2acba5$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.75.75 5.687 3.302a.625.625 0 0 1-.667.378l-2.674-.388-1.25 2.166L2.72 7.625a.625.625 0 0 1 0 .75l-1.624 2.168 1.25 2.165 2.674-.388a.625.625 0 0 1 .667.378L6.75 15.25h2.5l1.063-2.552a.625.625 0 0 1 .667-.378l2.674.388 1.25-2.165-1.623-2.168a.625.625 0 0 1 0-.75l1.623-2.167-1.25-2.166-2.674.388a.625.625 0 0 1-.667-.378L9.25.75z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.25 8a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"/>`
        }, props));
    $4ce317740f2acba5$var$SettingsIcon.displayName = 'SettingsIcon';
    var $4ce317740f2acba5$var$_default = module.exports.default = $4ce317740f2acba5$var$SettingsIcon;
});
parcelRegister("gQM0s", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c446bdb7079576c5$var$_react = $c446bdb7079576c5$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $ewCKl = parcelRequire("ewCKl");
    var $c446bdb7079576c5$var$_release = $c446bdb7079576c5$var$_interopRequireDefault((parcelRequire("20pgu")));
    function $c446bdb7079576c5$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c446bdb7079576c5$var$ShipIcon = (props)=>$c446bdb7079576c5$var$_react.default.createElement($ewCKl.IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 12h8v-2H6zM4 8.99C4 8.445 4.456 8 5.002 8h9.996C15.55 8 16 8.451 16 8.99V14H4z"/><path d="M6 7.005C6 5.898 6.898 5 7.998 5h2.004C11.106 5 12 5.894 12 7.005V10H6zm4 0V7H7.999c.005 0 .002.003.002.005V8h2z"/><path fill-rule="nonzero" d="M4.5 17h13.994l1.002-3H4.14zm-2.495-4.012A.862.862 0 0 1 2.883 12h18.393c.55 0 .857.417.681.944l-1.707 5.112c-.174.521-.758.944-1.315.944H3.725a1.15 1.15 0 0 1-1.118-.988z"/></g></svg>`
        }, props, {
            newIcon: $c446bdb7079576c5$var$_release.default
        }));
    $c446bdb7079576c5$var$ShipIcon.displayName = 'ShipIcon';
    var $c446bdb7079576c5$var$_default = module.exports.default = $c446bdb7079576c5$var$ShipIcon;
});
parcelRegister("20pgu", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $175f2df99609ec9b$var$_react = $175f2df99609ec9b$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $175f2df99609ec9b$var$_UNSAFE_baseNew = $175f2df99609ec9b$var$_interopRequireDefault((parcelRequire("ay9aj")));
    function $175f2df99609ec9b$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $175f2df99609ec9b$var$ReleaseIcon = (props)=>$175f2df99609ec9b$var$_react.default.createElement($175f2df99609ec9b$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" d="M.75 7.75V7a.75.75 0 0 0-.75.75zm14.5 0 .646.382A.75.75 0 0 0 15.25 7zm-12.5-3V4a.75.75 0 0 0-.75.75zm6.25 0 .648-.378A.75.75 0 0 0 9 4zm-4.25-2V2H4v.75zm1.5 0H7V2h-.75zm6.113 9.886.646.382zm2.241-5.268-2.887 4.886 1.292.764 2.887-4.886zM11.287 12.5H2V14h9.287zM1.5 12V7.75H0V12zM.75 8.5h2V7h-2zm2.75-.75v-3H2v3zm-.75.75h8V7h-8zm8 0h4.5V7h-4.5zM8.352 5.128l1.75 3 1.296-.756-1.75-3zM2.75 5.5h2V4h-2zm2.75-.75v-2H4v2zM4.75 3.5h1.5V2h-1.5zm0 2h1.5V4h-1.5zm1.5 0H9V4H6.25zM5.5 2.75v2H7v-2zM2 12.5a.5.5 0 0 1-.5-.5H0a2 2 0 0 0 2 2zm9.717-.246a.5.5 0 0 1-.43.246V14a2 2 0 0 0 1.722-.982z"/>`
        }, props));
    $175f2df99609ec9b$var$ReleaseIcon.displayName = 'ReleaseIcon';
    var $175f2df99609ec9b$var$_default = module.exports.default = $175f2df99609ec9b$var$ReleaseIcon;
});
parcelRegister("beysv", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $82dbbb4bb30bd572$var$_react = $82dbbb4bb30bd572$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $ewCKl = parcelRequire("ewCKl");
    var $82dbbb4bb30bd572$var$_linkExternal = $82dbbb4bb30bd572$var$_interopRequireDefault((parcelRequire("kRtpf")));
    function $82dbbb4bb30bd572$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $82dbbb4bb30bd572$var$ShortcutIcon = (props)=>$82dbbb4bb30bd572$var$_react.default.createElement($ewCKl.IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M5 19.01V19zM5 4.99V5zM19 19v-6h2v6a2 2 0 0 1-1.99 2H5a2 2 0 0 1-2-1.99V4.99C3 3.89 3.9 3 5 3h6v2H5v14zM5 4.99V5zM11 5H5v14h14v-6h2v6a2 2 0 0 1-1.99 2H5a2 2 0 0 1-2-1.99V4.99C3 3.89 3.9 3 5 3h6zm8 0v3a1 1 0 0 0 2 0V4a1 1 0 0 0-1-1h-4a1 1 0 0 0 0 2z"/><path d="m12.707 12.707 8-8a1 1 0 1 0-1.414-1.414l-8 8a1 1 0 0 0 1.414 1.414"/></g></svg>`
        }, props, {
            newIcon: $82dbbb4bb30bd572$var$_linkExternal.default
        }));
    $82dbbb4bb30bd572$var$ShortcutIcon.displayName = 'ShortcutIcon';
    var $82dbbb4bb30bd572$var$_default = module.exports.default = $82dbbb4bb30bd572$var$ShortcutIcon;
});
parcelRegister("kRtpf", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $f2ff915ec027295f$var$_react = $f2ff915ec027295f$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $f2ff915ec027295f$var$_UNSAFE_baseNew = $f2ff915ec027295f$var$_interopRequireDefault((parcelRequire("ay9aj")));
    function $f2ff915ec027295f$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $f2ff915ec027295f$var$LinkExternalIcon = (props)=>$f2ff915ec027295f$var$_react.default.createElement($f2ff915ec027295f$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6 1.75H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25v-3M7 9l6.75-6.75m.5 3.75V1.75H10"/>`
        }, props));
    $f2ff915ec027295f$var$LinkExternalIcon.displayName = 'LinkExternalIcon';
    var $f2ff915ec027295f$var$_default = module.exports.default = $f2ff915ec027295f$var$LinkExternalIcon;
});
parcelRegister("22abr", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $17b3aae41e571be7$var$_react = $17b3aae41e571be7$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $ewCKl = parcelRequire("ewCKl");
    var $17b3aae41e571be7$var$_logIn = $17b3aae41e571be7$var$_interopRequireDefault((parcelRequire("eV7hV")));
    function $17b3aae41e571be7$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $17b3aae41e571be7$var$SignInIcon = (props)=>$17b3aae41e571be7$var$_react.default.createElement($ewCKl.IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M15.503 3H12v2h7v14h-7v2h7.006c1.1 0 1.994-.893 1.994-1.995V4.995A1.993 1.993 0 0 0 19.006 3z"/><path d="M3.977 11A.99.99 0 0 0 3 12.001c0 .551.437.999.977.999h11.047a.99.99 0 0 0 .976-.999.99.99 0 0 0-.976-1.001z"/><path d="M12.303 8.305a1.053 1.053 0 0 0 0 1.478L14.5 12l-2.197 2.217a1.05 1.05 0 0 0 0 1.476c.404.409 1.06.409 1.465 0l2.93-2.955a1.055 1.055 0 0 0 0-1.477l-2.93-2.956a1.034 1.034 0 0 0-1.465 0"/></g></svg>`
        }, props, {
            newIcon: $17b3aae41e571be7$var$_logIn.default
        }));
    $17b3aae41e571be7$var$SignInIcon.displayName = 'SignInIcon';
    var $17b3aae41e571be7$var$_default = module.exports.default = $17b3aae41e571be7$var$SignInIcon;
});
parcelRegister("eV7hV", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $adcc0ad6e25225cf$var$_react = $adcc0ad6e25225cf$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $adcc0ad6e25225cf$var$_UNSAFE_baseNew = $adcc0ad6e25225cf$var$_interopRequireDefault((parcelRequire("ay9aj")));
    function $adcc0ad6e25225cf$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $adcc0ad6e25225cf$var$LogInIcon = (props)=>$adcc0ad6e25225cf$var$_react.default.createElement($adcc0ad6e25225cf$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 1.75h5c.69 0 1.25.56 1.25 1.25v10c0 .69-.56 1.25-1.25 1.25H8M5.75 4.5 9.25 8m0 0-3.5 3.5M9.25 8H1"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M5.75 4.5 9.25 8l-3.5 3.5"/>`
        }, props));
    $adcc0ad6e25225cf$var$LogInIcon.displayName = 'LogInIcon';
    var $adcc0ad6e25225cf$var$_default = module.exports.default = $adcc0ad6e25225cf$var$LogInIcon;
});
parcelRegister("7VV60", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $5c6a2556623d6eba$var$_react = $5c6a2556623d6eba$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $ewCKl = parcelRequire("ewCKl");
    var $5c6a2556623d6eba$var$_starUnstarred = $5c6a2556623d6eba$var$_interopRequireDefault((parcelRequire("hRfSp")));
    function $5c6a2556623d6eba$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $5c6a2556623d6eba$var$StarIcon = (props)=>$5c6a2556623d6eba$var$_react.default.createElement($ewCKl.IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="m12 16.373 3.98 2.193-.76-4.655 3.276-3.347-4.524-.69L12 5.687l-1.972 4.189-4.524.689L8.78 13.91l-.762 4.655zm0 2.283-3.016 1.662a2 2 0 0 1-2.939-2.075l.599-3.656-2.57-2.624a2 2 0 0 1 1.129-3.377l3.47-.528 1.518-3.224a2 2 0 0 1 3.618 0l1.519 3.224 3.47.528a2 2 0 0 1 1.127 3.377l-2.569 2.624.599 3.656a2 2 0 0 1-2.94 2.075z"/></svg>`
        }, props, {
            newIcon: $5c6a2556623d6eba$var$_starUnstarred.default
        }));
    $5c6a2556623d6eba$var$StarIcon.displayName = 'StarIcon';
    var $5c6a2556623d6eba$var$_default = module.exports.default = $5c6a2556623d6eba$var$StarIcon;
});
parcelRegister("hRfSp", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $d003b3a2ea9f2b31$var$_react = $d003b3a2ea9f2b31$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $d003b3a2ea9f2b31$var$_UNSAFE_baseNew = $d003b3a2ea9f2b31$var$_interopRequireDefault((parcelRequire("ay9aj")));
    function $d003b3a2ea9f2b31$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $d003b3a2ea9f2b31$var$StarUnstarredIcon = (props)=>$d003b3a2ea9f2b31$var$_react.default.createElement($d003b3a2ea9f2b31$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" d="m8 11.25.424-.618L8 10.34l-.424.29zm-4.375 3-.724-.194a.75.75 0 0 0 1.148.813zM5 9.125l.724.194.125-.463-.369-.307zM1.25 6l-.058-.748A.75.75 0 0 0 .77 6.576zm4.875-.375.058.748.472-.037.17-.442zM8 .75l.7-.27a.75.75 0 0 0-1.4 0zm1.875 4.875-.7.27.17.441.472.037zM14.75 6l.48.576a.75.75 0 0 0-.423-1.324zM11 9.125l-.48-.576-.369.307.125.463zm1.375 5.125-.424.619a.75.75 0 0 0 1.148-.813zm-4.8-3.618-4.374 3 .848 1.237 4.375-3zM4.35 14.444 5.724 9.32l-1.448-.388L2.9 14.056zM5.48 8.55 1.73 5.424.77 6.576l3.75 3.125zM1.308 6.748l4.875-.375-.116-1.496-4.875.375zm5.517-.854L8.7 1.02 7.3.481 5.425 5.356zM7.3 1.02l1.875 4.875 1.4-.538L8.7.48zm2.517 5.354 4.876.375.114-1.496-4.874-.375zm4.453-.95L10.52 8.55l.96 1.152 3.75-3.125zM10.276 9.32l1.375 5.125 1.448-.388-1.375-5.125zm2.523 4.313-4.375-3-.848 1.237 4.375 3z"/>`
        }, props));
    $d003b3a2ea9f2b31$var$StarUnstarredIcon.displayName = 'StarUnstarredIcon';
    var $d003b3a2ea9f2b31$var$_default = module.exports.default = $d003b3a2ea9f2b31$var$StarUnstarredIcon;
});
parcelRegister("218ob", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $17822eac412824da$var$_react = $17822eac412824da$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $ewCKl = parcelRequire("ewCKl");
    var $17822eac412824da$var$_starStarred = $17822eac412824da$var$_interopRequireDefault((parcelRequire("9dOOz")));
    function $17822eac412824da$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $17822eac412824da$var$StarFilledIcon = (props)=>$17822eac412824da$var$_react.default.createElement($ewCKl.IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m12.072 17.284-3.905 2.053a1 1 0 0 1-1.451-1.054l.745-4.349-3.159-3.08a1 1 0 0 1 .554-1.705l4.366-.635 1.953-3.956a1 1 0 0 1 1.794 0l1.952 3.956 4.366.635a1 1 0 0 1 .555 1.705l-3.16 3.08.746 4.349a1 1 0 0 1-1.45 1.054z"/></svg>`
        }, props, {
            newIcon: $17822eac412824da$var$_starStarred.default
        }));
    $17822eac412824da$var$StarFilledIcon.displayName = 'StarFilledIcon';
    var $17822eac412824da$var$_default = module.exports.default = $17822eac412824da$var$StarFilledIcon;
});
parcelRegister("9dOOz", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $6b6cbeab90be5d3b$var$_react = $6b6cbeab90be5d3b$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $6b6cbeab90be5d3b$var$_UNSAFE_baseNew = $6b6cbeab90be5d3b$var$_interopRequireDefault((parcelRequire("ay9aj")));
    function $6b6cbeab90be5d3b$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $6b6cbeab90be5d3b$var$StarStarredIcon = (props)=>$6b6cbeab90be5d3b$var$_react.default.createElement($6b6cbeab90be5d3b$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" d="m8 11.25-4.375 3L5 9.125 1.25 6l4.875-.375L8 .75l1.875 4.875L14.75 6 11 9.125l1.375 5.125z"/><path fill="currentcolor" d="m8 11.25.424-.618L8 10.34l-.424.29zm-4.375 3-.724-.194a.75.75 0 0 0 1.148.813zM5 9.125l.724.194.125-.463-.369-.307zM1.25 6l-.058-.748A.75.75 0 0 0 .77 6.576zm4.875-.375.058.748.472-.037.17-.442zM8 .75l.7-.27a.75.75 0 0 0-1.4 0zm1.875 4.875-.7.27.17.441.472.037zM14.75 6l.48.576a.75.75 0 0 0-.423-1.324zM11 9.125l-.48-.576-.369.307.125.463zm1.375 5.125-.424.618a.75.75 0 0 0 1.148-.812zm-4.8-3.618-4.374 3 .848 1.236 4.375-3zM4.35 14.444 5.724 9.32l-1.448-.388L2.9 14.056zM5.48 8.55 1.73 5.424.77 6.576l3.75 3.125zM1.308 6.748l4.875-.375-.116-1.496-4.875.375zm5.517-.854L8.7 1.02 7.3.481 5.425 5.356zM7.3 1.02l1.875 4.875 1.4-.538L8.7.48zm2.517 5.354 4.876.375.114-1.496-4.874-.375zm4.453-.95L10.52 8.55l.96 1.152 3.75-3.125zM10.276 9.32l1.375 5.125 1.448-.388-1.375-5.125zm2.523 4.313-4.375-3-.848 1.236 4.375 3z"/>`
        }, props));
    $6b6cbeab90be5d3b$var$StarStarredIcon.displayName = 'StarStarredIcon';
    var $6b6cbeab90be5d3b$var$_default = module.exports.default = $6b6cbeab90be5d3b$var$StarStarredIcon;
});
parcelRegister("8xfk8", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $636d4ac03e73a52d$var$_react = $636d4ac03e73a52d$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $ewCKl = parcelRequire("ewCKl");
    var $636d4ac03e73a52d$var$_personAvatar = $636d4ac03e73a52d$var$_interopRequireDefault((parcelRequire("9dxCg")));
    function $636d4ac03e73a52d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $636d4ac03e73a52d$var$UserAvatarCircleIcon = (props)=>$636d4ac03e73a52d$var$_react.default.createElement($ewCKl.IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><circle cx="12" cy="9" r="3" fill="inherit"/><path fill="inherit" fill-rule="nonzero" d="M7 18.245A7.97 7.97 0 0 0 12 20c1.892 0 3.63-.657 5-1.755V15c0-1.115-.895-2-2-2H9c-1.113 0-2 .895-2 2z"/></g></svg>`
        }, props, {
            newIcon: $636d4ac03e73a52d$var$_personAvatar.default
        }));
    $636d4ac03e73a52d$var$UserAvatarCircleIcon.displayName = 'UserAvatarCircleIcon';
    var $636d4ac03e73a52d$var$_default = module.exports.default = $636d4ac03e73a52d$var$UserAvatarCircleIcon;
});
parcelRegister("g9jff", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $bc1c6a44ebf23164$var$_react = $bc1c6a44ebf23164$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $ewCKl = parcelRequire("ewCKl");
    var $bc1c6a44ebf23164$var$_warning = $bc1c6a44ebf23164$var$_interopRequireDefault((parcelRequire("dhjSs")));
    function $bc1c6a44ebf23164$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $bc1c6a44ebf23164$var$WarningIcon = (props)=>$bc1c6a44ebf23164$var$_react.default.createElement($ewCKl.IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771z"/><path fill="inherit" d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
        }, props, {
            newIcon: $bc1c6a44ebf23164$var$_warning.default
        }));
    $bc1c6a44ebf23164$var$WarningIcon.displayName = 'WarningIcon';
    var $bc1c6a44ebf23164$var$_default = module.exports.default = $bc1c6a44ebf23164$var$WarningIcon;
});
parcelRegister("dhjSs", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $9aac481a33039ef4$var$_react = $9aac481a33039ef4$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $9aac481a33039ef4$var$_UNSAFE_baseNew = $9aac481a33039ef4$var$_interopRequireDefault((parcelRequire("ay9aj")));
    function $9aac481a33039ef4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $9aac481a33039ef4$var$WarningIcon = (props)=>$9aac481a33039ef4$var$_react.default.createElement($9aac481a33039ef4$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.757-1.395 2.76-1.395 3.516 0l5.9 10.878C16.381 13.38 15.416 15 13.9 15H2.1C.584 15-.38 13.38.342 12.047zM7.25 9.5v-5h1.5v5zM8 12.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
        }, props));
    $9aac481a33039ef4$var$WarningIcon.displayName = 'WarningIcon';
    var $9aac481a33039ef4$var$_default = module.exports.default = $9aac481a33039ef4$var$WarningIcon;
});
parcelRegister("f5sRC", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$8061a917f4d0eea2$export$2e2bcd8739ae039);
    parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $5VAfc = parcelRequire("5VAfc");
    var $a3dKr = parcelRequire("a3dKr");
    const $8061a917f4d0eea2$var$headerStyles = (0, $byn9U.css)({
        display: 'flex',
        position: 'relative',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBlockEnd: -(0, $a3dKr.keylineHeight),
        paddingBlockEnd: "var(--ds-space-200, 16px)",
        paddingBlockStart: "var(--ds-space-300, 24px)",
        paddingInline: "var(--ds-space-300, 24px)"
    });
    const $8061a917f4d0eea2$var$ModalHeader = (props)=>{
        const { children: children, testId: userDefinedTestId } = props;
        const { testId: modalTestId } = (0, $5VAfc.useModal)();
        const testId = userDefinedTestId || modalTestId && `${modalTestId}--header`;
        return (0, $byn9U.jsx)("div", {
            css: $8061a917f4d0eea2$var$headerStyles,
            "data-testid": testId
        }, children);
    };
    var $8061a917f4d0eea2$export$2e2bcd8739ae039 = $8061a917f4d0eea2$var$ModalHeader;
});
parcelRegister("5VAfc", function(module, exports) {
    $parcel$export(module.exports, "useModal", ()=>$dc78453b7119b626$export$33ffd74ebf07f060);
    var $eUqFw = parcelRequire("eUqFw");
    var $791jD = parcelRequire("791jD");
    const $dc78453b7119b626$export$33ffd74ebf07f060 = ()=>{
        const modalContext = (0, $eUqFw.useContext)((0, $791jD.ModalContext));
        if (modalContext == null) throw Error("@atlaskit/modal-dialog: Modal context unavailable \u2013 this component needs to be a child of ModalDialog.");
        return modalContext;
    };
});
parcelRegister("791jD", function(module, exports) {
    $parcel$export(module.exports, "ModalContext", ()=>$264b93b96c79e3a6$export$ab57792b9b6974a6);
    $parcel$export(module.exports, "ScrollContext", ()=>$264b93b96c79e3a6$export$dece24112a937f92);
    var $eUqFw = parcelRequire("eUqFw");
    const $264b93b96c79e3a6$export$ab57792b9b6974a6 = (0, $eUqFw.createContext)(null);
    const $264b93b96c79e3a6$export$dece24112a937f92 = (0, $eUqFw.createContext)(null);
});
parcelRegister("a3dKr", function(module, exports) {
    $parcel$export(module.exports, "width", ()=>$12c492be9db3ed2e$export$7e3df82ee760448c);
    $parcel$export(module.exports, "gutter", ()=>$12c492be9db3ed2e$export$f2b922cb4a245974);
    $parcel$export(module.exports, "borderRadius", ()=>$12c492be9db3ed2e$export$7a57f79000377ca2);
    $parcel$export(module.exports, "verticalOffset", ()=>$12c492be9db3ed2e$export$9212741279b5f103);
    $parcel$export(module.exports, "keylineHeight", ()=>$12c492be9db3ed2e$export$4c317248f944c2a9);
    $parcel$export(module.exports, "keylineColor", ()=>$12c492be9db3ed2e$export$d901150a4cc83165);
    $parcel$export(module.exports, "textColor", ()=>$12c492be9db3ed2e$export$32f78bffcd82ff28);
    $parcel$export(module.exports, "iconColor", ()=>$12c492be9db3ed2e$export$3797a580396e3639);
    var $h04Oa = parcelRequire("h04Oa");
    const $12c492be9db3ed2e$export$7e3df82ee760448c = {
        values: [
            'small',
            'medium',
            'large',
            'x-large'
        ],
        widths: {
            small: 400,
            medium: 600,
            large: 800,
            'x-large': 968
        },
        defaultValue: 'medium'
    };
    const $12c492be9db3ed2e$export$f2b922cb4a245974 = 60;
    const $12c492be9db3ed2e$var$gridSize = (0, $h04Oa.gridSize)();
    const $12c492be9db3ed2e$export$7a57f79000377ca2 = (0, $h04Oa.borderRadius)();
    const $12c492be9db3ed2e$export$9212741279b5f103 = $12c492be9db3ed2e$var$gridSize * 2;
    const $12c492be9db3ed2e$export$4c317248f944c2a9 = 2;
    const $12c492be9db3ed2e$export$d901150a4cc83165 = `var(--ds-border, ${(0, $207acf722dcd432b$export$3e51e8f1440314ba)})`;
    const $12c492be9db3ed2e$export$32f78bffcd82ff28 = `var(--ds-text, ${(0, $207acf722dcd432b$export$fbda843f0a27fe96)})`;
    const $12c492be9db3ed2e$export$3797a580396e3639 = {
        danger: `var(--ds-icon-danger, ${(0, $207acf722dcd432b$export$2010d0fb4295b346)})`,
        warning: "var(--ds-icon-warning, #D97008)"
    };
});
parcelRegister("f8NQh", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$afb5dfc52e935488$export$2e2bcd8739ae039);
    var $byn9U = parcelRequire("byn9U");
    var $14miB = parcelRequire("14miB");
    var $fDwW4 = parcelRequire("fDwW4");
    var $5VAfc = parcelRequire("5VAfc");
    var $a3dKr = parcelRequire("a3dKr");
    function $afb5dfc52e935488$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $afb5dfc52e935488$var$titleStyles = {
        name: "1yaejj3",
        styles: "display:flex;min-width:0;margin:var(--ds-space-0, 0px);gap:var(--ds-space-100, 8px);font:var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    };
    const $afb5dfc52e935488$var$textStyles = {
        name: "1k30s2j",
        styles: "min-width:0;flex:1 1 auto;word-wrap:break-word"
    };
    const $afb5dfc52e935488$var$iconStyles = {
        name: "1cdsq8b",
        styles: "flex:0 0 auto;color:inherit;font-size:inherit;font-style:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit"
    };
    const $afb5dfc52e935488$var$truncatedTextStyles = {
        name: "1h52dri",
        styles: "overflow:hidden;text-overflow:ellipsis;white-space:nowrap"
    };
    const $afb5dfc52e935488$var$TitleIcon = ({ appearance: appearance })=>{
        const Icon = appearance === 'danger' ? (0, ($parcel$interopDefault($14miB))) : (0, ($parcel$interopDefault($fDwW4)));
        return (0, $byn9U.jsx)("span", {
            css: $afb5dfc52e935488$var$iconStyles
        }, (0, $byn9U.jsx)(Icon, {
            label: appearance,
            color: (0, $a3dKr.iconColor)[appearance],
            spacing: "spacious"
        }));
    };
    const $afb5dfc52e935488$var$ModalTitle = (props)=>{
        const { appearance: appearance, children: children, isMultiline: isMultiline = true, testId: userDefinedTestId } = props;
        const { titleId: titleId, testId: modalTestId } = (0, $5VAfc.useModal)();
        const testId = userDefinedTestId || modalTestId && `${modalTestId}--title`;
        return (0, $byn9U.jsx)("h1", {
            css: $afb5dfc52e935488$var$titleStyles,
            "data-testid": testId
        }, appearance && (0, $byn9U.jsx)($afb5dfc52e935488$var$TitleIcon, {
            appearance: appearance
        }), (0, $byn9U.jsx)("span", {
            id: titleId,
            css: [
                $afb5dfc52e935488$var$textStyles,
                !isMultiline && $afb5dfc52e935488$var$truncatedTextStyles
            ],
            "data-testid": testId && `${testId}-text`
        }, children));
    };
    var $afb5dfc52e935488$export$2e2bcd8739ae039 = $afb5dfc52e935488$var$ModalTitle;
});
parcelRegister("14miB", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $0c777648cfe4a62d$var$_react = $0c777648cfe4a62d$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $0c777648cfe4a62d$var$_error = $0c777648cfe4a62d$var$_interopRequireDefault((parcelRequire("1jDKU")));
    var $0c777648cfe4a62d$var$_error2 = $0c777648cfe4a62d$var$_interopRequireDefault((parcelRequire("hCaWp")));
    function $0c777648cfe4a62d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $0c777648cfe4a62d$var$ErrorIcon = (props)=>$0c777648cfe4a62d$var$_react.default.createElement($0c777648cfe4a62d$var$_error.default, Object.assign({
            LEGACY_fallbackIcon: $0c777648cfe4a62d$var$_error2.default
        }, props));
    $0c777648cfe4a62d$var$ErrorIcon.Name = 'ErrorIconMigration';
    var $0c777648cfe4a62d$var$_default = module.exports.default = $0c777648cfe4a62d$var$ErrorIcon;
});
parcelRegister("fDwW4", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $b6240bd82f57940e$var$_react = $b6240bd82f57940e$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $b6240bd82f57940e$var$_warning = $b6240bd82f57940e$var$_interopRequireDefault((parcelRequire("dhjSs")));
    var $b6240bd82f57940e$var$_warning2 = $b6240bd82f57940e$var$_interopRequireDefault((parcelRequire("g9jff")));
    function $b6240bd82f57940e$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $b6240bd82f57940e$var$WarningIcon = (props)=>$b6240bd82f57940e$var$_react.default.createElement($b6240bd82f57940e$var$_warning.default, Object.assign({
            LEGACY_fallbackIcon: $b6240bd82f57940e$var$_warning2.default
        }, props));
    $b6240bd82f57940e$var$WarningIcon.Name = 'WarningIconMigration';
    var $b6240bd82f57940e$var$_default = module.exports.default = $b6240bd82f57940e$var$WarningIcon;
});
parcelRegister("75GCb", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$a5a6b5b0a22c318d$export$2e2bcd8739ae039);
    parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $8MHxr = parcelRequire("8MHxr");
    var $5VAfc = parcelRequire("5VAfc");
    var $efH1F = parcelRequire("efH1F");
    var $a3dKr = parcelRequire("a3dKr");
    var $e8X75 = parcelRequire("e8X75");
    function $a5a6b5b0a22c318d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $a5a6b5b0a22c318d$var$bodyStyles = {
        name: "mkkf9p",
        styles: "flex:1 1 auto"
    };
    const $a5a6b5b0a22c318d$var$bodyScrollStyles = (0, $byn9U.css)({
        paddingBlock: (0, $a3dKr.keylineHeight),
        paddingInline: "var(--ds-space-300, 24px)"
    });
    const $a5a6b5b0a22c318d$var$viewportScrollStyles = {
        name: "1g6ejo8",
        styles: "padding-inline:var(--ds-space-300, 24px)"
    };
    const $a5a6b5b0a22c318d$var$ModalBody = (props)=>{
        const { children: children, testId: userDefinedTestId } = props;
        const { testId: modalTestId } = (0, $5VAfc.useModal)();
        const shouldScrollInViewport = (0, $e8X75.default)();
        const testId = userDefinedTestId || modalTestId && `${modalTestId}--body`;
        return shouldScrollInViewport ? (0, $byn9U.jsx)("div", {
            css: [
                $a5a6b5b0a22c318d$var$bodyStyles,
                $a5a6b5b0a22c318d$var$viewportScrollStyles
            ],
            "data-testid": testId
        }, children) : (0, $byn9U.jsx)((0, $8MHxr.TouchScrollable), null, (0, $byn9U.jsx)((0, $efH1F.default), {
            testId: userDefinedTestId || modalTestId
        }, (0, $byn9U.jsx)("div", {
            css: [
                $a5a6b5b0a22c318d$var$bodyStyles,
                $a5a6b5b0a22c318d$var$bodyScrollStyles
            ],
            "data-testid": testId
        }, children)));
    };
    var $a5a6b5b0a22c318d$export$2e2bcd8739ae039 = $a5a6b5b0a22c318d$var$ModalBody;
});
parcelRegister("efH1F", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0a96ae24151bb168$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $74BVL = parcelRequire("74BVL");
    var $8yx6O = parcelRequire("8yx6O");
    var $9xS6A = parcelRequire("9xS6A");
    var $4oSDA = parcelRequire("4oSDA");
    var $dAXH1 = parcelRequire("dAXH1");
    var $gVxCl = parcelRequire("gVxCl");
    var $jcsHn = parcelRequire("jcsHn");
    var $jijTN = parcelRequire("jijTN");
    var $a3dKr = parcelRequire("a3dKr");
    const $0a96ae24151bb168$var$baseStyles = (0, $byn9U.css)({
        display: 'inherit',
        margin: "var(--ds-space-0, 0px)",
        flex: 'inherit',
        flexDirection: 'inherit',
        flexGrow: 1,
        overflowX: 'hidden',
        overflowY: 'auto',
        [(0, $jijTN.media).above.xs]: {
            height: 'unset',
            overflowY: 'auto'
        }
    });
    const $0a96ae24151bb168$var$topKeylineStyles = (0, $byn9U.css)({
        borderBlockStart: `${(0, $a3dKr.keylineHeight)}px solid ${(0, $a3dKr.keylineColor)}`
    });
    const $0a96ae24151bb168$var$bottomKeylineStyles = (0, $byn9U.css)({
        borderBlockEnd: `${(0, $a3dKr.keylineHeight)}px solid ${(0, $a3dKr.keylineColor)}`
    });
    const $0a96ae24151bb168$var$ScrollContainer = (0, $eUqFw.forwardRef)((props, ref)=>{
        const { testId: testId, children: children } = props;
        const [hasSiblings, setSiblings] = (0, $gVxCl.default)({
            previous: false,
            next: false
        });
        const [showContentFocus, setContentFocus] = (0, $eUqFw.useState)(false);
        const [showTopKeyline, setTopKeyline] = (0, $eUqFw.useState)(false);
        const [showBottomKeyline, setBottomKeyline] = (0, $eUqFw.useState)(false);
        const scrollableRef = (0, $eUqFw.useRef)(null);
        const setLazySiblings = (0, $dAXH1.default)(setSiblings);
        const setLazyContentFocus = (0, $dAXH1.default)((0, $8yx6O.default)(()=>{
            const target = scrollableRef.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        }));
        const setLazyKeylines = (0, $dAXH1.default)((0, $8yx6O.default)(()=>{
            const target = scrollableRef.current;
            if (target) {
                const scrollableDistance = target.scrollHeight - target.clientHeight;
                if (hasSiblings.current.previous) setTopKeyline(target.scrollTop > (0, $a3dKr.keylineHeight));
                if (hasSiblings.current.next) setBottomKeyline(target.scrollTop <= scrollableDistance - (0, $a3dKr.keylineHeight));
            }
        }));
        (0, $eUqFw.useEffect)(()=>{
            const target = scrollableRef.current;
            const unbindWindowEvent = (0, $74BVL.bind)(window, {
                type: 'resize',
                listener: setLazyKeylines
            });
            const unbindTargetEvent = target ? (0, $74BVL.bind)(target, {
                type: 'scroll',
                listener: setLazyKeylines
            }) : (0, $4oSDA.default);
            setLazyContentFocus();
            setLazyKeylines();
            setLazySiblings({
                previous: Boolean(target?.previousElementSibling),
                next: Boolean(target?.nextElementSibling)
            });
            return ()=>{
                unbindWindowEvent();
                unbindTargetEvent();
            };
        }, [
            setLazyContentFocus,
            setLazyKeylines,
            setLazySiblings
        ]);
        return (0, $byn9U.jsx)((0, $jcsHn.default), {
            isInset: true
        }, (0, $byn9U.jsx)("div", {
            tabIndex: showContentFocus ? 0 : undefined,
            role: showContentFocus ? 'region' : undefined,
            "aria-label": showContentFocus ? 'Scrollable content' : undefined,
            "data-testid": testId && `${testId}--scrollable`,
            ref: (0, $9xS6A.default)([
                ref,
                scrollableRef
            ]),
            css: [
                $0a96ae24151bb168$var$baseStyles,
                showTopKeyline && $0a96ae24151bb168$var$topKeylineStyles,
                showBottomKeyline && $0a96ae24151bb168$var$bottomKeylineStyles
            ]
        }, children));
    });
    $0a96ae24151bb168$var$ScrollContainer.displayName = 'ScrollContainer';
    var $0a96ae24151bb168$export$2e2bcd8739ae039 = $0a96ae24151bb168$var$ScrollContainer;
});
parcelRegister("9xS6A", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0b95759247e54771$export$2e2bcd8739ae039);
    function $0b95759247e54771$export$2e2bcd8739ae039(refs) {
        return (value)=>{
            refs.forEach((ref)=>{
                if (typeof ref === 'function') ref(value);
                else if (ref !== null) ref.current = value;
            });
        };
    }
});
parcelRegister("dAXH1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$86ddd19c941d154c$export$2e2bcd8739ae039);
    var $k9b79 = parcelRequire("k9b79");
    function $86ddd19c941d154c$export$2e2bcd8739ae039(callback) {
        const ref = (0, $k9b79.default)(()=>callback);
        return ref.current;
    }
});
parcelRegister("k9b79", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$40c2e24e351138b8$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    const $40c2e24e351138b8$var$uniqueReferencedValue = {};
    function $40c2e24e351138b8$export$2e2bcd8739ae039(initializer) {
        const ref = (0, $eUqFw.useRef)($40c2e24e351138b8$var$uniqueReferencedValue);
        if (ref.current === $40c2e24e351138b8$var$uniqueReferencedValue) ref.current = initializer();
        return ref;
    }
});
parcelRegister("gVxCl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$41a617b02088471c$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    function $41a617b02088471c$export$2e2bcd8739ae039(initialState) {
        const [value, setValue] = (0, $eUqFw.useState)(initialState);
        const valueRef = (0, $eUqFw.useRef)(value);
        valueRef.current = value;
        return [
            valueRef,
            setValue
        ];
    }
});
parcelRegister("jijTN", function(module, exports) {
    $parcel$export(module.exports, "media", ()=>$798572e568033fa8$export$987d49ffe1b0900f);
    $parcel$export(module.exports, "UNSAFE_media", ()=>$798572e568033fa8$export$c881183ca713c214);
    const $798572e568033fa8$export$987d49ffe1b0900f = {
        above: {
            xxs: '@media all',
            xs: '@media (min-width: 30rem)',
            sm: '@media (min-width: 48rem)',
            md: '@media (min-width: 64rem)',
            lg: '@media (min-width: 90rem)',
            xl: '@media (min-width: 110.5rem)'
        },
        only: {
            xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
            xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
            sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
            md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
            lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
            xl: '@media (min-width: 110.5rem)'
        },
        below: {
            xs: '@media not all and (min-width: 30rem)',
            sm: '@media not all and (min-width: 48rem)',
            md: '@media not all and (min-width: 64rem)',
            lg: '@media not all and (min-width: 90rem)',
            xl: '@media not all and (min-width: 110.5rem)'
        }
    };
    const $798572e568033fa8$export$c881183ca713c214 = $798572e568033fa8$export$987d49ffe1b0900f;
});
parcelRegister("e8X75", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$52f5bc0c1af2ae8c$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $791jD = parcelRequire("791jD");
    function $52f5bc0c1af2ae8c$export$2e2bcd8739ae039() {
        const shouldScrollInViewport = (0, $eUqFw.useContext)((0, $791jD.ScrollContext));
        if (shouldScrollInViewport == null) throw Error("@atlaskit/modal-dialog: Scroll context unavailable \u2013 this component needs to be a child of ModalDialog.");
        return shouldScrollInViewport;
    }
});
parcelRegister("2EGkc", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$04dc36e84311a7da$export$2e2bcd8739ae039);
    var $byn9U = parcelRequire("byn9U");
    var $5VAfc = parcelRequire("5VAfc");
    var $a3dKr = parcelRequire("a3dKr");
    const $04dc36e84311a7da$var$footerStyles = (0, $byn9U.css)({
        display: 'flex',
        position: 'relative',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: "var(--ds-space-100, 8px)",
        marginBlockStart: -(0, $a3dKr.keylineHeight),
        paddingBlockEnd: "var(--ds-space-300, 24px)",
        paddingBlockStart: "var(--ds-space-200, 16px)",
        paddingInline: "var(--ds-space-300, 24px)"
    });
    const $04dc36e84311a7da$var$ModalFooter = (props)=>{
        const { children: children, testId: userDefinedTestId } = props;
        const { testId: modalTestId } = (0, $5VAfc.useModal)();
        const testId = userDefinedTestId || modalTestId && `${modalTestId}--footer`;
        return (0, $byn9U.jsx)("div", {
            css: $04dc36e84311a7da$var$footerStyles,
            "data-testid": testId
        }, children);
    };
    var $04dc36e84311a7da$export$2e2bcd8739ae039 = $04dc36e84311a7da$var$ModalFooter;
});
parcelRegister("cmipe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$027ae8750a46011f$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $74BVL = parcelRequire("74BVL");
    var $chfvj = parcelRequire("chfvj");
    var $4oSDA = parcelRequire("4oSDA");
    var $cho8R = parcelRequire("cho8R");
    var $bsJFv = parcelRequire("bsJFv");
    var $amx2g = parcelRequire("amx2g");
    var $3zwh8 = parcelRequire("3zwh8");
    var $gN8bb = parcelRequire("gN8bb");
    var $jLWxm = parcelRequire("jLWxm");
    var $4UBDE = parcelRequire("4UBDE");
    var $h04Oa = parcelRequire("h04Oa");
    var $kmtpF = parcelRequire("kmtpF");
    var $5mmZs = parcelRequire("5mmZs");
    var $ZNXT4 = parcelRequire("ZNXT4");
    var $ljFqD = parcelRequire("ljFqD");
    var $2CeSd = parcelRequire("2CeSd");
    const $027ae8750a46011f$var$tooltipZIndex = (0, $h04Oa.layers).tooltip();
    const $027ae8750a46011f$var$analyticsAttributes = {
        componentName: 'tooltip',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $027ae8750a46011f$var$invertedDirection = {
        top: 'bottom',
        bottom: 'top',
        left: 'right',
        right: 'left'
    };
    const $027ae8750a46011f$var$getDirectionFromPlacement = (placement)=>placement.split('-')[0];
    function $027ae8750a46011f$var$Tooltip({ children: children, position: position = 'bottom', mousePosition: mousePosition = 'bottom', content: content, truncate: truncate = false, component: Container = (0, $ljFqD.default), tag: TargetContainer = 'div', testId: testId, delay: delay = 300, onShow: onShow = (0, $4oSDA.default), onHide: onHide = (0, $4oSDA.default), hideTooltipOnClick: hideTooltipOnClick = false, hideTooltipOnMouseDown: hideTooltipOnMouseDown = false, analyticsContext: analyticsContext, strategy: strategy = 'fixed', ignoreTooltipPointerEvents: ignoreTooltipPointerEvents = false }) {
        const tooltipPosition = position === 'mouse' ? mousePosition : position;
        const onShowHandler = (0, $chfvj.usePlatformLeafSyntheticEventHandler)({
            fn: onShow,
            action: 'displayed',
            analyticsData: analyticsContext,
            ...$027ae8750a46011f$var$analyticsAttributes
        });
        const onHideHandler = (0, $chfvj.usePlatformLeafSyntheticEventHandler)({
            fn: onHide,
            action: 'hidden',
            analyticsData: analyticsContext,
            ...$027ae8750a46011f$var$analyticsAttributes
        });
        const apiRef = (0, $eUqFw.useRef)(null);
        const [state, setState] = (0, $eUqFw.useState)('hide');
        const targetRef = (0, $eUqFw.useRef)(null);
        const containerRef = (0, $eUqFw.useRef)(null);
        const setImplicitRefFromChildren = (node)=>{
            containerRef.current = node;
            targetRef.current = node ? node.firstElementChild : null;
        };
        const setDirectRef = (0, $eUqFw.useCallback)((node)=>{
            targetRef.current = node;
        }, []);
        const lastState = (0, $eUqFw.useRef)(state);
        const lastDelay = (0, $eUqFw.useRef)(delay);
        const lastHandlers = (0, $eUqFw.useRef)({
            onShowHandler: onShowHandler,
            onHideHandler: onHideHandler
        });
        const hasCalledShowHandler = (0, $eUqFw.useRef)(false);
        (0, $eUqFw.useEffect)(()=>{
            lastState.current = state;
            lastDelay.current = delay;
            lastHandlers.current = {
                onShowHandler: onShowHandler,
                onHideHandler: onHideHandler
            };
        }, [
            delay,
            onHideHandler,
            onShowHandler,
            state
        ]);
        const start = (0, $eUqFw.useCallback)((api)=>{
            apiRef.current = api;
            hasCalledShowHandler.current = false;
        }, []);
        const done = (0, $eUqFw.useCallback)(()=>{
            if (!apiRef.current) return;
            if (hasCalledShowHandler.current) lastHandlers.current.onHideHandler();
            apiRef.current = null;
            hasCalledShowHandler.current = false;
            setState('hide');
        }, []);
        const abort = (0, $eUqFw.useCallback)(()=>{
            if (!apiRef.current) return;
            apiRef.current.abort();
            if (hasCalledShowHandler.current) lastHandlers.current.onHideHandler();
            apiRef.current = null;
        }, []);
        (0, $eUqFw.useEffect)(function mount() {
            return function unmount() {
                if (apiRef.current) abort();
            };
        }, [
            abort
        ]);
        const isDraggingRef = (0, $eUqFw.useRef)(false);
        (0, $eUqFw.useEffect)(()=>{
            return (0, $kmtpF.register)({
                onRegister ({ isDragging: isDragging }) {
                    isDraggingRef.current = isDragging;
                },
                onDragStart () {
                    apiRef.current?.requestHide({
                        isImmediate: true
                    });
                    isDraggingRef.current = true;
                },
                onDragEnd () {
                    isDraggingRef.current = false;
                }
            });
        }, []);
        const showTooltip = (0, $eUqFw.useCallback)((source)=>{
            if (isDraggingRef.current) return;
            if (apiRef.current && !apiRef.current.isActive()) abort();
            if (apiRef.current && apiRef.current.isActive()) {
                apiRef.current.keep();
                return;
            }
            const entry = {
                source: source,
                delay: lastDelay.current,
                show: ({ isImmediate: isImmediate })=>{
                    if (!hasCalledShowHandler.current) {
                        hasCalledShowHandler.current = true;
                        lastHandlers.current.onShowHandler();
                    }
                    setState(isImmediate ? 'show-immediate' : 'fade-in');
                },
                hide: ({ isImmediate: isImmediate })=>{
                    if (isImmediate) setState('hide');
                    else setState('before-fade-out');
                },
                done: done
            };
            const api = (0, $5mmZs.show)(entry);
            start(api);
        }, [
            abort,
            done,
            start
        ]);
        const hideTooltipOnEsc = (0, $eUqFw.useCallback)(()=>{
            apiRef.current?.requestHide({
                isImmediate: true
            });
        }, [
            apiRef
        ]);
        (0, $cho8R.default)({
            onClose: hideTooltipOnEsc,
            isDisabled: state === 'hide' || state === 'fade-out'
        });
        (0, $eUqFw.useEffect)(()=>{
            if (state === 'hide') return 0, $4oSDA.default;
            if (state === 'before-fade-out') setState('fade-out');
            const unbind = (0, $74BVL.bind)(window, {
                type: 'scroll',
                listener: ()=>{
                    if (apiRef.current) apiRef.current.requestHide({
                        isImmediate: true
                    });
                },
                options: {
                    capture: true,
                    passive: true,
                    once: true
                }
            });
            return unbind;
        }, [
            state
        ]);
        const onMouseDown = (0, $eUqFw.useCallback)(()=>{
            if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
                isImmediate: true
            });
        }, [
            hideTooltipOnMouseDown
        ]);
        const onClick = (0, $eUqFw.useCallback)(()=>{
            if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
                isImmediate: true
            });
        }, [
            hideTooltipOnClick
        ]);
        const onMouseOver = (0, $eUqFw.useCallback)((event)=>{
            if (containerRef.current && event.target === containerRef.current) return;
            if (event.defaultPrevented) return;
            event.preventDefault();
            const source = position === 'mouse' ? {
                type: 'mouse',
                mouse: (0, $2CeSd.getMousePosition)({
                    left: event.clientX,
                    top: event.clientY
                })
            } : {
                type: 'keyboard'
            };
            showTooltip(source);
        }, [
            position,
            showTooltip
        ]);
        const onMouseOut = (0, $eUqFw.useCallback)((event)=>{
            if (containerRef.current && event.target === containerRef.current) return;
            if (event.defaultPrevented) return;
            event.preventDefault();
            if (apiRef.current) apiRef.current.requestHide({
                isImmediate: false
            });
        }, []);
        const onMouseMove = position === 'mouse' ? (event)=>{
            if (apiRef.current?.isActive()) apiRef.current.mousePosition = (0, $2CeSd.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            });
        } : undefined;
        const onMouseOverTooltip = (0, $eUqFw.useCallback)(()=>{
            if (apiRef.current && apiRef.current.isActive()) {
                apiRef.current.keep();
                return;
            }
        }, []);
        const onFocus = (0, $eUqFw.useCallback)(()=>{
            showTooltip({
                type: 'keyboard'
            });
        }, [
            showTooltip
        ]);
        const onBlur = (0, $eUqFw.useCallback)(()=>{
            if (apiRef.current) apiRef.current.requestHide({
                isImmediate: false
            });
        }, []);
        const onAnimationFinished = (0, $eUqFw.useCallback)((transition)=>{
            if (transition === 'exiting' && lastState.current === 'fade-out' && apiRef.current) apiRef.current.finishHideAnimation();
        }, []);
        const CastTargetContainer = TargetContainer;
        const shouldRenderTooltipContainer = state !== 'hide' && Boolean(content);
        const shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out';
        (0, $bsJFv.useNotifyOpenLayerObserver)({
            isOpen: shouldRenderTooltipContainer
        });
        const getReferenceElement = ()=>{
            if (position === 'mouse' && apiRef.current?.mousePosition) return apiRef.current?.mousePosition;
            return targetRef.current || undefined;
        };
        const tooltipId = (0, $ZNXT4.default)('tooltip', shouldRenderTooltipContainer);
        const tooltipTriggerProps = {
            onMouseOver: onMouseOver,
            onMouseOut: onMouseOut,
            onMouseMove: onMouseMove,
            onMouseDown: onMouseDown,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur
        };
        if (testId) tooltipTriggerProps['data-testid'] = `${testId}--container`;
        (0, $eUqFw.useEffect)(()=>{
            if (!containerRef.current || !targetRef.current || !tooltipId) return;
            const target = targetRef.current;
            if (shouldRenderTooltipContainer) target.setAttribute('aria-describedby', tooltipId);
            else target.removeAttribute('aria-describedby');
        }, [
            shouldRenderTooltipContainer,
            tooltipId
        ]);
        const hiddenContent = (0, ($parcel$interopDefault($eUqFw))).createElement("span", {
            "data-testid": testId ? `${testId}-hidden` : undefined,
            hidden: true,
            id: tooltipId
        }, typeof content === 'function' ? content({}) : content);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, typeof children === 'function' ? (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, children({
            ...tooltipTriggerProps,
            'aria-describedby': tooltipId,
            ref: setDirectRef
        }), shouldRenderTooltipContainer && hiddenContent) : (0, ($parcel$interopDefault($eUqFw))).createElement(CastTargetContainer, {
            ...tooltipTriggerProps,
            ref: setImplicitRefFromChildren,
            role: "presentation"
        }, children, shouldRenderTooltipContainer && hiddenContent), shouldRenderTooltipContainer ? (0, ($parcel$interopDefault($eUqFw))).createElement((0, $4UBDE.default), {
            zIndex: $027ae8750a46011f$var$tooltipZIndex
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jLWxm.Popper), {
            placement: tooltipPosition,
            referenceElement: getReferenceElement(),
            strategy: strategy
        }, ({ ref: ref, style: style, update: update, placement: placement })=>{
            const direction = position === 'mouse' ? undefined : $027ae8750a46011f$var$invertedDirection[$027ae8750a46011f$var$getDirectionFromPlacement(placement)];
            return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $amx2g.default), {
                appear: true
            }, shouldRenderTooltipChildren && (0, ($parcel$interopDefault($eUqFw))).createElement((0, $3zwh8.default), {
                distance: "constant",
                entranceDirection: direction,
                exitDirection: direction,
                onFinish: onAnimationFinished,
                duration: state === 'show-immediate' ? 0 : (0, $gN8bb.mediumDurationMs)
            }, ({ className: className })=>(0, ($parcel$interopDefault($eUqFw))).createElement(Container, {
                    ref: ref,
                    className: `Tooltip ${className}`,
                    style: {
                        ...style,
                        ...ignoreTooltipPointerEvents && {
                            pointerEvents: 'none'
                        }
                    },
                    truncate: truncate,
                    placement: tooltipPosition,
                    testId: getReferenceElement() ? testId : testId && `${testId}--unresolved`,
                    onMouseOut: onMouseOut,
                    onMouseOver: onMouseOverTooltip
                }, typeof content === 'function' ? content({
                    update: update
                }) : content)));
        })) : null);
    }
    $027ae8750a46011f$var$Tooltip.displayName = 'Tooltip';
    var $027ae8750a46011f$export$2e2bcd8739ae039 = $027ae8750a46011f$var$Tooltip;
});
parcelRegister("cho8R", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$18866e8bb258242c$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $74BVL = parcelRequire("74BVL");
    function $18866e8bb258242c$export$2e2bcd8739ae039({ onClose: onClose, isDisabled: isDisabled }) {
        const escapePressed = (0, $eUqFw.useRef)(false);
        const onKeyDown = (0, $eUqFw.useCallback)((e)=>{
            if (isDisabled || escapePressed.current || e.key !== (0, $942f5139e5aad792$export$2bb790b9008907b4)) return;
            escapePressed.current = true;
            onClose(e);
        }, [
            onClose,
            isDisabled
        ]);
        const onKeyUp = (0, $eUqFw.useCallback)(()=>{
            escapePressed.current = false;
        }, []);
        (0, $eUqFw.useEffect)(()=>{
            return (0, $74BVL.bindAll)(document, [
                {
                    type: 'keydown',
                    listener: onKeyDown
                },
                {
                    type: 'keyup',
                    listener: onKeyUp
                }
            ], {
                capture: false
            });
        }, [
            onKeyDown,
            onKeyUp
        ]);
    }
});
const $942f5139e5aad792$export$390330c10ff2b9a1 = 'ArrowUp';
const $942f5139e5aad792$export$a80636c6f41931fe = 'ArrowDown';
const $942f5139e5aad792$export$4af703091671bc = 'Home';
const $942f5139e5aad792$export$e2bc30913faa5db7 = 'End';
const $942f5139e5aad792$export$10f6869ed0a7d75b = 'Tab';
const $942f5139e5aad792$export$8152f929a25a0ff4 = 'Enter';
const $942f5139e5aad792$export$e51a3576c045c8d5 = 'Space';
const $942f5139e5aad792$export$2bb790b9008907b4 = 'Escape';
parcelRegister("bsJFv", function(module, exports) {
    $parcel$export(module.exports, "useNotifyOpenLayerObserver", ()=>$1a285cfba17273d6$export$469bb693f11edc7f);
    var $eUqFw = parcelRequire("eUqFw");
    var $iDwTy = parcelRequire("iDwTy");
    var $aQHUY = parcelRequire("aQHUY");
    function $1a285cfba17273d6$export$469bb693f11edc7f({ isOpen: isOpen = true } = {}) {
        const context = (0, $eUqFw.useContext)((0, $aQHUY.OpenLayerObserverContext));
        (0, $eUqFw.useEffect)(()=>{
            if (!(0, $iDwTy.fg)('platform_design_system_team_layering_observer')) return;
            if (context === null) return;
            if (!isOpen) return;
            context.increment();
            return ()=>{
                context.decrement();
            };
        }, [
            context,
            isOpen
        ]);
    }
});
parcelRegister("aQHUY", function(module, exports) {
    $parcel$export(module.exports, "OpenLayerObserverContext", ()=>$06e10fb010d3a45d$export$5fbf4d7fae6cdc00);
    var $eUqFw = parcelRequire("eUqFw");
    const $06e10fb010d3a45d$export$5fbf4d7fae6cdc00 = (0, $eUqFw.createContext)(null);
});
parcelRegister("kmtpF", function(module, exports) {
    $parcel$export(module.exports, "register", ()=>$ad8edfdecba08219$export$6503ec6e8aabbaf);
    var $74BVL = parcelRequire("74BVL");
    const $ad8edfdecba08219$var$registrations = new Set();
    let $ad8edfdecba08219$var$cleanupEndEventListeners = null;
    function $ad8edfdecba08219$var$onDragStart() {
        if ($ad8edfdecba08219$var$cleanupEndEventListeners) return;
        $ad8edfdecba08219$var$cleanupEndEventListeners = (0, $74BVL.bindAll)(window, [
            {
                type: 'dragend',
                listener: $ad8edfdecba08219$var$onDragEnd
            },
            {
                type: 'pointerdown',
                listener: $ad8edfdecba08219$var$onDragEnd
            },
            {
                type: 'pointermove',
                listener: (()=>{
                    let callCount = 0;
                    return function listener() {
                        if (callCount < 20) {
                            callCount++;
                            return;
                        }
                        $ad8edfdecba08219$var$onDragEnd();
                    };
                })()
            }
        ]);
        const clone = Array.from($ad8edfdecba08219$var$registrations);
        clone.forEach((subscriber)=>{
            subscriber.onDragStart();
        });
    }
    function $ad8edfdecba08219$var$onDragEnd() {
        $ad8edfdecba08219$var$cleanupEndEventListeners?.();
        $ad8edfdecba08219$var$cleanupEndEventListeners = null;
        const clone = Array.from($ad8edfdecba08219$var$registrations);
        clone.forEach((subscriber)=>{
            subscriber.onDragEnd();
        });
    }
    function $ad8edfdecba08219$var$bindStartEvents() {
        return (0, $74BVL.bindAll)(window, [
            {
                type: 'dragstart',
                listener: $ad8edfdecba08219$var$onDragStart
            },
            {
                type: 'dragenter',
                listener: $ad8edfdecba08219$var$onDragStart
            }
        ]);
    }
    let $ad8edfdecba08219$var$cleanupStartEventListeners = null;
    function $ad8edfdecba08219$export$6503ec6e8aabbaf(registration) {
        if (!$ad8edfdecba08219$var$cleanupStartEventListeners) $ad8edfdecba08219$var$cleanupStartEventListeners = $ad8edfdecba08219$var$bindStartEvents();
        $ad8edfdecba08219$var$registrations.add(registration);
        registration.onRegister({
            isDragging: $ad8edfdecba08219$var$cleanupEndEventListeners !== null
        });
        return function unregister() {
            $ad8edfdecba08219$var$registrations.delete(registration);
            if ($ad8edfdecba08219$var$registrations.size === 0) {
                $ad8edfdecba08219$var$cleanupStartEventListeners?.();
                $ad8edfdecba08219$var$cleanupStartEventListeners = null;
            }
        };
    }
});
parcelRegister("5mmZs", function(module, exports) {
    $parcel$export(module.exports, "show", ()=>$b1ecd3f32bc412ff$export$57bf213be019eeb0);
    var $43dz4 = parcelRequire("43dz4");
    let $b1ecd3f32bc412ff$var$active = null;
    function $b1ecd3f32bc412ff$export$57bf213be019eeb0(entry) {
        let phase = 'waiting-to-show';
        function isActive() {
            return Boolean($b1ecd3f32bc412ff$var$active && $b1ecd3f32bc412ff$var$active.entry === entry);
        }
        function cleanup() {
            if (isActive()) {
                (0, $43dz4.clearScheduled)();
                $b1ecd3f32bc412ff$var$active = null;
            }
        }
        function done() {
            if (isActive()) entry.done();
            phase = 'done';
            cleanup();
        }
        function immediatelyHideAndDone() {
            if (isActive()) entry.hide({
                isImmediate: true
            });
            done();
        }
        function keep() {
            if (!isActive()) return;
            if (phase === 'waiting-to-hide') {
                phase = 'shown';
                (0, $43dz4.clearScheduled)();
                return;
            }
            if (phase === 'hide-animating') {
                phase = 'shown';
                (0, $43dz4.clearScheduled)();
                entry.show({
                    isImmediate: false
                });
                return;
            }
        }
        function requestHide({ isImmediate: isImmediate }) {
            if (!isActive()) return;
            if (phase === 'waiting-to-show') {
                immediatelyHideAndDone();
                return;
            }
            if (phase === 'waiting-to-hide') return;
            if (isImmediate) {
                immediatelyHideAndDone();
                return;
            }
            phase = 'waiting-to-hide';
            (0, $43dz4.scheduleTimeout)(()=>{
                phase = 'hide-animating';
                entry.hide({
                    isImmediate: false
                });
            }, entry.delay);
        }
        function finishHideAnimation() {
            if (isActive() && phase === 'hide-animating') done();
        }
        function isVisible() {
            return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
        }
        function getInitialMouse() {
            if (entry.source.type === 'mouse') return entry.source.mouse;
            return null;
        }
        function start() {
            const showImmediately = Boolean($b1ecd3f32bc412ff$var$active && $b1ecd3f32bc412ff$var$active.isVisible());
            if ($b1ecd3f32bc412ff$var$active) {
                (0, $43dz4.clearScheduled)();
                $b1ecd3f32bc412ff$var$active.entry.hide({
                    isImmediate: true
                });
                $b1ecd3f32bc412ff$var$active.entry.done();
                $b1ecd3f32bc412ff$var$active = null;
            }
            $b1ecd3f32bc412ff$var$active = {
                entry: entry,
                isVisible: isVisible
            };
            function show() {
                phase = 'shown';
                entry.show({
                    isImmediate: showImmediately
                });
            }
            if (showImmediately) {
                show();
                return;
            }
            phase = 'waiting-to-show';
            (0, $43dz4.scheduleTimeout)(show, entry.delay);
        }
        start();
        const result = {
            keep: keep,
            abort: cleanup,
            isActive: isActive,
            requestHide: requestHide,
            finishHideAnimation: finishHideAnimation,
            mousePosition: getInitialMouse()
        };
        return result;
    }
});
parcelRegister("43dz4", function(module, exports) {
    $parcel$export(module.exports, "clearScheduled", ()=>$38b1e431e2b8f572$export$eaf678f6f93f5250);
    $parcel$export(module.exports, "scheduleTimeout", ()=>$38b1e431e2b8f572$export$5f4d6617421d489b);
    let $38b1e431e2b8f572$var$delayId = null;
    function $38b1e431e2b8f572$export$eaf678f6f93f5250() {
        if ($38b1e431e2b8f572$var$delayId != null) {
            window.clearTimeout($38b1e431e2b8f572$var$delayId);
            $38b1e431e2b8f572$var$delayId = null;
        }
    }
    function $38b1e431e2b8f572$export$5f4d6617421d489b(fn, delay) {
        $38b1e431e2b8f572$export$eaf678f6f93f5250();
        $38b1e431e2b8f572$var$delayId = window.setTimeout(()=>{
            $38b1e431e2b8f572$var$delayId = null;
            fn();
        }, delay);
    }
});
parcelRegister("ZNXT4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a92330bde7848fd0$export$2e2bcd8739ae039);
    var $5aRS9 = parcelRequire("5aRS9");
    function $a92330bde7848fd0$export$2e2bcd8739ae039(prefix, shouldRenderId) {
        const seed = (0, $5aRS9.useIdSeed)();
        return shouldRenderId ? `${seed(prefix)}` : undefined;
    }
});
parcelRegister("5aRS9", function(module, exports) {
    $parcel$export(module.exports, "useId", ()=>$37b8f0847b93706d$export$f680877a34711e37);
    $parcel$export(module.exports, "IdProvider", ()=>$37b8f0847b93706d$export$6be90bcb437e928f);
    $parcel$export(module.exports, "useIdSeed", ()=>$37b8f0847b93706d$export$6ee17796e3d70de2);
    var $eUqFw = parcelRequire("eUqFw");
    var $jFtVs = parcelRequire("jFtVs");
    var $iDwTy = parcelRequire("iDwTy");
    const $37b8f0847b93706d$var$react18UseId = (0, ($parcel$interopDefault($eUqFw))).useId ?? undefined;
    function $37b8f0847b93706d$export$f680877a34711e37() {
        if ($37b8f0847b93706d$var$react18UseId && (0, $iDwTy.fg)('platform.design-system-team.react-18-use-id_mn8q4')) return $37b8f0847b93706d$var$react18UseId();
        return `uid${(0, $jFtVs.useUID)()}`;
    }
    const $37b8f0847b93706d$export$6be90bcb437e928f = (0, $eUqFw.forwardRef)(({ children: children, postfix: postfix = '', prefix: prefix = '' }, ref)=>{
        const id = `${prefix}${$37b8f0847b93706d$export$f680877a34711e37()}${postfix}`;
        (0, $eUqFw.useEffect)(()=>{
            if (!ref) return;
            switch(typeof ref){
                case 'function':
                    ref(id);
                    break;
                case 'object':
                    ref.current = id;
                    break;
                default:
                    throw new Error(`Unreachable case for unsupported type of ref "${typeof ref}"`);
            }
        }, [
            id,
            ref
        ]);
        return typeof children === 'function' ? children({
            id: id
        }) : children;
    });
    function $37b8f0847b93706d$export$6ee17796e3d70de2() {
        if ($37b8f0847b93706d$var$react18UseId && (0, $iDwTy.fg)('platform.design-system-team.react-18-use-id_mn8q4')) {
            const uid = $37b8f0847b93706d$var$react18UseId();
            return (id)=>`${uid}-${id.toString()}`;
        }
        return (0, $jFtVs.useUIDSeed)();
    }
});
parcelRegister("ljFqD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$205427043dd161f4$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $1VK7e = parcelRequire("1VK7e");
    function $205427043dd161f4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $205427043dd161f4$var$baseStyles = (0, $byn9U.css)({
        boxSizing: 'border-box',
        maxWidth: '240px',
        padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-075, 6px)"}`,
        backgroundColor: `var(--ds-background-neutral-bold, ${(0, $207acf722dcd432b$export$7d61b15e0da132af)})`,
        borderRadius: "var(--ds-border-radius, 3px)",
        color: `var(--ds-text-inverse, ${(0, $207acf722dcd432b$export$29a4f05edc054374)})`,
        font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        insetBlockStart: "var(--ds-space-0, 0px)",
        insetInlineStart: "var(--ds-space-0, 0px)",
        overflowWrap: 'break-word',
        wordWrap: 'break-word'
    });
    const $205427043dd161f4$var$truncateStyles = {
        name: "1e1ci1f",
        styles: "max-width:420px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap"
    };
    const $205427043dd161f4$var$TooltipContainer = (0, $eUqFw.forwardRef)(function TooltipContainer({ style: style, className: className, children: children, truncate: truncate, placement: placement, testId: testId, onMouseOut: onMouseOut, onMouseOver: onMouseOver, id: id }, ref) {
        return (0, $byn9U.jsx)((0, $1VK7e.default), {
            ref: ref,
            style: style,
            className: className,
            placement: placement,
            testId: testId,
            id: id,
            onMouseOut: onMouseOut,
            onMouseOver: onMouseOver,
            css: [
                $205427043dd161f4$var$baseStyles,
                truncate ? $205427043dd161f4$var$truncateStyles : null
            ]
        }, children);
    });
    $205427043dd161f4$var$TooltipContainer.displayName = 'TooltipContainer';
    var $205427043dd161f4$export$2e2bcd8739ae039 = $205427043dd161f4$var$TooltipContainer;
});
parcelRegister("1VK7e", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$281ef0078602d5fe$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $h04Oa = parcelRequire("h04Oa");
    const $281ef0078602d5fe$var$VAR_PRIMITIVE_ZINDEX = 'tooltipPrimitiveZindex';
    const $281ef0078602d5fe$var$primitiveStyles = (0, $byn9U.css)({
        zindex: `var(${$281ef0078602d5fe$var$VAR_PRIMITIVE_ZINDEX})`,
        cursor: `default`
    });
    const $281ef0078602d5fe$var$TooltipPrimitive = (0, $eUqFw.forwardRef)(function TooltipPrimitive({ style: style, className: className, children: children, placement: placement, testId: testId, onMouseOut: onMouseOut, onMouseOver: onMouseOver, id: id }, ref) {
        const styleWithZIndex = {
            ...style,
            [$281ef0078602d5fe$var$VAR_PRIMITIVE_ZINDEX]: (0, $h04Oa.layers).tooltip()
        };
        return (0, $byn9U.jsx)("div", {
            ref: ref,
            style: styleWithZIndex,
            "data-testid": testId ? `${testId}--wrapper` : undefined
        }, (0, $byn9U.jsx)("div", {
            role: "tooltip",
            className: className,
            onMouseOut: onMouseOut,
            onMouseOver: onMouseOver,
            css: $281ef0078602d5fe$var$primitiveStyles,
            "data-placement": placement,
            "data-testid": testId,
            id: id
        }, children));
    });
    $281ef0078602d5fe$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
    var $281ef0078602d5fe$export$2e2bcd8739ae039 = $281ef0078602d5fe$var$TooltipPrimitive;
});
parcelRegister("2CeSd", function(module, exports) {
    $parcel$export(module.exports, "getMousePosition", ()=>$e2577b83aeea849e$export$642213d516a9b928);
    function $e2577b83aeea849e$export$642213d516a9b928(mouseCoordinates) {
        const safeMouse = mouseCoordinates || {
            top: 0,
            left: 0
        };
        const getBoundingClientRect = ()=>({
                top: safeMouse.top,
                left: safeMouse.left,
                bottom: safeMouse.top,
                right: safeMouse.left,
                width: 0,
                height: 0
            });
        return {
            getBoundingClientRect: getBoundingClientRect,
            clientWidth: 0,
            clientHeight: 0
        };
    }
});
parcelRegister("eUJtf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c437c710961ebea0$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $amx2g = parcelRequire("amx2g");
    const $c437c710961ebea0$var$ModalTransition = (props)=>{
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $amx2g.default), {
            appear: true
        }, props.children);
    };
    var $c437c710961ebea0$export$2e2bcd8739ae039 = $c437c710961ebea0$var$ModalTransition;
});
parcelRegister("ghFHl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$355f8d2dd497d041$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $iDwTy = parcelRequire("iDwTy");
    var $jGR8u = parcelRequire("jGR8u");
    var $fHiYa = parcelRequire("fHiYa");
    var $a5MxG = parcelRequire("a5MxG");
    function $355f8d2dd497d041$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $355f8d2dd497d041$var$visitedLinkStyles = (0, $fHiYa.xcss)({
        ':visited': {
            color: 'color.link.visited'
        },
        ':visited:hover': {
            color: 'color.link.visited'
        },
        ':visited:active': {
            color: 'color.link.visited.pressed'
        }
    });
    const $355f8d2dd497d041$var$defaultAppearanceStyles = (0, $fHiYa.xcss)({
        textDecoration: 'underline',
        color: 'color.link',
        ':hover': {
            color: 'color.link',
            textDecoration: 'none'
        },
        ':active': {
            color: 'color.link.pressed'
        },
        ':focus': {
            textDecoration: 'underline'
        }
    });
    const $355f8d2dd497d041$var$subtleAppearanceStyles = (0, $fHiYa.xcss)({
        textDecoration: 'none',
        color: 'color.text.subtle',
        ':hover': {
            color: 'color.text.subtle',
            textDecoration: 'underline'
        },
        ':active': {
            color: 'color.text'
        }
    });
    const $355f8d2dd497d041$var$inverseAppearanceStyles = (0, $fHiYa.xcss)({
        textDecoration: 'underline',
        color: 'color.text.inverse',
        ':hover': {
            color: 'color.text.inverse',
            textDecoration: 'none'
        },
        ':active': {
            color: 'color.text.inverse'
        },
        ':focus': {
            textDecoration: 'underline'
        }
    });
    const $355f8d2dd497d041$var$iconWrapperStyles = (0, $fHiYa.xcss)({
        display: 'inline',
        whiteSpace: 'nowrap',
        verticalAlign: 'top',
        position: 'relative',
        insetBlockStart: '0.11em'
    });
    const $355f8d2dd497d041$var$iconStyles = {
        name: "7pys7l",
        styles: "width:0.9em;height:0.9em;margin-inline-start:.3em"
    };
    const $355f8d2dd497d041$var$LinkWithoutRef = ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, className: preventedClassName, style: preventedStyle, ...htmlAttributes }, ref)=>{
        return (0, $byn9U.jsx)((0, $a5MxG.default), {
            ...htmlAttributes,
            target: target,
            ref: ref,
            xcss: [
                appearance === 'default' && $355f8d2dd497d041$var$defaultAppearanceStyles,
                appearance === 'subtle' && $355f8d2dd497d041$var$subtleAppearanceStyles,
                appearance === 'inverse' && $355f8d2dd497d041$var$inverseAppearanceStyles,
                appearance !== 'inverse' && $355f8d2dd497d041$var$visitedLinkStyles
            ],
            testId: testId,
            componentName: "Link",
            newWindowLabel: newWindowLabel
        }, children, target === '_blank' && (0, $byn9U.jsx)((0, $jGR8u.default), {
            as: "span",
            xcss: $355f8d2dd497d041$var$iconWrapperStyles,
            testId: testId && `${testId}__icon`
        }, "\uFEFF", (0, $iDwTy.fg)('platform-visual-refresh-icons') ? (0, $byn9U.jsx)("svg", {
            width: "12",
            height: "12",
            viewBox: "0 0 12 12",
            fill: "none",
            css: $355f8d2dd497d041$var$iconStyles
        }, (0, $byn9U.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
            fill: "currentColor"
        })) : (0, $byn9U.jsx)("svg", {
            css: $355f8d2dd497d041$var$iconStyles,
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "currentColor"
        }, (0, $byn9U.jsx)("path", {
            d: "M17.5715 3.95926L10.7587 10.772C10.5546 10.9692 10.2811 11.0784 9.99723 11.0759C9.71338 11.0734 9.44185 10.9596 9.24113 10.7589C9.04041 10.5581 8.92655 10.2866 8.92409 10.0027C8.92162 9.7189 9.03074 9.44543 9.22794 9.24125L16.0407 2.4285H14.3237C14.0366 2.4285 13.7613 2.31444 13.5582 2.11142C13.3552 1.90839 13.2411 1.63303 13.2411 1.34591C13.2411 1.05879 13.3552 0.783424 13.5582 0.580399C13.7613 0.377373 14.0366 0.263314 14.3237 0.263314H18.4981C18.5509 0.254962 18.6043 0.250507 18.658 0.250041C18.8017 0.248792 18.9443 0.276183 19.0773 0.330617C19.2104 0.385051 19.3313 0.465437 19.4329 0.567084C19.5346 0.668732 19.6149 0.789606 19.6694 0.922652C19.7238 1.0557 19.7512 1.19825 19.75 1.342C19.7495 1.3956 19.7451 1.44896 19.7367 1.50165V5.67628C19.7367 5.9634 19.6227 6.23877 19.4196 6.44179C19.2166 6.64482 18.9412 6.75888 18.6541 6.75888C18.367 6.75888 18.0916 6.64482 17.8886 6.44179C17.6856 6.23877 17.5715 5.9634 17.5715 5.67628V3.95926Z"
        }), (0, $byn9U.jsx)("path", {
            d: "M2.41519 17.5848V2.4285H8.91076V0.263314H2.41194C1.22001 0.263314 0.25 1.23007 0.25 2.42201V17.5913C0.250574 18.1638 0.47834 18.7127 0.883283 19.1175C1.28823 19.5222 1.83724 19.7497 2.40978 19.75H17.5769C17.8608 19.7499 18.1418 19.6938 18.404 19.585C18.6662 19.4762 18.9044 19.3168 19.105 19.116C19.3055 18.9151 19.4646 18.6767 19.573 18.4143C19.6814 18.152 19.737 17.8708 19.7367 17.587V11.0893H17.5715V17.5848H2.41519Z"
        }))));
    };
    const $355f8d2dd497d041$var$Link = (0, $eUqFw.forwardRef)($355f8d2dd497d041$var$LinkWithoutRef);
    var $355f8d2dd497d041$export$2e2bcd8739ae039 = $355f8d2dd497d041$var$Link;
});
parcelRegister("a5MxG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$831e514fb9cf59bd$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $8ynlC = parcelRequire("8ynlC");
    var $kRXtb = parcelRequire("kRXtb");
    var $mQ4ff = parcelRequire("mQ4ff");
    var $4oSDA = parcelRequire("4oSDA");
    var $5aRS9 = parcelRequire("5aRS9");
    var $cOm24 = parcelRequire("cOm24");
    var $62Dwb = parcelRequire("62Dwb");
    var $3P7YC = parcelRequire("3P7YC");
    var $fHiYa = parcelRequire("fHiYa");
    function $831e514fb9cf59bd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $831e514fb9cf59bd$var$focusRingStyles = (0, $byn9U.css)({
        '&:focus, &:focus-visible': {
            outlineColor: (0, $3P7YC.borderColorMap)['color.border.focused'],
            outlineOffset: (0, $3P7YC.positiveSpaceMap)['space.025'],
            outlineStyle: 'solid',
            outlineWidth: (0, $3P7YC.borderWidthMap)['border.width.outline']
        },
        '&:focus:not(:focus-visible)': {
            outline: 'none'
        },
        '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
            '&:focus-visible': {
                outline: '1px solid'
            }
        }
    });
    const $831e514fb9cf59bd$var$baseStyles = {
        name: "9ge06c",
        styles: "box-sizing:border-box;text-decoration:underline"
    };
    const $831e514fb9cf59bd$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
    const $831e514fb9cf59bd$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
    const $831e514fb9cf59bd$var$OPENS_NEW_WINDOW_LABEL = '(opens new window)';
    const $831e514fb9cf59bd$var$AnchorNoRef = ({ href: href, children: children, backgroundColor: backgroundColor, newWindowLabel: newWindowLabel, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, onClick: providedOnClick = (0, $4oSDA.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, style: style, target: target, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
        const interactionContext = (0, $eUqFw.useContext)((0, $cOm24.default));
        const handleClick = (0, $eUqFw.useCallback)((e, analyticsEvent)=>{
            interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
            providedOnClick(e, analyticsEvent);
        }, [
            providedOnClick,
            interactionContext,
            interactionName
        ]);
        const opensNewWindowLabelId = (0, $5aRS9.useId)();
        const onClick = (0, $kRXtb.usePlatformLeafEventHandler)({
            fn: handleClick,
            action: 'clicked',
            componentName: componentName || 'Anchor',
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local",
            analyticsData: analyticsContext,
            actionSubject: 'link'
        });
        const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
        const resolvedStyles = (0, $fHiYa.parseXcss)(xcss);
        const RouterLink = (0, $mQ4ff.default)();
        const isExternal = typeof href === 'string' && $831e514fb9cf59bd$var$IS_EXTERNAL_LINK_REGEX.test(href);
        const isNonHttpBased = typeof href === 'string' && $831e514fb9cf59bd$var$IS_NON_HTTP_BASED.test(href);
        const isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
        const hrefObjectUsedWithoutRouterLink = RouterLink === undefined && typeof href === 'object';
        (0, $8ynlC.default)(!hrefObjectUsedWithoutRouterLink, `@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider`);
        const Component = isRouterLink ? RouterLink : 'a';
        return (0, $byn9U.jsx)(Component, {
            style: style,
            ref: ref,
            className: resolvedStyles.static,
            ...safeHtmlAttributes,
            href: !isRouterLink && typeof href !== 'string' ? undefined : href,
            target: target,
            onClick: onClick,
            "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? `${ariaLabel} , ${newWindowLabel ? newWindowLabel : $831e514fb9cf59bd$var$OPENS_NEW_WINDOW_LABEL}` : ariaLabel,
            "aria-labelledby": ariaLabelledBy && target === '_blank' ? `${ariaLabelledBy} ${opensNewWindowLabelId}` : ariaLabelledBy,
            css: [
                $831e514fb9cf59bd$var$baseStyles,
                $831e514fb9cf59bd$var$focusRingStyles,
                backgroundColor && (0, $3P7YC.backgroundColorStylesMap)[backgroundColor],
                padding && (0, $3P7YC.paddingStylesMap).padding[padding],
                paddingBlock && (0, $3P7YC.paddingStylesMap).paddingBlock[paddingBlock],
                paddingBlockStart && (0, $3P7YC.paddingStylesMap).paddingBlockStart[paddingBlockStart],
                paddingBlockEnd && (0, $3P7YC.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
                paddingInline && (0, $3P7YC.paddingStylesMap).paddingInline[paddingInline],
                paddingInlineStart && (0, $3P7YC.paddingStylesMap).paddingInlineStart[paddingInlineStart],
                paddingInlineEnd && (0, $3P7YC.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
                resolvedStyles.emotion
            ],
            "data-testid": testId,
            "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined
        }, children, target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && (0, $byn9U.jsx)((0, $62Dwb.default), {
            id: opensNewWindowLabelId
        }, `, ${newWindowLabel ? newWindowLabel : $831e514fb9cf59bd$var$OPENS_NEW_WINDOW_LABEL}`));
    };
    const $831e514fb9cf59bd$var$Anchor = (0, $eUqFw.forwardRef)($831e514fb9cf59bd$var$AnchorNoRef);
    var $831e514fb9cf59bd$export$2e2bcd8739ae039 = $831e514fb9cf59bd$var$Anchor;
});
parcelRegister("mQ4ff", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$461ad76a466a68bc$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $fynTZ = parcelRequire("fynTZ");
    const $461ad76a466a68bc$var$useRouterLink = ()=>{
        const { routerLinkComponent: routerLinkComponent } = (0, $eUqFw.useContext)((0, $fynTZ.RouterLinkProviderContext));
        if (routerLinkComponent) return routerLinkComponent;
    };
    var $461ad76a466a68bc$export$2e2bcd8739ae039 = $461ad76a466a68bc$var$useRouterLink;
});
parcelRegister("fynTZ", function(module, exports) {
    $parcel$export(module.exports, "RouterLinkProviderContext", ()=>$dd1674a5617b490f$export$2931e0ee690eee88);
    $parcel$export(module.exports, "default", ()=>$dd1674a5617b490f$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    const $dd1674a5617b490f$export$2931e0ee690eee88 = (0, $eUqFw.createContext)({});
    const $dd1674a5617b490f$var$RouterLinkProvider = ({ routerLinkComponent: routerLinkComponent, children: children })=>{
        return (0, ($parcel$interopDefault($eUqFw))).createElement($dd1674a5617b490f$export$2931e0ee690eee88.Provider, {
            value: {
                routerLinkComponent: routerLinkComponent
            }
        }, children);
    };
    var $dd1674a5617b490f$export$2e2bcd8739ae039 = $dd1674a5617b490f$var$RouterLinkProvider;
});
parcelRegister("9GIq2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$21e2cdd8df42dc04$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $jGR8u = parcelRequire("jGR8u");
    var $1AHzd = parcelRequire("1AHzd");
    var $fHiYa = parcelRequire("fHiYa");
    const $21e2cdd8df42dc04$var$CSS_VAR_TEXT_COLOR = '--banner-text-color';
    const $21e2cdd8df42dc04$var$inlineStyles = (0, $fHiYa.xcss)({
        minWidth: '0'
    });
    const $21e2cdd8df42dc04$var$textStyles = (0, $byn9U.css)({
        color: `var(${$21e2cdd8df42dc04$var$CSS_VAR_TEXT_COLOR})`,
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        fontWeight: "var(--ds-font-weight-medium, 500)",
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        'a, a:visited, a:hover, a:focus, a:active': {
            color: 'currentColor',
            textDecoration: 'underline'
        }
    });
    const $21e2cdd8df42dc04$var$backgroundColors = {
        warning: 'color.background.warning.bold',
        error: 'color.background.danger.bold',
        announcement: 'color.background.neutral.bold'
    };
    const $21e2cdd8df42dc04$var$tokenBackgroundColors = {
        warning: `var(--ds-background-warning-bold, ${(0, $207acf722dcd432b$export$c6930421db9fa514)})`,
        error: `var(--ds-background-danger-bold, ${(0, $207acf722dcd432b$export$2010d0fb4295b346)})`,
        announcement: `var(--ds-background-neutral-bold, ${(0, $207acf722dcd432b$export$c39c0fe0f26207ae)})`
    };
    const $21e2cdd8df42dc04$var$tokenTextColors = {
        warning: `var(--ds-text-warning-inverse, ${(0, $207acf722dcd432b$export$ad0bacf983b7ddaa)})`,
        error: `var(--ds-text-inverse, ${(0, $207acf722dcd432b$export$29a4f05edc054374)})`,
        announcement: `var(--ds-text-inverse, ${(0, $207acf722dcd432b$export$29a4f05edc054374)})`
    };
    const $21e2cdd8df42dc04$var$containerStyles = (0, $fHiYa.xcss)({
        height: '3rem',
        alignItems: 'center',
        display: 'flex'
    });
    const $21e2cdd8df42dc04$var$iconWrapperStyles = (0, $fHiYa.xcss)({
        display: 'block',
        width: '1.5rem',
        height: '1.5rem',
        flexShrink: '0'
    });
    const $21e2cdd8df42dc04$var$Banner = (0, $eUqFw.forwardRef)(({ appearance: appearance = 'warning', children: children, icon: icon, testId: testId }, ref)=>{
        const appearanceType = appearance in $21e2cdd8df42dc04$var$backgroundColors ? appearance : 'warning';
        return (0, $byn9U.jsx)((0, $jGR8u.default), {
            xcss: $21e2cdd8df42dc04$var$containerStyles,
            backgroundColor: $21e2cdd8df42dc04$var$backgroundColors[appearanceType],
            padding: "space.150",
            testId: testId,
            ref: ref,
            role: "alert"
        }, (0, $byn9U.jsx)((0, $1AHzd.default), {
            space: "space.050",
            alignBlock: "center",
            alignInline: "start",
            xcss: $21e2cdd8df42dc04$var$inlineStyles
        }, icon ? (0, $byn9U.jsx)((0, $jGR8u.default), {
            as: "span",
            xcss: $21e2cdd8df42dc04$var$iconWrapperStyles,
            style: {
                fill: $21e2cdd8df42dc04$var$tokenBackgroundColors[appearanceType],
                color: $21e2cdd8df42dc04$var$tokenTextColors[appearanceType]
            }
        }, icon) : null, (0, $byn9U.jsx)("span", {
            style: {
                [$21e2cdd8df42dc04$var$CSS_VAR_TEXT_COLOR]: $21e2cdd8df42dc04$var$tokenTextColors[appearanceType]
            },
            css: $21e2cdd8df42dc04$var$textStyles
        }, children)));
    });
    var $21e2cdd8df42dc04$export$2e2bcd8739ae039 = $21e2cdd8df42dc04$var$Banner;
});
parcelRegister("95AD8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a91e759474ec7422$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $74BVL = parcelRequire("74BVL");
    var $kRXtb = parcelRequire("kRXtb");
    var $4oSDA = parcelRequire("4oSDA");
    var $1TGzV = parcelRequire("1TGzV");
    var $01RXE = parcelRequire("01RXE");
    var $iDwTy = parcelRequire("iDwTy");
    var $4hd8s = parcelRequire("4hd8s");
    var $jLWxm = parcelRequire("jLWxm");
    var $2JWZX = parcelRequire("2JWZX");
    var $a5a1I = parcelRequire("a5a1I");
    var $2GlL1 = parcelRequire("2GlL1");
    const $a91e759474ec7422$var$checkIsChildOfPortal = (node)=>{
        if (!node) return false;
        return node.classList && node.classList.contains('atlaskit-portal-container') || $a91e759474ec7422$var$checkIsChildOfPortal(node.parentElement);
    };
    const $a91e759474ec7422$var$EscapeCloseManager = ({ handleClose: handleClose })=>{
        (0, $01RXE.useCloseOnEscapePress)({
            onClose: handleClose
        });
        return (0, $byn9U.jsx)("span", null);
    };
    const $a91e759474ec7422$var$InlineDialog = (0, $eUqFw.memo)(function InlineDialog({ isOpen: isOpen = false, onContentBlur: onContentBlur = (0, $4oSDA.default), onContentClick: onContentClick = (0, $4oSDA.default), onContentFocus: onContentFocus = (0, $4oSDA.default), onClose: providedOnClose = (0, $4oSDA.default), placement: placement = 'bottom-start', strategy: strategy = 'fixed', testId: testId, content: content, children: children }) {
        const containerRef = (0, $eUqFw.useRef)(null);
        const triggerRef = (0, $eUqFw.useRef)(null);
        const onClose = (0, $kRXtb.usePlatformLeafEventHandler)({
            fn: (event)=>providedOnClose(event),
            action: 'closed',
            componentName: 'inlineDialog',
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        });
        const onCloseRef = (0, $eUqFw.useRef)(onClose);
        const isLayeringEnabled = (0, $iDwTy.fg)('platform.design-system-team.inline-message-layering_wfp1p') && isOpen;
        (0, $eUqFw.useEffect)(()=>{
            onCloseRef.current = onClose;
        });
        const handleCloseRequest = (0, $eUqFw.useCallback)((event)=>{
            const { target: target } = event;
            if (!(target instanceof HTMLElement)) return;
            if (!document.body.contains(target)) return;
            if (isLayeringEnabled) {
                onCloseRef.current?.({
                    isOpen: false,
                    event: event
                });
                return;
            }
            if ($a91e759474ec7422$var$checkIsChildOfPortal(target)) return;
            if (containerRef.current && !containerRef.current.contains(target)) onCloseRef.current?.({
                isOpen: false,
                event: event
            });
        }, [
            isLayeringEnabled
        ]);
        const handleClick = (0, $eUqFw.useCallback)((event)=>{
            if (triggerRef.current && triggerRef.current.contains(event.target)) return;
            if (isLayeringEnabled && containerRef.current?.contains(event.target)) return;
            handleCloseRequest(event);
        }, [
            handleCloseRequest,
            isLayeringEnabled
        ]);
        (0, $eUqFw.useEffect)(()=>{
            if (!isOpen) return;
            return (0, $74BVL.bind)(window, {
                type: 'click',
                listener: handleClick,
                options: {
                    capture: true
                }
            });
        }, [
            isOpen,
            handleClick
        ]);
        const handleKeyDown = (0, $eUqFw.useCallback)((event)=>{
            if (event.key === 'Escape') handleCloseRequest(event);
        }, [
            handleCloseRequest
        ]);
        (0, $eUqFw.useEffect)(()=>{
            if (!isOpen || isLayeringEnabled) return;
            const unbind = (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: handleKeyDown,
                options: {
                    capture: true
                }
            });
            return unbind;
        }, [
            isOpen,
            handleKeyDown,
            isLayeringEnabled
        ]);
        const popper = isOpen ? (0, $byn9U.jsx)((0, $jLWxm.Popper), {
            placement: placement,
            strategy: strategy
        }, ({ ref: ref, style: style })=>(0, $byn9U.jsx)((0, $2GlL1.Container), {
                onBlur: onContentBlur,
                onFocus: onContentFocus,
                onClick: onContentClick,
                ref: (node)=>{
                    if (node) {
                        containerRef.current = node;
                        if (typeof ref === 'function') ref(node);
                        else ref.current = node;
                    }
                },
                style: style,
                testId: testId
            }, content)) : null;
        return (0, $byn9U.jsx)((0, $4hd8s.Manager), null, (0, $byn9U.jsx)((0, $2JWZX.Reference), null, ({ ref: ref })=>(0, $byn9U.jsx)((0, $a5a1I.default), {
                innerRef: (node)=>{
                    triggerRef.current = node;
                    if (typeof ref === 'function') ref(node);
                    else ref.current = node;
                },
                hasNodeResolver: !(0, $iDwTy.fg)('platform_design_system_team_portal_logic_r18_fix')
            }, (0, $byn9U.jsx)((0, ($parcel$interopDefault($eUqFw))).Fragment, null, children))), isLayeringEnabled ? (0, $byn9U.jsx)((0, $1TGzV.UNSAFE_LAYERING), {
            isDisabled: false
        }, popper, (0, $byn9U.jsx)($a91e759474ec7422$var$EscapeCloseManager, {
            handleClose: handleCloseRequest
        })) : popper);
    });
    var $a91e759474ec7422$export$2e2bcd8739ae039 = $a91e759474ec7422$var$InlineDialog;
});
parcelRegister("1TGzV", function(module, exports) {
    $parcel$export(module.exports, "LevelContext", ()=>$13a597de552473a4$export$650d12d3c2ddb8fc);
    $parcel$export(module.exports, "TopLevelContext", ()=>$13a597de552473a4$export$48b383b280e20440);
    $parcel$export(module.exports, "UNSAFE_LAYERING", ()=>$13a597de552473a4$export$a183686c3f6f4ea8);
    var $eUqFw = parcelRequire("eUqFw");
    var $4oSDA = parcelRequire("4oSDA");
    const $13a597de552473a4$export$650d12d3c2ddb8fc = (0, $eUqFw.createContext)(0);
    const $13a597de552473a4$export$48b383b280e20440 = (0, $eUqFw.createContext)({
        topLevelRef: {
            current: null
        },
        setTopLevel: (0, $4oSDA.default)
    });
    const $13a597de552473a4$var$LevelProvider = ({ children: children, currentLevel: currentLevel })=>{
        const { setTopLevel: setTopLevel, topLevelRef: topLevelRef } = (0, $eUqFw.useContext)($13a597de552473a4$export$48b383b280e20440);
        if (topLevelRef.current === null || currentLevel > topLevelRef.current) setTopLevel(currentLevel);
        (0, $eUqFw.useEffect)(()=>{
            return ()=>{
                setTimeout(()=>{
                    setTopLevel(currentLevel - 1);
                }, 0);
            };
        }, [
            setTopLevel,
            currentLevel
        ]);
        return (0, ($parcel$interopDefault($eUqFw))).createElement($13a597de552473a4$export$650d12d3c2ddb8fc.Provider, {
            value: currentLevel
        }, children);
    };
    const $13a597de552473a4$var$LayeringProvider = ({ children: children })=>{
        const topLevelRef = (0, $eUqFw.useRef)(0);
        const value = (0, $eUqFw.useMemo)(()=>({
                topLevelRef: topLevelRef,
                setTopLevel: (level)=>{
                    topLevelRef.current = level;
                }
            }), [
            topLevelRef
        ]);
        return (0, ($parcel$interopDefault($eUqFw))).createElement($13a597de552473a4$export$48b383b280e20440.Provider, {
            value: value
        }, children);
    };
    const $13a597de552473a4$export$a183686c3f6f4ea8 = ({ children: children, isDisabled: isDisabled = true })=>{
        const currentLevel = (0, $eUqFw.useContext)($13a597de552473a4$export$650d12d3c2ddb8fc);
        if (isDisabled) return (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, children);
        const isNested = currentLevel > 0;
        const content = (0, ($parcel$interopDefault($eUqFw))).createElement($13a597de552473a4$var$LevelProvider, {
            currentLevel: currentLevel + 1
        }, children);
        return isNested ? content : (0, ($parcel$interopDefault($eUqFw))).createElement($13a597de552473a4$var$LayeringProvider, null, content);
    };
});
parcelRegister("01RXE", function(module, exports) {
    $parcel$export(module.exports, "useCloseOnEscapePress", ()=>$be24ca9eb7f334e4$export$4a4bf067ea9e7886);
    $parcel$export(module.exports, "UNSAFE_useLayering", ()=>$be24ca9eb7f334e4$export$cec37b93989366d4);
    var $eUqFw = parcelRequire("eUqFw");
    var $74BVL = parcelRequire("74BVL");
    var $1TGzV = parcelRequire("1TGzV");
    const $be24ca9eb7f334e4$var$ESCAPE = 'Escape';
    function $be24ca9eb7f334e4$export$4a4bf067ea9e7886({ onClose: onClose, isDisabled: isDisabled }) {
        const escapePressed = (0, $eUqFw.useRef)(false);
        const { isLayerDisabled: isLayerDisabled } = $be24ca9eb7f334e4$export$cec37b93989366d4();
        const onKeyDown = (0, $eUqFw.useCallback)((e)=>{
            const isDisabledLayer = isLayerDisabled();
            if (isDisabled || escapePressed.current || e.key !== $be24ca9eb7f334e4$var$ESCAPE || isDisabledLayer) return;
            escapePressed.current = true;
            onClose(e);
        }, [
            onClose,
            isDisabled,
            isLayerDisabled
        ]);
        const onKeyUp = (0, $eUqFw.useCallback)(()=>{
            escapePressed.current = false;
        }, []);
        (0, $eUqFw.useEffect)(()=>{
            return (0, $74BVL.bindAll)(document, [
                {
                    type: 'keydown',
                    listener: onKeyDown
                },
                {
                    type: 'keyup',
                    listener: onKeyUp
                }
            ], {
                capture: false
            });
        }, [
            onKeyDown,
            onKeyUp
        ]);
    }
    function $be24ca9eb7f334e4$export$cec37b93989366d4() {
        const currentLevel = (0, $eUqFw.useContext)((0, $1TGzV.LevelContext));
        const { topLevelRef: topLevelRef } = (0, $eUqFw.useContext)((0, $1TGzV.TopLevelContext));
        const isLayerDisabled = (0, $eUqFw.useCallback)(()=>{
            return !!topLevelRef.current && currentLevel !== topLevelRef.current;
        }, [
            currentLevel,
            topLevelRef
        ]);
        return {
            currentLevel: currentLevel,
            topLevelRef: topLevelRef,
            isLayerDisabled: isLayerDisabled
        };
    }
});
parcelRegister("a5a1I", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$66e2767bee1e17b8$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $lbDTY = parcelRequire("lbDTY");
    const $66e2767bee1e17b8$var$NodeResolverWrapper = ({ hasNodeResolver: hasNodeResolver, children: children, innerRef: innerRef })=>{
        if (hasNodeResolver) return (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($lbDTY))), {
            innerRef: innerRef
        }, children);
        return (0, ($parcel$interopDefault($eUqFw))).createElement("div", {
            ref: (node)=>innerRef(node)
        }, children);
    };
    var $66e2767bee1e17b8$export$2e2bcd8739ae039 = $66e2767bee1e17b8$var$NodeResolverWrapper;
});
parcelRegister("2GlL1", function(module, exports) {
    $parcel$export(module.exports, "Container", ()=>$122013c19b9e68fd$export$42a852a2b6b56249);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $h04Oa = parcelRequire("h04Oa");
    const $122013c19b9e68fd$var$CSS_THEME_BACKGROUND = '--theme-background';
    const $122013c19b9e68fd$var$CSS_THEME_COLOR = '--theme-color';
    const $122013c19b9e68fd$var$CSS_THEME_BOX_SHADOW = '--theme-box-shadow';
    const $122013c19b9e68fd$var$containerStyles = (0, $byn9U.css)({
        boxSizing: 'content-box',
        maxWidth: `${448}px`,
        maxHeight: `${448}px`,
        padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-300, 24px)"}`,
        zIndex: (0, $h04Oa.layers).dialog(),
        background: `var(${$122013c19b9e68fd$var$CSS_THEME_BACKGROUND})`,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxShadow: `var(${$122013c19b9e68fd$var$CSS_THEME_BOX_SHADOW})`,
        color: `var(${$122013c19b9e68fd$var$CSS_THEME_COLOR})`,
        '&:focus': {
            outline: 'none'
        }
    });
    const $122013c19b9e68fd$export$42a852a2b6b56249 = (0, $eUqFw.forwardRef)(({ children: children, onBlur: onBlur, onClick: onClick, onFocus: onFocus, style: style, testId: testId }, ref)=>{
        return ((0, $byn9U.jsx)("div", {
            css: $122013c19b9e68fd$var$containerStyles,
            "data-testid": testId,
            onBlur: onBlur,
            onClick: onClick,
            onFocus: onFocus,
            ref: ref,
            style: {
                [$122013c19b9e68fd$var$CSS_THEME_BACKGROUND]: `var(--ds-surface-overlay, ${(0, $207acf722dcd432b$export$29a4f05edc054374)})`,
                [$122013c19b9e68fd$var$CSS_THEME_COLOR]: `var(--ds-text, ${(0, $207acf722dcd432b$export$fbda843f0a27fe96)})`,
                [$122013c19b9e68fd$var$CSS_THEME_BOX_SHADOW]: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $207acf722dcd432b$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $207acf722dcd432b$export$d2d3bedfb276cac0)}`})`,
                ...style
            }
        }, children));
    });
});
parcelRegister("ceCeY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$83ab40d9000064a6$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $6Pq2D = parcelRequire("6Pq2D");
    var $1TUfP = parcelRequire("1TUfP");
    var $8MHxr = parcelRequire("8MHxr");
    var $kRXtb = parcelRequire("kRXtb");
    var $keXg2 = parcelRequire("keXg2");
    var $4oSDA = parcelRequire("4oSDA");
    var $1TGzV = parcelRequire("1TGzV");
    var $3zwh8 = parcelRequire("3zwh8");
    var $iDwTy = parcelRequire("iDwTy");
    var $4UBDE = parcelRequire("4UBDE");
    var $h04Oa = parcelRequire("h04Oa");
    var $d5m9O = parcelRequire("d5m9O");
    var $idm7a = parcelRequire("idm7a");
    var $anJhX = parcelRequire("anJhX");
    function $83ab40d9000064a6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $83ab40d9000064a6$var$fillScreenStyles = {
        name: "1yerbni",
        styles: "width:100vw;height:100vh;position:fixed;inset-block-start:var(--ds-space-0, 0);inset-inline-start:var(--ds-space-0, 0);overflow-y:auto;-webkit-overflow-scrolling:touch"
    };
    const $83ab40d9000064a6$var$allowlistElements = (element, callback)=>{
        if (element.hasAttribute('data-atlas-extension')) return false;
        if (typeof callback === 'function') return callback(element);
        return true;
    };
    const $83ab40d9000064a6$var$ModalWrapper = (props)=>{
        const { autoFocus: autoFocus = true, focusLockAllowlist: focusLockAllowlist, shouldCloseOnEscapePress: shouldCloseOnEscapePress = true, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick = true, shouldScrollInViewport: shouldScrollInViewport = false, shouldReturnFocus: shouldReturnFocus = true, stackIndex: stackIndexOverride, onClose: onClose = (0, $4oSDA.default), onStackChange: onStackChange = (0, $4oSDA.default), isBlanketHidden: isBlanketHidden, children: children, height: height, width: width, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, label: label, testId: testId } = props;
        const calculatedStackIndex = (0, $idm7a.default)({
            onStackChange: onStackChange
        });
        const stackIndex = stackIndexOverride || calculatedStackIndex;
        const isForeground = stackIndex === 0;
        const FocusLock = (0, $iDwTy.fg)('platform_dst_modal-dialog-bump-focus-lock') ? (0, $1TUfP.default) : (0, $6Pq2D.default);
        const autoFocusLock = typeof autoFocus === 'boolean' ? autoFocus : false;
        const onCloseHandler = (0, $kRXtb.usePlatformLeafEventHandler)({
            fn: onClose,
            action: 'closed',
            componentName: 'modalDialog',
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        });
        const onBlanketClicked = (0, $eUqFw.useCallback)((e)=>{
            if (shouldCloseOnOverlayClick) onCloseHandler(e);
        }, [
            shouldCloseOnOverlayClick,
            onCloseHandler
        ]);
        const allowListCallback = (0, $eUqFw.useCallback)((element)=>$83ab40d9000064a6$var$allowlistElements(element, focusLockAllowlist), [
            focusLockAllowlist
        ]);
        (0, $anJhX.default)();
        const modalDialogWithBlanket = (0, $byn9U.jsx)((0, $keXg2.default), {
            isTinted: !isBlanketHidden,
            onBlanketClicked: onBlanketClicked,
            testId: testId && `${testId}--blanket`
        }, (0, $byn9U.jsx)((0, $d5m9O.default), {
            testId: testId,
            label: label,
            autoFocus: autoFocus,
            stackIndex: stackIndex,
            onClose: onCloseHandler,
            shouldCloseOnEscapePress: shouldCloseOnEscapePress && isForeground,
            shouldScrollInViewport: shouldScrollInViewport,
            height: height,
            width: width,
            onCloseComplete: onCloseComplete,
            onOpenComplete: onOpenComplete
        }, children));
        let returnFocus = true;
        let onDeactivation;
        if ('boolean' === typeof shouldReturnFocus) returnFocus = shouldReturnFocus;
        else onDeactivation = ()=>{
            window.setTimeout(()=>{
                shouldReturnFocus.current?.focus();
            }, 0);
        };
        return (0, $byn9U.jsx)((0, $1TGzV.UNSAFE_LAYERING), {
            isDisabled: false
        }, (0, $byn9U.jsx)((0, $4UBDE.default), {
            zIndex: (0, $h04Oa.layers).modal()
        }, (0, $byn9U.jsx)((0, $3zwh8.default), null, (fadeInProps)=>(0, $byn9U.jsx)("div", {
                ...fadeInProps,
                css: $83ab40d9000064a6$var$fillScreenStyles,
                "aria-hidden": !isForeground
            }, (0, $byn9U.jsx)(FocusLock, {
                autoFocus: autoFocusLock,
                returnFocus: returnFocus,
                onDeactivation: onDeactivation,
                whiteList: allowListCallback
            }, (0, $byn9U.jsx)((0, ($parcel$interopDefault($8MHxr))), null), shouldScrollInViewport ? (0, $byn9U.jsx)((0, $8MHxr.TouchScrollable), null, modalDialogWithBlanket) : modalDialogWithBlanket)))));
    };
    var $83ab40d9000064a6$export$2e2bcd8739ae039 = $83ab40d9000064a6$var$ModalWrapper;
});
parcelRegister("keXg2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$69768a0f94b4bce6$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $kRXtb = parcelRequire("kRXtb");
    var $4oSDA = parcelRequire("4oSDA");
    var $h04Oa = parcelRequire("h04Oa");
    function $69768a0f94b4bce6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $69768a0f94b4bce6$var$packageName = "platform-pkg";
    const $69768a0f94b4bce6$var$packageVersion = "0.0.0-use.local";
    const $69768a0f94b4bce6$var$analyticsAttributes = {
        componentName: 'blanket',
        packageName: $69768a0f94b4bce6$var$packageName,
        packageVersion: $69768a0f94b4bce6$var$packageVersion
    };
    const $69768a0f94b4bce6$var$baseStyles = (0, $byn9U.css)({
        position: 'fixed',
        zIndex: (0, $h04Oa.layers).blanket(),
        inset: 0,
        backgroundColor: `var(--ds-blanket, ${(0, $207acf722dcd432b$export$486ab785e4bac3c6)})`,
        overflowY: 'auto',
        pointerEvents: 'initial'
    });
    const $69768a0f94b4bce6$var$shouldAllowClickThroughStyles = {
        name: "je8g23",
        styles: "pointer-events:none"
    };
    const $69768a0f94b4bce6$var$invisibleStyles = {
        name: "1peqg37",
        styles: "background-color:transparent"
    };
    const $69768a0f94b4bce6$var$Blanket = (0, $eUqFw.memo)((0, $eUqFw.forwardRef)(function Blanket({ shouldAllowClickThrough: shouldAllowClickThrough = false, isTinted: isTinted = false, onBlanketClicked: onBlanketClicked = (0, $4oSDA.default), testId: testId, children: children, analyticsContext: analyticsContext }, ref) {
        const mouseDownTarget = (0, $eUqFw.useRef)(null);
        const onBlanketClickedWithAnalytics = (0, $kRXtb.usePlatformLeafEventHandler)({
            fn: onBlanketClicked,
            action: 'clicked',
            analyticsData: analyticsContext,
            ...$69768a0f94b4bce6$var$analyticsAttributes
        });
        const blanketClickOutsideChildren = (0, $eUqFw.useCallback)((e)=>e.currentTarget === e.target && mouseDownTarget.current === e.target ? onBlanketClickedWithAnalytics(e) : undefined, [
            onBlanketClickedWithAnalytics
        ]);
        const onClick = shouldAllowClickThrough ? undefined : blanketClickOutsideChildren;
        const onMouseDown = (0, $eUqFw.useCallback)((e)=>{
            mouseDownTarget.current = e.target;
        }, []);
        return ((0, $byn9U.jsx)("div", {
            role: "presentation",
            css: [
                $69768a0f94b4bce6$var$baseStyles,
                shouldAllowClickThrough && $69768a0f94b4bce6$var$shouldAllowClickThroughStyles,
                !isTinted && $69768a0f94b4bce6$var$invisibleStyles
            ],
            onClick: onClick,
            onMouseDown: onMouseDown,
            "data-testid": testId,
            ref: ref
        }, children));
    }));
    $69768a0f94b4bce6$var$Blanket.displayName = 'Blanket';
    var $69768a0f94b4bce6$export$2e2bcd8739ae039 = $69768a0f94b4bce6$var$Blanket;
});
parcelRegister("d5m9O", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$35de90b0f19ec0b1$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $9xS6A = parcelRequire("9xS6A");
    var $lc5TP = parcelRequire("lc5TP");
    var $5aRS9 = parcelRequire("5aRS9");
    var $jcsHn = parcelRequire("jcsHn");
    var $01RXE = parcelRequire("01RXE");
    var $3zwh8 = parcelRequire("3zwh8");
    var $1wAEf = parcelRequire("1wAEf");
    var $jijTN = parcelRequire("jijTN");
    var $1e6Pr = parcelRequire("1e6Pr");
    var $a3dKr = parcelRequire("a3dKr");
    var $791jD = parcelRequire("791jD");
    var $ksXjt = parcelRequire("ksXjt");
    var $gpErV = parcelRequire("gpErV");
    var $b6tIq = parcelRequire("b6tIq");
    var $9JQf7 = parcelRequire("9JQf7");
    var $6hXsH = parcelRequire("6hXsH");
    var $gCvMJ = parcelRequire("gCvMJ");
    const $35de90b0f19ec0b1$var$dialogStyles = (0, $byn9U.css)({
        display: 'flex',
        width: '100%',
        maxWidth: '100vw',
        height: '100%',
        minHeight: 0,
        maxHeight: '100vh',
        flex: '0 1 auto',
        flexDirection: 'column',
        backgroundColor: `var(--ds-surface-overlay, ${(0, $207acf722dcd432b$export$29a4f05edc054374)})`,
        color: (0, $a3dKr.textColor),
        [(0, $1e6Pr.CURRENT_SURFACE_CSS_VAR)]: `var(--ds-surface-overlay, ${(0, $207acf722dcd432b$export$29a4f05edc054374)})`,
        pointerEvents: 'auto',
        [(0, $jijTN.media).above.xs]: {
            width: 'var(--modal-dialog-width)',
            maxWidth: 'inherit',
            borderRadius: (0, $a3dKr.borderRadius),
            boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $207acf722dcd432b$export$920c0d5c49070351)}, 0 2px 1px ${(0, $207acf722dcd432b$export$920c0d5c49070351)}, 0 0 20px -6px ${(0, $207acf722dcd432b$export$d2d3bedfb276cac0)}`})`,
            marginInlineEnd: 'inherit',
            marginInlineStart: 'inherit'
        },
        '& > form:only-child': {
            display: 'inherit',
            maxHeight: 'inherit',
            flexDirection: 'inherit'
        }
    });
    const $35de90b0f19ec0b1$var$viewportScrollStyles = (0, $byn9U.css)({
        minHeight: '100vh',
        maxHeight: 'none',
        [(0, $jijTN.media).above.xs]: {
            minHeight: 'var(--modal-dialog-height)'
        }
    });
    const $35de90b0f19ec0b1$var$bodyScrollStyles = (0, $byn9U.css)({
        [(0, $jijTN.media).above.xs]: {
            height: 'var(--modal-dialog-height)',
            maxHeight: 'inherit'
        }
    });
    const $35de90b0f19ec0b1$var$ModalDialog = (props)=>{
        const { width: width = 'medium', shouldScrollInViewport: shouldScrollInViewport = false, shouldCloseOnEscapePress: shouldCloseOnEscapePress, autoFocus: autoFocus, stackIndex: stackIndex, onClose: onClose, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, height: height, children: children, label: label, testId: testId } = props;
        const id = (0, $5aRS9.useId)();
        const titleId = `modal-dialog-title-${id}`;
        (0, $eUqFw.useEffect)(()=>{
            return (0, $1wAEf.combine)((0, $gpErV.disableDraggingToCrossOriginIFramesForElement)(), (0, $9JQf7.disableDraggingToCrossOriginIFramesForTextSelection)(), (0, $b6tIq.disableDraggingToCrossOriginIFramesForExternal)());
        }, []);
        (0, $lc5TP.default)(typeof autoFocus === 'object' ? autoFocus : undefined, typeof autoFocus === 'object');
        const [motionRef, onMotionFinish] = (0, $ksXjt.default)({
            onOpenComplete: onOpenComplete,
            onCloseComplete: onCloseComplete
        });
        const modalDialogContext = (0, $eUqFw.useMemo)(()=>({
                testId: testId,
                titleId: titleId,
                onClose: onClose
            }), [
            testId,
            titleId,
            onClose
        ]);
        (0, $01RXE.useCloseOnEscapePress)({
            onClose: onClose,
            isDisabled: !shouldCloseOnEscapePress
        });
        const { currentLevel: currentLevel } = (0, $01RXE.UNSAFE_useLayering)();
        return (0, $byn9U.jsx)((0, $gCvMJ.default), {
            stackIndex: stackIndex,
            shouldScrollInViewport: shouldScrollInViewport,
            testId: testId
        }, (0, $byn9U.jsx)((0, $791jD.ModalContext).Provider, {
            value: modalDialogContext
        }, (0, $byn9U.jsx)((0, $791jD.ScrollContext).Provider, {
            value: shouldScrollInViewport
        }, (0, $byn9U.jsx)((0, $3zwh8.default), {
            entranceDirection: "bottom",
            onFinish: onMotionFinish
        }, (bottomFadeInProps)=>(0, $byn9U.jsx)((0, $jcsHn.default), null, (0, $byn9U.jsx)("section", {
                ...bottomFadeInProps,
                "aria-label": label,
                ref: (0, $9xS6A.default)([
                    bottomFadeInProps.ref,
                    motionRef
                ]),
                style: {
                    '--modal-dialog-width': (0, $6hXsH.dialogWidth)(width),
                    '--modal-dialog-height': (0, $6hXsH.dialogHeight)(height)
                },
                css: [
                    $35de90b0f19ec0b1$var$dialogStyles,
                    shouldScrollInViewport ? $35de90b0f19ec0b1$var$viewportScrollStyles : $35de90b0f19ec0b1$var$bodyScrollStyles
                ],
                role: "dialog",
                "aria-labelledby": label ? undefined : titleId,
                "data-testid": testId,
                "data-modal-stack": stackIndex,
                tabIndex: -1,
                "aria-modal": true,
                "data-ds--level": currentLevel
            }, children))))));
    };
    var $35de90b0f19ec0b1$export$2e2bcd8739ae039 = $35de90b0f19ec0b1$var$ModalDialog;
});
parcelRegister("ksXjt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8070c69b5a0a5859$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    function $8070c69b5a0a5859$export$2e2bcd8739ae039({ onOpenComplete: onOpenComplete, onCloseComplete: onCloseComplete }) {
        const motionRef = (0, $eUqFw.useRef)(null);
        const onMotionFinish = (0, $eUqFw.useCallback)((state)=>{
            if (state === 'entering' && onOpenComplete) onOpenComplete(motionRef.current, true);
            if (state === 'exiting' && onCloseComplete) onCloseComplete(motionRef.current);
        }, [
            onOpenComplete,
            onCloseComplete
        ]);
        return [
            motionRef,
            onMotionFinish
        ];
    }
});
parcelRegister("gpErV", function(module, exports) {
    $parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForElement", ()=>$5d8c0402d2c441b1$export$ec28e97c7d8b1b35);
    var $74BVL = parcelRequire("74BVL");
    var $1wAEf = parcelRequire("1wAEf");
    var $fWAkH = parcelRequire("fWAkH");
    var $DNGsI = parcelRequire("DNGsI");
    function $5d8c0402d2c441b1$var$watchForInteractionEnd({ stop: stop }) {
        let isDragging = false;
        function stopIfNotDragging() {
            if (isDragging) return;
            stop();
        }
        const unbindEvents = (0, $74BVL.bindAll)(window, [
            {
                type: 'pointerdown',
                listener: stop
            },
            {
                type: 'pointerup',
                listener: stopIfNotDragging
            },
            {
                type: 'dragstart',
                listener: stopIfNotDragging,
                options: {
                    capture: false
                }
            }
        ], {
            capture: true,
            once: true
        });
        const unbindMonitor = (0, $fWAkH.monitorForElements)({
            onGenerateDragPreview () {
                isDragging = true;
            },
            onDrop () {
                isDragging = false;
                stop();
            }
        });
        return (0, $1wAEf.combine)(unbindEvents, unbindMonitor);
    }
    function $5d8c0402d2c441b1$var$watchForInteractionStart({ start: start }) {
        return (0, $74BVL.bind)(window, {
            type: 'mousedown',
            listener (event) {
                if (event.target instanceof HTMLElement && event.target.closest('[draggable="true"]')) start();
            }
        });
    }
    const $5d8c0402d2c441b1$var$api = (0, $DNGsI.makeFixForAdapter)({
        watchForInteractionStart: $5d8c0402d2c441b1$var$watchForInteractionStart,
        watchForInteractionEnd: $5d8c0402d2c441b1$var$watchForInteractionEnd
    });
    function $5d8c0402d2c441b1$export$ec28e97c7d8b1b35() {
        return $5d8c0402d2c441b1$var$api.registerUsage();
    }
});
parcelRegister("DNGsI", function(module, exports) {
    $parcel$export(module.exports, "makeFixForAdapter", ()=>$1fb0a1f3fd67d117$export$a74bff2507e6126b);
    var $1wAEf = parcelRequire("1wAEf");
    function $1fb0a1f3fd67d117$var$setStyle(el, { property: property, rule: rule, priority: priority = '' }) {
        const originalValue = el.style.getPropertyValue(property);
        const originalPriority = el.style.getPropertyPriority(property);
        el.style.setProperty(property, rule, priority);
        return function cleanup() {
            el.style.setProperty(property, originalValue, originalPriority);
        };
    }
    function $1fb0a1f3fd67d117$var$hasSameOrigin(href1, href2) {
        let url1;
        let url2;
        try {
            url1 = new URL(href1);
            url2 = new URL(href2);
        } catch (error) {
            return false;
        }
        return url1.protocol === url2.protocol && url1.host === url2.host && url1.port === url2.port;
    }
    function $1fb0a1f3fd67d117$var$isIframeOnAnotherDomain(iframe) {
        if (iframe.srcdoc) return false;
        if (iframe.src.startsWith('data:')) return false;
        return !$1fb0a1f3fd67d117$var$hasSameOrigin(window.location.href, iframe.src);
    }
    const $1fb0a1f3fd67d117$var$registry = new Map();
    function $1fb0a1f3fd67d117$var$applyFix(watchForEndOfInteraction) {
        const iframes = Array.from(document.querySelectorAll('iframe')).filter($1fb0a1f3fd67d117$var$isIframeOnAnotherDomain);
        const cleanups = iframes.map((iframe)=>{
            let entry = $1fb0a1f3fd67d117$var$registry.get(iframe);
            if (!entry) {
                entry = {
                    reset: $1fb0a1f3fd67d117$var$setStyle(iframe, {
                        property: 'pointer-events',
                        rule: 'none',
                        priority: 'important'
                    }),
                    count: 1
                };
                $1fb0a1f3fd67d117$var$registry.set(iframe, entry);
            } else entry.count++;
            return function cleanup() {
                entry.count--;
                if (entry.count < 1) {
                    entry.reset();
                    $1fb0a1f3fd67d117$var$registry.delete(iframe);
                }
            };
        });
        function stop() {
            cleanupWatcher();
            (0, $1wAEf.combine)(...cleanups)();
        }
        const cleanupWatcher = watchForEndOfInteraction({
            stop: stop
        });
    }
    function $1fb0a1f3fd67d117$export$a74bff2507e6126b({ watchForInteractionStart: watchForInteractionStart, watchForInteractionEnd: watchForInteractionEnd }) {
        let registrationCount = 0;
        let stopWatchingInteractionStart = null;
        function start() {
            $1fb0a1f3fd67d117$var$applyFix(watchForInteractionEnd);
        }
        function registerUsage() {
            if (registrationCount === 0) stopWatchingInteractionStart = watchForInteractionStart({
                start: start
            });
            registrationCount++;
            return function unregisterUsage() {
                registrationCount--;
                if (registrationCount !== 0) return;
                stopWatchingInteractionStart?.();
                stopWatchingInteractionStart = null;
            };
        }
        return {
            registerUsage: registerUsage
        };
    }
});
parcelRegister("b6tIq", function(module, exports) {
    $parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForExternal", ()=>$6be51a40214613e4$export$27d79116d3a4e7d5);
    var $7n923 = parcelRequire("7n923");
    var $DNGsI = parcelRequire("DNGsI");
    function $6be51a40214613e4$var$watchForInteractionStart({ start: start }) {
        return (0, $7n923.monitorForExternal)({
            onDragStart () {
                start();
            }
        });
    }
    function $6be51a40214613e4$var$watchForInteractionEnd({ stop: stop }) {
        return (0, $7n923.monitorForExternal)({
            onDrop () {
                stop();
            }
        });
    }
    const $6be51a40214613e4$var$api = (0, $DNGsI.makeFixForAdapter)({
        watchForInteractionStart: $6be51a40214613e4$var$watchForInteractionStart,
        watchForInteractionEnd: $6be51a40214613e4$var$watchForInteractionEnd
    });
    function $6be51a40214613e4$export$27d79116d3a4e7d5() {
        return $6be51a40214613e4$var$api.registerUsage();
    }
});
parcelRegister("9JQf7", function(module, exports) {
    $parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForTextSelection", ()=>$b4d80bfe27489276$export$9c0606fcefb5d1e2);
    var $74BVL = parcelRequire("74BVL");
    var $1wAEf = parcelRequire("1wAEf");
    var $8coz1 = parcelRequire("8coz1");
    var $DNGsI = parcelRequire("DNGsI");
    function $b4d80bfe27489276$var$watchForInteractionEnd({ stop: stop }) {
        let isDragging = false;
        function stopIfNotDragging() {
            if (isDragging) return;
            stop();
        }
        let frameId = null;
        const unbindEvents = (0, $74BVL.bindAll)(window, [
            {
                type: 'pointerdown',
                listener: stop
            },
            {
                type: 'pointerup',
                listener: stopIfNotDragging
            },
            {
                type: 'dragstart',
                listener () {
                    frameId = requestAnimationFrame(()=>{
                        frameId = null;
                        stopIfNotDragging();
                    });
                },
                options: {
                    capture: false
                }
            }
        ], {
            capture: true,
            once: true
        });
        const unbindMonitor = (0, $8coz1.monitorForTextSelection)({
            onDragStart () {
                isDragging = true;
            },
            onDrop () {
                isDragging = false;
                stop();
            }
        });
        return (0, $1wAEf.combine)(unbindEvents, unbindMonitor, function abortFrame() {
            if (frameId != null) cancelAnimationFrame(frameId);
        });
    }
    function $b4d80bfe27489276$var$watchForInteractionStart({ start: start }) {
        return (0, $74BVL.bind)(window, {
            type: 'mousedown',
            listener () {
                const selection = window.getSelection();
                if (!selection) return;
                if (selection.isCollapsed) return;
                start();
            }
        });
    }
    const $b4d80bfe27489276$var$api = (0, $DNGsI.makeFixForAdapter)({
        watchForInteractionStart: $b4d80bfe27489276$var$watchForInteractionStart,
        watchForInteractionEnd: $b4d80bfe27489276$var$watchForInteractionEnd
    });
    function $b4d80bfe27489276$export$9c0606fcefb5d1e2() {
        return $b4d80bfe27489276$var$api.registerUsage();
    }
});
parcelRegister("6hXsH", function(module, exports) {
    $parcel$export(module.exports, "dialogWidth", ()=>$6ceb3256c0ac8bae$export$a3da89b899389ed8);
    $parcel$export(module.exports, "dialogHeight", ()=>$6ceb3256c0ac8bae$export$ceba93bf0bdd16f2);
    var $a3dKr = parcelRequire("a3dKr");
    const $6ceb3256c0ac8bae$export$a3da89b899389ed8 = (input)=>{
        if (!input) return 'auto';
        const isWidthName = (0, $a3dKr.width).values.indexOf(input.toString()) !== -1;
        const widthName = isWidthName && input;
        if (widthName) return `${(0, $a3dKr.width).widths[widthName]}px`;
        return typeof input === 'number' ? `${input}px` : input;
    };
    const $6ceb3256c0ac8bae$export$ceba93bf0bdd16f2 = (input)=>{
        if (!input) return 'auto';
        return typeof input === 'number' ? `${input}px` : input;
    };
});
parcelRegister("gCvMJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b894acecee680be2$export$2e2bcd8739ae039);
    var $byn9U = parcelRequire("byn9U");
    var $gN8bb = parcelRequire("gN8bb");
    var $jijTN = parcelRequire("jijTN");
    var $h04Oa = parcelRequire("h04Oa");
    var $a3dKr = parcelRequire("a3dKr");
    function $b894acecee680be2$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $b894acecee680be2$var$maxWidthDimensions = `calc(100vw - ${(0, $a3dKr.gutter) * 2}px)`;
    const $b894acecee680be2$var$maxHeightDimensions = `calc(100vh - ${(0, $a3dKr.gutter) * 2 - 1}px)`;
    const $b894acecee680be2$var$positionerStyles = (0, $byn9U.css)({
        display: 'flex',
        width: '100%',
        maxWidth: '100%',
        height: '100%',
        position: 'fixed',
        zIndex: (0, $h04Oa.layers).modal(),
        flexDirection: 'column',
        insetBlockStart: 0,
        insetInlineStart: 0
    });
    const $b894acecee680be2$var$viewportScrollStyles = (0, $byn9U.css)({
        height: 'auto',
        position: 'relative',
        [(0, $jijTN.media).above.xs]: {
            margin: `${(0, $a3dKr.gutter)}px auto`,
            pointerEvents: 'none'
        }
    });
    const $b894acecee680be2$var$bodyScrollStyles = (0, $byn9U.css)({
        [(0, $jijTN.media).above.xs]: {
            maxWidth: $b894acecee680be2$var$maxWidthDimensions,
            maxHeight: $b894acecee680be2$var$maxHeightDimensions,
            position: 'absolute',
            insetBlockStart: `${(0, $a3dKr.gutter)}px`,
            insetInlineEnd: 0,
            insetInlineStart: 0,
            marginInlineEnd: 'auto',
            marginInlineStart: 'auto',
            pointerEvents: 'none'
        }
    });
    const $b894acecee680be2$var$stackTransitionStyles = (0, $byn9U.css)({
        transitionDuration: `${(0, $gN8bb.mediumDurationMs)}ms`,
        transitionProperty: 'transform',
        transitionTimingFunction: (0, $cb3878f71492e237$export$c07234257a03d5e9),
        '@media (prefers-reduced-motion: reduce)': {
            animation: 'none',
            transition: 'none'
        }
    });
    const $b894acecee680be2$var$stackTransformStyles = {
        name: "937ak9",
        styles: "transform:translateY(var(--modal-dialog-translate-y))"
    };
    const $b894acecee680be2$var$stackIdleStyles = {
        name: "179q9ic",
        styles: "transform:none"
    };
    const $b894acecee680be2$var$Positioner = (props)=>{
        const { children: children, stackIndex: stackIndex, shouldScrollInViewport: shouldScrollInViewport, testId: testId } = props;
        return (0, $byn9U.jsx)("div", {
            style: {
                '--modal-dialog-translate-y': `${stackIndex * ((0, $a3dKr.verticalOffset) / 2)}px`
            },
            css: [
                $b894acecee680be2$var$positionerStyles,
                $b894acecee680be2$var$stackTransitionStyles,
                stackIndex > 0 ? $b894acecee680be2$var$stackTransformStyles : $b894acecee680be2$var$stackIdleStyles,
                shouldScrollInViewport ? $b894acecee680be2$var$viewportScrollStyles : $b894acecee680be2$var$bodyScrollStyles
            ],
            "data-testid": testId && `${testId}--positioner`
        }, children);
    };
    var $b894acecee680be2$export$2e2bcd8739ae039 = $b894acecee680be2$var$Positioner;
});
const $cb3878f71492e237$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $cb3878f71492e237$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $cb3878f71492e237$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
parcelRegister("idm7a", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$508cb70916a133e3$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $dAXH1 = parcelRequire("dAXH1");
    var $lnAMz = parcelRequire("lnAMz");
    var $gVxCl = parcelRequire("gVxCl");
    var $amx2g = parcelRequire("amx2g");
    const $508cb70916a133e3$var$modalStackRegister = [];
    function $508cb70916a133e3$export$2e2bcd8739ae039({ onStackChange: onStackChange }) {
        const { isExiting: isExiting } = (0, $amx2g.useExitingPersistence)();
        const [stackIndexRef, setStackIndex] = (0, $gVxCl.default)(0);
        const currentStackIndex = stackIndexRef.current;
        const previousStackIndex = (0, $lnAMz.default)(stackIndexRef.current);
        const updateStack = (0, $dAXH1.default)(()=>{
            const newStackIndex = $508cb70916a133e3$var$modalStackRegister.indexOf(updateStack);
            if (stackIndexRef.current !== newStackIndex) {
                setStackIndex(newStackIndex);
                stackIndexRef.current = newStackIndex;
            }
        });
        (0, $eUqFw.useEffect)(()=>{
            const currentStackIndex = $508cb70916a133e3$var$modalStackRegister.indexOf(updateStack);
            if (!isExiting && currentStackIndex === -1) $508cb70916a133e3$var$modalStackRegister.unshift(updateStack);
            if (isExiting && currentStackIndex !== -1) $508cb70916a133e3$var$modalStackRegister.splice(currentStackIndex, 1);
            $508cb70916a133e3$var$modalStackRegister.forEach((cb)=>cb());
        }, [
            updateStack,
            isExiting
        ]);
        (0, $eUqFw.useEffect)(()=>()=>{
                const currentStackIndex = $508cb70916a133e3$var$modalStackRegister.indexOf(updateStack);
                if (currentStackIndex !== -1) {
                    $508cb70916a133e3$var$modalStackRegister.splice(currentStackIndex, 1);
                    $508cb70916a133e3$var$modalStackRegister.forEach((cb)=>cb());
                }
            }, [
            updateStack
        ]);
        (0, $eUqFw.useEffect)(()=>{
            if (previousStackIndex === undefined) return;
            if (previousStackIndex !== currentStackIndex) onStackChange(currentStackIndex);
        }, [
            onStackChange,
            previousStackIndex,
            currentStackIndex
        ]);
        return currentStackIndex;
    }
});
parcelRegister("lnAMz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$94b5a56fa1824f4c$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    function $94b5a56fa1824f4c$export$2e2bcd8739ae039(value) {
        const ref = (0, $eUqFw.useRef)();
        (0, $eUqFw.useEffect)(()=>{
            ref.current = value;
        }, [
            value
        ]);
        return ref.current;
    }
});
parcelRegister("anJhX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$74d9027b2bd91c46$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $74BVL = parcelRequire("74BVL");
    function $74d9027b2bd91c46$var$getScrollDistance() {
        return window.pageYOffset || document.documentElement?.scrollTop || document.body?.scrollTop || 0;
    }
    function $74d9027b2bd91c46$export$2e2bcd8739ae039() {
        const [scrollTopOffset, setScrollTopOffset] = (0, $eUqFw.useState)(0);
        (0, $eUqFw.useLayoutEffect)(()=>{
            setScrollTopOffset($74d9027b2bd91c46$var$getScrollDistance());
        }, []);
        const onWindowScroll = (0, $eUqFw.useCallback)(()=>{
            if ($74d9027b2bd91c46$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
        }, [
            scrollTopOffset
        ]);
        (0, $eUqFw.useEffect)(()=>{
            return (0, $74BVL.bind)(window, {
                type: 'scroll',
                listener: onWindowScroll
            });
        }, [
            onWindowScroll
        ]);
        return scrollTopOffset;
    }
});
parcelRegister("23sYR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4cc555413d7ca25f$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "Popup", ()=>(parcelRequire("2wYke")).Popup);
    var $2wYke = parcelRequire("2wYke");
    var $4cc555413d7ca25f$export$2e2bcd8739ae039 = (0, $2wYke.Popup);
});
parcelRegister("2wYke", function(module, exports) {
    $parcel$export(module.exports, "Popup", ()=>$4f0093f36846e0fb$export$129a32eedafa97c5);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $5aRS9 = parcelRequire("5aRS9");
    var $1TGzV = parcelRequire("1TGzV");
    var $bsJFv = parcelRequire("bsJFv");
    var $iDwTy = parcelRequire("iDwTy");
    var $4hd8s = parcelRequire("4hd8s");
    var $2JWZX = parcelRequire("2JWZX");
    var $4UBDE = parcelRequire("4UBDE");
    var $jGR8u = parcelRequire("jGR8u");
    var $fHiYa = parcelRequire("fHiYa");
    var $h04Oa = parcelRequire("h04Oa");
    var $7Xcw6 = parcelRequire("7Xcw6");
    var $34wbZ = parcelRequire("34wbZ");
    var $B432y = parcelRequire("B432y");
    var $2t9vK = parcelRequire("2t9vK");
    const $4f0093f36846e0fb$var$defaultLayer = (0, $h04Oa.layers).layer();
    const $4f0093f36846e0fb$var$wrapperStyles = (0, $fHiYa.xcss)({
        position: 'relative'
    });
    const $4f0093f36846e0fb$export$129a32eedafa97c5 = (0, $eUqFw.memo)(({ xcss: xcss, appearance: inAppearance = 'default', isOpen: isOpen, id: providedId, offset: offset, testId: testId, trigger: trigger, content: content, onClose: onClose, boundary: boundary, rootBoundary: rootBoundary = 'viewport', shouldFlip: shouldFlip = true, placement: placement = 'auto', fallbackPlacements: fallbackPlacements, popupComponent: PopupContainer, autoFocus: autoFocus = true, zIndex: zIndex = $4f0093f36846e0fb$var$defaultLayer, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick = false, shouldRenderToParent: inShouldRenderToParent = false, shouldFitContainer: shouldFitContainer = false, shouldDisableFocusLock: shouldDisableFocusLock = false, shouldReturnFocus: shouldReturnFocus = true, strategy: strategy, role: role, label: label, titleId: titleId, modifiers: modifiers, shouldFitViewport: shouldFitViewport })=>{
        const [triggerRef, setTriggerRef] = (0, $eUqFw.useState)(null);
        const getMergedTriggerRef = (0, $B432y.useGetMemoizedMergedTriggerRef)();
        const getMergedTriggerRefNew = (0, $2t9vK.useGetMemoizedMergedTriggerRefNew)();
        const generatedId = (0, $5aRS9.useId)();
        const { appearance: appearance, shouldRenderToParent: shouldRenderToParent } = (0, $34wbZ.usePopupAppearance)({
            appearance: inAppearance,
            shouldRenderToParent: inShouldRenderToParent
        });
        const id = providedId || generatedId;
        (0, $bsJFv.useNotifyOpenLayerObserver)({
            isOpen: isOpen
        });
        const renderPopperWrapper = (0, $byn9U.jsx)((0, $1TGzV.UNSAFE_LAYERING), {
            isDisabled: false
        }, (0, $byn9U.jsx)((0, $7Xcw6.default), {
            xcss: xcss,
            appearance: appearance,
            content: content,
            isOpen: isOpen,
            placement: placement,
            fallbackPlacements: fallbackPlacements,
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: shouldFlip,
            offset: offset,
            popupComponent: PopupContainer,
            id: id,
            testId: testId,
            onClose: onClose,
            autoFocus: autoFocus,
            shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
            shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
            shouldFitContainer: shouldFitContainer,
            shouldDisableFocusLock: shouldDisableFocusLock,
            shouldReturnFocus: shouldReturnFocus,
            triggerRef: triggerRef,
            strategy: shouldFitContainer ? 'absolute' : strategy,
            role: role,
            label: label,
            titleId: titleId,
            modifiers: modifiers,
            shouldFitViewport: shouldFitViewport
        }));
        const popupContent = (0, $byn9U.jsx)((0, $4hd8s.Manager), null, (0, $byn9U.jsx)((0, $2JWZX.Reference), null, ({ ref: ref })=>{
            return trigger({
                ref: !(0, $iDwTy.fg)('platform-design-system-dsp-20476-dropdown-menu') ? getMergedTriggerRef(ref, setTriggerRef, isOpen) : getMergedTriggerRefNew(ref, setTriggerRef),
                'aria-controls': isOpen ? id : undefined,
                'aria-expanded': isOpen,
                'aria-haspopup': role === 'dialog' && (0, $iDwTy.fg)('platform_dst_popup-disable-focuslock') ? 'dialog' : true
            });
        }), isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : (0, $byn9U.jsx)((0, $4UBDE.default), {
            zIndex: zIndex
        }, renderPopperWrapper)));
        if (shouldFitContainer) return (0, $byn9U.jsx)((0, $jGR8u.default), {
            xcss: $4f0093f36846e0fb$var$wrapperStyles
        }, popupContent);
        return popupContent;
    });
    var $4f0093f36846e0fb$export$2e2bcd8739ae039 = $4f0093f36846e0fb$export$129a32eedafa97c5;
});
parcelRegister("7Xcw6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$af9b8ea80c9b8f1b$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $jcsHn = parcelRequire("jcsHn");
    var $01RXE = parcelRequire("01RXE");
    var $iDwTy = parcelRequire("iDwTy");
    var $jLWxm = parcelRequire("jLWxm");
    var $h04Oa = parcelRequire("h04Oa");
    var $1e6Pr = parcelRequire("1e6Pr");
    var $4EEnS = parcelRequire("4EEnS");
    var $29cWE = parcelRequire("29cWE");
    var $8CtAs = parcelRequire("8CtAs");
    function $af9b8ea80c9b8f1b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $af9b8ea80c9b8f1b$var$fullWidthStyles = {
        name: "1d3w5wq",
        styles: "width:100%"
    };
    const $af9b8ea80c9b8f1b$var$rootStyles = (0, $byn9U.css)({
        display: 'block',
        boxSizing: 'border-box',
        zIndex: (0, $h04Oa.layers).layer(),
        backgroundColor: `var(--ds-surface-overlay, ${(0, $207acf722dcd432b$export$29a4f05edc054374)})`,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $207acf722dcd432b$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $207acf722dcd432b$export$d2d3bedfb276cac0)}`})`,
        color: "var(--ds-text, #172B4D)",
        [(0, $1e6Pr.CURRENT_SURFACE_CSS_VAR)]: `var(--ds-surface-overlay, ${(0, $207acf722dcd432b$export$29a4f05edc054374)})`,
        '&:focus': {
            outline: 'none'
        }
    });
    const $af9b8ea80c9b8f1b$var$scrollableStyles = {
        name: "1qmr6ab",
        styles: "overflow:auto"
    };
    const $af9b8ea80c9b8f1b$var$blanketStyles = {
        name: "nsh9jl",
        styles: "position:fixed;inset:0;background-color:var(--ds-blanket, #091E427D)"
    };
    const $af9b8ea80c9b8f1b$var$modalStyles = {
        name: "1rni9zo",
        styles: "max-height:50vh;position:fixed;inset-block-start:var(--ds-space-050, 4px);inset-inline:var(--ds-space-050, 4px)"
    };
    const $af9b8ea80c9b8f1b$var$DefaultPopupComponent = (0, $eUqFw.forwardRef)((props, ref)=>{
        const { shouldRenderToParent: shouldRenderToParent, shouldFitContainer: shouldFitContainer, children: children, appearance: appearance, xcss: xcss, ...htmlAttributes } = props;
        return (0, $byn9U.jsx)("div", {
            className: xcss,
            css: [
                $af9b8ea80c9b8f1b$var$rootStyles,
                appearance === 'UNSAFE_modal-below-sm' && $af9b8ea80c9b8f1b$var$modalStyles,
                !shouldRenderToParent && $af9b8ea80c9b8f1b$var$scrollableStyles,
                shouldFitContainer && $af9b8ea80c9b8f1b$var$fullWidthStyles
            ],
            ...htmlAttributes,
            ref: ref
        }, children);
    });
    function $af9b8ea80c9b8f1b$var$PopperWrapper({ xcss: xcss, isOpen: isOpen, id: id, offset: offset, testId: testId, content: content, fallbackPlacements: fallbackPlacements, onClose: onClose, boundary: boundary, rootBoundary: rootBoundary, shouldFlip: shouldFlip, placement: placement = 'auto', popupComponent: PopupContainer = $af9b8ea80c9b8f1b$var$DefaultPopupComponent, autoFocus: autoFocus = true, triggerRef: triggerRef, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick, shouldRenderToParent: shouldRenderToParent, shouldFitContainer: shouldFitContainer, shouldDisableFocusLock: shouldDisableFocusLock, shouldReturnFocus: shouldReturnFocus = true, strategy: strategy, role: role, label: label, titleId: titleId, modifiers: modifiers, shouldFitViewport: shouldFitViewport, appearance: appearance = 'default' }) {
        const [popupRef, setPopupRef] = (0, $eUqFw.useState)(null);
        const [initialFocusRef, setInitialFocusRef] = (0, $eUqFw.useState)(null);
        const shouldCloseOnTab = shouldRenderToParent && shouldDisableFocusLock;
        const shouldDisableFocusTrap = role !== 'dialog';
        (0, $8CtAs.useFocusManager)({
            initialFocusRef: initialFocusRef,
            popupRef: popupRef,
            shouldCloseOnTab: shouldCloseOnTab,
            triggerRef: triggerRef,
            autoFocus: autoFocus,
            shouldDisableFocusTrap: shouldDisableFocusTrap,
            shouldReturnFocus: shouldReturnFocus
        });
        (0, $29cWE.useCloseManager)({
            isOpen: isOpen,
            onClose: onClose,
            popupRef: popupRef,
            triggerRef: triggerRef,
            shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
            shouldCloseOnTab: shouldCloseOnTab,
            autoFocus: autoFocus,
            shouldDisableFocusTrap: shouldDisableFocusTrap,
            shouldRenderToParent: shouldRenderToParent
        });
        const { currentLevel: currentLevel } = (0, $01RXE.UNSAFE_useLayering)();
        const mergedModifiers = (0, $eUqFw.useMemo)(()=>[
                {
                    name: 'flip',
                    enabled: shouldFlip,
                    options: {
                        rootBoundary: rootBoundary,
                        boundary: boundary,
                        fallbackPlacements: fallbackPlacements
                    }
                },
                ...modifiers || []
            ], [
            shouldFlip,
            rootBoundary,
            boundary,
            fallbackPlacements,
            modifiers
        ]);
        return (0, $byn9U.jsx)((0, $jLWxm.Popper), {
            placement: placement,
            offset: offset,
            modifiers: mergedModifiers,
            strategy: strategy,
            shouldFitViewport: shouldFitViewport
        }, ({ ref: ref, style: style, placement: placement, update: update })=>{
            const popupContainer = (0, $byn9U.jsx)(PopupContainer, {
                xcss: xcss,
                appearance: appearance,
                id: id,
                "data-ds--level": currentLevel,
                "data-placement": placement,
                "data-testid": testId,
                role: role,
                "aria-label": label,
                "aria-labelledby": titleId,
                ref: (node)=>{
                    if (node) {
                        if (typeof ref === 'function') ref(node);
                        else ref.current = node;
                        setPopupRef(node);
                    }
                },
                style: appearance === 'UNSAFE_modal-below-sm' ? {} : style,
                tabIndex: autoFocus ? 0 : undefined,
                shouldRenderToParent: shouldRenderToParent,
                shouldFitContainer: shouldFitContainer
            }, (0, $byn9U.jsx)((0, $4EEnS.RepositionOnUpdate), {
                update: update
            }, content({
                update: update,
                isOpen: isOpen,
                onClose: onClose,
                setInitialFocusRef: setInitialFocusRef
            })));
            return !initialFocusRef && (0, $iDwTy.fg)('platform-design-system-apply-popup-wrapper-focus') ? (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)((0, $jcsHn.default), null, popupContainer), appearance === 'UNSAFE_modal-below-sm' && (0, $byn9U.jsx)("div", {
                css: $af9b8ea80c9b8f1b$var$blanketStyles
            })) : (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, popupContainer, appearance === 'UNSAFE_modal-below-sm' && (0, $byn9U.jsx)("div", {
                css: $af9b8ea80c9b8f1b$var$blanketStyles
            }));
        });
    }
    var $af9b8ea80c9b8f1b$export$2e2bcd8739ae039 = $af9b8ea80c9b8f1b$var$PopperWrapper;
});
parcelRegister("4EEnS", function(module, exports) {
    $parcel$export(module.exports, "RepositionOnUpdate", ()=>$782308605a23bebf$export$51eddd7655ca235a);
    var $eUqFw = parcelRequire("eUqFw");
    const $782308605a23bebf$export$51eddd7655ca235a = ({ children: children, update: update })=>{
        const isFirstRenderRef = (0, $eUqFw.useRef)(true);
        (0, $eUqFw.useLayoutEffect)(()=>{
            if (isFirstRenderRef.current) {
                isFirstRenderRef.current = false;
                return;
            }
            update();
        }, [
            update
        ]);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, children);
    };
});
parcelRegister("29cWE", function(module, exports) {
    $parcel$export(module.exports, "useCloseManager", ()=>$6cfacdc0088c0830$export$92dae2778ae88f9d);
    var $eUqFw = parcelRequire("eUqFw");
    var $74BVL = parcelRequire("74BVL");
    var $4oSDA = parcelRequire("4oSDA");
    var $01RXE = parcelRequire("01RXE");
    var $iDwTy = parcelRequire("iDwTy");
    var $6syqS = parcelRequire("6syqS");
    var $co3Uu = parcelRequire("co3Uu");
    const $6cfacdc0088c0830$export$92dae2778ae88f9d = ({ isOpen: isOpen, onClose: onClose, popupRef: popupRef, triggerRef: triggerRef, autoFocus: autoFocus, shouldDisableFocusTrap: shouldDisableFocusTrap, shouldUseCaptureOnOutsideClick: capture, shouldCloseOnTab: shouldCloseOnTab, shouldRenderToParent: shouldRenderToParent })=>{
        const { isLayerDisabled: isLayerDisabled, currentLevel: currentLevel } = (0, $01RXE.UNSAFE_useLayering)();
        const { requestFrame: requestFrame, cancelAllFrames: cancelAllFrames } = (0, $co3Uu.useAnimationFrame)();
        (0, $eUqFw.useEffect)(()=>{
            if (!isOpen || !popupRef) return 0, $4oSDA.default;
            const closePopup = (event)=>{
                if (onClose) {
                    if ((0, $iDwTy.fg)('sibling-dropdown-close-issue')) {
                        let currentLevel = null;
                        if (event.target instanceof HTMLElement) currentLevel = event.target.closest(`[data-ds--level]`)?.getAttribute('data-ds--level');
                        currentLevel ? onClose(event, Number(currentLevel)) : onClose(event);
                    } else onClose(event);
                }
                if (shouldDisableFocusTrap && (0, $iDwTy.fg)('platform_dst_popup-disable-focuslock')) requestFrame(()=>{
                    triggerRef?.setAttribute('tabindex', '0');
                    if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '0');
                });
            };
            const onClick = (event)=>{
                const { target: target } = event;
                const doesDomNodeExist = document.body.contains(target);
                if (!doesDomNodeExist) return;
                if (isLayerDisabled()) {
                    if ((0, $iDwTy.fg)('design-system-closed-all-when-click-outside')) {
                        if (target instanceof HTMLElement) {
                            const levelOfClickedLayer = target.closest?.(`[data-ds--level]`)?.getAttribute('data-ds--level');
                            if (levelOfClickedLayer && Number(levelOfClickedLayer) > currentLevel) return;
                        }
                    } else return;
                }
                const isClickOnPopup = popupRef && popupRef.contains(target);
                const isClickOnTrigger = triggerRef && triggerRef.contains(target);
                if (!isClickOnPopup && !isClickOnTrigger) {
                    closePopup(event);
                    if (document.activeElement && !(0, $6syqS.isInteractiveElement)(document.activeElement) && (0, $iDwTy.fg)('platform_dst_popup-disable-focuslock')) triggerRef?.focus();
                }
            };
            const onKeyDown = (event)=>{
                if ((0, $iDwTy.fg)('platform_dst_popup-disable-focuslock')) {
                    const { key: key, shiftKey: shiftKey } = event;
                    if (shiftKey && key === 'Tab' && !shouldRenderToParent) {
                        if (isLayerDisabled()) return;
                        requestFrame(()=>{
                            const isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                            if (isPopupFocusOut) {
                                closePopup(event);
                                if (currentLevel === 1) triggerRef?.focus();
                            }
                        });
                        return;
                    }
                    if (key === 'Tab') {
                        if (shouldCloseOnTab) {
                            if (isLayerDisabled()) return;
                            closePopup(event);
                            return;
                        }
                        if (isLayerDisabled() && document.activeElement?.closest('[aria-modal]')) return;
                        if (shouldDisableFocusTrap) {
                            if (shouldRenderToParent) requestFrame(()=>{
                                const isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                                if (isPopupFocusOut) closePopup(event);
                            });
                            else requestFrame(()=>{
                                if (!document.hasFocus()) closePopup(event);
                            });
                            return;
                        }
                    }
                    if (isLayerDisabled()) return;
                    if (key === 'Escape' || key === 'Esc') {
                        if (triggerRef && autoFocus) triggerRef.focus();
                        closePopup(event);
                    }
                } else {
                    if (isLayerDisabled()) return;
                    const { key: key } = event;
                    if (key === 'Escape' || key === 'Esc' || shouldCloseOnTab && key === 'Tab') closePopup(event);
                }
            };
            const unbind = (0, $74BVL.bindAll)(window, [
                {
                    type: 'click',
                    listener: onClick,
                    options: {
                        capture: capture
                    }
                },
                {
                    type: 'keydown',
                    listener: onKeyDown
                }
            ]);
            let unbindBlur = (0, $4oSDA.default);
            unbindBlur = (0, $74BVL.bind)(window, {
                type: 'blur',
                listener: function onBlur(e) {
                    if (isLayerDisabled() || !(document.activeElement instanceof HTMLIFrameElement)) return;
                    closePopup(e);
                }
            });
            return ()=>{
                cancelAllFrames();
                unbind();
                unbindBlur();
            };
        }, [
            isOpen,
            onClose,
            popupRef,
            triggerRef,
            autoFocus,
            shouldDisableFocusTrap,
            capture,
            isLayerDisabled,
            shouldCloseOnTab,
            currentLevel,
            shouldRenderToParent,
            requestFrame,
            cancelAllFrames
        ]);
    };
});
parcelRegister("6syqS", function(module, exports) {
    $parcel$export(module.exports, "isInteractiveElement", ()=>$7e2faaaec26a9042$export$3dee5e4542c672d9);
    const $7e2faaaec26a9042$var$interactiveTags = [
        'button',
        'a',
        'input',
        'select',
        'textarea'
    ];
    const $7e2faaaec26a9042$export$3dee5e4542c672d9 = (element)=>{
        if ($7e2faaaec26a9042$var$interactiveTags.includes(element.tagName.toLowerCase())) return true;
        if (element.getAttribute('tabindex') !== null || element.hasAttribute('contenteditable')) return true;
        return false;
    };
});
parcelRegister("co3Uu", function(module, exports) {
    $parcel$export(module.exports, "useAnimationFrame", ()=>$b231424a1d095352$export$641fa9c94086b46e);
    var $eUqFw = parcelRequire("eUqFw");
    const $b231424a1d095352$export$641fa9c94086b46e = ()=>{
        const animationsRef = (0, $eUqFw.useRef)([]);
        const requestFrame = (0, $eUqFw.useCallback)((callback)=>{
            const id = requestAnimationFrame(callback);
            animationsRef.current.push(id);
            return id;
        }, []);
        const cancelFrame = (0, $eUqFw.useCallback)((id)=>{
            cancelAnimationFrame(id);
            animationsRef.current = animationsRef.current.filter((frameId)=>frameId !== id);
        }, []);
        const cancelAllFrames = (0, $eUqFw.useCallback)(()=>{
            animationsRef.current.forEach((id)=>cancelAnimationFrame(id));
            animationsRef.current = [];
        }, []);
        return {
            requestFrame: requestFrame,
            cancelFrame: cancelFrame,
            cancelAllFrames: cancelAllFrames
        };
    };
});
parcelRegister("8CtAs", function(module, exports) {
    $parcel$export(module.exports, "useFocusManager", ()=>$a195adf725331444$export$10c5169755ce7bd7);
    var $eUqFw = parcelRequire("eUqFw");
    var $a2Ury = parcelRequire("a2Ury");
    var $4oSDA = parcelRequire("4oSDA");
    var $01RXE = parcelRequire("01RXE");
    var $iDwTy = parcelRequire("iDwTy");
    var $co3Uu = parcelRequire("co3Uu");
    const $a195adf725331444$export$10c5169755ce7bd7 = ({ initialFocusRef: initialFocusRef, popupRef: popupRef, triggerRef: triggerRef, autoFocus: autoFocus, shouldCloseOnTab: shouldCloseOnTab, shouldDisableFocusTrap: shouldDisableFocusTrap, shouldReturnFocus: shouldReturnFocus, shouldRenderToParent: shouldRenderToParent })=>{
        const { requestFrame: requestFrame, cancelAllFrames: cancelAllFrames } = (0, $co3Uu.useAnimationFrame)();
        const { currentLevel: currentLevel } = (0, $01RXE.UNSAFE_useLayering)();
        (0, $eUqFw.useEffect)(()=>{
            if (!popupRef || shouldCloseOnTab) return 0, $4oSDA.default;
            if (shouldDisableFocusTrap && (0, $iDwTy.fg)('platform_dst_popup-disable-focuslock')) {
                const isDropdown = popupRef.matches('[id^=ds--dropdown--]');
                const popups = document.querySelectorAll(`[data-ds--level="${currentLevel - 1}"]`);
                if (!(popups[popups.length - 1] && !shouldRenderToParent && isDropdown)) {
                    requestFrame(()=>{
                        triggerRef?.setAttribute('tabindex', '-1');
                        if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '-1');
                        (initialFocusRef || popupRef).focus();
                    });
                    return 0, $4oSDA.default;
                }
            }
            const trapConfig = {
                clickOutsideDeactivates: true,
                escapeDeactivates: true,
                initialFocus: initialFocusRef || popupRef,
                fallbackFocus: popupRef,
                returnFocusOnDeactivate: shouldReturnFocus
            };
            const focusTrap = (0, ($parcel$interopDefault($a2Ury)))(popupRef, trapConfig);
            requestFrame(()=>{
                focusTrap.activate();
            });
            return ()=>{
                cancelAllFrames();
                focusTrap.deactivate();
            };
        }, [
            popupRef,
            triggerRef,
            autoFocus,
            initialFocusRef,
            shouldCloseOnTab,
            shouldDisableFocusTrap,
            requestFrame,
            cancelAllFrames,
            shouldReturnFocus,
            shouldRenderToParent,
            currentLevel
        ]);
    };
});
parcelRegister("34wbZ", function(module, exports) {
    $parcel$export(module.exports, "usePopupAppearance", ()=>$03a0473fad425d43$export$4065aef1d79a5730);
    var $eUqFw = parcelRequire("eUqFw");
    var $hHxfS = parcelRequire("hHxfS");
    function $03a0473fad425d43$export$4065aef1d79a5730({ appearance: _appearance, shouldRenderToParent: _shouldRenderToParent }) {
        const mq = (0, $hHxfS.UNSAFE_useMediaQuery)('below.sm', (e)=>{
            setIsSmallViewport(!!e.matches);
        });
        const [isSmallViewport, setIsSmallViewport] = (0, $eUqFw.useState)(!!mq?.matches);
        const appearance = _appearance === 'UNSAFE_modal-below-sm' && isSmallViewport ? 'UNSAFE_modal-below-sm' : 'default';
        const shouldRenderToParent = _shouldRenderToParent && appearance === 'default';
        return {
            appearance: appearance,
            shouldRenderToParent: shouldRenderToParent
        };
    }
});
parcelRegister("hHxfS", function(module, exports) {
    $parcel$export(module.exports, "UNSAFE_useMediaQuery", ()=>$18f81bed54a5b04a$export$49e55ae2c03d6045);
    var $eUqFw = parcelRequire("eUqFw");
    var $74BVL = parcelRequire("74BVL");
    var $3PEoH = parcelRequire("3PEoH");
    var $jijTN = parcelRequire("jijTN");
    const $18f81bed54a5b04a$var$queries = {
        'above.xxs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $jijTN.UNSAFE_media).above.xxs.replace('@media ', '').trim()),
        'above.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $jijTN.UNSAFE_media).above.xs.replace('@media ', '').trim()),
        'above.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $jijTN.UNSAFE_media).above.sm.replace('@media ', '').trim()),
        'above.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $jijTN.UNSAFE_media).above.md.replace('@media ', '').trim()),
        'above.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $jijTN.UNSAFE_media).above.lg.replace('@media ', '').trim()),
        'above.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $jijTN.UNSAFE_media).above.xl.replace('@media ', '').trim()),
        'below.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $jijTN.UNSAFE_media).below.xs.replace('@media ', '').trim()),
        'below.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $jijTN.UNSAFE_media).below.sm.replace('@media ', '').trim()),
        'below.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $jijTN.UNSAFE_media).below.md.replace('@media ', '').trim()),
        'below.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $jijTN.UNSAFE_media).below.lg.replace('@media ', '').trim()),
        'below.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $jijTN.UNSAFE_media).below.xl.replace('@media ', '').trim())
    };
    const $18f81bed54a5b04a$export$49e55ae2c03d6045 = (queryString, listener)=>{
        const listenerRef = (0, $eUqFw.useRef)(listener);
        (0, $eUqFw.useEffect)(()=>{
            listenerRef.current = listener;
        }, [
            listener
        ]);
        const hasListener = !!listener;
        const mq = $18f81bed54a5b04a$var$queries[queryString];
        (0, $3PEoH.useLayoutEffect)(()=>{
            listenerRef.current = listener;
            if (!mq || !hasListener || !listenerRef.current) return;
            return (0, $74BVL.bind)(mq, {
                type: 'change',
                listener: (event)=>{
                    return listenerRef.current(event);
                }
            });
        }, [
            mq,
            hasListener
        ]);
        return mq || null;
    };
});
parcelRegister("3PEoH", function(module, exports) {
    $parcel$export(module.exports, "useLayoutEffect", ()=>$f4eeefe320a060be$export$e5c5a5f917a5871c);
    var $eUqFw = parcelRequire("eUqFw");
    const $f4eeefe320a060be$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $eUqFw.useEffect) : (0, $eUqFw.useLayoutEffect);
});
parcelRegister("B432y", function(module, exports) {
    $parcel$export(module.exports, "useGetMemoizedMergedTriggerRef", ()=>$34781ac4a710580c$export$7cc5c058dd769dff);
    var $eUqFw = parcelRequire("eUqFw");
    var $5iWql = parcelRequire("5iWql");
    const $34781ac4a710580c$export$7cc5c058dd769dff = ()=>{
        const [getMemoizedMergedTriggerRef] = (0, $eUqFw.useState)(()=>(0, $5iWql.default)((ref, setTriggerRef, isOpen)=>{
                return (node)=>{
                    if (node && isOpen) {
                        if (typeof ref === 'function') ref(node);
                        else if (ref) ref.current = node;
                        setTriggerRef(node);
                    }
                };
            }));
        return getMemoizedMergedTriggerRef;
    };
});
parcelRegister("2t9vK", function(module, exports) {
    $parcel$export(module.exports, "useGetMemoizedMergedTriggerRefNew", ()=>$da8cda65d35fcf95$export$5d3a2de79e07b376);
    var $eUqFw = parcelRequire("eUqFw");
    var $5iWql = parcelRequire("5iWql");
    const $da8cda65d35fcf95$export$5d3a2de79e07b376 = ()=>{
        const [getMemoizedMergedTriggerRefNew] = (0, $eUqFw.useState)(()=>(0, $5iWql.default)((ref, setTriggerRef)=>{
                return (node)=>{
                    if (node) {
                        if (typeof ref === 'function') ref(node);
                        else if (ref) ref.current = node;
                        setTriggerRef(node);
                    }
                };
            }));
        return getMemoizedMergedTriggerRefNew;
    };
});
parcelRegister("d0vGL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f7534a69a877d9cd$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $5jihj = parcelRequire("5jihj");
    var $75FXO = parcelRequire("75FXO");
    const $f7534a69a877d9cd$var$Spotlight = ({ dialogWidth: dialogWidth = 400, pulse: pulse = true, testId: testId = 'spotlight', targetNode: targetNode, target: target, ...rest })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $75FXO.SpotlightConsumer), null, ({ opened: opened, closed: closed, targets: targets })=>{
            const actualTargetNode = targetNode || (typeof target === 'string' ? targets[target] : undefined);
            return actualTargetNode ? (0, ($parcel$interopDefault($eUqFw))).createElement((0, $5jihj.default), {
                ...rest,
                targetNode: actualTargetNode,
                target: target,
                onOpened: opened,
                onClosed: closed,
                testId: testId,
                dialogWidth: dialogWidth,
                pulse: pulse
            }) : null;
        });
    var $f7534a69a877d9cd$export$2e2bcd8739ae039 = $f7534a69a877d9cd$var$Spotlight;
});
parcelRegister("5jihj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6e95bd717b5fc075$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $kQ44K = parcelRequire("kQ44K");
    var $8MHxr = parcelRequire("8MHxr");
    var $k7cZh = parcelRequire("k7cZh");
    var $1TGzV = parcelRequire("1TGzV");
    var $iDwTy = parcelRequire("iDwTy");
    var $4UBDE = parcelRequire("4UBDE");
    var $h04Oa = parcelRequire("h04Oa");
    var $jJMGg = parcelRequire("jJMGg");
    var $dsPq4 = parcelRequire("dsPq4");
    var $hzahF = parcelRequire("hzahF");
    var $eisPc = parcelRequire("eisPc");
    var $fmPy5 = parcelRequire("fmPy5");
    var $8J4Ez = parcelRequire("8J4Ez");
    class $6e95bd717b5fc075$var$SpotlightInner extends (0, ($parcel$interopDefault($eUqFw))).Component {
        static{
            this.defaultProps = {
                dialogWidth: 400,
                pulse: true
            };
        }
        componentDidUpdate(prevProps) {
            if (prevProps.targetNode !== this.props.targetNode) (0, $k7cZh.default)(this.props.targetNode, {
                scrollMode: 'if-needed',
                block: this.props.scrollPositionBlock
            });
        }
        componentDidMount() {
            (0, $k7cZh.default)(this.props.targetNode, {
                scrollMode: 'if-needed',
                block: this.props.scrollPositionBlock
            });
            this.props.onOpened();
        }
        componentWillUnmount() {
            this.props.onClosed();
        }
        render() {
            const { pulse: pulse, target: target, targetNode: targetNode, targetBgColor: targetBgColor, targetOnClick: targetOnClick, targetRadius: targetRadius, testId: testId, targetReplacement: TargetReplacement } = this.props;
            const { replacementElement: replacementElement } = this.state;
            return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $8J4Ez.SpotlightTransitionConsumer), null, ({ isOpen: isOpen, onExited: onExited })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $4UBDE.default), {
                    zIndex: (0, $h04Oa.layers).spotlight() + 1
                }, TargetReplacement ? (0, ($parcel$interopDefault($eUqFw))).createElement((0, $eisPc.default), {
                    hasNodeResolver: !(0, $iDwTy.fg)('platform_design_system_team_onboarding_noderesolve'),
                    innerRef: (elem)=>this.setState({
                            replacementElement: elem
                        })
                }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jJMGg.ElementBox), {
                    element: targetNode
                }, (box)=>(0, ($parcel$interopDefault($eUqFw))).createElement(TargetReplacement, {
                        "data-testid": `${testId}--target`,
                        ...this.getTargetNodeStyle(box)
                    }))) : (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jJMGg.ElementBox), {
                    element: targetNode
                }, (box)=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $hzahF.default), {
                        testId: `${testId}--target`,
                        pulse: pulse,
                        target: target,
                        style: this.getTargetNodeStyle(box),
                        targetBgColor: targetBgColor,
                        targetNode: targetNode,
                        targetOnClick: targetOnClick,
                        targetRadius: targetRadius
                    })), TargetReplacement && !replacementElement ? null : (0, ($parcel$interopDefault($eUqFw))).createElement((0, $dsPq4.Fade), {
                    hasEntered: isOpen,
                    onExited: onExited
                }, (animationStyles)=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $1TGzV.UNSAFE_LAYERING), {
                        isDisabled: (0, $iDwTy.fg)('platform_design_system_team_spotlight_layering') ? false : true
                    }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $fmPy5.default), {
                        testId: `${testId}--dialog`,
                        actions: this.props.actions,
                        actionsBeforeElement: this.props.actionsBeforeElement,
                        children: this.props.children,
                        dialogPlacement: this.props.dialogPlacement,
                        dialogWidth: this.props.dialogWidth,
                        footer: this.props.footer,
                        header: this.props.header,
                        heading: this.props.heading,
                        headingAfterElement: this.props.headingAfterElement,
                        image: this.props.image,
                        targetNode: replacementElement || targetNode,
                        animationStyles: animationStyles
                    }))), (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($8MHxr))), null)));
        }
        constructor(...args){
            super(...args);
            this.state = {
                replacementElement: null
            };
            this.getTargetNodeStyle = (box)=>{
                if (!(0, $kQ44K.canUseDOM)) return {};
                return {
                    ...box,
                    position: 'fixed'
                };
            };
        }
    }
    var $6e95bd717b5fc075$export$2e2bcd8739ae039 = $6e95bd717b5fc075$var$SpotlightInner;
});
parcelRegister("jJMGg", function(module, exports) {
    $parcel$export(module.exports, "ElementBox", ()=>$1e4d4217109b8c4f$export$1b6719bd7aff3c00);
    var $eUqFw = parcelRequire("eUqFw");
    var $74BVL = parcelRequire("74BVL");
    var $iDwTy = parcelRequire("iDwTy");
    const $1e4d4217109b8c4f$var$POSITION_UPDATE_INTERVAL = 200;
    const $1e4d4217109b8c4f$var$getElementRect = (element)=>{
        const { height: height, left: left, top: top, width: width } = element.getBoundingClientRect();
        return {
            height: height,
            left: left,
            top: top,
            width: width
        };
    };
    const $1e4d4217109b8c4f$var$useResizeAwareElementBox = (element, updateMethod)=>{
        const [box, setBox] = (0, $eUqFw.useState)({
            width: 0,
            height: 0,
            left: 0,
            top: 0
        });
        (0, $eUqFw.useLayoutEffect)(()=>{
            if (updateMethod === 'resizeListener') setBox($1e4d4217109b8c4f$var$getElementRect(element));
        }, [
            element,
            updateMethod
        ]);
        (0, $eUqFw.useEffect)(()=>{
            const onResize = ()=>{
                requestAnimationFrame(()=>{
                    setBox($1e4d4217109b8c4f$var$getElementRect(element));
                });
            };
            if (updateMethod === 'resizeListener') return (0, $74BVL.bind)(window, {
                type: 'resize',
                listener: onResize
            });
        }, [
            element,
            updateMethod
        ]);
        return box;
    };
    const $1e4d4217109b8c4f$var$usePollingElementBox = (element, updateMethod)=>{
        const [width, setWidth] = (0, $eUqFw.useState)(0);
        const [height, setHeight] = (0, $eUqFw.useState)(0);
        const [left, setLeft] = (0, $eUqFw.useState)(0);
        const [top, setTop] = (0, $eUqFw.useState)(0);
        (0, $eUqFw.useLayoutEffect)(()=>{
            if (updateMethod === 'polling') {
                const newBox = $1e4d4217109b8c4f$var$getElementRect(element);
                setWidth(newBox.width);
                setHeight(newBox.height);
                setLeft(newBox.left);
                setTop(newBox.top);
            }
        }, [
            element,
            updateMethod
        ]);
        const requestRef = (0, $eUqFw.useRef)();
        const previousUpdateTimeRef = (0, $eUqFw.useRef)();
        const animate = (0, $eUqFw.useCallback)((time)=>{
            if (previousUpdateTimeRef.current !== undefined) {
                const timeSinceLastUpdate = time - previousUpdateTimeRef.current;
                if (timeSinceLastUpdate > $1e4d4217109b8c4f$var$POSITION_UPDATE_INTERVAL) {
                    const newBox = $1e4d4217109b8c4f$var$getElementRect(element);
                    setWidth(newBox.width);
                    setHeight(newBox.height);
                    setLeft(newBox.left);
                    setTop(newBox.top);
                    previousUpdateTimeRef.current = time;
                }
            } else previousUpdateTimeRef.current = time;
            requestRef.current = requestAnimationFrame(animate);
        }, [
            element
        ]);
        (0, $eUqFw.useEffect)(()=>{
            if (updateMethod === 'polling') requestRef.current = requestAnimationFrame(animate);
            return ()=>{
                if (requestRef.current !== undefined) cancelAnimationFrame(requestRef.current);
            };
        }, [
            animate,
            element,
            updateMethod
        ]);
        const box = (0, $eUqFw.useMemo)(()=>({
                width: width,
                height: height,
                left: left,
                top: top
            }), [
            width,
            height,
            left,
            top
        ]);
        return box;
    };
    const $1e4d4217109b8c4f$export$54f449d89c9b029a = (element)=>{
        const updateMethod = (0, $iDwTy.getBooleanFF)('platform.design-system.refresh-spotlight-on-interval') ? 'polling' : 'resizeListener';
        const boxViaResizeListener = $1e4d4217109b8c4f$var$useResizeAwareElementBox(element, updateMethod);
        const boxViaPolling = $1e4d4217109b8c4f$var$usePollingElementBox(element, updateMethod);
        return updateMethod === 'resizeListener' ? boxViaResizeListener : boxViaPolling;
    };
    const $1e4d4217109b8c4f$export$1b6719bd7aff3c00 = (props)=>{
        const box = $1e4d4217109b8c4f$export$54f449d89c9b029a(props.element);
        return props.children(box);
    };
});
parcelRegister("dsPq4", function(module, exports) {
    $parcel$export(module.exports, "Fade", ()=>$e61cef6f518875fb$export$c983850c6c9d8b0e);
    var $eUqFw = parcelRequire("eUqFw");
    var $247XK = parcelRequire("247XK");
    var $iDwTy = parcelRequire("iDwTy");
    const $e61cef6f518875fb$var$duration = {
        enter: 0,
        exit: 100
    };
    const $e61cef6f518875fb$export$c983850c6c9d8b0e = ({ hasEntered: hasEntered, children: children, onExited: onExited })=>{
        const nodeRef = (0, ($parcel$interopDefault($eUqFw))).useRef(null);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $247XK.default), {
            in: hasEntered,
            timeout: $e61cef6f518875fb$var$duration,
            onExited: onExited,
            unmountOnExit: true,
            appear: true,
            ...(0, $iDwTy.fg)('platform-design-system-dsp-20687-transition-group') && {
                nodeRef: nodeRef
            }
        }, (status)=>{
            const base = {
                transition: `opacity ${$e61cef6f518875fb$var$duration.exit}ms`,
                opacity: 0
            };
            const anim = {
                entered: {
                    opacity: 1
                },
                exiting: {
                    opacity: 0
                }
            };
            const style = {
                ...base,
                ...anim[status]
            };
            return children(style);
        });
    };
});
parcelRegister("hzahF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6ece6a848db71c4c$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $4zUES = parcelRequire("4zUES");
    var $37dld = parcelRequire("37dld");
    const $6ece6a848db71c4c$var$computedStyleAttributesToClone = [
        'fontSize',
        'fontWeight',
        'lineHeight',
        'padding',
        'color',
        'textOverflow'
    ];
    function $6ece6a848db71c4c$var$cloneAndOverrideStyles(node) {
        const shouldCloneChildren = true;
        const clonedNode = node.cloneNode(shouldCloneChildren);
        const computedStyles = getComputedStyle(node);
        $6ece6a848db71c4c$var$computedStyleAttributesToClone.forEach((attribute)=>{
            clonedNode.style[attribute] = computedStyles[attribute];
        });
        clonedNode.style.margin = '0';
        clonedNode.style.position = 'static';
        clonedNode.style.transform = 'translate(0, 0) translate3d(0, 0, 0)';
        return clonedNode;
    }
    const $6ece6a848db71c4c$var$Clone = (props)=>{
        const { pulse: pulse, style: style, shouldWatch: shouldWatch, target: target, targetBgColor: targetBgColor, targetOnClick: targetOnClick, targetNode: targetNode, targetRadius: targetRadius, testId: testId } = props;
        const contentVersion = (0, $37dld.useElementObserver)(targetNode, {
            disableWatch: !shouldWatch
        });
        const contentHTML = (0, $eUqFw.useMemo)(()=>$6ece6a848db71c4c$var$cloneAndOverrideStyles(targetNode).outerHTML, [
            contentVersion,
            targetNode
        ]);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $4zUES.TargetInner), {
            "data-testid": testId,
            pulse: pulse,
            bgColor: targetBgColor,
            radius: targetRadius,
            style: style
        }, (0, ($parcel$interopDefault($eUqFw))).createElement("div", {
            dangerouslySetInnerHTML: {
                __html: contentHTML
            },
            style: {
                height: '100%',
                pointerEvents: 'none'
            }
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $4zUES.TargetOverlay), {
            onClick: targetOnClick ? (event)=>targetOnClick({
                    event: event,
                    target: target
                }) : undefined
        }));
    };
    var $6ece6a848db71c4c$export$2e2bcd8739ae039 = $6ece6a848db71c4c$var$Clone;
});
parcelRegister("4zUES", function(module, exports) {
    $parcel$export(module.exports, "TargetInner", ()=>$2b7e8f458a555f38$export$b1542cc928b93af);
    $parcel$export(module.exports, "TargetOverlay", ()=>$2b7e8f458a555f38$export$a28a07e0025d709d);
    $parcel$export(module.exports, "Pulse", ()=>$2b7e8f458a555f38$export$927d63e2511364c0);
    var $byn9U = parcelRequire("byn9U");
    var $2oI17 = parcelRequire("2oI17");
    function $2b7e8f458a555f38$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $2b7e8f458a555f38$var$baseShadow = `0 0 0 2px ${`var(--ds-border-discovery, ${(0, $207acf722dcd432b$export$b48405b95304b5a1)})`}`;
    const $2b7e8f458a555f38$var$easing = 'cubic-bezier(0.55, 0.055, 0.675, 0.19)';
    const $2b7e8f458a555f38$var$pulseKeyframes = (0, $byn9U.keyframes)({
        '0%, 33%': {
            boxShadow: `${$2b7e8f458a555f38$var$baseShadow}, 0 0 0 ${"var(--ds-border-discovery, rgba(101, 84, 192, 1))"}`
        },
        '66%, 100%': {
            boxShadow: `${$2b7e8f458a555f38$var$baseShadow}, 0 0 0 10px rgba(101, 84, 192, 0.01)`
        }
    });
    const $2b7e8f458a555f38$export$9fd1cab52ce14fd5 = $2b7e8f458a555f38$var$pulseKeyframes.name;
    const $2b7e8f458a555f38$var$animationStyles = (0, $byn9U.css)({
        animation: `${$2b7e8f458a555f38$var$pulseKeyframes} 3000ms ${$2b7e8f458a555f38$var$easing} infinite`,
        boxShadow: $2b7e8f458a555f38$var$baseShadow
    });
    const $2b7e8f458a555f38$var$Base = ({ children: children, bgColor: bgColor, radius: radius, style: style, testId: testId, ...props })=>(0, $byn9U.jsx)("div", {
            "data-testid": testId,
            style: {
                ...style,
                backgroundColor: bgColor,
                borderRadius: radius ? `${radius}px` : undefined
            },
            ...props
        }, children);
    const $2b7e8f458a555f38$export$b1542cc928b93af = ({ children: children, pulse: pulse, ...props })=>(0, $byn9U.jsx)($2b7e8f458a555f38$var$Base, {
            ...props,
            css: [
                pulse && $2b7e8f458a555f38$var$animationStyles,
                (0, $2oI17.reduceMotionAsPerUserPreference)
            ]
        }, children);
    const $2b7e8f458a555f38$var$targetOverlayStyles = {
        name: "1ydh0jg",
        styles: "width:100%;height:100%;position:absolute;inset-block-start:0;inset-inline-start:0"
    };
    const $2b7e8f458a555f38$export$a28a07e0025d709d = (props)=>(0, $byn9U.jsx)("div", {
            ...props,
            css: $2b7e8f458a555f38$var$targetOverlayStyles,
            style: {
                cursor: props.onClick ? 'pointer' : 'auto'
            }
        });
    const $2b7e8f458a555f38$export$927d63e2511364c0 = ({ children: children, pulse: pulse = true, testId: testId, ...props })=>(0, $byn9U.jsx)($2b7e8f458a555f38$var$Base, {
            ...props,
            css: [
                pulse && $2b7e8f458a555f38$var$animationStyles,
                (0, $2oI17.reduceMotionAsPerUserPreference)
            ],
            testId: testId
        }, children);
});
parcelRegister("37dld", function(module, exports) {
    $parcel$export(module.exports, "useElementObserver", ()=>$670cda915e0507b3$export$729bafd4e621fba0);
    var $eUqFw = parcelRequire("eUqFw");
    function $670cda915e0507b3$export$729bafd4e621fba0(element, opts = {}) {
        const { onChange: onChange, disableWatch: disableWatch = false } = opts;
        const [targetContentVersion, setTargetContentVersion] = (0, $eUqFw.useState)(0);
        const mutationObserver = (0, $eUqFw.useRef)(undefined);
        const cancelIdleCallback1 = (0, $eUqFw.useRef)(undefined);
        const disposer = (0, $eUqFw.useCallback)(()=>{
            cancelIdleCallback1.current?.();
            cancelIdleCallback1.current = undefined;
            mutationObserver.current?.disconnect();
            mutationObserver.current = undefined;
        }, []);
        const onMutation = (0, $eUqFw.useCallback)(()=>{
            cancelIdleCallback1.current?.();
            cancelIdleCallback1.current = $670cda915e0507b3$var$callWhenIdle(()=>setTargetContentVersion((v)=>{
                    const version = v + 1;
                    onChange?.(version);
                    return version;
                }));
        }, [
            onChange
        ]);
        (0, $eUqFw.useEffect)(()=>{
            disposer();
            if (!disableWatch && element) {
                mutationObserver.current = new MutationObserver(onMutation);
                mutationObserver.current.observe(element, {
                    attributes: true,
                    childList: true,
                    subtree: true
                });
            }
            return disposer;
        }, [
            disableWatch,
            disposer,
            element,
            onMutation
        ]);
        return targetContentVersion;
    }
    function $670cda915e0507b3$export$12e07a2a9f87578a({ element: element, children: children, onChange: onChange, disableWatch: disableWatch }) {
        $670cda915e0507b3$export$729bafd4e621fba0(element, {
            disableWatch: disableWatch,
            onChange: onChange
        });
        return {
            children: children
        };
    }
    function $670cda915e0507b3$var$callWhenIdle(callback, opts = {}) {
        const { timeout: timeout = 100 } = opts;
        if (typeof window.requestIdleCallback === 'function') {
            const idleHandle = window.requestIdleCallback(callback, {
                timeout: timeout
            });
            return ()=>cancelIdleCallback(idleHandle);
        }
        const timeoutHandle = setTimeout(callback, timeout);
        return ()=>clearTimeout(timeoutHandle);
    }
});
parcelRegister("eisPc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e6835f3c91dc92bc$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $lbDTY = parcelRequire("lbDTY");
    const $e6835f3c91dc92bc$var$NodeResolverSpotlightInner = ({ hasNodeResolver: hasNodeResolver, children: children, innerRef: innerRef })=>{
        const divRef = (0, $eUqFw.useRef)(null);
        (0, $eUqFw.useEffect)(()=>{
            if (!hasNodeResolver) innerRef(divRef.current?.firstElementChild);
        }, [
            hasNodeResolver
        ]);
        if (hasNodeResolver) return (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($lbDTY))), {
            innerRef: innerRef
        }, children);
        return (0, ($parcel$interopDefault($eUqFw))).createElement("div", {
            ref: divRef
        }, children);
    };
    var $e6835f3c91dc92bc$export$2e2bcd8739ae039 = $e6835f3c91dc92bc$var$NodeResolverSpotlightInner;
});
parcelRegister("fmPy5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e545387216ce2a8b$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $6Pq2D = parcelRequire("6Pq2D");
    var $1TUfP = parcelRequire("1TUfP");
    var $iDwTy = parcelRequire("iDwTy");
    var $jLWxm = parcelRequire("jLWxm");
    var $ayvfM = parcelRequire("ayvfM");
    var $ernNa = parcelRequire("ernNa");
    var $3UE0y = parcelRequire("3UE0y");
    const $e545387216ce2a8b$var$FocusLock = (0, $iDwTy.fg)('platform_dst_onboarding-bump-react-focus-lock') ? (0, $1TUfP.default) : (0, $6Pq2D.default);
    class $e545387216ce2a8b$var$SpotlightDialogComponent extends (0, $eUqFw.Component) {
        componentDidMount() {
            this.focusLockTimeoutId = window.setTimeout(()=>{
                this.setState({
                    focusLockDisabled: false
                });
            }, 200);
        }
        componentWillUnmount() {
            window.clearTimeout(this.focusLockTimeoutId);
        }
        render() {
            const { actions: actions, actionsBeforeElement: actionsBeforeElement, animationStyles: animationStyles, children: children, dialogPlacement: dialogPlacement, dialogWidth: dialogWidth, footer: footer, header: header, heading: heading, headingAfterElement: headingAfterElement, image: image, targetNode: targetNode, testId: testId } = this.props;
            const { focusLockDisabled: focusLockDisabled } = this.state;
            const translatedPlacement = dialogPlacement ? ({
                'top left': 'top-start',
                'top center': 'top',
                'top right': 'top-end',
                'right top': 'right-start',
                'right middle': 'right',
                'right bottom': 'right-end',
                'bottom left': 'bottom-start',
                'bottom center': 'bottom',
                'bottom right': 'bottom-end',
                'left top': 'left-start',
                'left middle': 'left',
                'left bottom': 'left-end'
            })[dialogPlacement] : undefined;
            const modifiers = [
                {
                    name: 'preventOverflow',
                    options: {
                        padding: 5,
                        rootBoundary: 'document',
                        altAxis: true,
                        tether: false
                    }
                }
            ];
            return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jLWxm.Popper), {
                modifiers: modifiers,
                referenceElement: targetNode,
                placement: translatedPlacement
            }, ({ ref: ref, style: style, update: update })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $3UE0y.default), {
                    value: dialogWidth,
                    onChange: update
                }, (0, ($parcel$interopDefault($eUqFw))).createElement($e545387216ce2a8b$var$FocusLock, {
                    disabled: focusLockDisabled,
                    returnFocus: false,
                    autoFocus: true
                }, (0, ($parcel$interopDefault($eUqFw))).createElement("div", {
                    ref: ref,
                    style: {
                        ...style,
                        ...animationStyles
                    }
                }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $ernNa.default), {
                    testId: testId,
                    width: dialogWidth,
                    actions: actions,
                    actionsBeforeElement: actionsBeforeElement,
                    image: image && (0, ($parcel$interopDefault($eUqFw))).createElement((0, $ayvfM.DialogImage), {
                        alt: heading,
                        src: image
                    }),
                    components: {
                        Header: header,
                        Footer: footer
                    },
                    heading: heading,
                    headingAfterElement: headingAfterElement,
                    headingLevel: 2
                }, children)))));
        }
        constructor(...args){
            super(...args);
            this.state = {
                focusLockDisabled: true
            };
        }
    }
    var $e545387216ce2a8b$export$2e2bcd8739ae039 = $e545387216ce2a8b$var$SpotlightDialogComponent;
});
parcelRegister("ayvfM", function(module, exports) {
    $parcel$export(module.exports, "DialogImage", ()=>$579db56886324189$export$855e1a47874d6b81);
    $parcel$export(module.exports, "DialogActionItemContainer", ()=>$579db56886324189$export$ed9b6b50bbed5f27);
    $parcel$export(module.exports, "DialogActionItem", ()=>$579db56886324189$export$6ae54e00f59e1f33);
    var $byn9U = parcelRequire("byn9U");
    function $579db56886324189$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $579db56886324189$var$imageStyles = {
        name: "1hyxgad",
        styles: "max-width:100%;height:auto"
    };
    const $579db56886324189$var$actionItemContainerStyles = (0, $byn9U.css)({
        display: 'flex',
        margin: `${"var(--ds-space-0, 0px)"} -4px`,
        flexDirection: 'row-reverse'
    });
    const $579db56886324189$var$actionItemStyles = (0, $byn9U.css)({
        margin: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`
    });
    const $579db56886324189$export$855e1a47874d6b81 = ({ alt: alt, ...props })=>(0, $byn9U.jsx)("img", {
            css: $579db56886324189$var$imageStyles,
            alt: alt,
            ...props
        });
    const $579db56886324189$export$ed9b6b50bbed5f27 = ({ children: children })=>(0, $byn9U.jsx)("div", {
            css: $579db56886324189$var$actionItemContainerStyles
        }, children);
    const $579db56886324189$export$6ae54e00f59e1f33 = ({ children: children })=>(0, $byn9U.jsx)("div", {
            css: $579db56886324189$var$actionItemStyles
        }, children);
});
parcelRegister("ernNa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$480c099d3ed92511$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $11GuH = parcelRequire("11GuH");
    var $iTWoL = parcelRequire("iTWoL");
    var $ld5Wr = parcelRequire("ld5Wr");
    var $jGR8u = parcelRequire("jGR8u");
    var $2IZkH = parcelRequire("2IZkH");
    var $fHiYa = parcelRequire("fHiYa");
    var $ayvfM = parcelRequire("ayvfM");
    var $5a0YU = parcelRequire("5a0YU");
    function $480c099d3ed92511$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $480c099d3ed92511$var$bodyStyles = (0, $byn9U.css)({
        display: 'flex',
        padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-250, 20px)"}`,
        flexDirection: 'column'
    });
    const $480c099d3ed92511$var$imageStyles = {
        name: "4zleql",
        styles: "display:block"
    };
    const $480c099d3ed92511$var$defaultHeaderStyles = {
        name: "8dfjp9",
        styles: "display:flex;align-items:baseline;justify-content:space-between;padding-block-end:var(--ds-space-100, 8px)"
    };
    const $480c099d3ed92511$var$DefaultHeader = ({ children: children })=>(0, $byn9U.jsx)("div", {
            css: $480c099d3ed92511$var$defaultHeaderStyles
        }, children);
    const $480c099d3ed92511$var$defaultFooterStyles = {
        name: "1xj74a2",
        styles: "display:flex;align-items:center;justify-content:space-between;padding-block-start:var(--ds-space-100, 8px)"
    };
    const $480c099d3ed92511$var$DefaultFooter = ({ children: children })=>(0, $byn9U.jsx)("div", {
            css: $480c099d3ed92511$var$defaultFooterStyles
        }, children);
    const $480c099d3ed92511$var$containerStyles = (0, $fHiYa.xcss)({
        height: 'fit-content',
        zIndex: 'spotlight',
        borderRadius: 'border.radius',
        color: 'color.text.inverse',
        overflow: 'auto',
        minWidth: '160px',
        maxWidth: '600px'
    });
    const $480c099d3ed92511$var$containerShadowStyles = (0, $fHiYa.xcss)({
        boxShadow: 'elevation.shadow.raised'
    });
    const $480c099d3ed92511$var$SpotlightCard = (0, $eUqFw.forwardRef)((props, ref)=>{
        const { actions: actions = [], actionsBeforeElement: actionsBeforeElement, children: children, components: components = {}, heading: heading, headingLevel: headingLevel = 4, headingAfterElement: headingAfterElement, image: image, innerRef: innerRef, isFlat: isFlat, testId: testId, width: width = 400, headingId: headingId } = props;
        const { Header: Header = $480c099d3ed92511$var$DefaultHeader, Footer: Footer = $480c099d3ed92511$var$DefaultFooter } = components;
        return (0, $byn9U.jsx)((0, $iTWoL.default).Provider, {
            value: (0, $5a0YU.spotlightButtonTheme)
        }, (0, $byn9U.jsx)((0, $jGR8u.default), {
            backgroundColor: "color.background.discovery.bold",
            xcss: [
                $480c099d3ed92511$var$containerStyles,
                !isFlat && $480c099d3ed92511$var$containerShadowStyles
            ],
            style: {
                width: width
            },
            ref: ref || innerRef,
            testId: testId
        }, typeof image === 'string' ? (0, $byn9U.jsx)("img", {
            css: $480c099d3ed92511$var$imageStyles,
            src: image,
            alt: ""
        }) : image, (0, $byn9U.jsx)("div", {
            css: $480c099d3ed92511$var$bodyStyles
        }, heading || headingAfterElement ? (0, $byn9U.jsx)(Header, null, (0, $byn9U.jsx)((0, $ld5Wr.default), {
            id: headingId,
            size: "medium",
            as: `h${headingLevel}`,
            color: "color.text.inverse"
        }, heading), headingAfterElement) : null, (0, $byn9U.jsx)((0, $2IZkH.default), null, children), actions.length > 0 || actionsBeforeElement ? (0, $byn9U.jsx)(Footer, null, actionsBeforeElement || (0, $byn9U.jsx)("span", null), (0, $byn9U.jsx)((0, $ayvfM.DialogActionItemContainer), null, actions.map(({ text: text, key: key, ...rest }, idx)=>{
            return (0, $byn9U.jsx)((0, $ayvfM.DialogActionItem), {
                key: key || (typeof text === 'string' ? text : `${idx}`)
            }, (0, $byn9U.jsx)((0, $11GuH.default), rest, text));
        }))) : null)));
    });
    $480c099d3ed92511$var$SpotlightCard.displayName = 'SpotlightCard';
    var $480c099d3ed92511$export$2e2bcd8739ae039 = $480c099d3ed92511$var$SpotlightCard;
});
parcelRegister("5a0YU", function(module, exports) {
    $parcel$export(module.exports, "spotlightButtonTheme", ()=>$8eccc723e105a215$export$39a36121076ca24);
    $parcel$export(module.exports, "modalButtonTheme", ()=>$8eccc723e105a215$export$d131eb21ba4cbd16);
    const $8eccc723e105a215$var$spotlightTheme = {
        default: {
            background: {
                default: `var(--ds-background-inverse-subtle, ${$207acf722dcd432b$export$147899de772240ec})`,
                hover: `var(--ds-background-inverse-subtle-hovered, ${$207acf722dcd432b$export$a7175d4e9206bc80})`,
                active: `var(--ds-background-inverse-subtle-pressed, ${$207acf722dcd432b$export$147899de772240ec})`,
                disabled: `var(--ds-background-disabled, ${$207acf722dcd432b$export$c71e4279dd54a18d})`,
                selected: `var(--ds-background-inverse-subtle-pressed, ${$207acf722dcd432b$export$2837b5a1a71d5c02})`,
                focus: `var(--ds-background-inverse-subtle, ${$207acf722dcd432b$export$147899de772240ec})`
            },
            color: {
                default: `var(--ds-text-inverse, ${$207acf722dcd432b$export$29a4f05edc054374})`,
                hover: `var(--ds-text-inverse, ${$207acf722dcd432b$export$29a4f05edc054374})`,
                active: `var(--ds-text-inverse, ${$207acf722dcd432b$export$29a4f05edc054374})`,
                disabled: {
                    light: `var(--ds-text-disabled, ${$207acf722dcd432b$export$29a4f05edc054374})`,
                    dark: `var(--ds-text-disabled, ${$207acf722dcd432b$export$633847cf062b69e0})`
                },
                selected: `var(--ds-text-inverse, ${$207acf722dcd432b$export$29a4f05edc054374})`,
                focus: `var(--ds-text-inverse, ${$207acf722dcd432b$export$29a4f05edc054374})`
            }
        },
        subtle: {
            background: {
                default: 'none',
                hover: `var(--ds-background-inverse-subtle-hovered, ${$207acf722dcd432b$export$a7175d4e9206bc80})`,
                active: `var(--ds-background-inverse-subtle-pressed, ${$207acf722dcd432b$export$147899de772240ec})`,
                disabled: 'none',
                selected: {
                    light: `var(--ds-background-selected-hovered, ${$207acf722dcd432b$export$ad0bacf983b7ddaa})`,
                    dark: `var(--ds-background-selected-hovered, ${$207acf722dcd432b$export$3d4f271a500072a})`
                },
                focusSelected: {
                    light: `var(--ds-background-selected-hovered, ${$207acf722dcd432b$export$ad0bacf983b7ddaa})`,
                    dark: `var(--ds-background-selected-hovered, ${$207acf722dcd432b$export$3d4f271a500072a})`
                }
            },
            color: {
                default: `var(--ds-text-inverse, ${$207acf722dcd432b$export$29a4f05edc054374})`,
                hover: `var(--ds-text-inverse, ${$207acf722dcd432b$export$29a4f05edc054374})`,
                active: `var(--ds-text-inverse, ${$207acf722dcd432b$export$29a4f05edc054374})`,
                disabled: `var(--ds-text-disabled, ${$207acf722dcd432b$export$29a4f05edc054374})`,
                selected: `var(--ds-text-inverse, ${$207acf722dcd432b$export$29a4f05edc054374})`,
                focus: `var(--ds-text-inverse, ${$207acf722dcd432b$export$29a4f05edc054374})`
            }
        },
        'subtle-link': {
            textDecoration: {
                hover: `underline ${`var(--ds-text-inverse, ${$207acf722dcd432b$export$4b0a4417ed59760f})`}`
            },
            textDecorationLine: {
                active: 'none'
            },
            color: {
                default: `var(--ds-text-inverse, ${$207acf722dcd432b$export$29a4f05edc054374})`,
                hover: `var(--ds-text-inverse, ${$207acf722dcd432b$export$4b0a4417ed59760f})`,
                active: `var(--ds-text-inverse, ${$207acf722dcd432b$export$6011520a64d9a187})`,
                disabled: `var(--ds-text-discovery, ${$207acf722dcd432b$export$147899de772240ec})`,
                selected: `var(--ds-text-selected, ${$207acf722dcd432b$export$29a4f05edc054374})`,
                focus: `var(--ds-text-inverse, ${$207acf722dcd432b$export$29a4f05edc054374})`
            }
        }
    };
    const $8eccc723e105a215$var$modalTheme = {
        primary: {
            background: {
                default: `var(--ds-background-discovery-bold, ${$207acf722dcd432b$export$c71e4279dd54a18d})`,
                hover: `var(--ds-background-discovery-bold-hovered, ${$207acf722dcd432b$export$a7175d4e9206bc80})`,
                active: `var(--ds-background-discovery-bold-pressed, ${$207acf722dcd432b$export$147899de772240ec})`,
                disabled: {
                    light: `var(--ds-background-disabled, ${$207acf722dcd432b$export$3e51e8f1440314ba})`,
                    dark: `var(--ds-background-disabled, ${$207acf722dcd432b$export$d281fbfe3cff2df6})`
                },
                selected: `var(--ds-background-selected-hovered, ${$207acf722dcd432b$export$2837b5a1a71d5c02})`,
                focus: `var(--ds-background-discovery-bold-hovered, ${$207acf722dcd432b$export$c71e4279dd54a18d})`
            },
            color: {
                default: `var(--ds-text-inverse, ${$207acf722dcd432b$export$29a4f05edc054374})`,
                disabled: {
                    light: `var(--ds-text-disabled, ${$207acf722dcd432b$export$29a4f05edc054374})`,
                    dark: `var(--ds-text-disabled, ${$207acf722dcd432b$export$633847cf062b69e0})`
                },
                selected: `var(--ds-text-selected, ${$207acf722dcd432b$export$29a4f05edc054374})`,
                focus: `var(--ds-text-inverse, ${$207acf722dcd432b$export$29a4f05edc054374})`
            }
        }
    };
    function $8eccc723e105a215$var$extract(newTheme, { mode: mode, appearance: appearance, state: state }) {
        if (!newTheme[appearance]) return undefined;
        const root = newTheme[appearance];
        return Object.keys(root).reduce((acc, val)=>{
            let node = root;
            [
                val,
                state,
                mode
            ].forEach((item)=>{
                if (!node[item]) return undefined;
                if (typeof node[item] !== 'object') {
                    acc[val] = node[item];
                    return undefined;
                }
                node = node[item];
                return undefined;
            });
            return acc;
        }, {});
    }
    const $8eccc723e105a215$export$39a36121076ca24 = (current, themeProps)=>{
        const { buttonStyles: buttonStyles, ...rest } = current(themeProps);
        return {
            buttonStyles: {
                ...buttonStyles,
                ...$8eccc723e105a215$var$extract($8eccc723e105a215$var$spotlightTheme, themeProps)
            },
            ...rest
        };
    };
    const $8eccc723e105a215$export$d131eb21ba4cbd16 = (current, themeProps)=>{
        const { buttonStyles: buttonStyles, ...rest } = current(themeProps);
        return {
            buttonStyles: {
                ...buttonStyles,
                ...$8eccc723e105a215$var$extract($8eccc723e105a215$var$modalTheme, themeProps)
            },
            ...rest
        };
    };
});
parcelRegister("3UE0y", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2e3d4304eee41484$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    class $2e3d4304eee41484$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($eUqFw))).Component {
        componentDidUpdate(prevProps) {
            if (prevProps.value !== this.props.value) this.props.onChange();
        }
        render() {
            return this.props.children;
        }
    }
});
parcelRegister("8J4Ez", function(module, exports) {
    $parcel$export(module.exports, "SpotlightTransitionConsumer", ()=>$4554c4e1acedeedf$export$7d63b19b854c2fe8);
    $parcel$export(module.exports, "default", ()=>$4554c4e1acedeedf$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $4oSDA = parcelRequire("4oSDA");
    const $4554c4e1acedeedf$var$SpotlightTransitionContext = (0, $eUqFw.createContext)({
        isOpen: true,
        onExited: (0, $4oSDA.default)
    });
    const $4554c4e1acedeedf$var$hasChildren = (children)=>(0, ($parcel$interopDefault($eUqFw))).Children.count(children) > 0 && ((0, ($parcel$interopDefault($eUqFw))).Children.map(children || false, (child)=>!!child)?.filter(Boolean)?.length || 0) > 0;
    class $4554c4e1acedeedf$var$SpotlightTransition extends (0, ($parcel$interopDefault($eUqFw))).Component {
        static getDerivedStateFromProps(props, state) {
            const { currentChildren: previousChildren } = state;
            const exiting = $4554c4e1acedeedf$var$hasChildren(previousChildren) && !$4554c4e1acedeedf$var$hasChildren(props.children);
            return {
                currentChildren: exiting ? previousChildren : props.children
            };
        }
        render() {
            return (0, ($parcel$interopDefault($eUqFw))).createElement($4554c4e1acedeedf$var$SpotlightTransitionContext.Provider, {
                value: {
                    onExited: this.onExited,
                    isOpen: $4554c4e1acedeedf$var$hasChildren(this.props.children)
                }
            }, this.state.currentChildren);
        }
        constructor(...args){
            super(...args);
            this.state = {
                currentChildren: undefined
            };
            this.onExited = ()=>{
                this.setState({
                    currentChildren: this.props.children
                });
            };
        }
    }
    const $4554c4e1acedeedf$export$7d63b19b854c2fe8 = $4554c4e1acedeedf$var$SpotlightTransitionContext.Consumer;
    var $4554c4e1acedeedf$export$2e2bcd8739ae039 = $4554c4e1acedeedf$var$SpotlightTransition;
});
parcelRegister("75FXO", function(module, exports) {
    $parcel$export(module.exports, "TargetConsumer", ()=>$943da65f857133e5$export$f643dd64c1952cc8);
    $parcel$export(module.exports, "SpotlightContext", ()=>$943da65f857133e5$export$7b5aa0f5b37a336d);
    $parcel$export(module.exports, "SpotlightConsumer", ()=>$943da65f857133e5$export$3503199acd121708);
    $parcel$export(module.exports, "default", ()=>$943da65f857133e5$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $5iWql = parcelRequire("5iWql");
    var $4oSDA = parcelRequire("4oSDA");
    var $4UBDE = parcelRequire("4UBDE");
    var $h04Oa = parcelRequire("h04Oa");
    var $1C2jJ = parcelRequire("1C2jJ");
    var $dsPq4 = parcelRequire("dsPq4");
    var $2fFJv = parcelRequire("2fFJv");
    const { Consumer: $943da65f857133e5$export$f643dd64c1952cc8, Provider: $943da65f857133e5$var$TargetProvider } = (0, $eUqFw.createContext)(undefined);
    const $943da65f857133e5$export$7b5aa0f5b37a336d = (0, $eUqFw.createContext)({
        opened: (0, $4oSDA.default),
        closed: (0, $4oSDA.default),
        targets: {}
    });
    const { Consumer: $943da65f857133e5$export$3503199acd121708, Provider: $943da65f857133e5$var$SpotlightStateProvider } = $943da65f857133e5$export$7b5aa0f5b37a336d;
    const $943da65f857133e5$var$Container = ({ component: Wrapper, children: children })=>(0, ($parcel$interopDefault($eUqFw))).createElement(Wrapper, null, children);
    class $943da65f857133e5$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
        static{
            this.defaultProps = {
                blanketIsTinted: true
            };
        }
        componentDidMount() {
            typeof $2fFJv;
        }
        render() {
            const { blanketIsTinted: blanketIsTinted, children: children, component: Tag, onBlanketClicked: onBlanketClicked } = this.props;
            return (0, ($parcel$interopDefault($eUqFw))).createElement($943da65f857133e5$var$SpotlightStateProvider, {
                value: this.getStateProviderValue(this.state.targets)
            }, (0, ($parcel$interopDefault($eUqFw))).createElement($943da65f857133e5$var$TargetProvider, {
                value: this.targetRef
            }, (0, ($parcel$interopDefault($eUqFw))).createElement($943da65f857133e5$var$Container, {
                component: Tag || (0, ($parcel$interopDefault($eUqFw))).Fragment
            }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $dsPq4.Fade), {
                hasEntered: this.state.spotlightCount > 0
            }, (animationStyles)=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $4UBDE.default), {
                    zIndex: (0, $h04Oa.layers).spotlight()
                }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $1C2jJ.default), {
                    style: animationStyles,
                    isTinted: blanketIsTinted,
                    onBlanketClicked: onBlanketClicked
                }))), children)));
        }
        constructor(...args){
            super(...args);
            this.state = {
                spotlightCount: 0,
                targets: {}
            };
            this.targetRef = (name)=>(element)=>{
                    this.setState((state)=>({
                            targets: {
                                ...state.targets,
                                [name]: element || undefined
                            }
                        }));
                };
            this.spotlightOpen = ()=>{
                this.setState((state)=>({
                        spotlightCount: state.spotlightCount + 1
                    }));
            };
            this.spotlightClose = ()=>{
                this.setState((state)=>({
                        spotlightCount: state.spotlightCount - 1
                    }));
            };
            this.getStateProviderValue = (0, $5iWql.default)((targets)=>({
                    opened: this.spotlightOpen,
                    closed: this.spotlightClose,
                    targets: targets
                }));
        }
    }
});
parcelRegister("1C2jJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c4b34243ca93fb93$export$2e2bcd8739ae039);
    var $byn9U = parcelRequire("byn9U");
    var $h04Oa = parcelRequire("h04Oa");
    const $c4b34243ca93fb93$var$blanketStyles = (0, $byn9U.css)({
        position: 'fixed',
        zIndex: (0, $h04Oa.layers).spotlight(),
        inset: 0,
        transition: 'opacity 220ms'
    });
    const $c4b34243ca93fb93$var$Blanket = (props)=>{
        const { onBlanketClicked: onBlanketClicked } = props;
        return (0, $byn9U.jsx)("div", {
            role: "presentation",
            css: $c4b34243ca93fb93$var$blanketStyles,
            style: {
                ...props.style,
                backgroundColor: props.isTinted ? `var(--ds-blanket, ${0, $207acf722dcd432b$export$486ab785e4bac3c6})` : 'transparent'
            },
            onClick: onBlanketClicked
        });
    };
    var $c4b34243ca93fb93$export$2e2bcd8739ae039 = $c4b34243ca93fb93$var$Blanket;
});
parcelRegister("lrUL4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$47b1a5569006b0e3$export$2e2bcd8739ae039);
    var $j3Zft = parcelRequire("j3Zft");
    var $2fFJv = parcelRequire("2fFJv");
    function $47b1a5569006b0e3$var$getTokenValue(tokenId, fallback = '') {
        let token = (0, $j3Zft.default)[tokenId];
        let tokenValue = fallback;
        typeof $2fFJv;
        if (typeof window === 'undefined') return tokenValue;
        tokenValue = window.getComputedStyle(document.documentElement).getPropertyValue(token).trim();
        tokenValue = tokenValue || fallback;
        return tokenValue;
    }
    var $47b1a5569006b0e3$export$2e2bcd8739ae039 = $47b1a5569006b0e3$var$getTokenValue;
});
parcelRegister("j3Zft", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0471407e7f2eca1e$export$2e2bcd8739ae039);
    const $0471407e7f2eca1e$var$tokens = {
        'color.text': '--ds-text',
        'color.text.accent.lime': '--ds-text-accent-lime',
        'color.text.accent.lime.bolder': '--ds-text-accent-lime-bolder',
        'color.text.accent.red': '--ds-text-accent-red',
        'color.text.accent.red.bolder': '--ds-text-accent-red-bolder',
        'color.text.accent.orange': '--ds-text-accent-orange',
        'color.text.accent.orange.bolder': '--ds-text-accent-orange-bolder',
        'color.text.accent.yellow': '--ds-text-accent-yellow',
        'color.text.accent.yellow.bolder': '--ds-text-accent-yellow-bolder',
        'color.text.accent.green': '--ds-text-accent-green',
        'color.text.accent.green.bolder': '--ds-text-accent-green-bolder',
        'color.text.accent.teal': '--ds-text-accent-teal',
        'color.text.accent.teal.bolder': '--ds-text-accent-teal-bolder',
        'color.text.accent.blue': '--ds-text-accent-blue',
        'color.text.accent.blue.bolder': '--ds-text-accent-blue-bolder',
        'color.text.accent.purple': '--ds-text-accent-purple',
        'color.text.accent.purple.bolder': '--ds-text-accent-purple-bolder',
        'color.text.accent.magenta': '--ds-text-accent-magenta',
        'color.text.accent.magenta.bolder': '--ds-text-accent-magenta-bolder',
        'color.text.accent.gray': '--ds-text-accent-gray',
        'color.text.accent.gray.bolder': '--ds-text-accent-gray-bolder',
        'color.text.disabled': '--ds-text-disabled',
        'color.text.inverse': '--ds-text-inverse',
        'color.text.selected': '--ds-text-selected',
        'color.text.brand': '--ds-text-brand',
        'color.text.danger': '--ds-text-danger',
        'color.text.warning': '--ds-text-warning',
        'color.text.warning.inverse': '--ds-text-warning-inverse',
        'color.text.success': '--ds-text-success',
        'color.text.discovery': '--ds-text-discovery',
        'color.text.information': '--ds-text-information',
        'color.text.subtlest': '--ds-text-subtlest',
        'color.text.subtle': '--ds-text-subtle',
        'color.link': '--ds-link',
        'color.link.pressed': '--ds-link-pressed',
        'color.link.visited': '--ds-link-visited',
        'color.link.visited.pressed': '--ds-link-visited-pressed',
        'color.icon': '--ds-icon',
        'color.icon.accent.lime': '--ds-icon-accent-lime',
        'color.icon.accent.red': '--ds-icon-accent-red',
        'color.icon.accent.orange': '--ds-icon-accent-orange',
        'color.icon.accent.yellow': '--ds-icon-accent-yellow',
        'color.icon.accent.green': '--ds-icon-accent-green',
        'color.icon.accent.teal': '--ds-icon-accent-teal',
        'color.icon.accent.blue': '--ds-icon-accent-blue',
        'color.icon.accent.purple': '--ds-icon-accent-purple',
        'color.icon.accent.magenta': '--ds-icon-accent-magenta',
        'color.icon.accent.gray': '--ds-icon-accent-gray',
        'color.icon.disabled': '--ds-icon-disabled',
        'color.icon.inverse': '--ds-icon-inverse',
        'color.icon.selected': '--ds-icon-selected',
        'color.icon.brand': '--ds-icon-brand',
        'color.icon.danger': '--ds-icon-danger',
        'color.icon.warning': '--ds-icon-warning',
        'color.icon.warning.inverse': '--ds-icon-warning-inverse',
        'color.icon.success': '--ds-icon-success',
        'color.icon.discovery': '--ds-icon-discovery',
        'color.icon.information': '--ds-icon-information',
        'color.icon.subtlest': '--ds-icon-subtlest',
        'color.icon.subtle': '--ds-icon-subtle',
        'color.border': '--ds-border',
        'color.border.accent.lime': '--ds-border-accent-lime',
        'color.border.accent.red': '--ds-border-accent-red',
        'color.border.accent.orange': '--ds-border-accent-orange',
        'color.border.accent.yellow': '--ds-border-accent-yellow',
        'color.border.accent.green': '--ds-border-accent-green',
        'color.border.accent.teal': '--ds-border-accent-teal',
        'color.border.accent.blue': '--ds-border-accent-blue',
        'color.border.accent.purple': '--ds-border-accent-purple',
        'color.border.accent.magenta': '--ds-border-accent-magenta',
        'color.border.accent.gray': '--ds-border-accent-gray',
        'color.border.disabled': '--ds-border-disabled',
        'color.border.focused': '--ds-border-focused',
        'color.border.input': '--ds-border-input',
        'color.border.inverse': '--ds-border-inverse',
        'color.border.selected': '--ds-border-selected',
        'color.border.brand': '--ds-border-brand',
        'color.border.danger': '--ds-border-danger',
        'color.border.warning': '--ds-border-warning',
        'color.border.success': '--ds-border-success',
        'color.border.discovery': '--ds-border-discovery',
        'color.border.information': '--ds-border-information',
        'color.border.bold': '--ds-border-bold',
        'color.background.accent.lime.subtlest': '--ds-background-accent-lime-subtlest',
        'color.background.accent.lime.subtlest.hovered': '--ds-background-accent-lime-subtlest-hovered',
        'color.background.accent.lime.subtlest.pressed': '--ds-background-accent-lime-subtlest-pressed',
        'color.background.accent.lime.subtler': '--ds-background-accent-lime-subtler',
        'color.background.accent.lime.subtler.hovered': '--ds-background-accent-lime-subtler-hovered',
        'color.background.accent.lime.subtler.pressed': '--ds-background-accent-lime-subtler-pressed',
        'color.background.accent.lime.subtle': '--ds-background-accent-lime-subtle',
        'color.background.accent.lime.subtle.hovered': '--ds-background-accent-lime-subtle-hovered',
        'color.background.accent.lime.subtle.pressed': '--ds-background-accent-lime-subtle-pressed',
        'color.background.accent.lime.bolder': '--ds-background-accent-lime-bolder',
        'color.background.accent.lime.bolder.hovered': '--ds-background-accent-lime-bolder-hovered',
        'color.background.accent.lime.bolder.pressed': '--ds-background-accent-lime-bolder-pressed',
        'color.background.accent.red.subtlest': '--ds-background-accent-red-subtlest',
        'color.background.accent.red.subtlest.hovered': '--ds-background-accent-red-subtlest-hovered',
        'color.background.accent.red.subtlest.pressed': '--ds-background-accent-red-subtlest-pressed',
        'color.background.accent.red.subtler': '--ds-background-accent-red-subtler',
        'color.background.accent.red.subtler.hovered': '--ds-background-accent-red-subtler-hovered',
        'color.background.accent.red.subtler.pressed': '--ds-background-accent-red-subtler-pressed',
        'color.background.accent.red.subtle': '--ds-background-accent-red-subtle',
        'color.background.accent.red.subtle.hovered': '--ds-background-accent-red-subtle-hovered',
        'color.background.accent.red.subtle.pressed': '--ds-background-accent-red-subtle-pressed',
        'color.background.accent.red.bolder': '--ds-background-accent-red-bolder',
        'color.background.accent.red.bolder.hovered': '--ds-background-accent-red-bolder-hovered',
        'color.background.accent.red.bolder.pressed': '--ds-background-accent-red-bolder-pressed',
        'color.background.accent.orange.subtlest': '--ds-background-accent-orange-subtlest',
        'color.background.accent.orange.subtlest.hovered': '--ds-background-accent-orange-subtlest-hovered',
        'color.background.accent.orange.subtlest.pressed': '--ds-background-accent-orange-subtlest-pressed',
        'color.background.accent.orange.subtler': '--ds-background-accent-orange-subtler',
        'color.background.accent.orange.subtler.hovered': '--ds-background-accent-orange-subtler-hovered',
        'color.background.accent.orange.subtler.pressed': '--ds-background-accent-orange-subtler-pressed',
        'color.background.accent.orange.subtle': '--ds-background-accent-orange-subtle',
        'color.background.accent.orange.subtle.hovered': '--ds-background-accent-orange-subtle-hovered',
        'color.background.accent.orange.subtle.pressed': '--ds-background-accent-orange-subtle-pressed',
        'color.background.accent.orange.bolder': '--ds-background-accent-orange-bolder',
        'color.background.accent.orange.bolder.hovered': '--ds-background-accent-orange-bolder-hovered',
        'color.background.accent.orange.bolder.pressed': '--ds-background-accent-orange-bolder-pressed',
        'color.background.accent.yellow.subtlest': '--ds-background-accent-yellow-subtlest',
        'color.background.accent.yellow.subtlest.hovered': '--ds-background-accent-yellow-subtlest-hovered',
        'color.background.accent.yellow.subtlest.pressed': '--ds-background-accent-yellow-subtlest-pressed',
        'color.background.accent.yellow.subtler': '--ds-background-accent-yellow-subtler',
        'color.background.accent.yellow.subtler.hovered': '--ds-background-accent-yellow-subtler-hovered',
        'color.background.accent.yellow.subtler.pressed': '--ds-background-accent-yellow-subtler-pressed',
        'color.background.accent.yellow.subtle': '--ds-background-accent-yellow-subtle',
        'color.background.accent.yellow.subtle.hovered': '--ds-background-accent-yellow-subtle-hovered',
        'color.background.accent.yellow.subtle.pressed': '--ds-background-accent-yellow-subtle-pressed',
        'color.background.accent.yellow.bolder': '--ds-background-accent-yellow-bolder',
        'color.background.accent.yellow.bolder.hovered': '--ds-background-accent-yellow-bolder-hovered',
        'color.background.accent.yellow.bolder.pressed': '--ds-background-accent-yellow-bolder-pressed',
        'color.background.accent.green.subtlest': '--ds-background-accent-green-subtlest',
        'color.background.accent.green.subtlest.hovered': '--ds-background-accent-green-subtlest-hovered',
        'color.background.accent.green.subtlest.pressed': '--ds-background-accent-green-subtlest-pressed',
        'color.background.accent.green.subtler': '--ds-background-accent-green-subtler',
        'color.background.accent.green.subtler.hovered': '--ds-background-accent-green-subtler-hovered',
        'color.background.accent.green.subtler.pressed': '--ds-background-accent-green-subtler-pressed',
        'color.background.accent.green.subtle': '--ds-background-accent-green-subtle',
        'color.background.accent.green.subtle.hovered': '--ds-background-accent-green-subtle-hovered',
        'color.background.accent.green.subtle.pressed': '--ds-background-accent-green-subtle-pressed',
        'color.background.accent.green.bolder': '--ds-background-accent-green-bolder',
        'color.background.accent.green.bolder.hovered': '--ds-background-accent-green-bolder-hovered',
        'color.background.accent.green.bolder.pressed': '--ds-background-accent-green-bolder-pressed',
        'color.background.accent.teal.subtlest': '--ds-background-accent-teal-subtlest',
        'color.background.accent.teal.subtlest.hovered': '--ds-background-accent-teal-subtlest-hovered',
        'color.background.accent.teal.subtlest.pressed': '--ds-background-accent-teal-subtlest-pressed',
        'color.background.accent.teal.subtler': '--ds-background-accent-teal-subtler',
        'color.background.accent.teal.subtler.hovered': '--ds-background-accent-teal-subtler-hovered',
        'color.background.accent.teal.subtler.pressed': '--ds-background-accent-teal-subtler-pressed',
        'color.background.accent.teal.subtle': '--ds-background-accent-teal-subtle',
        'color.background.accent.teal.subtle.hovered': '--ds-background-accent-teal-subtle-hovered',
        'color.background.accent.teal.subtle.pressed': '--ds-background-accent-teal-subtle-pressed',
        'color.background.accent.teal.bolder': '--ds-background-accent-teal-bolder',
        'color.background.accent.teal.bolder.hovered': '--ds-background-accent-teal-bolder-hovered',
        'color.background.accent.teal.bolder.pressed': '--ds-background-accent-teal-bolder-pressed',
        'color.background.accent.blue.subtlest': '--ds-background-accent-blue-subtlest',
        'color.background.accent.blue.subtlest.hovered': '--ds-background-accent-blue-subtlest-hovered',
        'color.background.accent.blue.subtlest.pressed': '--ds-background-accent-blue-subtlest-pressed',
        'color.background.accent.blue.subtler': '--ds-background-accent-blue-subtler',
        'color.background.accent.blue.subtler.hovered': '--ds-background-accent-blue-subtler-hovered',
        'color.background.accent.blue.subtler.pressed': '--ds-background-accent-blue-subtler-pressed',
        'color.background.accent.blue.subtle': '--ds-background-accent-blue-subtle',
        'color.background.accent.blue.subtle.hovered': '--ds-background-accent-blue-subtle-hovered',
        'color.background.accent.blue.subtle.pressed': '--ds-background-accent-blue-subtle-pressed',
        'color.background.accent.blue.bolder': '--ds-background-accent-blue-bolder',
        'color.background.accent.blue.bolder.hovered': '--ds-background-accent-blue-bolder-hovered',
        'color.background.accent.blue.bolder.pressed': '--ds-background-accent-blue-bolder-pressed',
        'color.background.accent.purple.subtlest': '--ds-background-accent-purple-subtlest',
        'color.background.accent.purple.subtlest.hovered': '--ds-background-accent-purple-subtlest-hovered',
        'color.background.accent.purple.subtlest.pressed': '--ds-background-accent-purple-subtlest-pressed',
        'color.background.accent.purple.subtler': '--ds-background-accent-purple-subtler',
        'color.background.accent.purple.subtler.hovered': '--ds-background-accent-purple-subtler-hovered',
        'color.background.accent.purple.subtler.pressed': '--ds-background-accent-purple-subtler-pressed',
        'color.background.accent.purple.subtle': '--ds-background-accent-purple-subtle',
        'color.background.accent.purple.subtle.hovered': '--ds-background-accent-purple-subtle-hovered',
        'color.background.accent.purple.subtle.pressed': '--ds-background-accent-purple-subtle-pressed',
        'color.background.accent.purple.bolder': '--ds-background-accent-purple-bolder',
        'color.background.accent.purple.bolder.hovered': '--ds-background-accent-purple-bolder-hovered',
        'color.background.accent.purple.bolder.pressed': '--ds-background-accent-purple-bolder-pressed',
        'color.background.accent.magenta.subtlest': '--ds-background-accent-magenta-subtlest',
        'color.background.accent.magenta.subtlest.hovered': '--ds-background-accent-magenta-subtlest-hovered',
        'color.background.accent.magenta.subtlest.pressed': '--ds-background-accent-magenta-subtlest-pressed',
        'color.background.accent.magenta.subtler': '--ds-background-accent-magenta-subtler',
        'color.background.accent.magenta.subtler.hovered': '--ds-background-accent-magenta-subtler-hovered',
        'color.background.accent.magenta.subtler.pressed': '--ds-background-accent-magenta-subtler-pressed',
        'color.background.accent.magenta.subtle': '--ds-background-accent-magenta-subtle',
        'color.background.accent.magenta.subtle.hovered': '--ds-background-accent-magenta-subtle-hovered',
        'color.background.accent.magenta.subtle.pressed': '--ds-background-accent-magenta-subtle-pressed',
        'color.background.accent.magenta.bolder': '--ds-background-accent-magenta-bolder',
        'color.background.accent.magenta.bolder.hovered': '--ds-background-accent-magenta-bolder-hovered',
        'color.background.accent.magenta.bolder.pressed': '--ds-background-accent-magenta-bolder-pressed',
        'color.background.accent.gray.subtlest': '--ds-background-accent-gray-subtlest',
        'color.background.accent.gray.subtlest.hovered': '--ds-background-accent-gray-subtlest-hovered',
        'color.background.accent.gray.subtlest.pressed': '--ds-background-accent-gray-subtlest-pressed',
        'color.background.accent.gray.subtler': '--ds-background-accent-gray-subtler',
        'color.background.accent.gray.subtler.hovered': '--ds-background-accent-gray-subtler-hovered',
        'color.background.accent.gray.subtler.pressed': '--ds-background-accent-gray-subtler-pressed',
        'color.background.accent.gray.subtle': '--ds-background-accent-gray-subtle',
        'color.background.accent.gray.subtle.hovered': '--ds-background-accent-gray-subtle-hovered',
        'color.background.accent.gray.subtle.pressed': '--ds-background-accent-gray-subtle-pressed',
        'color.background.accent.gray.bolder': '--ds-background-accent-gray-bolder',
        'color.background.accent.gray.bolder.hovered': '--ds-background-accent-gray-bolder-hovered',
        'color.background.accent.gray.bolder.pressed': '--ds-background-accent-gray-bolder-pressed',
        'color.background.disabled': '--ds-background-disabled',
        'color.background.input': '--ds-background-input',
        'color.background.input.hovered': '--ds-background-input-hovered',
        'color.background.input.pressed': '--ds-background-input-pressed',
        'color.background.inverse.subtle': '--ds-background-inverse-subtle',
        'color.background.inverse.subtle.hovered': '--ds-background-inverse-subtle-hovered',
        'color.background.inverse.subtle.pressed': '--ds-background-inverse-subtle-pressed',
        'color.background.neutral': '--ds-background-neutral',
        'color.background.neutral.hovered': '--ds-background-neutral-hovered',
        'color.background.neutral.pressed': '--ds-background-neutral-pressed',
        'color.background.neutral.subtle': '--ds-background-neutral-subtle',
        'color.background.neutral.subtle.hovered': '--ds-background-neutral-subtle-hovered',
        'color.background.neutral.subtle.pressed': '--ds-background-neutral-subtle-pressed',
        'color.background.neutral.bold': '--ds-background-neutral-bold',
        'color.background.neutral.bold.hovered': '--ds-background-neutral-bold-hovered',
        'color.background.neutral.bold.pressed': '--ds-background-neutral-bold-pressed',
        'color.background.selected': '--ds-background-selected',
        'color.background.selected.hovered': '--ds-background-selected-hovered',
        'color.background.selected.pressed': '--ds-background-selected-pressed',
        'color.background.selected.bold': '--ds-background-selected-bold',
        'color.background.selected.bold.hovered': '--ds-background-selected-bold-hovered',
        'color.background.selected.bold.pressed': '--ds-background-selected-bold-pressed',
        'color.background.brand.subtlest': '--ds-background-brand-subtlest',
        'color.background.brand.subtlest.hovered': '--ds-background-brand-subtlest-hovered',
        'color.background.brand.subtlest.pressed': '--ds-background-brand-subtlest-pressed',
        'color.background.brand.bold': '--ds-background-brand-bold',
        'color.background.brand.bold.hovered': '--ds-background-brand-bold-hovered',
        'color.background.brand.bold.pressed': '--ds-background-brand-bold-pressed',
        'color.background.brand.boldest': '--ds-background-brand-boldest',
        'color.background.brand.boldest.hovered': '--ds-background-brand-boldest-hovered',
        'color.background.brand.boldest.pressed': '--ds-background-brand-boldest-pressed',
        'color.background.danger': '--ds-background-danger',
        'color.background.danger.hovered': '--ds-background-danger-hovered',
        'color.background.danger.pressed': '--ds-background-danger-pressed',
        'color.background.danger.bold': '--ds-background-danger-bold',
        'color.background.danger.bold.hovered': '--ds-background-danger-bold-hovered',
        'color.background.danger.bold.pressed': '--ds-background-danger-bold-pressed',
        'color.background.warning': '--ds-background-warning',
        'color.background.warning.hovered': '--ds-background-warning-hovered',
        'color.background.warning.pressed': '--ds-background-warning-pressed',
        'color.background.warning.bold': '--ds-background-warning-bold',
        'color.background.warning.bold.hovered': '--ds-background-warning-bold-hovered',
        'color.background.warning.bold.pressed': '--ds-background-warning-bold-pressed',
        'color.background.success': '--ds-background-success',
        'color.background.success.hovered': '--ds-background-success-hovered',
        'color.background.success.pressed': '--ds-background-success-pressed',
        'color.background.success.bold': '--ds-background-success-bold',
        'color.background.success.bold.hovered': '--ds-background-success-bold-hovered',
        'color.background.success.bold.pressed': '--ds-background-success-bold-pressed',
        'color.background.discovery': '--ds-background-discovery',
        'color.background.discovery.hovered': '--ds-background-discovery-hovered',
        'color.background.discovery.pressed': '--ds-background-discovery-pressed',
        'color.background.discovery.bold': '--ds-background-discovery-bold',
        'color.background.discovery.bold.hovered': '--ds-background-discovery-bold-hovered',
        'color.background.discovery.bold.pressed': '--ds-background-discovery-bold-pressed',
        'color.background.information': '--ds-background-information',
        'color.background.information.hovered': '--ds-background-information-hovered',
        'color.background.information.pressed': '--ds-background-information-pressed',
        'color.background.information.bold': '--ds-background-information-bold',
        'color.background.information.bold.hovered': '--ds-background-information-bold-hovered',
        'color.background.information.bold.pressed': '--ds-background-information-bold-pressed',
        'color.blanket': '--ds-blanket',
        'color.blanket.selected': '--ds-blanket-selected',
        'color.blanket.danger': '--ds-blanket-danger',
        'color.interaction.hovered': '--ds-interaction-hovered',
        'color.interaction.pressed': '--ds-interaction-pressed',
        'color.skeleton': '--ds-skeleton',
        'color.skeleton.subtle': '--ds-skeleton-subtle',
        'color.chart.categorical.1': '--ds-chart-categorical-1',
        'color.chart.categorical.1.hovered': '--ds-chart-categorical-1-hovered',
        'color.chart.categorical.2': '--ds-chart-categorical-2',
        'color.chart.categorical.2.hovered': '--ds-chart-categorical-2-hovered',
        'color.chart.categorical.3': '--ds-chart-categorical-3',
        'color.chart.categorical.3.hovered': '--ds-chart-categorical-3-hovered',
        'color.chart.categorical.4': '--ds-chart-categorical-4',
        'color.chart.categorical.4.hovered': '--ds-chart-categorical-4-hovered',
        'color.chart.categorical.5': '--ds-chart-categorical-5',
        'color.chart.categorical.5.hovered': '--ds-chart-categorical-5-hovered',
        'color.chart.categorical.6': '--ds-chart-categorical-6',
        'color.chart.categorical.6.hovered': '--ds-chart-categorical-6-hovered',
        'color.chart.categorical.7': '--ds-chart-categorical-7',
        'color.chart.categorical.7.hovered': '--ds-chart-categorical-7-hovered',
        'color.chart.categorical.8': '--ds-chart-categorical-8',
        'color.chart.categorical.8.hovered': '--ds-chart-categorical-8-hovered',
        'color.chart.lime.bold': '--ds-chart-lime-bold',
        'color.chart.lime.bold.hovered': '--ds-chart-lime-bold-hovered',
        'color.chart.lime.bolder': '--ds-chart-lime-bolder',
        'color.chart.lime.bolder.hovered': '--ds-chart-lime-bolder-hovered',
        'color.chart.lime.boldest': '--ds-chart-lime-boldest',
        'color.chart.lime.boldest.hovered': '--ds-chart-lime-boldest-hovered',
        'color.chart.neutral': '--ds-chart-neutral',
        'color.chart.neutral.hovered': '--ds-chart-neutral-hovered',
        'color.chart.red.bold': '--ds-chart-red-bold',
        'color.chart.red.bold.hovered': '--ds-chart-red-bold-hovered',
        'color.chart.red.bolder': '--ds-chart-red-bolder',
        'color.chart.red.bolder.hovered': '--ds-chart-red-bolder-hovered',
        'color.chart.red.boldest': '--ds-chart-red-boldest',
        'color.chart.red.boldest.hovered': '--ds-chart-red-boldest-hovered',
        'color.chart.orange.bold': '--ds-chart-orange-bold',
        'color.chart.orange.bold.hovered': '--ds-chart-orange-bold-hovered',
        'color.chart.orange.bolder': '--ds-chart-orange-bolder',
        'color.chart.orange.bolder.hovered': '--ds-chart-orange-bolder-hovered',
        'color.chart.orange.boldest': '--ds-chart-orange-boldest',
        'color.chart.orange.boldest.hovered': '--ds-chart-orange-boldest-hovered',
        'color.chart.yellow.bold': '--ds-chart-yellow-bold',
        'color.chart.yellow.bold.hovered': '--ds-chart-yellow-bold-hovered',
        'color.chart.yellow.bolder': '--ds-chart-yellow-bolder',
        'color.chart.yellow.bolder.hovered': '--ds-chart-yellow-bolder-hovered',
        'color.chart.yellow.boldest': '--ds-chart-yellow-boldest',
        'color.chart.yellow.boldest.hovered': '--ds-chart-yellow-boldest-hovered',
        'color.chart.green.bold': '--ds-chart-green-bold',
        'color.chart.green.bold.hovered': '--ds-chart-green-bold-hovered',
        'color.chart.green.bolder': '--ds-chart-green-bolder',
        'color.chart.green.bolder.hovered': '--ds-chart-green-bolder-hovered',
        'color.chart.green.boldest': '--ds-chart-green-boldest',
        'color.chart.green.boldest.hovered': '--ds-chart-green-boldest-hovered',
        'color.chart.teal.bold': '--ds-chart-teal-bold',
        'color.chart.teal.bold.hovered': '--ds-chart-teal-bold-hovered',
        'color.chart.teal.bolder': '--ds-chart-teal-bolder',
        'color.chart.teal.bolder.hovered': '--ds-chart-teal-bolder-hovered',
        'color.chart.teal.boldest': '--ds-chart-teal-boldest',
        'color.chart.teal.boldest.hovered': '--ds-chart-teal-boldest-hovered',
        'color.chart.blue.bold': '--ds-chart-blue-bold',
        'color.chart.blue.bold.hovered': '--ds-chart-blue-bold-hovered',
        'color.chart.blue.bolder': '--ds-chart-blue-bolder',
        'color.chart.blue.bolder.hovered': '--ds-chart-blue-bolder-hovered',
        'color.chart.blue.boldest': '--ds-chart-blue-boldest',
        'color.chart.blue.boldest.hovered': '--ds-chart-blue-boldest-hovered',
        'color.chart.purple.bold': '--ds-chart-purple-bold',
        'color.chart.purple.bold.hovered': '--ds-chart-purple-bold-hovered',
        'color.chart.purple.bolder': '--ds-chart-purple-bolder',
        'color.chart.purple.bolder.hovered': '--ds-chart-purple-bolder-hovered',
        'color.chart.purple.boldest': '--ds-chart-purple-boldest',
        'color.chart.purple.boldest.hovered': '--ds-chart-purple-boldest-hovered',
        'color.chart.magenta.bold': '--ds-chart-magenta-bold',
        'color.chart.magenta.bold.hovered': '--ds-chart-magenta-bold-hovered',
        'color.chart.magenta.bolder': '--ds-chart-magenta-bolder',
        'color.chart.magenta.bolder.hovered': '--ds-chart-magenta-bolder-hovered',
        'color.chart.magenta.boldest': '--ds-chart-magenta-boldest',
        'color.chart.magenta.boldest.hovered': '--ds-chart-magenta-boldest-hovered',
        'color.chart.gray.bold': '--ds-chart-gray-bold',
        'color.chart.gray.bold.hovered': '--ds-chart-gray-bold-hovered',
        'color.chart.gray.bolder': '--ds-chart-gray-bolder',
        'color.chart.gray.bolder.hovered': '--ds-chart-gray-bolder-hovered',
        'color.chart.gray.boldest': '--ds-chart-gray-boldest',
        'color.chart.gray.boldest.hovered': '--ds-chart-gray-boldest-hovered',
        'color.chart.brand': '--ds-chart-brand',
        'color.chart.brand.hovered': '--ds-chart-brand-hovered',
        'color.chart.danger': '--ds-chart-danger',
        'color.chart.danger.hovered': '--ds-chart-danger-hovered',
        'color.chart.danger.bold': '--ds-chart-danger-bold',
        'color.chart.danger.bold.hovered': '--ds-chart-danger-bold-hovered',
        'color.chart.warning': '--ds-chart-warning',
        'color.chart.warning.hovered': '--ds-chart-warning-hovered',
        'color.chart.warning.bold': '--ds-chart-warning-bold',
        'color.chart.warning.bold.hovered': '--ds-chart-warning-bold-hovered',
        'color.chart.success': '--ds-chart-success',
        'color.chart.success.hovered': '--ds-chart-success-hovered',
        'color.chart.success.bold': '--ds-chart-success-bold',
        'color.chart.success.bold.hovered': '--ds-chart-success-bold-hovered',
        'color.chart.discovery': '--ds-chart-discovery',
        'color.chart.discovery.hovered': '--ds-chart-discovery-hovered',
        'color.chart.discovery.bold': '--ds-chart-discovery-bold',
        'color.chart.discovery.bold.hovered': '--ds-chart-discovery-bold-hovered',
        'color.chart.information': '--ds-chart-information',
        'color.chart.information.hovered': '--ds-chart-information-hovered',
        'color.chart.information.bold': '--ds-chart-information-bold',
        'color.chart.information.bold.hovered': '--ds-chart-information-bold-hovered',
        'elevation.surface': '--ds-surface',
        'elevation.surface.hovered': '--ds-surface-hovered',
        'elevation.surface.pressed': '--ds-surface-pressed',
        'elevation.surface.overlay': '--ds-surface-overlay',
        'elevation.surface.overlay.hovered': '--ds-surface-overlay-hovered',
        'elevation.surface.overlay.pressed': '--ds-surface-overlay-pressed',
        'elevation.surface.raised': '--ds-surface-raised',
        'elevation.surface.raised.hovered': '--ds-surface-raised-hovered',
        'elevation.surface.raised.pressed': '--ds-surface-raised-pressed',
        'elevation.surface.sunken': '--ds-surface-sunken',
        'elevation.shadow.overflow': '--ds-shadow-overflow',
        'elevation.shadow.overflow.perimeter': '--ds-shadow-overflow-perimeter',
        'elevation.shadow.overflow.spread': '--ds-shadow-overflow-spread',
        'elevation.shadow.overlay': '--ds-shadow-overlay',
        'elevation.shadow.raised': '--ds-shadow-raised',
        'opacity.disabled': '--ds-opacity-disabled',
        'opacity.loading': '--ds-opacity-loading',
        'utility.UNSAFE.textTransformUppercase': '--ds-UNSAFE-textTransformUppercase',
        'utility.UNSAFE.transparent': '--ds-UNSAFE-transparent',
        'utility.elevation.surface.current': '--ds-elevation-surface-current',
        'border.radius.050': '--ds-border-radius-050',
        'border.radius': '--ds-border-radius',
        'border.radius.100': '--ds-border-radius-100',
        'border.radius.200': '--ds-border-radius-200',
        'border.radius.300': '--ds-border-radius-300',
        'border.radius.400': '--ds-border-radius-400',
        'border.radius.circle': '--ds-border-radius-circle',
        'border.width': '--ds-border-width',
        'border.width.0': '--ds-border-width-0',
        'border.width.indicator': '--ds-border-width-indicator',
        'border.width.outline': '--ds-border-width-outline',
        'space.0': '--ds-space-0',
        'space.025': '--ds-space-025',
        'space.050': '--ds-space-050',
        'space.075': '--ds-space-075',
        'space.100': '--ds-space-100',
        'space.150': '--ds-space-150',
        'space.200': '--ds-space-200',
        'space.250': '--ds-space-250',
        'space.300': '--ds-space-300',
        'space.400': '--ds-space-400',
        'space.500': '--ds-space-500',
        'space.600': '--ds-space-600',
        'space.800': '--ds-space-800',
        'space.1000': '--ds-space-1000',
        'space.negative.025': '--ds-space-negative-025',
        'space.negative.050': '--ds-space-negative-050',
        'space.negative.075': '--ds-space-negative-075',
        'space.negative.100': '--ds-space-negative-100',
        'space.negative.150': '--ds-space-negative-150',
        'space.negative.200': '--ds-space-negative-200',
        'space.negative.250': '--ds-space-negative-250',
        'space.negative.300': '--ds-space-negative-300',
        'space.negative.400': '--ds-space-negative-400',
        'font.letterSpacing.0': '--ds-font-letterSpacing-0',
        'font.letterSpacing.100': '--ds-font-letterSpacing-100',
        'font.letterSpacing.200': '--ds-font-letterSpacing-200',
        'font.letterSpacing.300': '--ds-font-letterSpacing-300',
        'font.letterSpacing.400': '--ds-font-letterSpacing-400',
        'font.heading.xxlarge': '--ds-font-heading-xxlarge',
        'font.heading.xlarge': '--ds-font-heading-xlarge',
        'font.heading.large': '--ds-font-heading-large',
        'font.heading.medium': '--ds-font-heading-medium',
        'font.heading.small': '--ds-font-heading-small',
        'font.heading.xsmall': '--ds-font-heading-xsmall',
        'font.heading.xxsmall': '--ds-font-heading-xxsmall',
        'font.body.large': '--ds-font-body-large',
        'font.body': '--ds-font-body',
        'font.body.small': '--ds-font-body-small',
        'font.body.UNSAFE_small': '--ds-font-body-UNSAFE_small',
        'font.code': '--ds-font-code',
        'font.weight.regular': '--ds-font-weight-regular',
        'font.weight.medium': '--ds-font-weight-medium',
        'font.weight.semibold': '--ds-font-weight-semibold',
        'font.weight.bold': '--ds-font-weight-bold',
        'font.family.heading': '--ds-font-family-heading',
        'font.family.body': '--ds-font-family-body',
        'font.family.code': '--ds-font-family-code',
        'font.family.monospace': '--ds-font-family-monospace',
        'font.family.sans': '--ds-font-family-sans',
        'font.family.brand.heading': '--ds-font-family-brand-heading',
        'font.family.brand.body': '--ds-font-family-brand-body',
        'font.size.050': '--ds-font-size-050',
        'font.size.075': '--ds-font-size-075',
        'font.size.100': '--ds-font-size-100',
        'font.size.200': '--ds-font-size-200',
        'font.size.300': '--ds-font-size-300',
        'font.size.400': '--ds-font-size-400',
        'font.size.500': '--ds-font-size-500',
        'font.size.600': '--ds-font-size-600',
        'font.lineHeight.1': '--ds-font-lineHeight-1',
        'font.lineHeight.100': '--ds-font-lineHeight-100',
        'font.lineHeight.200': '--ds-font-lineHeight-200',
        'font.lineHeight.300': '--ds-font-lineHeight-300',
        'font.lineHeight.400': '--ds-font-lineHeight-400',
        'font.lineHeight.500': '--ds-font-lineHeight-500',
        'font.lineHeight.600': '--ds-font-lineHeight-600'
    };
    var $0471407e7f2eca1e$export$2e2bcd8739ae039 = $0471407e7f2eca1e$var$tokens;
});
parcelRegister("ipmlN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0d0bcabeb61e9448$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $23gMr = parcelRequire("23gMr");
    var $cmipe = parcelRequire("cmipe");
    var $foM3E = parcelRequire("foM3E");
    const $0d0bcabeb61e9448$var$IconButton = (0, ($parcel$interopDefault($eUqFw))).memo((0, ($parcel$interopDefault($eUqFw))).forwardRef(function Button({ 'aria-label': preventedAriaLabel, 'aria-labelledby': ariaLabelledBy, analyticsContext: analyticsContext, appearance: appearance, autoFocus: autoFocus, icon: icon, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading, isSelected: isSelected, isTooltipDisabled: isTooltipDisabled = true, label: label, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shape: shape, spacing: spacing, testId: testId, tooltip: tooltip, type: type = 'button', ...unsafeRest }, ref) {
        const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
        const baseProps = (0, $foM3E.default)({
            analyticsContext: analyticsContext,
            appearance: appearance,
            ariaLabelledBy: ariaLabelledBy,
            autoFocus: autoFocus,
            buttonType: 'button',
            icon: icon,
            interactionName: interactionName,
            isDisabled: isDisabled,
            isLoading: isLoading,
            isSelected: isSelected,
            label: label,
            onClick: onClick,
            onClickCapture: onClickCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onTouchEndCapture: onTouchEndCapture,
            onTouchStartCapture: onTouchStartCapture,
            ref: ref,
            shape: shape,
            spacing: spacing,
            testId: testId
        });
        if (!isTooltipDisabled) return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $cmipe.default), {
            content: tooltip?.content ?? label,
            testId: tooltip?.testId,
            position: tooltip?.position,
            delay: tooltip?.delay,
            onShow: tooltip?.onShow,
            onHide: tooltip?.onHide,
            mousePosition: tooltip?.mousePosition,
            analyticsContext: tooltip?.analyticsContext,
            strategy: tooltip?.strategy,
            tag: tooltip?.tag,
            truncate: tooltip?.truncate,
            component: tooltip?.component,
            hideTooltipOnClick: tooltip?.hideTooltipOnClick,
            hideTooltipOnMouseDown: tooltip?.hideTooltipOnMouseDown,
            ignoreTooltipPointerEvents: tooltip?.ignoreTooltipPointerEvents
        }, (triggerProps)=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $23gMr.default), {
                ...saferRest,
                "aria-labelledby": baseProps['aria-labelledby'],
                type: type,
                testId: testId,
                componentName: "IconButton",
                analyticsContext: analyticsContext,
                interactionName: interactionName,
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    saferRest.onMouseOver?.(e);
                },
                onMouseOut: (e)=>{
                    triggerProps.onMouseOut?.(e);
                    saferRest.onMouseOut?.(e);
                },
                onMouseMove: (e)=>{
                    triggerProps.onMouseMove?.(e);
                    saferRest.onMouseMove?.(e);
                },
                onMouseDown: (e)=>{
                    triggerProps.onMouseDown?.(e);
                    saferRest.onMouseDown?.(e);
                },
                onFocus: (e)=>{
                    triggerProps.onFocus?.(e);
                    saferRest.onFocus?.(e);
                },
                onBlur: (e)=>{
                    triggerProps.onBlur?.(e);
                    saferRest.onBlur?.(e);
                },
                onClick: (event, analyticsEvent)=>{
                    baseProps?.onClick?.(event, analyticsEvent);
                    triggerProps?.onClick?.(event);
                },
                ref: (ref)=>{
                    baseProps.ref(ref);
                    triggerProps?.ref?.(ref);
                },
                xcss: baseProps.xcss,
                isDisabled: baseProps.isDisabled,
                onMouseDownCapture: baseProps.onMouseDownCapture,
                onMouseUpCapture: baseProps.onMouseUpCapture,
                onKeyDownCapture: baseProps.onKeyDownCapture,
                onKeyUpCapture: baseProps.onKeyUpCapture,
                onTouchStartCapture: baseProps.onTouchStartCapture,
                onTouchEndCapture: baseProps.onTouchEndCapture,
                onPointerDownCapture: baseProps.onPointerDownCapture,
                onPointerUpCapture: baseProps.onPointerUpCapture,
                onClickCapture: baseProps.onClickCapture
            }, baseProps.children));
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $23gMr.default), {
            ...saferRest,
            "aria-labelledby": baseProps['aria-labelledby'],
            ref: baseProps.ref,
            xcss: baseProps.xcss,
            isDisabled: baseProps.isDisabled,
            onClick: baseProps.onClick,
            onMouseDownCapture: baseProps.onMouseDownCapture,
            onMouseUpCapture: baseProps.onMouseUpCapture,
            onKeyDownCapture: baseProps.onKeyDownCapture,
            onKeyUpCapture: baseProps.onKeyUpCapture,
            onTouchStartCapture: baseProps.onTouchStartCapture,
            onTouchEndCapture: baseProps.onTouchEndCapture,
            onPointerDownCapture: baseProps.onPointerDownCapture,
            onPointerUpCapture: baseProps.onPointerUpCapture,
            onClickCapture: baseProps.onClickCapture,
            type: type,
            testId: testId,
            componentName: "IconButton",
            analyticsContext: analyticsContext,
            interactionName: interactionName
        }, baseProps.children);
    }));
    $0d0bcabeb61e9448$var$IconButton.displayName = 'IconButton';
    var $0d0bcabeb61e9448$export$2e2bcd8739ae039 = $0d0bcabeb61e9448$var$IconButton;
});
parcelRegister("foM3E", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6514cea91a15f9cb$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $62Dwb = parcelRequire("62Dwb");
    var $1IlnG = parcelRequire("1IlnG");
    var $bbGxH = parcelRequire("bbGxH");
    var $kV0Jd = parcelRequire("kV0Jd");
    const $6514cea91a15f9cb$var$useIconButton = ({ analyticsContext: analyticsContext, appearance: appearance, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, autoFocus: autoFocus, buttonType: buttonType, icon: icon, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading = false, isSelected: isSelected, label: label, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, ref: ref, shape: shape, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId })=>{
        const isCircle = shape === 'circle';
        const baseProps = (0, $kV0Jd.default)({
            analyticsContext: analyticsContext,
            appearance: appearance,
            autoFocus: autoFocus,
            ariaLabel: ariaLabel,
            ariaLabelledBy: ariaLabelledBy,
            buttonType: buttonType,
            children: (0, ($parcel$interopDefault($eUqFw))).createElement((0, $1IlnG.default), {
                type: "icon",
                isLoading: isLoading
            }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $bbGxH.default), {
                icon: icon
            }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $62Dwb.default), null, label)),
            interactionName: interactionName,
            isDisabled: isDisabled,
            isLoading: isLoading,
            isSelected: isSelected,
            isIconButton: true,
            isCircle: isCircle,
            onClick: onClick,
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture,
            ref: ref,
            shouldFitContainer: shouldFitContainer,
            spacing: spacing,
            testId: testId
        });
        return baseProps;
    };
    var $6514cea91a15f9cb$export$2e2bcd8739ae039 = $6514cea91a15f9cb$var$useIconButton;
});
parcelRegister("1IlnG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0f63c782484b4c14$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $jGR8u = parcelRequire("jGR8u");
    var $fHiYa = parcelRequire("fHiYa");
    const $0f63c782484b4c14$var$textStyles = (0, $fHiYa.xcss)({
        flexGrow: 1,
        flexShrink: 1,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
    const $0f63c782484b4c14$var$iconStyles = (0, $fHiYa.xcss)({
        display: 'flex',
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        fontSize: 0,
        lineHeight: 0,
        userSelect: 'none'
    });
    const $0f63c782484b4c14$var$commonStyles = (0, $fHiYa.xcss)({
        transition: 'opacity 0.3s'
    });
    const $0f63c782484b4c14$var$fadeStyles = (0, $fHiYa.xcss)({
        opacity: 0
    });
    const $0f63c782484b4c14$var$beforeIconStyles = (0, $fHiYa.xcss)({
        '--ds--button--new-icon-padding-start': "var(--ds-space-050, 4px)",
        '--ds--button--new-icon-padding-end': "var(--ds-space-025, 2px)"
    });
    const $0f63c782484b4c14$var$afterIconStyles = (0, $fHiYa.xcss)({
        '--ds--button--new-icon-padding-start': "var(--ds-space-025, 2px)",
        '--ds--button--new-icon-padding-end': "var(--ds-space-050, 4px)"
    });
    const $0f63c782484b4c14$var$Content = ({ children: children, type: type = 'text', isLoading: isLoading, position: position })=>{
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            as: "span",
            xcss: [
                $0f63c782484b4c14$var$commonStyles,
                ...type === 'text' ? [
                    $0f63c782484b4c14$var$textStyles
                ] : [
                    $0f63c782484b4c14$var$iconStyles
                ],
                ...isLoading ? [
                    $0f63c782484b4c14$var$fadeStyles
                ] : [],
                ...position === 'before' ? [
                    $0f63c782484b4c14$var$beforeIconStyles
                ] : [],
                ...position === 'after' ? [
                    $0f63c782484b4c14$var$afterIconStyles
                ] : []
            ]
        }, children);
    };
    var $0f63c782484b4c14$export$2e2bcd8739ae039 = $0f63c782484b4c14$var$Content;
});
parcelRegister("bbGxH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$538d7716d51e61a6$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    function $538d7716d51e61a6$var$isIconRenderProp(func) {
        return !func.displayName && !func.render && typeof func === 'function';
    }
    const $538d7716d51e61a6$var$IconRenderer = ({ icon: Icon })=>{
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, $538d7716d51e61a6$var$isIconRenderProp(Icon) ? Icon({
            label: '',
            color: 'currentColor'
        }) : (0, ($parcel$interopDefault($eUqFw))).createElement(Icon, {
            label: "",
            color: 'currentColor'
        }));
    };
    var $538d7716d51e61a6$export$2e2bcd8739ae039 = $538d7716d51e61a6$var$IconRenderer;
});
parcelRegister("kV0Jd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e363e52b00952ddc$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $9xS6A = parcelRequire("9xS6A");
    var $lc5TP = parcelRequire("lc5TP");
    var $5aRS9 = parcelRequire("5aRS9");
    var $iDwTy = parcelRequire("iDwTy");
    var $jGR8u = parcelRequire("jGR8u");
    var $fHiYa = parcelRequire("fHiYa");
    var $62Dwb = parcelRequire("62Dwb");
    var $hRAZG = parcelRequire("hRAZG");
    var $30MNa = parcelRequire("30MNa");
    var $2aSFO = parcelRequire("2aSFO");
    const $e363e52b00952ddc$var$buttonStyles = (0, $fHiYa.xcss)({
        display: 'inline-flex',
        boxSizing: 'border-box',
        width: 'auto',
        maxWidth: '100%',
        position: 'relative',
        alignItems: 'baseline',
        justifyContent: 'center',
        columnGap: 'space.050',
        borderRadius: 'border.radius.100',
        borderWidth: 'border.width.0',
        flexShrink: 0,
        height: `${32 / 14}em`,
        paddingInlineEnd: 'space.150',
        paddingInlineStart: 'space.150',
        textAlign: 'center',
        transition: 'background 0.1s ease-out',
        verticalAlign: 'middle',
        '::after': {
            borderRadius: 'inherit',
            inset: 'space.0',
            borderStyle: 'solid',
            borderWidth: "var(--ds-border-width, 1px)",
            pointerEvents: 'none',
            position: 'absolute'
        }
    });
    const $e363e52b00952ddc$var$hardCodedButtonStyles = (0, $fHiYa.xcss)({
        fontFamily: 'inherit',
        fontSize: 'inherit',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: `${32 / 14}em`,
        paddingBlock: 'space.0'
    });
    const $e363e52b00952ddc$var$tokenizedButtonStyles = (0, $fHiYa.xcss)({
        font: 'font.body',
        fontWeight: 'font.weight.medium',
        paddingBlock: 'space.075'
    });
    const $e363e52b00952ddc$var$defaultInteractiveStyles = (0, $fHiYa.xcss)({
        ':hover': {
            background: "var(--ds-background-neutral-hovered, #091e4214)",
            color: `var(--ds-text, ${$207acf722dcd432b$export$c39c0fe0f26207ae})`
        },
        ':active': {
            background: `var(--ds-background-neutral-pressed, ${$207acf722dcd432b$export$8c13c2ee36917869})`,
            color: `var(--ds-text, ${$207acf722dcd432b$export$b3de0ae08da2ce64})`
        }
    });
    const $e363e52b00952ddc$var$defaultInteractiveRefreshedStyles = (0, $fHiYa.xcss)({
        ':hover': {
            background: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
            color: 'color.text.subtle'
        },
        ':active': {
            background: "var(--ds-background-neutral-subtle-pressed, #091E4224)",
            color: 'color.text.subtle'
        }
    });
    const $e363e52b00952ddc$var$defaultStyles = (0, $fHiYa.xcss)({
        background: `var(--ds-background-neutral, ${$207acf722dcd432b$export$8d43898f60b96a82})`,
        color: `var(--ds-text, ${$207acf722dcd432b$export$c39c0fe0f26207ae})`,
        ':visited': {
            color: `var(--ds-text, ${$207acf722dcd432b$export$c39c0fe0f26207ae})`
        }
    });
    const $e363e52b00952ddc$var$defaultRefreshedStyles = (0, $fHiYa.xcss)({
        background: "var(--ds-background-neutral-subtle, #00000000)",
        color: 'color.text.subtle',
        '::after': {
            content: '""',
            borderColor: 'color.border'
        },
        ':visited': {
            color: 'color.text.subtle'
        }
    });
    const $e363e52b00952ddc$var$primaryStyles = (0, $fHiYa.xcss)({
        background: "var(--ds-background-brand-bold, #0052CC)",
        color: "var(--ds-text-inverse, #FFFFFF)",
        ':visited': {
            color: "var(--ds-text-inverse, #FFFFFF)"
        }
    });
    const $e363e52b00952ddc$var$primaryInteractiveStyles = (0, $fHiYa.xcss)({
        ':hover': {
            color: "var(--ds-text-inverse, #FFFFFF)",
            background: "var(--ds-background-brand-bold-hovered, #0065FF)"
        },
        ':active': {
            color: "var(--ds-text-inverse, #FFFFFF)",
            background: "var(--ds-background-brand-bold-pressed, #0747A6)"
        }
    });
    const $e363e52b00952ddc$var$warningStyles = (0, $fHiYa.xcss)({
        background: "var(--ds-background-warning-bold, #FFAB00)",
        color: "var(--ds-text-warning-inverse, #172B4D)",
        ':visited': {
            color: "var(--ds-text-warning-inverse, #172B4D)"
        }
    });
    const $e363e52b00952ddc$var$warningInteractiveStyles = (0, $fHiYa.xcss)({
        ':hover': {
            color: "var(--ds-text-warning-inverse, #172B4D)",
            background: "var(--ds-background-warning-bold-hovered, #FFC400)"
        },
        ':active': {
            color: "var(--ds-text-warning-inverse, #172B4D)",
            background: "var(--ds-background-warning-bold-pressed, #FF991F)"
        }
    });
    const $e363e52b00952ddc$var$dangerStyles = (0, $fHiYa.xcss)({
        background: "var(--ds-background-danger-bold, #DE350B)",
        color: 'color.text.inverse',
        ':visited': {
            color: 'color.text.inverse'
        }
    });
    const $e363e52b00952ddc$var$dangerInteractiveStyles = (0, $fHiYa.xcss)({
        ':hover': {
            color: 'color.text.inverse',
            background: "var(--ds-background-danger-bold-hovered, #FF5630)"
        },
        ':active': {
            color: 'color.text.inverse',
            background: "var(--ds-background-danger-bold-pressed, #BF2600)"
        }
    });
    const $e363e52b00952ddc$var$discoveryStyles = (0, $fHiYa.xcss)({
        background: "var(--ds-background-discovery-bold, #5243AA)",
        color: 'color.text.inverse',
        ':visited': {
            color: 'color.text.inverse'
        }
    });
    const $e363e52b00952ddc$var$discoveryInteractiveStyles = (0, $fHiYa.xcss)({
        ':hover': {
            color: 'color.text.inverse',
            background: "var(--ds-background-discovery-bold-hovered, #8777D9)"
        },
        ':active': {
            color: 'color.text.inverse',
            background: "var(--ds-background-discovery-bold-pressed, #5243AA)"
        }
    });
    const $e363e52b00952ddc$var$subtleStyles = (0, $fHiYa.xcss)({
        background: "var(--ds-background-neutral-subtle, transparent)",
        color: "var(--ds-text, #42526E)",
        ':visited': {
            color: "var(--ds-text, #42526E)"
        }
    });
    const $e363e52b00952ddc$var$subtleRefreshedStyles = (0, $fHiYa.xcss)({
        background: "var(--ds-background-neutral-subtle, transparent)",
        color: 'color.text.subtle',
        ':visited': {
            color: 'color.text.subtle'
        }
    });
    const $e363e52b00952ddc$var$subtleInteractiveStyles = (0, $fHiYa.xcss)({
        ':hover': {
            background: "var(--ds-background-neutral-subtle-hovered, #091e4214)",
            color: "var(--ds-text, #42526E)"
        },
        ':active': {
            background: "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
            color: "var(--ds-text, #42526E)"
        }
    });
    const $e363e52b00952ddc$var$subtleInteractiveRefreshedStyles = (0, $fHiYa.xcss)({
        ':hover': {
            background: "var(--ds-background-neutral-subtle-hovered, #091e4214)",
            color: 'color.text.subtle'
        },
        ':active': {
            background: "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
            color: 'color.text.subtle'
        }
    });
    const $e363e52b00952ddc$var$linkDecorationUnsetStyles = (0, $fHiYa.xcss)({
        textDecoration: 'none',
        ':hover': {
            textDecoration: 'none'
        },
        ':active': {
            textDecoration: 'none'
        },
        ':focus': {
            textDecoration: 'none'
        }
    });
    const $e363e52b00952ddc$var$disabledStyles = (0, $fHiYa.xcss)({
        cursor: 'not-allowed',
        background: `var(--ds-background-disabled, ${$207acf722dcd432b$export$8d43898f60b96a82})`,
        color: "var(--ds-text-disabled, #091E424F)",
        ':hover': {
            background: `var(--ds-background-disabled, ${$207acf722dcd432b$export$8d43898f60b96a82})`,
            color: "var(--ds-text-disabled, #091E424F)"
        },
        ':active': {
            background: `var(--ds-background-disabled, ${$207acf722dcd432b$export$8d43898f60b96a82})`,
            color: "var(--ds-text-disabled, #091E424F)"
        },
        '::after': {
            content: 'none'
        }
    });
    const $e363e52b00952ddc$var$selectedStyles = (0, $fHiYa.xcss)({
        background: `var(--ds-background-selected, ${$207acf722dcd432b$export$ad0bacf983b7ddaa})`,
        color: `var(--ds-text-selected, ${$207acf722dcd432b$export$9fdfb749e33cdf97})`,
        ':visited': {
            color: `var(--ds-text-selected, ${$207acf722dcd432b$export$9fdfb749e33cdf97})`
        }
    });
    const $e363e52b00952ddc$var$selectedRefreshedStyles = (0, $fHiYa.xcss)({
        background: "var(--ds-background-selected, #E9F2FF)",
        color: 'color.text.selected',
        '::after': {
            content: '""',
            borderColor: 'color.border.selected'
        },
        ':visited': {
            color: 'color.text.selected'
        }
    });
    const $e363e52b00952ddc$var$selectedInsideSplitButtonStyles = (0, $fHiYa.xcss)({
        zIndex: 2
    });
    const $e363e52b00952ddc$var$selectedInteractiveStyles = (0, $fHiYa.xcss)({
        ':hover': {
            color: `var(--ds-text-selected, ${$207acf722dcd432b$export$9fdfb749e33cdf97})`,
            background: `var(--ds-background-selected-hovered, ${$207acf722dcd432b$export$ad0bacf983b7ddaa})`
        },
        ':active': {
            color: `var(--ds-text-selected, ${$207acf722dcd432b$export$9fdfb749e33cdf97})`,
            background: `var(--ds-background-selected-pressed, ${$207acf722dcd432b$export$ad0bacf983b7ddaa})`
        }
    });
    const $e363e52b00952ddc$var$selectedWarningStyles = (0, $fHiYa.xcss)({
        background: `var(--ds-background-selected, ${$207acf722dcd432b$export$59619663aa6500fb})`,
        color: `var(--ds-text-selected, ${$207acf722dcd432b$export$7d61b15e0da132af})`,
        ':hover': {
            color: `var(--ds-text-selected, ${$207acf722dcd432b$export$9fdfb749e33cdf97})`,
            background: `var(--ds-background-selected, ${$207acf722dcd432b$export$59619663aa6500fb})`
        },
        ':active': {
            color: `var(--ds-text-selected, ${$207acf722dcd432b$export$9fdfb749e33cdf97})`,
            background: `var(--ds-background-selected, ${$207acf722dcd432b$export$59619663aa6500fb})`
        }
    });
    const $e363e52b00952ddc$var$selectedDangerStyles = (0, $fHiYa.xcss)({
        background: `var(--ds-background-selected, ${$207acf722dcd432b$export$2837b5a1a71d5c02})`,
        color: `var(--ds-text-selected, ${$207acf722dcd432b$export$9fdfb749e33cdf97})`,
        ':hover': {
            color: `var(--ds-text-selected, ${$207acf722dcd432b$export$9fdfb749e33cdf97})`,
            background: `var(--ds-background-selected, ${$207acf722dcd432b$export$2837b5a1a71d5c02})`
        },
        ':active': {
            color: `var(--ds-text-selected, ${$207acf722dcd432b$export$9fdfb749e33cdf97})`,
            background: `var(--ds-background-selected, ${$207acf722dcd432b$export$2837b5a1a71d5c02})`
        }
    });
    const $e363e52b00952ddc$var$selectedDiscoveryStyles = (0, $fHiYa.xcss)({
        background: "var(--ds-background-selected, #403294)",
        color: `var(--ds-text-selected, ${$207acf722dcd432b$export$9fdfb749e33cdf97})`,
        ':hover': {
            color: `var(--ds-text-selected, ${$207acf722dcd432b$export$9fdfb749e33cdf97})`,
            background: "var(--ds-background-selected, #403294)"
        },
        ':active': {
            color: `var(--ds-text-selected, ${$207acf722dcd432b$export$9fdfb749e33cdf97})`,
            background: "var(--ds-background-selected, #403294)"
        }
    });
    const $e363e52b00952ddc$var$spacingCompactStyles = (0, $fHiYa.xcss)({
        columnGap: 'space.050',
        height: `${24 / 14}em`,
        paddingInlineEnd: 'space.150',
        paddingInlineStart: 'space.150',
        verticalAlign: 'middle'
    });
    const $e363e52b00952ddc$var$baseSpacingCompactStyles = (0, $fHiYa.xcss)({
        lineHeight: `${24 / 14}em`
    });
    const $e363e52b00952ddc$var$tokenizedSpacingCompactStyles = (0, $fHiYa.xcss)({
        paddingBlock: 'space.025'
    });
    const $e363e52b00952ddc$var$circleStyles = (0, $fHiYa.xcss)({
        borderRadius: 'border.radius.circle'
    });
    const $e363e52b00952ddc$var$fullWidthStyles = (0, $fHiYa.xcss)({
        width: '100%'
    });
    const $e363e52b00952ddc$var$loadingStyles = (0, $fHiYa.xcss)({
        cursor: 'progress'
    });
    const $e363e52b00952ddc$var$iconButtonStyles = (0, $fHiYa.xcss)({
        height: `${32 / 14}em`,
        width: `${32 / 14}em`,
        paddingInlineEnd: 'space.0',
        paddingInlineStart: 'space.0'
    });
    const $e363e52b00952ddc$var$iconButtonCompactStyles = (0, $fHiYa.xcss)({
        width: `${24 / 14}em`,
        height: `${24 / 14}em`
    });
    const $e363e52b00952ddc$var$buttonIconBeforeStyles = (0, $fHiYa.xcss)({
        paddingInlineStart: 'space.100'
    });
    const $e363e52b00952ddc$var$buttonIconAfterStyles = (0, $fHiYa.xcss)({
        paddingInlineEnd: 'space.100'
    });
    const $e363e52b00952ddc$var$splitButtonStyles = (0, $fHiYa.xcss)({
        ':focus-visible': {
            zIndex: 'card'
        }
    });
    const $e363e52b00952ddc$var$navigationSplitButtonStyles = (0, $fHiYa.xcss)({
        width: '24px',
        backgroundColor: 'color.background.neutral.subtle',
        paddingInlineEnd: 'space.075',
        paddingInlineStart: 'space.075'
    });
    const $e363e52b00952ddc$var$loadingOverlayStyles = (0, $fHiYa.xcss)({
        display: 'flex',
        position: 'absolute',
        alignItems: 'center',
        justifyContent: 'center',
        insetBlockEnd: 'space.0',
        insetBlockStart: 'space.0',
        insetInlineEnd: 'space.0',
        insetInlineStart: 'space.0'
    });
    const $e363e52b00952ddc$var$useButtonBase = ({ appearance: propAppearance = 'default', autoFocus: autoFocus = false, isDisabled: propIsDisabled = false, isLoading: isLoading = false, isSelected: propIsSelected = false, isIconButton: isIconButton = false, isCircle: isCircle = false, hasIconBefore: hasIconBefore = false, hasIconAfter: hasIconAfter = false, children: children, onClick: onClick, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onTouchStartCapture: onTouchStartCapture, onTouchEndCapture: onTouchEndCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onClickCapture: onClickCapture, ref: ref, shouldFitContainer: shouldFitContainer = false, spacing: propSpacing = 'default', testId: testId, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy })=>{
        const localRef = (0, $eUqFw.useRef)(null);
        const splitButtonContext = (0, $hRAZG.useSplitButtonContext)();
        const loadingLabelId = (0, $5aRS9.useId)();
        const isSplitButton = Boolean(splitButtonContext);
        const isNavigationSplitButton = splitButtonContext?.isNavigationSplitButton || false;
        const isDefaultAppearanceSplitButton = splitButtonContext?.appearance === 'default';
        const appearance = isDefaultAppearanceSplitButton && (0, $iDwTy.fg)('platform-component-visual-refresh') ? 'subtle' : splitButtonContext?.appearance || propAppearance;
        const spacing = splitButtonContext?.spacing || propSpacing;
        const isDisabled = splitButtonContext?.isDisabled || propIsDisabled;
        const isInteractive = !isDisabled && !isLoading;
        const isEffectivelyDisabled = isDisabled || isLoading;
        const isSelected = propIsSelected && !isDisabled;
        (0, $lc5TP.default)(localRef, autoFocus);
        return {
            ref: (0, $9xS6A.default)([
                localRef,
                ref
            ]),
            xcss: [
                (0, $iDwTy.fg)('platform.design-system-team.button-tokenised-typography-styles') ? $e363e52b00952ddc$var$tokenizedButtonStyles : $e363e52b00952ddc$var$hardCodedButtonStyles,
                $e363e52b00952ddc$var$buttonStyles,
                appearance === 'default' && ((0, $iDwTy.fg)('platform-component-visual-refresh') ? $e363e52b00952ddc$var$defaultRefreshedStyles : $e363e52b00952ddc$var$defaultStyles),
                appearance === 'default' && isInteractive && ((0, $iDwTy.fg)('platform-component-visual-refresh') ? $e363e52b00952ddc$var$defaultInteractiveRefreshedStyles : $e363e52b00952ddc$var$defaultInteractiveStyles),
                appearance === 'primary' && $e363e52b00952ddc$var$primaryStyles,
                appearance === 'primary' && isInteractive && $e363e52b00952ddc$var$primaryInteractiveStyles,
                appearance === 'warning' && $e363e52b00952ddc$var$warningStyles,
                appearance === 'warning' && isInteractive && $e363e52b00952ddc$var$warningInteractiveStyles,
                appearance === 'danger' && $e363e52b00952ddc$var$dangerStyles,
                appearance === 'danger' && isInteractive && $e363e52b00952ddc$var$dangerInteractiveStyles,
                appearance === 'discovery' && $e363e52b00952ddc$var$discoveryStyles,
                appearance === 'discovery' && isInteractive && $e363e52b00952ddc$var$discoveryInteractiveStyles,
                appearance === 'subtle' && ((0, $iDwTy.fg)('platform-component-visual-refresh') ? $e363e52b00952ddc$var$subtleRefreshedStyles : $e363e52b00952ddc$var$subtleStyles),
                appearance === 'subtle' && isInteractive && ((0, $iDwTy.fg)('platform-component-visual-refresh') ? $e363e52b00952ddc$var$subtleInteractiveRefreshedStyles : $e363e52b00952ddc$var$subtleInteractiveStyles),
                $e363e52b00952ddc$var$linkDecorationUnsetStyles,
                isSelected && ((0, $iDwTy.fg)('platform-component-visual-refresh') ? $e363e52b00952ddc$var$selectedRefreshedStyles : $e363e52b00952ddc$var$selectedStyles),
                isSelected && isSplitButton && $e363e52b00952ddc$var$selectedInsideSplitButtonStyles,
                isSelected && isInteractive && $e363e52b00952ddc$var$selectedInteractiveStyles,
                isSelected && appearance === 'danger' && $e363e52b00952ddc$var$selectedDangerStyles,
                isSelected && appearance === 'warning' && $e363e52b00952ddc$var$selectedWarningStyles,
                isSelected && appearance === 'discovery' && $e363e52b00952ddc$var$selectedDiscoveryStyles,
                isDisabled && $e363e52b00952ddc$var$disabledStyles,
                isCircle && !isSplitButton && $e363e52b00952ddc$var$circleStyles,
                spacing === 'compact' && $e363e52b00952ddc$var$spacingCompactStyles,
                spacing === 'compact' && ((0, $iDwTy.fg)('platform.design-system-team.button-tokenised-typography-styles') ? $e363e52b00952ddc$var$tokenizedSpacingCompactStyles : $e363e52b00952ddc$var$baseSpacingCompactStyles),
                hasIconBefore && $e363e52b00952ddc$var$buttonIconBeforeStyles,
                hasIconAfter && $e363e52b00952ddc$var$buttonIconAfterStyles,
                isIconButton && $e363e52b00952ddc$var$iconButtonStyles,
                isIconButton && spacing === 'compact' && $e363e52b00952ddc$var$iconButtonCompactStyles,
                shouldFitContainer && $e363e52b00952ddc$var$fullWidthStyles,
                isLoading && $e363e52b00952ddc$var$loadingStyles,
                isSplitButton && $e363e52b00952ddc$var$splitButtonStyles,
                isNavigationSplitButton && $e363e52b00952ddc$var$navigationSplitButtonStyles
            ],
            isDisabled: isEffectivelyDisabled,
            children: (0, ($parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, children, isLoading ? (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
                as: "span",
                xcss: $e363e52b00952ddc$var$loadingOverlayStyles
            }, (0, $2aSFO.default)({
                spacing: spacing,
                appearance: appearance,
                isDisabled: isDisabled,
                isSelected: isSelected,
                testId: testId
            })) : null, isLoading && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && (0, ($parcel$interopDefault($eUqFw))).createElement((0, $62Dwb.default), {
                id: loadingLabelId
            }, (0, $58d1fed93091242f$export$d4c5499dc806c969))),
            'aria-label': isLoading && ariaLabel && !ariaLabelledBy ? `${ariaLabel} ${0, $58d1fed93091242f$export$d4c5499dc806c969}` : ariaLabel,
            'aria-labelledby': isLoading && ariaLabelledBy ? `${ariaLabelledBy} ${loadingLabelId}` : ariaLabelledBy,
            ...(0, $30MNa.default)(isEffectivelyDisabled, {
                onClick: onClick,
                onMouseDownCapture: onMouseDownCapture,
                onMouseUpCapture: onMouseUpCapture,
                onKeyDownCapture: onKeyDownCapture,
                onKeyUpCapture: onKeyUpCapture,
                onTouchStartCapture: onTouchStartCapture,
                onTouchEndCapture: onTouchEndCapture,
                onPointerDownCapture: onPointerDownCapture,
                onPointerUpCapture: onPointerUpCapture,
                onClickCapture: onClickCapture
            })
        };
    };
    var $e363e52b00952ddc$export$2e2bcd8739ae039 = $e363e52b00952ddc$var$useButtonBase;
});
parcelRegister("hRAZG", function(module, exports) {
    $parcel$export(module.exports, "SplitButtonContext", ()=>$a0223567be062f0d$export$4b86304b2c0d7e71);
    $parcel$export(module.exports, "useSplitButtonContext", ()=>$a0223567be062f0d$export$47e2c6fdb142d947);
    var $eUqFw = parcelRequire("eUqFw");
    const $a0223567be062f0d$export$4b86304b2c0d7e71 = (0, $eUqFw.createContext)(undefined);
    const $a0223567be062f0d$export$47e2c6fdb142d947 = ()=>{
        const context = (0, $eUqFw.useContext)($a0223567be062f0d$export$4b86304b2c0d7e71);
        if (!context) return undefined;
        if (context.appearance === 'navigation') {
            const newContext = {
                spacing: 'default',
                appearance: 'subtle',
                isDisabled: false,
                isActiveOverSelected: false,
                isNavigationSplitButton: true,
                isHighlighted: context.isHighlighted
            };
            return newContext;
        }
        const splitButtonContext = {
            spacing: context.spacing,
            appearance: context.appearance,
            isDisabled: context.isDisabled,
            isActiveOverSelected: true,
            isNavigationSplitButton: false,
            isHighlighted: false
        };
        return splitButtonContext;
    };
});
parcelRegister("30MNa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5dd1ca9db4503c98$export$2e2bcd8739ae039);
    function $5dd1ca9db4503c98$var$abort(event) {
        event.preventDefault();
        event.stopPropagation();
    }
    const $5dd1ca9db4503c98$var$tabKeyCode = 9;
    function $5dd1ca9db4503c98$var$onKey(event) {
        if (event.keyCode === $5dd1ca9db4503c98$var$tabKeyCode) return;
        $5dd1ca9db4503c98$var$abort(event);
    }
    function $5dd1ca9db4503c98$export$2e2bcd8739ae039(shouldBlockEvents, events) {
        return shouldBlockEvents ? {
            onMouseDownCapture: $5dd1ca9db4503c98$var$abort,
            onMouseUpCapture: $5dd1ca9db4503c98$var$abort,
            onKeyDownCapture: $5dd1ca9db4503c98$var$onKey,
            onKeyUpCapture: $5dd1ca9db4503c98$var$onKey,
            onTouchStartCapture: $5dd1ca9db4503c98$var$abort,
            onTouchEndCapture: $5dd1ca9db4503c98$var$abort,
            onPointerDownCapture: $5dd1ca9db4503c98$var$abort,
            onPointerUpCapture: $5dd1ca9db4503c98$var$abort,
            onClickCapture: $5dd1ca9db4503c98$var$abort,
            onClick: $5dd1ca9db4503c98$var$abort
        } : events;
    }
});
const $58d1fed93091242f$export$d4c5499dc806c969 = ', Loading';
parcelRegister("2aSFO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2dc41f58bbbeb1cc$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $eUtxe = parcelRequire("eUtxe");
    function $2dc41f58bbbeb1cc$var$getIconSpacing(spacing) {
        switch(spacing){
            case 'compact':
                return 'small';
            default:
                return 'medium';
        }
    }
    function $2dc41f58bbbeb1cc$var$getSpinnerAppearance({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected }) {
        if (isDisabled || isSelected) return 'inherit';
        if (appearance === 'primary' || appearance === 'danger' || appearance === 'discovery') return 'invert';
        return 'inherit';
    }
    function $2dc41f58bbbeb1cc$export$2e2bcd8739ae039({ appearance: appearance, spacing: spacing, isDisabled: isDisabled, isSelected: isSelected, testId: testId }) {
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $eUtxe.default), {
            size: $2dc41f58bbbeb1cc$var$getIconSpacing(spacing),
            appearance: $2dc41f58bbbeb1cc$var$getSpinnerAppearance({
                appearance: appearance,
                isDisabled: isDisabled,
                isSelected: isSelected
            }),
            testId: testId ? `${testId}--loading-spinner` : undefined
        });
    }
});
parcelRegister("c9ga1", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $8d82dc7b066e48ee$var$_react = $8d82dc7b066e48ee$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $8d82dc7b066e48ee$var$_close = $8d82dc7b066e48ee$var$_interopRequireDefault((parcelRequire("bCjta")));
    var $8d82dc7b066e48ee$var$_cross = $8d82dc7b066e48ee$var$_interopRequireDefault((parcelRequire("lKozG")));
    function $8d82dc7b066e48ee$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $8d82dc7b066e48ee$var$CloseIcon = (props)=>$8d82dc7b066e48ee$var$_react.default.createElement($8d82dc7b066e48ee$var$_close.default, Object.assign({
            LEGACY_fallbackIcon: $8d82dc7b066e48ee$var$_cross.default
        }, props));
    $8d82dc7b066e48ee$var$CloseIcon.Name = 'CloseIconMigration';
    var $8d82dc7b066e48ee$var$_default = module.exports.default = $8d82dc7b066e48ee$var$CloseIcon;
});
parcelRegister("f680m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$810d96d5c45dbce3$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $7oZBH = parcelRequire("7oZBH");
    var $dH13t = parcelRequire("dH13t");
    const $810d96d5c45dbce3$var$svgStyles = (0, $byn9U.css)((0, $dH13t.commonSVGStyles));
    const $810d96d5c45dbce3$var$SVG = (0, $eUqFw.memo)(function SVG({ size: size = 'medium', label: label, primaryColor: primaryColor = 'currentColor', secondaryColor: secondaryColor, testId: testId, children: children }) {
        return (0, $byn9U.jsx)("svg", {
            viewBox: "0 0 24 24",
            style: {
                color: primaryColor,
                fill: secondaryColor || (0, $7oZBH.getBackground)()
            },
            css: [
                $810d96d5c45dbce3$var$svgStyles,
                (0, $dH13t.sizeStyleMap)[size]
            ],
            "data-testid": testId,
            "aria-label": label || undefined,
            role: label ? 'img' : 'presentation'
        }, children);
    });
    var $810d96d5c45dbce3$export$2e2bcd8739ae039 = $810d96d5c45dbce3$var$SVG;
});
parcelRegister("fe7tw", function(module, exports) {
    $parcel$export(module.exports, "AVATAR_SIZES", ()=>$4389a5650305fc82$export$9a270941bcff7e77);
    $parcel$export(module.exports, "AVATAR_RADIUS", ()=>$4389a5650305fc82$export$e6da6efe4d1a5c9b);
    $parcel$export(module.exports, "BORDER_WIDTH", ()=>$4389a5650305fc82$export$e2bd4c1faded7921);
    $parcel$export(module.exports, "ACTIVE_SCALE_FACTOR", ()=>$4389a5650305fc82$export$89a980dfdf90df51);
    $parcel$export(module.exports, "CSS_VAR_AVATAR_BGCOLOR", ()=>$4389a5650305fc82$export$3c061e31594ebabe);
    $parcel$export(module.exports, "ICON_SIZES", ()=>$4389a5650305fc82$export$fdc820179f1f9be4);
    $parcel$export(module.exports, "ICON_OFFSET", ()=>$4389a5650305fc82$export$382610e783aa2ae8);
    var $h04Oa = parcelRequire("h04Oa");
    const $4389a5650305fc82$export$9a270941bcff7e77 = {
        xsmall: (0, $h04Oa.gridSize)() * 2,
        small: (0, $h04Oa.gridSize)() * 3,
        medium: (0, $h04Oa.gridSize)() * 4,
        large: (0, $h04Oa.gridSize)() * 5,
        xlarge: (0, $h04Oa.gridSize)() * 12,
        xxlarge: (0, $h04Oa.gridSize)() * 16
    };
    const $4389a5650305fc82$export$e6da6efe4d1a5c9b = {
        xsmall: 2,
        small: 2,
        medium: 3,
        large: 3,
        xlarge: 6,
        xxlarge: 12
    };
    const $4389a5650305fc82$export$e2bd4c1faded7921 = 2;
    const $4389a5650305fc82$export$89a980dfdf90df51 = 0.9;
    const $4389a5650305fc82$export$3c061e31594ebabe = '--avatar-background-color';
    const $4389a5650305fc82$export$fdc820179f1f9be4 = {
        small: 12,
        medium: 14,
        large: 15,
        xlarge: 18
    };
    const $4389a5650305fc82$export$382610e783aa2ae8 = {
        small: 0,
        medium: 0,
        large: 1,
        xlarge: 7
    };
});
parcelRegister("lXjiR", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ffbe14da898ecc73$var$_react = $ffbe14da898ecc73$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $ffbe14da898ecc73$var$_UNSAFE_baseNew = $ffbe14da898ecc73$var$_interopRequireDefault((parcelRequire("ay9aj")));
    function $ffbe14da898ecc73$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ffbe14da898ecc73$var$StarUnstarredIcon = (props)=>$ffbe14da898ecc73$var$_react.default.createElement($ffbe14da898ecc73$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" d="m6 8.917.424-.619L6 8.008l-.424.29zM2.597 11.25l-.724-.194a.75.75 0 0 0 1.148.813zm1.07-3.986.724.194.124-.463-.368-.307zM.75 4.834l-.058-.748A.75.75 0 0 0 .27 5.41zm3.792-.292.057.747.473-.036.17-.442zM6 .75l.7-.27a.75.75 0 0 0-1.4 0zm1.458 3.792-.7.269.17.442.473.036zm3.792.291.48.577a.75.75 0 0 0-.423-1.324zm-2.917 2.43-.48-.575-.368.307.124.463zm1.07 3.987-.424.618a.75.75 0 0 0 1.148-.812zM5.576 8.298l-3.403 2.334.848 1.236 3.403-2.333zm-2.254 3.146L4.39 7.458 2.942 7.07l-1.07 3.986zm.825-4.756L1.23 4.258.27 5.41l2.917 2.43zM.807 5.58 4.6 5.29l-.115-1.495-3.792.292zm4.435-.77L6.7 1.019 5.3.481 3.842 4.272zM5.3 1.019l1.458 3.792 1.4-.539L6.7.481zm2.1 4.27 3.793.292.114-1.495-3.791-.292zm3.37-1.032-2.917 2.43.96 1.153 2.917-2.43zM7.609 7.458l1.07 3.986 1.448-.388-1.07-3.986zm2.218 3.174L6.424 8.298l-.848 1.237 3.403 2.333z"/>`,
            type: 'utility'
        }, props));
    $ffbe14da898ecc73$var$StarUnstarredIcon.displayName = 'StarUnstarredIcon';
    var $ffbe14da898ecc73$var$_default = module.exports.default = $ffbe14da898ecc73$var$StarUnstarredIcon;
});
parcelRegister("7LEad", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0efcfd4fbaffda48$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $23gMr = parcelRequire("23gMr");
    var $4PztY = parcelRequire("4PztY");
    const $0efcfd4fbaffda48$var$Button = (0, ($parcel$interopDefault($eUqFw))).memo((0, ($parcel$interopDefault($eUqFw))).forwardRef(function Button({ analyticsContext: analyticsContext, appearance: appearance, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus, children: children, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, type: type = 'button', ...unsafeRest }, ref) {
        const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
        const baseProps = (0, $4PztY.default)({
            ariaLabel: ariaLabel,
            ariaLabelledBy: ariaLabelledBy,
            analyticsContext: analyticsContext,
            appearance: appearance,
            autoFocus: autoFocus,
            buttonType: 'button',
            children: children,
            iconAfter: iconAfter,
            iconBefore: iconBefore,
            interactionName: interactionName,
            isDisabled: isDisabled,
            isLoading: isLoading,
            isSelected: isSelected,
            onClick: onClick,
            onClickCapture: onClickCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onTouchEndCapture: onTouchEndCapture,
            onTouchStartCapture: onTouchStartCapture,
            ref: ref,
            shouldFitContainer: shouldFitContainer,
            spacing: spacing,
            testId: testId
        });
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $23gMr.default), {
            ...saferRest,
            "aria-label": baseProps['aria-label'],
            "aria-labelledby": baseProps['aria-labelledby'],
            ref: baseProps.ref,
            xcss: baseProps.xcss,
            isDisabled: baseProps.isDisabled,
            onClick: baseProps.onClick,
            onMouseDownCapture: baseProps.onMouseDownCapture,
            onMouseUpCapture: baseProps.onMouseUpCapture,
            onKeyDownCapture: baseProps.onKeyDownCapture,
            onKeyUpCapture: baseProps.onKeyUpCapture,
            onTouchStartCapture: baseProps.onTouchStartCapture,
            onTouchEndCapture: baseProps.onTouchEndCapture,
            onPointerDownCapture: baseProps.onPointerDownCapture,
            onPointerUpCapture: baseProps.onPointerUpCapture,
            onClickCapture: baseProps.onClickCapture,
            type: type,
            testId: testId,
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            componentName: "Button"
        }, baseProps.children);
    }));
    $0efcfd4fbaffda48$var$Button.displayName = 'Button';
    var $0efcfd4fbaffda48$export$2e2bcd8739ae039 = $0efcfd4fbaffda48$var$Button;
});
parcelRegister("4PztY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3a36428eb14cf8e2$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $1IlnG = parcelRequire("1IlnG");
    var $bbGxH = parcelRequire("bbGxH");
    var $kV0Jd = parcelRequire("kV0Jd");
    const $3a36428eb14cf8e2$var$useDefaultButton = ({ analyticsContext: analyticsContext, appearance: appearance, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, autoFocus: autoFocus, buttonType: buttonType, children: children, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading = false, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, ref: ref, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId })=>{
        const baseProps = (0, $kV0Jd.default)({
            analyticsContext: analyticsContext,
            appearance: appearance,
            autoFocus: autoFocus,
            ariaLabel: ariaLabel,
            ariaLabelledBy: ariaLabelledBy,
            buttonType: buttonType,
            children: (0, ($parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, iconBefore && (0, ($parcel$interopDefault($eUqFw))).createElement((0, $1IlnG.default), {
                type: "icon",
                position: "before",
                isLoading: isLoading
            }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $bbGxH.default), {
                icon: iconBefore
            })), children && (0, ($parcel$interopDefault($eUqFw))).createElement((0, $1IlnG.default), {
                isLoading: isLoading
            }, children), iconAfter && (0, ($parcel$interopDefault($eUqFw))).createElement((0, $1IlnG.default), {
                type: "icon",
                position: "after",
                isLoading: isLoading
            }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $bbGxH.default), {
                icon: iconAfter
            }))),
            interactionName: interactionName,
            isDisabled: isDisabled,
            isLoading: isLoading,
            isSelected: isSelected,
            onClick: onClick,
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture,
            ref: ref,
            shouldFitContainer: shouldFitContainer,
            spacing: spacing,
            testId: testId,
            hasIconBefore: Boolean(iconBefore),
            hasIconAfter: Boolean(iconAfter)
        });
        return baseProps;
    };
    var $3a36428eb14cf8e2$export$2e2bcd8739ae039 = $3a36428eb14cf8e2$var$useDefaultButton;
});
parcelRegister("9VgVq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fb019b45941db6af$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $74BVL = parcelRequire("74BVL");
    var $7LEad = parcelRequire("7LEad");
    var $9xS6A = parcelRequire("9xS6A");
    var $4oSDA = parcelRequire("4oSDA");
    var $5skWh = parcelRequire("5skWh");
    var $dHMNX = parcelRequire("dHMNX");
    var $jogQH = parcelRequire("jogQH");
    var $iDwTy = parcelRequire("iDwTy");
    var $23sYR = parcelRequire("23sYR");
    var $h04Oa = parcelRequire("h04Oa");
    var $03WOI = parcelRequire("03WOI");
    var $9ZrLh = parcelRequire("9ZrLh");
    var $grKJS = parcelRequire("grKJS");
    var $8OgO6 = parcelRequire("8OgO6");
    var $f4ILk = parcelRequire("f4ILk");
    var $aHgG7 = parcelRequire("aHgG7");
    const $fb019b45941db6af$var$gridSize = (0, $h04Oa.gridSize)();
    const $fb019b45941db6af$var$MAX_HEIGHT = `calc(100vh - ${$fb019b45941db6af$var$gridSize * 2}px)`;
    const $fb019b45941db6af$var$opposites = {
        top: 'bottom',
        bottom: 'top',
        left: 'right',
        right: 'left',
        start: 'end',
        auto: 'auto',
        end: 'start'
    };
    const $fb019b45941db6af$var$getFallbackPlacements = (placement)=>{
        const placementPieces = placement.split('-');
        const mainAxis = placementPieces[0];
        if (![
            'top',
            'bottom'
        ].includes(mainAxis)) return undefined;
        else if (placementPieces.length === 2 && [
            'start',
            'end'
        ].includes(placementPieces[1])) {
            const crossAxis = placementPieces[1];
            return [
                `${mainAxis}`,
                `${mainAxis}-${$fb019b45941db6af$var$opposites[crossAxis]}`,
                `${$fb019b45941db6af$var$opposites[mainAxis]}-${crossAxis}`,
                `${$fb019b45941db6af$var$opposites[mainAxis]}`,
                `${$fb019b45941db6af$var$opposites[mainAxis]}-${$fb019b45941db6af$var$opposites[crossAxis]}`,
                'auto'
            ];
        } else return [
            `${mainAxis}-start`,
            `${mainAxis}-end`,
            `${$fb019b45941db6af$var$opposites[mainAxis]}`,
            `${$fb019b45941db6af$var$opposites[mainAxis]}-start`,
            `${$fb019b45941db6af$var$opposites[mainAxis]}-end`,
            `auto`
        ];
    };
    const $fb019b45941db6af$var$DropdownMenu = ({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $4oSDA.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $h04Oa.layers).modal(), label: label, interactionName: interactionName, strategy: strategy })=>{
        const [isLocalOpen, setLocalIsOpen] = (0, $5skWh.default)(isOpen, ()=>defaultOpen);
        const triggerRef = (0, $eUqFw.useRef)(null);
        const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eUqFw.useState)(false);
        const id = (0, $aHgG7.default)();
        const itemRef = (0, $f4ILk.default)();
        const fallbackPlacements = (0, $eUqFw.useMemo)(()=>$fb019b45941db6af$var$getFallbackPlacements(placement), [
            placement
        ]);
        const handleTriggerClicked = (0, $eUqFw.useCallback)((event)=>{
            const newValue = !isLocalOpen;
            const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
            if (type === 'keydown') setTriggeredUsingKeyboard(true);
            else if (clientX === 0 || clientY === 0) setTriggeredUsingKeyboard(true);
            else if (detail === 0) setTriggeredUsingKeyboard(true);
            else {
                itemRef?.current?.focus();
                setTriggeredUsingKeyboard(false);
            }
            setLocalIsOpen(newValue);
            onOpenChange({
                isOpen: newValue,
                event: event
            });
        }, [
            isLocalOpen,
            setLocalIsOpen,
            onOpenChange,
            itemRef
        ]);
        const handleOnClose = (0, $eUqFw.useCallback)((event, currentLevel)=>{
            if (event.key !== 'Escape' && event.key !== 'Tab' && event.target?.closest?.(`[id^=${(0, $aHgG7.PREFIX)}] [aria-haspopup]`)) {
                if (!currentLevel) return;
                const toCloseLevel = itemRef.current?.dataset['ds-Level'];
                if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
            }
            if (returnFocusRef) requestAnimationFrame(()=>{
                returnFocusRef.current?.focus();
            });
            else if (event.key === 'Tab' && event.shiftKey || event.key === 'Escape') requestAnimationFrame(()=>{
                itemRef.current?.focus();
            });
            else if (triggerRef.current) requestAnimationFrame(()=>{
                triggerRef.current?.focus();
            });
            const newValue = false;
            setLocalIsOpen(newValue);
            onOpenChange({
                isOpen: newValue,
                event: event
            });
        }, [
            itemRef,
            onOpenChange,
            returnFocusRef,
            setLocalIsOpen
        ]);
        const { isFocused: isFocused, bindFocus: bindFocus } = (0, $dHMNX.default)();
        (0, $eUqFw.useEffect)(()=>{
            if (!isFocused) return 0, $4oSDA.default;
            if (isLocalOpen) return 0, $4oSDA.default;
            return (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: function openOnKeyDown(e) {
                    let isNestedTriggerButton;
                    if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $aHgG7.PREFIX)}] [aria-haspopup]`);
                    if (e.key === (0, $942f5139e5aad792$export$a80636c6f41931fe) && !isNestedTriggerButton) {
                        e.preventDefault();
                        handleTriggerClicked(e);
                    } else if ((e.code === (0, $942f5139e5aad792$export$e51a3576c045c8d5) || e.key === (0, $942f5139e5aad792$export$8152f929a25a0ff4)) && e.detail === 0) setTriggeredUsingKeyboard(true);
                    else if (e.key === (0, $942f5139e5aad792$export$10f6869ed0a7d75b) && isNestedTriggerButton) handleOnClose(e);
                }
            });
        }, [
            isFocused,
            isLocalOpen,
            handleTriggerClicked,
            handleOnClose
        ]);
        const conditionalProps = shouldFitContainer ? {
            shouldFitContainer: shouldFitContainer,
            strategy: strategy !== 'fixed' ? strategy : undefined
        } : {
            shouldRenderToParent: shouldRenderToParent,
            strategy: strategy
        };
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $8OgO6.default), null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $grKJS.DropdownMenuProvider), {
            value: {
                returnFocusRef: triggerRef
            }
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $23sYR.default), {
            id: isLocalOpen ? id : undefined,
            shouldFlip: shouldFlip,
            isOpen: isLocalOpen,
            onClose: handleOnClose,
            zIndex: zIndex,
            placement: placement,
            fallbackPlacements: fallbackPlacements,
            testId: testId && `${testId}--content`,
            shouldUseCaptureOnOutsideClick: true,
            ...conditionalProps,
            shouldDisableFocusLock: true,
            trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, ...rest })=>{
                if (typeof trigger === 'function') return trigger({
                    'aria-controls': ariaControls,
                    'aria-expanded': ariaExpanded,
                    'aria-haspopup': ariaHasPopup,
                    ...rest,
                    ...bindFocus,
                    triggerRef: (0, $9xS6A.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    isSelected: isLocalOpen,
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`
                });
                return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $7LEad.default), {
                    ...bindFocus,
                    ref: (0, $9xS6A.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    "aria-controls": ariaControls,
                    "aria-expanded": ariaExpanded,
                    "aria-haspopup": ariaHasPopup,
                    isSelected: isLocalOpen,
                    iconAfter: (0, ($parcel$interopDefault($jogQH))),
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`,
                    "aria-label": label,
                    ...(0, $iDwTy.fg)('platform_button_item-add-ufo-metrics') && {
                        interactionName: interactionName
                    }
                }, trigger);
            },
            content: ({ setInitialFocusRef: setInitialFocusRef, update: update })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $03WOI.default), {
                    onClose: handleOnClose
                }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $9ZrLh.default), {
                    spacing: spacing,
                    maxHeight: $fb019b45941db6af$var$MAX_HEIGHT,
                    maxWidth: shouldFitContainer ? undefined : 800,
                    onClose: handleOnClose,
                    onUpdate: update,
                    isLoading: isLoading,
                    statusLabel: statusLabel,
                    setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                    shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                    isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                    autoFocus: autoFocus,
                    testId: testId && `${testId}--menu-wrapper`
                }, children))
        })));
    };
    var $fb019b45941db6af$export$2e2bcd8739ae039 = $fb019b45941db6af$var$DropdownMenu;
});
parcelRegister("5skWh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a40f80561528ba1e$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    function $a40f80561528ba1e$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
        const isControlled = propValue !== undefined;
        const [valueState, setValue] = (0, $eUqFw.useState)(getDefaultPropValue);
        const isControlledRef = (0, $eUqFw.useRef)(isControlled);
        (0, $eUqFw.useEffect)(()=>{
            isControlledRef.current = isControlled;
        }, [
            isControlled
        ]);
        const value = isControlled ? propValue : valueState;
        const setValueIfUncontrolled = (0, $eUqFw.useCallback)((newValue)=>{
            if (!isControlledRef.current) setValue(newValue);
        }, []);
        return [
            value,
            setValueIfUncontrolled
        ];
    }
});
parcelRegister("dHMNX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$21d7e59d45036f7a$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    function $21d7e59d45036f7a$export$2e2bcd8739ae039() {
        const [isFocused, setIsFocused] = (0, $eUqFw.useState)(false);
        const bindFocus = (0, $eUqFw.useRef)({
            onFocus: ()=>setIsFocused(true),
            onBlur: ()=>setIsFocused(false)
        });
        (0, $eUqFw.useEffect)(()=>{
            return ()=>setIsFocused(false);
        }, []);
        return {
            isFocused: isFocused,
            bindFocus: bindFocus.current
        };
    }
});
parcelRegister("jogQH", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $e1dd5416191a105d$var$_react = $e1dd5416191a105d$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $e1dd5416191a105d$var$_chevronDown = $e1dd5416191a105d$var$_interopRequireDefault((parcelRequire("eRXEa")));
    var $e1dd5416191a105d$var$_chevronDown2 = $e1dd5416191a105d$var$_interopRequireDefault((parcelRequire("186Wd")));
    function $e1dd5416191a105d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $e1dd5416191a105d$var$ChevronDownIcon = (props)=>$e1dd5416191a105d$var$_react.default.createElement($e1dd5416191a105d$var$_chevronDown.default, Object.assign({
            LEGACY_fallbackIcon: $e1dd5416191a105d$var$_chevronDown2.default
        }, props));
    $e1dd5416191a105d$var$ChevronDownIcon.Name = 'ChevronDownIconMigration';
    var $e1dd5416191a105d$var$_default = module.exports.default = $e1dd5416191a105d$var$ChevronDownIcon;
});
parcelRegister("03WOI", function(module, exports) {
    $parcel$export(module.exports, "FocusManagerContext", ()=>$56c4db2cd014500b$export$f18c1d4fc7326096);
    $parcel$export(module.exports, "default", ()=>$56c4db2cd014500b$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $74BVL = parcelRequire("74BVL");
    var $4oSDA = parcelRequire("4oSDA");
    var $01RXE = parcelRequire("01RXE");
    var $kj5LA = parcelRequire("kj5LA");
    const $56c4db2cd014500b$export$f18c1d4fc7326096 = (0, $eUqFw.createContext)({
        menuItemRefs: [],
        registerRef: (0, $4oSDA.default)
    });
    const $56c4db2cd014500b$var$FocusManager = ({ children: children, onClose: onClose })=>{
        const menuItemRefs = (0, $eUqFw.useRef)([]);
        const registerRefCalls = (0, $eUqFw.useRef)(0);
        const registerRef = (0, $eUqFw.useCallback)((ref)=>$56c4db2cd014500b$var$upsertRefAtFirstPosition(ref, menuItemRefs, registerRefCalls), []);
        const { isLayerDisabled: isLayerDisabled } = (0, $01RXE.UNSAFE_useLayering)();
        (0, $eUqFw.useEffect)(()=>{
            registerRefCalls.current = 0;
            return (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: (0, $kj5LA.default)(menuItemRefs.current, isLayerDisabled, onClose)
            });
        });
        const contextValue = {
            menuItemRefs: menuItemRefs.current,
            registerRef: registerRef
        };
        return (0, ($parcel$interopDefault($eUqFw))).createElement($56c4db2cd014500b$export$f18c1d4fc7326096.Provider, {
            value: contextValue
        }, children);
    };
    function $56c4db2cd014500b$var$upsertRefAtFirstPosition(ref, menuItemRefs, registerRefCalls) {
        const positionOnCall = registerRefCalls.current++;
        if (!menuItemRefs.current.includes(ref)) {
            menuItemRefs.current.splice(positionOnCall, 0, ref);
            return;
        }
        const positionCurrent = menuItemRefs.current.indexOf(ref);
        if (positionOnCall === positionCurrent) return;
        if (positionOnCall > positionCurrent) {
            registerRefCalls.current--;
            return;
        }
        menuItemRefs.current.splice(positionCurrent, 1);
        menuItemRefs.current.splice(positionOnCall, 0, ref);
    }
    var $56c4db2cd014500b$export$2e2bcd8739ae039 = $56c4db2cd014500b$var$FocusManager;
});
parcelRegister("kj5LA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d4e8a7cf678bb8e0$export$2e2bcd8739ae039);
    var $iDwTy = parcelRequire("iDwTy");
    var $aHgG7 = parcelRequire("aHgG7");
    const $d4e8a7cf678bb8e0$var$actionMap = {
        [(0, $942f5139e5aad792$export$a80636c6f41931fe)]: 'next',
        [(0, $942f5139e5aad792$export$390330c10ff2b9a1)]: 'prev',
        [(0, $942f5139e5aad792$export$4af703091671bc)]: 'first',
        [(0, $942f5139e5aad792$export$e2bc30913faa5db7)]: 'last'
    };
    const $d4e8a7cf678bb8e0$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
        while(currentFocusedIdx + 1 < refs.length){
            const isDisabled = refs[currentFocusedIdx + 1].hasAttribute('disabled');
            if (!isDisabled) return refs[currentFocusedIdx + 1];
            currentFocusedIdx++;
        }
    };
    const $d4e8a7cf678bb8e0$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
        while(currentFocusedIdx > 0){
            const isDisabled = refs[currentFocusedIdx - 1].hasAttribute('disabled');
            if (!isDisabled) return refs[currentFocusedIdx - 1];
            currentFocusedIdx--;
        }
    };
    function $d4e8a7cf678bb8e0$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
        return (e)=>{
            const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
            if ((0, $iDwTy.fg)('platform_dst_popup-disable-focuslock')) {
                const isNestedDropdown = !!document.activeElement?.closest(`[id^=${(0, $aHgG7.PREFIX)}]`);
                if (isLayerDisabled() && isNestedDropdown) {
                    if (e.key === (0, $942f5139e5aad792$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
                    return;
                }
            } else if (isLayerDisabled()) {
                if (e.key === (0, $942f5139e5aad792$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
                return;
            }
            const action = $d4e8a7cf678bb8e0$var$actionMap[e.key];
            switch(action){
                case 'next':
                    e.preventDefault();
                    if (currentFocusedIdx < refs.length - 1) {
                        const nextFocusableElement = $d4e8a7cf678bb8e0$var$getNextFocusableElement(refs, currentFocusedIdx);
                        nextFocusableElement?.focus();
                    } else {
                        const firstFocusableElement = $d4e8a7cf678bb8e0$var$getNextFocusableElement(refs, -1);
                        firstFocusableElement?.focus();
                    }
                    break;
                case 'prev':
                    e.preventDefault();
                    if (currentFocusedIdx > 0) {
                        const prevFocusableElement = $d4e8a7cf678bb8e0$var$getPrevFocusableElement(refs, currentFocusedIdx);
                        prevFocusableElement?.focus();
                    } else {
                        const lastFocusableElement = $d4e8a7cf678bb8e0$var$getPrevFocusableElement(refs, refs.length);
                        lastFocusableElement?.focus();
                    }
                    break;
                case 'first':
                    e.preventDefault();
                    const nextFocusableElement = $d4e8a7cf678bb8e0$var$getNextFocusableElement(refs, -1);
                    nextFocusableElement?.focus();
                    break;
                case 'last':
                    e.preventDefault();
                    const prevFocusableElement = $d4e8a7cf678bb8e0$var$getPrevFocusableElement(refs, refs.length);
                    prevFocusableElement?.focus();
                    break;
                default:
                    return;
            }
        };
    }
});
parcelRegister("aHgG7", function(module, exports) {
    $parcel$export(module.exports, "PREFIX", ()=>$4c534b5b8202f0a7$export$8a682ae47622dbb9);
    $parcel$export(module.exports, "default", ()=>$4c534b5b8202f0a7$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    const $4c534b5b8202f0a7$export$8a682ae47622dbb9 = 'ds--dropdown--';
    const $4c534b5b8202f0a7$var$generateRandomString = ()=>`${$4c534b5b8202f0a7$export$8a682ae47622dbb9}${Math.random().toString(16).substr(2, 8)}`;
    function $4c534b5b8202f0a7$export$2e2bcd8739ae039() {
        const cachedId = (0, $eUqFw.useRef)($4c534b5b8202f0a7$var$generateRandomString());
        return cachedId.current;
    }
});
parcelRegister("9ZrLh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c7bf0f93d5e700e7$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $du1iQ = parcelRequire("du1iQ");
    var $jGR8u = parcelRequire("jGR8u");
    var $fHiYa = parcelRequire("fHiYa");
    var $eUtxe = parcelRequire("eUtxe");
    var $03WOI = parcelRequire("03WOI");
    var $gCEAc = parcelRequire("gCEAc");
    var $cDYjw = parcelRequire("cDYjw");
    const $c7bf0f93d5e700e7$var$spinnerContainerStyles = (0, $fHiYa.xcss)({
        display: 'flex',
        minWidth: '160px',
        padding: 'space.250',
        justifyContent: 'center'
    });
    const $c7bf0f93d5e700e7$var$LoadingIndicator = ({ statusLabel: statusLabel = 'Loading', testId: testId })=>(0, $byn9U.jsx)((0, $jGR8u.default), {
            xcss: $c7bf0f93d5e700e7$var$spinnerContainerStyles
        }, (0, $byn9U.jsx)((0, $eUtxe.default), {
            size: "small",
            label: statusLabel,
            testId: testId
        }));
    const $c7bf0f93d5e700e7$var$MenuWrapper = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus })=>{
        const { menuItemRefs: menuItemRefs } = (0, $eUqFw.useContext)((0, $03WOI.FocusManagerContext));
        const closeOnMenuItemClick = (e)=>{
            const isTargetMenuItemOrDecendant = menuItemRefs.some((menuItem)=>{
                const isCheckboxOrRadio = (0, $gCEAc.default)(menuItem) || (0, $cDYjw.default)(menuItem);
                return menuItem.contains(e.target) && !isCheckboxOrRadio;
            });
            if (isTargetMenuItemOrDecendant && onClose) onClose(e);
        };
        (0, $eUqFw.useLayoutEffect)(()=>{
            onUpdate();
        }, [
            isLoading,
            onUpdate
        ]);
        (0, $eUqFw.useEffect)(()=>{
            const firstFocusableRef = menuItemRefs.find((ref)=>!ref.hasAttribute('disabled')) ?? null;
            if (shouldRenderToParent && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
            setInitialFocusRef?.(firstFocusableRef);
        }, [
            menuItemRefs,
            setInitialFocusRef,
            autoFocus,
            shouldRenderToParent,
            isTriggeredUsingKeyboard
        ]);
        return (0, $byn9U.jsx)((0, $du1iQ.default), {
            isLoading: isLoading,
            maxHeight: maxHeight,
            maxWidth: maxWidth,
            onClick: closeOnMenuItemClick,
            role: "menu",
            spacing: spacing,
            testId: testId && `${testId}--menu-group`
        }, isLoading ? (0, $byn9U.jsx)($c7bf0f93d5e700e7$var$LoadingIndicator, {
            statusLabel: statusLabel,
            testId: testId && `${testId}--loading-indicator`
        }) : children);
    };
    var $c7bf0f93d5e700e7$export$2e2bcd8739ae039 = $c7bf0f93d5e700e7$var$MenuWrapper;
});
parcelRegister("du1iQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$978692bd33616a02$export$2e2bcd8739ae039);
    var $byn9U = parcelRequire("byn9U");
    var $85yy4 = parcelRequire("85yy4");
    function $978692bd33616a02$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $978692bd33616a02$var$baseStyles = {
        name: "1u0qf12",
        styles: "display:flex;position:static;flex-direction:column;overflow:auto"
    };
    const $978692bd33616a02$var$MenuGroup = ({ isLoading: isLoading, maxWidth: maxWidth, minWidth: minWidth, minHeight: minHeight, maxHeight: maxHeight, testId: testId, role: role, spacing: spacing = 'cozy', className: UNSAFE_className, ...rest })=>(0, $byn9U.jsx)((0, $85yy4.SpacingContext).Provider, {
            value: spacing
        }, (0, $byn9U.jsx)((0, $85yy4.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
            value: "border"
        }, (0, $byn9U.jsx)("div", {
            "aria-busy": isLoading,
            style: {
                minWidth: minWidth,
                maxWidth: maxWidth,
                minHeight: minHeight,
                maxHeight: maxHeight
            },
            css: $978692bd33616a02$var$baseStyles,
            "data-testid": testId,
            role: role,
            className: UNSAFE_className,
            ...rest
        })));
    var $978692bd33616a02$export$2e2bcd8739ae039 = $978692bd33616a02$var$MenuGroup;
});
parcelRegister("85yy4", function(module, exports) {
    $parcel$export(module.exports, "SpacingContext", ()=>$b99e6684afa30175$export$443076ec7ebce042);
    $parcel$export(module.exports, "SELECTION_STYLE_CONTEXT_DO_NOT_USE", ()=>$b99e6684afa30175$export$9ca534b70725964d);
    var $eUqFw = parcelRequire("eUqFw");
    const $b99e6684afa30175$export$443076ec7ebce042 = (0, $eUqFw.createContext)('cozy');
    const $b99e6684afa30175$export$9ca534b70725964d = (0, $eUqFw.createContext)('border');
});
parcelRegister("gCEAc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ee3676477077f964$export$2e2bcd8739ae039);
    function $ee3676477077f964$export$2e2bcd8739ae039(element) {
        const role = element.getAttribute('role');
        return role === 'checkbox' || role === 'menuitemcheckbox';
    }
});
parcelRegister("cDYjw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d39d25b727bb870a$export$2e2bcd8739ae039);
    function $d39d25b727bb870a$export$2e2bcd8739ae039(element) {
        const role = element.getAttribute('role');
        return role === 'radio' || role === 'menuitemradio';
    }
});
parcelRegister("grKJS", function(module, exports) {
    $parcel$export(module.exports, "DropdownMenuProvider", ()=>$761861b4165e57e5$export$9357e33608f1035a);
    var $eUqFw = parcelRequire("eUqFw");
    const $761861b4165e57e5$var$DropdownMenuContext = (0, $eUqFw.createContext)(undefined);
    const $761861b4165e57e5$export$9357e33608f1035a = $761861b4165e57e5$var$DropdownMenuContext.Provider;
});
parcelRegister("8OgO6", function(module, exports) {
    $parcel$export(module.exports, "SelectionStoreContext", ()=>$b5b669700a2a4c8b$export$756f795847463ebd);
    $parcel$export(module.exports, "default", ()=>$b5b669700a2a4c8b$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $4oSDA = parcelRequire("4oSDA");
    const $b5b669700a2a4c8b$export$756f795847463ebd = (0, $eUqFw.createContext)({
        setItemState: (0, $4oSDA.default),
        getItemState: ()=>undefined,
        setGroupState: (0, $4oSDA.default),
        getGroupState: ()=>({})
    });
    const $b5b669700a2a4c8b$var$SelectionStore = (props)=>{
        const { children: children } = props;
        const store = (0, $eUqFw.useRef)({});
        const context = (0, $eUqFw.useMemo)(()=>({
                setItemState: (group, id, value)=>{
                    if (!store.current[group]) store.current[group] = {};
                    store.current[group][id] = value;
                },
                getItemState: (group, id)=>{
                    if (!store.current[group]) return undefined;
                    return store.current[group][id];
                },
                setGroupState: (group, value)=>{
                    store.current[group] = value;
                },
                getGroupState: (group)=>{
                    return store.current[group] || {};
                }
            }), []);
        return (0, ($parcel$interopDefault($eUqFw))).createElement($b5b669700a2a4c8b$export$756f795847463ebd.Provider, {
            value: context
        }, children);
    };
    var $b5b669700a2a4c8b$export$2e2bcd8739ae039 = $b5b669700a2a4c8b$var$SelectionStore;
});
parcelRegister("f4ILk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bd07e5c17e985ae6$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $03WOI = parcelRequire("03WOI");
    function $bd07e5c17e985ae6$var$useRegisterItemWithFocusManager() {
        const { registerRef: registerRef } = (0, $eUqFw.useContext)((0, $03WOI.FocusManagerContext));
        const itemRef = (0, $eUqFw.useRef)(null);
        (0, $eUqFw.useEffect)(()=>{
            if (itemRef.current !== null) registerRef(itemRef.current);
        }, [
            registerRef
        ]);
        return itemRef;
    }
    var $bd07e5c17e985ae6$export$2e2bcd8739ae039 = $bd07e5c17e985ae6$var$useRegisterItemWithFocusManager;
});
parcelRegister("268QM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$facd6dcd2a2241af$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $7pdsy = parcelRequire("7pdsy");
    var $4oSDA = parcelRequire("4oSDA");
    var $cOm24 = parcelRequire("cOm24");
    var $iDwTy = parcelRequire("iDwTy");
    var $lb1Up = parcelRequire("lb1Up");
    const $facd6dcd2a2241af$var$ButtonItem = (0, $eUqFw.memo)((0, $eUqFw.forwardRef)((props, ref)=>{
        const { children: children, cssFn: cssFn = (0, $4oSDA.default), description: description, iconAfter: iconAfter, iconBefore: iconBefore, isDisabled: isDisabled = false, isSelected: isSelected = false, onClick: onClick, testId: testId, overrides: overrides, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, interactionName: interactionName, ...rest } = props;
        const onMouseDownHandler = onMouseDown;
        const interactionContext = (0, $eUqFw.useContext)((0, $cOm24.default));
        const handleClick = (0, $eUqFw.useCallback)((e)=>{
            interactionContext?.tracePress(interactionName, e.timeStamp);
            onClick?.(e);
        }, [
            onClick,
            interactionContext,
            interactionName
        ]);
        if (!children) return null;
        (0, $7pdsy.propDeprecationWarning)("platform-pkg", 'cssFn', cssFn !== (0, $4oSDA.default), '');
        return (0, $byn9U.jsx)((0, $lb1Up.default), {
            className: UNSAFE_className,
            ...rest,
            overrides: overrides,
            iconBefore: iconBefore,
            iconAfter: iconAfter,
            isDisabled: isDisabled,
            isSelected: isSelected,
            description: description,
            title: children,
            shouldTitleWrap: shouldTitleWrap,
            shouldDescriptionWrap: shouldDescriptionWrap,
            css: cssFn({
                isSelected: isSelected,
                isDisabled: isDisabled
            }),
            testId: testId && `${testId}--primitive`
        }, ({ children: children, className: className })=>(0, $byn9U.jsx)("button", {
                "data-testid": testId,
                ...rest,
                className: className,
                ref: ref,
                disabled: isDisabled,
                onClick: (0, $iDwTy.fg)('platform_button_item-add-ufo-metrics') ? handleClick : onClick,
                onMouseDown: onMouseDownHandler,
                type: "button"
            }, children));
    }));
    var $facd6dcd2a2241af$export$2e2bcd8739ae039 = $facd6dcd2a2241af$var$ButtonItem;
});
parcelRegister("lb1Up", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5df4059210d56520$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $7pdsy = parcelRequire("7pdsy");
    var $jcsHn = parcelRequire("jcsHn");
    var $1AHzd = parcelRequire("1AHzd");
    var $cYsCT = parcelRequire("cYsCT");
    var $fHiYa = parcelRequire("fHiYa");
    var $85yy4 = parcelRequire("85yy4");
    function $5df4059210d56520$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $5df4059210d56520$var$defaultRender = (Component, props)=>(0, $byn9U.jsx)(Component, props);
    const $5df4059210d56520$var$beforeAfterElementStyles = {
        name: "sjfyf",
        styles: "display:flex;align-items:center;justify-content:center;flex-shrink:0"
    };
    const $5df4059210d56520$var$contentStyles = (0, $fHiYa.xcss)({
        outline: 'none',
        overflow: 'hidden',
        textAlign: 'left'
    });
    const $5df4059210d56520$var$truncateStyles = {
        name: "hdknak",
        styles: "display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap"
    };
    const $5df4059210d56520$var$titleStyles = {
        name: "183yev2",
        styles: "font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    };
    const $5df4059210d56520$var$wordBreakStyles = {
        name: "1sdjnkx",
        styles: "word-break:break-word"
    };
    const $5df4059210d56520$var$descriptionStyles = (0, $byn9U.css)({
        color: `var(--ds-text-subtlest, ${(0, $207acf722dcd432b$export$f563ee71e9ee74cd)})`,
        font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    });
    const $5df4059210d56520$var$disabledDescriptionStyles = (0, $byn9U.css)({
        color: `var(--ds-text-disabled, ${(0, $207acf722dcd432b$export$f563ee71e9ee74cd)})`
    });
    const $5df4059210d56520$var$positionRelativeStyles = {
        name: "bjn8wh",
        styles: "position:relative"
    };
    const $5df4059210d56520$var$primitiveStyles = {
        name: "vfenhj",
        styles: "display:flex;box-sizing:border-box;width:100%;min-height:40px;margin:var(--ds-space-0, 0px);align-items:center;border:0;outline:0;text-decoration:none;user-select:none;&::-moz-focus-inner{border:0;}&:hover{text-decoration:none;}"
    };
    const $5df4059210d56520$var$spacingMapStyles = {
        cozy: {
            name: "1x13z0k",
            styles: "padding-block:var(--ds-space-100, 8px);padding-inline:var(--ds-space-200, 16px)"
        },
        compact: {
            name: "1xdhs5i",
            styles: "min-height:32px;padding-block:var(--ds-space-050, 4px);padding-inline:var(--ds-space-150, 12px)"
        }
    };
    const $5df4059210d56520$var$interactiveStyles = {
        name: "e0dnmk",
        styles: "cursor:pointer"
    };
    const $5df4059210d56520$var$unselectedStyles = (0, $byn9U.css)({
        backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
        color: 'currentColor',
        '&:visited': {
            color: 'currentColor'
        },
        '&:hover': {
            backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${(0, $207acf722dcd432b$export$9fdfb749e33cdf97)})`,
            color: 'currentColor'
        },
        '&:active': {
            backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${(0, $207acf722dcd432b$export$3e51e8f1440314ba)})`,
            boxShadow: 'none',
            color: 'currentColor'
        }
    });
    const $5df4059210d56520$var$disabledStyles = (0, $byn9U.css)({
        cursor: 'not-allowed',
        '&, :hover, :active': {
            backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
            color: `var(--ds-text-disabled, ${(0, $207acf722dcd432b$export$f563ee71e9ee74cd)})`
        }
    });
    const $5df4059210d56520$var$selectedBorderStyles = {
        name: "1dgy7ry",
        styles: "&::before{width:2px;position:absolute;background:var(--ds-border-selected, transparent);content:\"\";inset-block-end:0;inset-block-start:0;inset-inline-start:0;}"
    };
    const $5df4059210d56520$var$selectedNotchStyles = (0, $byn9U.css)({
        '&::before': {
            width: 4,
            position: 'absolute',
            background: "var(--ds-border-selected, transparent)",
            borderRadius: `0 ${"var(--ds-border-radius, 4px)"} ${"var(--ds-border-radius, 4px)"} 0`,
            content: '""',
            insetBlockEnd: "var(--ds-space-150, 12px)",
            insetBlockStart: "var(--ds-space-150, 12px)",
            insetInlineStart: 0
        }
    });
    const $5df4059210d56520$var$selectedStyles = (0, $byn9U.css)({
        backgroundColor: `var(--ds-background-selected, ${(0, $207acf722dcd432b$export$9fdfb749e33cdf97)})`,
        color: "var(--ds-text-selected, currentColor)",
        '&:visited': {
            color: "var(--ds-text-selected, currentColor)"
        },
        '&:hover': {
            backgroundColor: `var(--ds-background-selected-hovered, ${(0, $207acf722dcd432b$export$9fdfb749e33cdf97)})`,
            color: "var(--ds-text-selected, currentColor)"
        },
        '&:active': {
            backgroundColor: `var(--ds-background-selected-pressed, ${(0, $207acf722dcd432b$export$3e51e8f1440314ba)})`,
            color: "var(--ds-text-selected, currentColor)"
        }
    });
    const $5df4059210d56520$var$gapMap = {
        compact: 'space.100',
        cozy: 'space.150'
    };
    const $5df4059210d56520$var$MenuItemPrimitive = ({ children: children, title: title, description: description, iconAfter: iconAfter, iconBefore: iconBefore, overrides: overrides, className: UNSAFE_externalClassName, shouldTitleWrap: shouldTitleWrap = false, shouldDescriptionWrap: shouldDescriptionWrap = false, isDisabled: isDisabled = false, isSelected: isSelected = false, testId: testId })=>{
        (0, $7pdsy.propDeprecationWarning)("platform-pkg", 'overrides', overrides !== undefined, '');
        const spacing = (0, $eUqFw.useContext)((0, $85yy4.SpacingContext));
        const selectionStyle = (0, $eUqFw.useContext)((0, $85yy4.SELECTION_STYLE_CONTEXT_DO_NOT_USE));
        const renderTitle = overrides && overrides.Title && overrides.Title.render || $5df4059210d56520$var$defaultRender;
        const UNSAFE_className = UNSAFE_externalClassName;
        return (0, $byn9U.jsx)((0, $byn9U.ClassNames), null, ({ css: cn, cx: cx })=>{
            return (0, $byn9U.jsx)((0, $jcsHn.default), {
                isInset: true
            }, children({
                className: cx([
                    cn([
                        $5df4059210d56520$var$positionRelativeStyles,
                        $5df4059210d56520$var$primitiveStyles,
                        $5df4059210d56520$var$spacingMapStyles[spacing],
                        !isDisabled && !isSelected && $5df4059210d56520$var$unselectedStyles,
                        !isDisabled && isSelected && [
                            $5df4059210d56520$var$selectedStyles,
                            [
                                selectionStyle === 'border' && $5df4059210d56520$var$selectedBorderStyles,
                                selectionStyle === 'notch' && $5df4059210d56520$var$selectedNotchStyles
                            ]
                        ],
                        isDisabled ? $5df4059210d56520$var$disabledStyles : $5df4059210d56520$var$interactiveStyles
                    ]),
                    UNSAFE_className
                ]),
                children: (0, $byn9U.jsx)((0, $1AHzd.default), {
                    as: "span",
                    spread: "space-between",
                    alignBlock: "center",
                    space: $5df4059210d56520$var$gapMap[spacing],
                    grow: "fill",
                    testId: testId && `${testId}--container`
                }, iconBefore && (0, $byn9U.jsx)("span", {
                    "data-item-elem-before": true,
                    css: $5df4059210d56520$var$beforeAfterElementStyles,
                    "data-testid": testId && `${testId}--icon-before`
                }, iconBefore), title && (0, $byn9U.jsx)((0, $cYsCT.default), {
                    alignBlock: "center",
                    grow: "fill",
                    xcss: $5df4059210d56520$var$contentStyles
                }, renderTitle('span', {
                    children: title,
                    className: cn($5df4059210d56520$var$titleStyles, shouldTitleWrap ? $5df4059210d56520$var$wordBreakStyles : $5df4059210d56520$var$truncateStyles),
                    'data-item-title': true
                }), description && (0, $byn9U.jsx)("span", {
                    "data-item-description": true,
                    css: [
                        $5df4059210d56520$var$descriptionStyles,
                        isDisabled && $5df4059210d56520$var$disabledDescriptionStyles,
                        shouldDescriptionWrap ? $5df4059210d56520$var$wordBreakStyles : $5df4059210d56520$var$truncateStyles
                    ]
                }, description)), iconAfter && (0, $byn9U.jsx)("span", {
                    "data-item-elem-after": true,
                    css: $5df4059210d56520$var$beforeAfterElementStyles,
                    "data-testid": testId && `${testId}--icon-after`
                }, iconAfter))
            }));
        });
    };
    var $5df4059210d56520$export$2e2bcd8739ae039 = $5df4059210d56520$var$MenuItemPrimitive;
});
parcelRegister("6AdPS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f135f1f65d1b270f$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $7pdsy = parcelRequire("7pdsy");
    var $4oSDA = parcelRequire("4oSDA");
    var $cOm24 = parcelRequire("cOm24");
    var $iDwTy = parcelRequire("iDwTy");
    var $lb1Up = parcelRequire("lb1Up");
    const $f135f1f65d1b270f$var$preventEvent = (e)=>{
        e.preventDefault();
    };
    const $f135f1f65d1b270f$var$CustomItem = (0, $eUqFw.memo)((0, $eUqFw.forwardRef)(({ component: Component, cssFn: cssFn = (0, $4oSDA.default), isDisabled: isDisabled = false, isSelected: isSelected = false, onClick: onClick, testId: testId, children: children, description: description, iconAfter: iconAfter, iconBefore: iconBefore, overrides: overrides, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, UNSAFE_isDraggable: UNSAFE_isDraggable, interactionName: interactionName, ...rest }, ref)=>{
        const onMouseDownHandler = onMouseDown;
        const interactionContext = (0, $eUqFw.useContext)((0, $cOm24.default));
        const handleClick = (0, $eUqFw.useCallback)((e)=>{
            interactionContext?.tracePress(interactionName, e.timeStamp);
            onClick?.(e);
        }, [
            onClick,
            interactionContext,
            interactionName
        ]);
        if (!Component) return null;
        (0, $7pdsy.propDeprecationWarning)("platform-pkg", 'cssFn', cssFn !== (0, $4oSDA.default), '');
        return (0, $byn9U.jsx)((0, $lb1Up.default), {
            className: UNSAFE_className,
            ...rest,
            overrides: overrides,
            description: description,
            iconAfter: iconAfter,
            title: children,
            iconBefore: iconBefore,
            isSelected: isSelected,
            isDisabled: isDisabled,
            shouldTitleWrap: shouldTitleWrap,
            shouldDescriptionWrap: shouldDescriptionWrap,
            css: (0, $byn9U.css)(cssFn({
                isDisabled: isDisabled,
                isSelected: isSelected
            })),
            testId: testId && `${testId}--primitive`
        }, ({ children: children, className: className })=>(0, $byn9U.jsx)(Component, {
                "data-testid": testId,
                ...rest,
                className: className,
                ref: ref,
                ...UNSAFE_isDraggable ? {} : {
                    draggable: false,
                    onDragStart: $f135f1f65d1b270f$var$preventEvent
                },
                onMouseDown: isDisabled ? $f135f1f65d1b270f$var$preventEvent : onMouseDownHandler,
                onClick: isDisabled ? $f135f1f65d1b270f$var$preventEvent : (0, $iDwTy.fg)('platform_button_item-add-ufo-metrics') ? handleClick : onClick,
                tabIndex: isDisabled ? -1 : undefined,
                "aria-disabled": isDisabled
            }, children));
    }));
    var $f135f1f65d1b270f$export$2e2bcd8739ae039 = $f135f1f65d1b270f$var$CustomItem;
});
parcelRegister("h4UGy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6ec17569dec1b5d2$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $mQ4ff = parcelRequire("mQ4ff");
    var $7pdsy = parcelRequire("7pdsy");
    var $4oSDA = parcelRequire("4oSDA");
    var $cOm24 = parcelRequire("cOm24");
    var $iDwTy = parcelRequire("iDwTy");
    var $lb1Up = parcelRequire("lb1Up");
    const $6ec17569dec1b5d2$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
    const $6ec17569dec1b5d2$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
    const $6ec17569dec1b5d2$var$preventEvent = (e)=>{
        e.preventDefault();
    };
    const $6ec17569dec1b5d2$var$LinkItem = (0, $eUqFw.memo)((0, $eUqFw.forwardRef)((props, ref)=>{
        const { children: children, href: href, cssFn: cssFn = (0, $4oSDA.default), description: description, iconAfter: iconAfter, iconBefore: iconBefore, isDisabled: isDisabled = false, isSelected: isSelected = false, onClick: onClick, testId: testId, overrides: overrides, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, UNSAFE_isDraggable: UNSAFE_isDraggable, interactionName: interactionName, ...rest } = props;
        const onMouseDownHandler = onMouseDown;
        const RouterLink = (0, $mQ4ff.default)();
        const interactionContext = (0, $eUqFw.useContext)((0, $cOm24.default));
        const handleClick = (0, $eUqFw.useCallback)((e)=>{
            interactionContext?.tracePress(interactionName, e.timeStamp);
            onClick?.(e);
        }, [
            onClick,
            interactionContext,
            interactionName
        ]);
        if (!children) return null;
        const isExternal = typeof href === 'string' && $6ec17569dec1b5d2$var$IS_EXTERNAL_LINK_REGEX.test(href);
        const isNonHttpBased = typeof href === 'string' && $6ec17569dec1b5d2$var$IS_NON_HTTP_BASED.test(href);
        const isEmptyHref = href == null || href === '';
        const isRouterLink = !UNSAFE_shouldDisableRouterLink && RouterLink && !isExternal && !isNonHttpBased && !isEmptyHref;
        const Component = isRouterLink ? RouterLink : 'a';
        (0, $7pdsy.propDeprecationWarning)("platform-pkg", 'cssFn', cssFn !== (0, $4oSDA.default), '');
        return (0, $byn9U.jsx)((0, $lb1Up.default), {
            ...rest,
            className: UNSAFE_className,
            overrides: overrides,
            iconBefore: iconBefore,
            iconAfter: iconAfter,
            isSelected: isSelected,
            isDisabled: isDisabled,
            description: description,
            shouldTitleWrap: shouldTitleWrap,
            shouldDescriptionWrap: shouldDescriptionWrap,
            css: cssFn({
                isSelected: isSelected,
                isDisabled: isDisabled
            }),
            title: children,
            testId: testId && `${testId}--primitive`
        }, ({ children: children, className: className })=>(0, $byn9U.jsx)(Component, {
                "data-testid": testId,
                "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
                "data-vc": "link-item",
                ...rest,
                className: className,
                href: isDisabled ? undefined : href,
                ...UNSAFE_isDraggable ? {} : {
                    draggable: false,
                    onDragStart: $6ec17569dec1b5d2$var$preventEvent
                },
                onMouseDown: isDisabled ? $6ec17569dec1b5d2$var$preventEvent : onMouseDownHandler,
                onClick: isDisabled ? $6ec17569dec1b5d2$var$preventEvent : (0, $iDwTy.fg)('platform_button_item-add-ufo-metrics') ? handleClick : onClick,
                "aria-current": isSelected ? 'page' : undefined,
                "aria-disabled": isDisabled,
                ref: ref
            }, children));
    }));
    var $6ec17569dec1b5d2$export$2e2bcd8739ae039 = $6ec17569dec1b5d2$var$LinkItem;
});
parcelRegister("7wSSY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a3d5ebb82ddcc3d2$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $7pdsy = parcelRequire("7pdsy");
    var $iDwTy = parcelRequire("iDwTy");
    var $h04Oa = parcelRequire("h04Oa");
    var $dNgQx = parcelRequire("dNgQx");
    var $fRHE6 = parcelRequire("fRHE6");
    function $a3d5ebb82ddcc3d2$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $a3d5ebb82ddcc3d2$var$gridSize = (0, $h04Oa.gridSize)();
    const $a3d5ebb82ddcc3d2$var$itemHeadingTopMargin = $a3d5ebb82ddcc3d2$var$gridSize * 2.5;
    const $a3d5ebb82ddcc3d2$var$itemHeadingBottomMargin = $a3d5ebb82ddcc3d2$var$gridSize * 0.75;
    const $a3d5ebb82ddcc3d2$var$itemHeadingContentHeight = (0, $dNgQx.headingSizes).h100.lineHeight;
    const $a3d5ebb82ddcc3d2$var$skeletonHeadingHeight = $a3d5ebb82ddcc3d2$var$gridSize;
    const $a3d5ebb82ddcc3d2$var$skeletonHeadingMarginOffset = 3;
    const $a3d5ebb82ddcc3d2$var$skeletonHeadingTopMargin = $a3d5ebb82ddcc3d2$var$itemHeadingTopMargin + ($a3d5ebb82ddcc3d2$var$itemHeadingContentHeight - $a3d5ebb82ddcc3d2$var$skeletonHeadingHeight) - $a3d5ebb82ddcc3d2$var$skeletonHeadingMarginOffset;
    const $a3d5ebb82ddcc3d2$var$skeletonHeadingBottomMargin = $a3d5ebb82ddcc3d2$var$itemHeadingBottomMargin + $a3d5ebb82ddcc3d2$var$skeletonHeadingMarginOffset;
    const $a3d5ebb82ddcc3d2$var$sectionPaddingTopBottom = $a3d5ebb82ddcc3d2$var$gridSize * 0.75;
    const $a3d5ebb82ddcc3d2$var$VAR_SEPARATOR_COLOR = '--ds-menu-seperator-color';
    const $a3d5ebb82ddcc3d2$var$sectionStyles = (0, $byn9U.css)({
        '&::before, &::after': {
            display: 'block',
            height: $a3d5ebb82ddcc3d2$var$sectionPaddingTopBottom,
            content: '""'
        },
        '& [data-ds--menu--heading-item]': {
            marginBlockEnd: $a3d5ebb82ddcc3d2$var$itemHeadingBottomMargin,
            marginBlockStart: $a3d5ebb82ddcc3d2$var$itemHeadingTopMargin,
            '&:first-of-type': {
                marginBlockStart: $a3d5ebb82ddcc3d2$var$itemHeadingTopMargin - $a3d5ebb82ddcc3d2$var$sectionPaddingTopBottom
            }
        },
        '& [data-ds--menu--skeleton-heading-item]': {
            marginBlockEnd: $a3d5ebb82ddcc3d2$var$skeletonHeadingBottomMargin,
            marginBlockStart: $a3d5ebb82ddcc3d2$var$skeletonHeadingTopMargin,
            '&:first-of-type': {
                marginBlockStart: $a3d5ebb82ddcc3d2$var$skeletonHeadingTopMargin - $a3d5ebb82ddcc3d2$var$sectionPaddingTopBottom
            }
        },
        '&:focus': {
            outlineOffset: -1
        }
    });
    const $a3d5ebb82ddcc3d2$var$scrollableStyles = {
        name: "qji62u",
        styles: "flex-shrink:1;overflow:auto"
    };
    const $a3d5ebb82ddcc3d2$var$unscrollableStyles = {
        name: "ozd7xs",
        styles: "flex-shrink:0"
    };
    const $a3d5ebb82ddcc3d2$var$thickSeparatorStyles = (0, $byn9U.css)({
        borderBlockStart: `2px solid var(${$a3d5ebb82ddcc3d2$var$VAR_SEPARATOR_COLOR}, ${`var(--ds-border, ${(0, $207acf722dcd432b$export$920c0d5c49070351)})`})`
    });
    const $a3d5ebb82ddcc3d2$var$thinSeparatorStyles = (0, $byn9U.css)({
        borderBlockStart: `1px solid var(${$a3d5ebb82ddcc3d2$var$VAR_SEPARATOR_COLOR}, ${`var(--ds-border, ${(0, $207acf722dcd432b$export$920c0d5c49070351)})`})`
    });
    const $a3d5ebb82ddcc3d2$var$noSeparatorStyles = (0, $byn9U.css)({
        '[data-section] + &': {
            marginBlockStart: -6
        }
    });
    const $a3d5ebb82ddcc3d2$var$Section = (0, $eUqFw.forwardRef)(({ children: children, overrides: overrides, title: title, titleId: titleId, testId: testId, isScrollable: isScrollable, hasSeparator: hasSeparator, id: id, isList: isList = false, className: UNSAFE_className, ...rest }, ref)=>{
        (0, $7pdsy.propDeprecationWarning)("platform-pkg", 'overrides', overrides !== undefined, '');
        const UNSAFE_headingOverrides = overrides && overrides.HeadingItem && overrides.HeadingItem.cssFn;
        const content = isList ? (0, $byn9U.jsx)("ul", {
            style: {
                margin: 0,
                padding: 0
            }
        }, (0, $eUqFw.Children).map((0, $eUqFw.Children).toArray(children), (child, index)=>(0, $byn9U.jsx)("li", {
                style: {
                    listStyleType: 'none',
                    margin: 0,
                    padding: 0
                },
                key: index
            }, child))) : children;
        const childrenMarkup = title !== undefined ? (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)((0, $fRHE6.default), {
            cssFn: UNSAFE_headingOverrides,
            testId: testId && `${testId}--heading`,
            "aria-hidden": true
        }, title), content) : (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, content);
        return (0, $byn9U.jsx)("div", {
            ...rest,
            className: UNSAFE_className,
            id: id,
            css: [
                $a3d5ebb82ddcc3d2$var$sectionStyles,
                isScrollable ? $a3d5ebb82ddcc3d2$var$scrollableStyles : $a3d5ebb82ddcc3d2$var$unscrollableStyles,
                hasSeparator ? (0, $iDwTy.fg)('platform.design-system-team.section-1px-seperator-borders') ? $a3d5ebb82ddcc3d2$var$thinSeparatorStyles : $a3d5ebb82ddcc3d2$var$thickSeparatorStyles : $a3d5ebb82ddcc3d2$var$noSeparatorStyles
            ],
            "aria-label": title,
            "aria-labelledby": titleId,
            "data-testid": testId,
            role: "group",
            "data-section": true,
            ref: ref
        }, childrenMarkup);
    });
    var $a3d5ebb82ddcc3d2$export$2e2bcd8739ae039 = $a3d5ebb82ddcc3d2$var$Section;
});
parcelRegister("fRHE6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d7cf5a76ed1e2b2e$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $7pdsy = parcelRequire("7pdsy");
    var $4oSDA = parcelRequire("4oSDA");
    const $d7cf5a76ed1e2b2e$var$headingStyles = (0, $byn9U.css)({
        color: `var(--ds-text-subtle, ${(0, $207acf722dcd432b$export$e2ef2124cf4024b1)})`,
        font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        paddingBlock: "var(--ds-space-0, 0px)",
        paddingInline: "var(--ds-space-200, 16px)"
    });
    const $d7cf5a76ed1e2b2e$var$HeadingItem = (0, $eUqFw.memo)(({ children: children, testId: testId, headingLevel: headingLevel = 2, id: id, cssFn: cssFn = (0, $4oSDA.default), className: UNSAFE_className, ...rest })=>{
        (0, $7pdsy.propDeprecationWarning)("platform-pkg", 'cssFn', cssFn !== (0, $4oSDA.default), '');
        const UNSAFE_overrides = (0, $byn9U.css)(cssFn(undefined));
        return (0, $byn9U.jsx)("div", {
            css: [
                $d7cf5a76ed1e2b2e$var$headingStyles,
                UNSAFE_overrides
            ],
            role: "heading",
            "aria-level": headingLevel,
            "data-testid": testId,
            "data-ds--menu--heading-item": true,
            id: id,
            className: UNSAFE_className,
            ...rest
        }, children);
    });
    var $d7cf5a76ed1e2b2e$export$2e2bcd8739ae039 = $d7cf5a76ed1e2b2e$var$HeadingItem;
});
parcelRegister("b7seu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eee34eba5b8fd10d$export$2e2bcd8739ae039);
    var $byn9U = parcelRequire("byn9U");
    var $dNgQx = parcelRequire("dNgQx");
    const $eee34eba5b8fd10d$var$itemHeadingContentHeight = (0, $dNgQx.headingSizes).h100.lineHeight;
    const $eee34eba5b8fd10d$var$itemHeadingFontSize = (0, $dNgQx.headingSizes).h100.size;
    const $eee34eba5b8fd10d$var$headingStyles = (0, $byn9U.css)({
        color: `var(--ds-text-subtle, ${(0, $207acf722dcd432b$export$e2ef2124cf4024b1)})`,
        fontSize: $eee34eba5b8fd10d$var$itemHeadingFontSize,
        fontWeight: "var(--ds-font-weight-bold, 700)",
        lineHeight: $eee34eba5b8fd10d$var$itemHeadingContentHeight / $eee34eba5b8fd10d$var$itemHeadingFontSize,
        paddingBlock: "var(--ds-space-0, 0px)",
        paddingInline: "var(--ds-space-200, 16px)",
        textTransform: 'uppercase'
    });
    const $eee34eba5b8fd10d$var$GroupTitle = ({ id: id, title: title })=>(0, $byn9U.jsx)("div", {
            "data-ds--menu--heading-item": true,
            role: "menuitem",
            id: id,
            "aria-hidden": "true",
            css: $eee34eba5b8fd10d$var$headingStyles
        }, title);
    var $eee34eba5b8fd10d$export$2e2bcd8739ae039 = $eee34eba5b8fd10d$var$GroupTitle;
});
parcelRegister("5uhaw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$298d8be94bd59eb4$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $1inzG = parcelRequire("1inzG");
    var $5aRS9 = parcelRequire("5aRS9");
    var $jcsHn = parcelRequire("jcsHn");
    var $iDwTy = parcelRequire("iDwTy");
    var $hSIJW = parcelRequire("hSIJW");
    var $fe7tw = parcelRequire("fe7tw");
    var $cFm0F = parcelRequire("cFm0F");
    var $6GB9P = parcelRequire("6GB9P");
    var $iNUWe = parcelRequire("iNUWe");
    var $bsSWB = parcelRequire("bsSWB");
    const $298d8be94bd59eb4$var$packageName = "platform-pkg";
    const $298d8be94bd59eb4$var$packageVersion = "0.0.0-use.local";
    const $298d8be94bd59eb4$var$getTestId = (testId, children)=>!children ? {
            'data-testid': `${testId}--inner`
        } : {
            testId: `${testId}--inner`
        };
    const $298d8be94bd59eb4$var$getStyles = (css, { size: size, radius: radius, appearance: appearance, borderColor: borderColor = (0, $iDwTy.fg)('platform-component-visual-refresh') ? "var(--ds-surface, #FFFFFF)" : `var(--ds-surface-overlay, ${0, $207acf722dcd432b$export$29a4f05edc054374})`, stackIndex: stackIndex, isInteractive: isInteractive, isDisabled: isDisabled })=>css`
		height: ${size}px;
		width: ${size}px;
		align-items: stretch;
		background-color: ${borderColor};
		border-radius: ${appearance === 'circle' ? '50%' : `${radius}px`};
		box-sizing: content-box;
		cursor: inherit;
		display: flex;
		flex-direction: column;
		justify-content: center;
		outline: none;
		overflow: hidden;
		position: static;
		transform: translateZ(0);
		transition:
			transform 200ms,
			opacity 200ms;
		box-shadow: 0 0 0 ${0, $fe7tw.BORDER_WIDTH}px ${borderColor};
		border: none;
		margin: ${"var(--ds-space-025, 2px)"};
		padding: ${"var(--ds-space-0, 0px)"};

		&::-moz-focus-inner {
			border: 0;
			margin: ${"var(--ds-space-0, 0px)"};
			padding: ${"var(--ds-space-0, 0px)"};
		}

		&::after {
			background-color: transparent;
			inset: 0px;

			/* Added border-radius style to fix hover issue in safari */
			border-radius: ${appearance === 'circle' ? '50%' : `${radius}px`};
			content: ' ';
			opacity: 0;
			pointer-events: none;
			position: absolute;
			transition: opacity 200ms;
			width: 100%;
		}

		:focus {
			box-shadow: none;
		}

		${stackIndex && `position: relative;`}

		${isInteractive && `
      cursor: pointer;

      :hover {
        &::after {
          background-color: ${`var(--ds-interaction-hovered, ${0, $207acf722dcd432b$export$6e5e7499ff054f6d})`};
          opacity: 1;
        }
      }

      :active {
        &::after {
          background-color: ${`var(--ds-interaction-pressed, ${0, $207acf722dcd432b$export$6e5e7499ff054f6d})`};
          opacity: 1;
        }
      }

      :active {
        transform: scale(${0, $fe7tw.ACTIVE_SCALE_FACTOR});
      }

      @media screen and (forced-colors: active) {
        &:focus-visible {
          outline: 1px solid
        }
      }
    `}

    ${isDisabled && `
        cursor: not-allowed;

        &::after {
          opacity: ${"var(--ds-opacity-disabled, 0.7)"};
          pointer-events: none;
          background-color: ${`var(--ds-surface, ${0, $207acf722dcd432b$export$29a4f05edc054374})`};
        }
      `}
	`;
    const $298d8be94bd59eb4$var$Avatar = (0, $eUqFw.forwardRef)(({ analyticsContext: analyticsContext, appearance: appearance = 'circle', label: label, borderColor: borderColor, children: children, href: href, isDisabled: isDisabled, name: name, onClick: onClick, presence: presence, size: sizeProp, src: src, stackIndex: stackIndex, status: status, target: target, testId: testId, as: AvatarContainer = 'div' }, ref)=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $1inzG.useAnalyticsEvents)();
        const context = (0, $cFm0F.useAvatarContext)();
        const size = sizeProp ?? context?.size ?? 'medium';
        const customPresenceNode = (0, $eUqFw.isValidElement)(presence) ? presence : null;
        const customStatusNode = (0, $eUqFw.isValidElement)(status) ? status : null;
        const isValidIconSize = size !== 'xxlarge' && size !== 'xsmall';
        const lastAnalytics = (0, $eUqFw.useRef)(analyticsContext);
        const labelId = (0, $5aRS9.useId)();
        (0, $eUqFw.useEffect)(()=>{
            lastAnalytics.current = analyticsContext;
        }, [
            analyticsContext
        ]);
        const onClickHandler = (0, $eUqFw.useCallback)((event)=>{
            if (isDisabled || typeof onClick !== 'function') return;
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'avatar',
                attributes: {
                    componentName: 'avatar',
                    packageName: $298d8be94bd59eb4$var$packageName,
                    packageVersion: $298d8be94bd59eb4$var$packageVersion
                }
            });
            const context = {
                componentName: 'avatar',
                packageName: $298d8be94bd59eb4$var$packageName,
                packageVersion: $298d8be94bd59eb4$var$packageVersion,
                ...lastAnalytics.current
            };
            analyticsEvent.context.push(context);
            const clone = analyticsEvent.clone();
            if (clone) clone.fire('atlaskit');
            onClick(event, analyticsEvent);
        }, [
            createAnalyticsEvent,
            isDisabled,
            onClick
        ]);
        const componentProps = ()=>{
            if (isDisabled) return {
                disabled: true
            };
            return {
                ...href && (0, $bsSWB.getLinkProps)(href, target),
                ...onClick && !href ? (0, $bsSWB.getButtonProps)(onClickHandler) : {
                    onClick: onClick
                }
            };
        };
        const isPresence = isValidIconSize && presence && !status;
        const isStatus = isValidIconSize && status;
        const defaultLabel = [
            name,
            isStatus && !customStatusNode && `(${status})`,
            isPresence && !customPresenceNode && `(${presence})`
        ].filter(Boolean).join(' ');
        const isInteractive = onClick || href || isDisabled;
        const containerShouldBeImage = Boolean(!isInteractive && defaultLabel);
        return (0, $byn9U.jsx)(AvatarContainer, {
            "data-testid": testId,
            role: containerShouldBeImage ? 'img' : undefined,
            "aria-labelledby": containerShouldBeImage ? labelId : undefined,
            style: {
                display: 'inline-block',
                position: 'relative',
                outline: 0,
                zIndex: stackIndex
            }
        }, (0, $byn9U.jsx)((0, $byn9U.ClassNames), null, ({ css: css })=>{
            const props = {
                className: $298d8be94bd59eb4$var$getStyles(css, {
                    size: (0, $fe7tw.AVATAR_SIZES)[size],
                    radius: (0, $fe7tw.AVATAR_RADIUS)[size],
                    appearance: appearance,
                    borderColor: borderColor,
                    stackIndex: stackIndex,
                    isInteractive: Boolean(href || onClick) && !isDisabled,
                    isDisabled: isDisabled
                }),
                ...componentProps(),
                ...testId && $298d8be94bd59eb4$var$getTestId(testId, children),
                ...(isInteractive || children) && {
                    'aria-label': label || defaultLabel
                },
                children: (0, $byn9U.jsx)((0, $hSIJW.default), {
                    alt: !containerShouldBeImage && src ? name : undefined,
                    appearance: appearance,
                    size: size,
                    src: src,
                    testId: testId
                }),
                ref: ref
            };
            if (children) return children(props);
            const element = (0, $bsSWB.getCustomElement)(isDisabled, href, onClick);
            return element === 'a' || element === 'button' ? (0, $byn9U.jsx)((0, $jcsHn.default), null, (0, $eUqFw.createElement)(element, props)) : (0, $eUqFw.createElement)(element, props);
        }), isPresence && (0, $byn9U.jsx)((0, $6GB9P.PresenceWrapper), {
            appearance: appearance,
            size: size,
            presence: typeof presence === 'string' ? presence : undefined,
            testId: testId
        }, customPresenceNode), isStatus && (0, $byn9U.jsx)((0, $iNUWe.StatusWrapper), {
            appearance: appearance,
            size: size,
            borderColor: borderColor,
            status: typeof status === 'string' ? status : undefined,
            testId: testId
        }, customStatusNode), containerShouldBeImage ? (0, $byn9U.jsx)("span", {
            "data-testid": testId && `${testId}--label`,
            id: labelId,
            hidden: true
        }, defaultLabel) : undefined);
    });
    $298d8be94bd59eb4$var$Avatar.displayName = 'Avatar';
    var $298d8be94bd59eb4$export$2e2bcd8739ae039 = $298d8be94bd59eb4$var$Avatar;
});
parcelRegister("hSIJW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b47a79169c93af56$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $90vbB = parcelRequire("90vbB");
    var $20pgu = parcelRequire("20pgu");
    var $bepFn = parcelRequire("bepFn");
    var $gQM0s = parcelRequire("gQM0s");
    var $iDwTy = parcelRequire("iDwTy");
    var $fe7tw = parcelRequire("fe7tw");
    function $b47a79169c93af56$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $b47a79169c93af56$var$avatarDefaultIconStyles = (0, $byn9U.css)({
        display: 'block',
        width: '100%',
        height: '100%',
        backgroundColor: `var(--ds-icon-subtle, ${(0, $207acf722dcd432b$export$7c87d337fb91a97d)})`
    });
    const $b47a79169c93af56$var$avatarDefaultIconVisualRefreshStyles = {
        name: "dg8dij",
        styles: "display:block;width:100%;height:100%;background-color:var(--ds-background-accent-gray-subtler, #DCDFE4)"
    };
    const $b47a79169c93af56$var$nestedAvatarStyles = Object.entries((0, $fe7tw.AVATAR_SIZES)).reduce((styles, [key, size])=>{
        return {
            ...styles,
            [key]: (0, $byn9U.css)({
                '& svg': {
                    width: `${size}px`,
                    height: `${size}px`
                }
            })
        };
    }, {});
    const $b47a79169c93af56$var$avatarImageStyles = {
        name: "1gr7gcv",
        styles: "display:flex;width:100%;height:100%;flex:1 1 100%"
    };
    const $b47a79169c93af56$var$AvatarImage = ({ alt: alt = '', src: src, appearance: appearance, size: size, testId: testId })=>{
        const [hasImageErrored, setHasImageErrored] = (0, $eUqFw.useState)(false);
        const borderRadius = appearance === 'circle' ? '50%' : `${(0, $fe7tw.AVATAR_RADIUS)[size]}px`;
        const isHidden = !alt ? true : undefined;
        (0, $eUqFw.useEffect)(()=>{
            setHasImageErrored(false);
        }, [
            src
        ]);
        if (!src || hasImageErrored) return (0, $byn9U.jsx)("span", {
            css: [
                (0, $iDwTy.fg)('platform-component-visual-refresh') ? $b47a79169c93af56$var$avatarDefaultIconVisualRefreshStyles : $b47a79169c93af56$var$avatarDefaultIconStyles,
                $b47a79169c93af56$var$nestedAvatarStyles[size]
            ]
        }, appearance === 'circle' ? (0, $iDwTy.fg)('platform-component-visual-refresh') ? (0, $byn9U.jsx)((0, ($parcel$interopDefault($90vbB))), {
            label: alt,
            color: "var(--ds-icon-subtle, #626F86)",
            testId: testId && `${testId}--person`,
            spacing: "spacious"
        }) : (0, $byn9U.jsx)((0, ($parcel$interopDefault($bepFn))), {
            label: alt,
            primaryColor: `var(--ds-icon-inverse, ${(0, $207acf722dcd432b$export$29a4f05edc054374)})`,
            secondaryColor: `var(--ds-icon-subtle, ${(0, $207acf722dcd432b$export$7c87d337fb91a97d)})`,
            testId: testId && `${testId}--person`,
            "aria-hidden": isHidden
        }) : (0, $iDwTy.fg)('platform-component-visual-refresh') ? (0, $byn9U.jsx)((0, ($parcel$interopDefault($20pgu))), {
            label: alt,
            color: "var(--ds-icon-subtle, #626F86)",
            testId: testId && `${testId}--ship`,
            spacing: "spacious"
        }) : (0, $byn9U.jsx)((0, ($parcel$interopDefault($gQM0s))), {
            label: alt,
            primaryColor: `var(--ds-icon-inverse, ${(0, $207acf722dcd432b$export$29a4f05edc054374)})`,
            secondaryColor: `var(--ds-icon-subtle, ${(0, $207acf722dcd432b$export$7c87d337fb91a97d)})`,
            testId: testId && `${testId}--ship`,
            "aria-hidden": isHidden
        }));
        return (0, $byn9U.jsx)("img", {
            src: src,
            alt: alt,
            "data-testid": testId && `${testId}--image`,
            css: $b47a79169c93af56$var$avatarImageStyles,
            style: {
                borderRadius: borderRadius
            },
            onError: ()=>setHasImageErrored(true),
            "aria-hidden": isHidden,
            "data-vc": testId ? `${testId}--image` : 'avatar-image'
        });
    };
    var $b47a79169c93af56$export$2e2bcd8739ae039 = $b47a79169c93af56$var$AvatarImage;
});
parcelRegister("cFm0F", function(module, exports) {
    $parcel$export(module.exports, "AvatarContext", ()=>$73f86650c17fe32a$export$a20dad690e1279e2);
    $parcel$export(module.exports, "useAvatarContext", ()=>$73f86650c17fe32a$export$b50b87a1c4086b23);
    var $eUqFw = parcelRequire("eUqFw");
    const $73f86650c17fe32a$export$a20dad690e1279e2 = (0, $eUqFw.createContext)(undefined);
    const $73f86650c17fe32a$export$b50b87a1c4086b23 = ()=>(0, $eUqFw.useContext)($73f86650c17fe32a$export$a20dad690e1279e2);
});
parcelRegister("6GB9P", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a141fe73cc435456$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "PresenceWrapper", ()=>$a141fe73cc435456$export$972c5e90200fa0ef);
    var $eUqFw = parcelRequire("eUqFw");
    var $fe7tw = parcelRequire("fe7tw");
    var $8ykqj = parcelRequire("8ykqj");
    const $a141fe73cc435456$var$BusyIndicator = (0, ($parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, (0, ($parcel$interopDefault($eUqFw))).createElement("circle", {
        fill: `var(--ds-icon-danger, ${(0, $207acf722dcd432b$export$4a7404f376229999)})`,
        cx: "4",
        cy: "4",
        r: "4"
    }), (0, ($parcel$interopDefault($eUqFw))).createElement("path", {
        fill: `var(--ds-surface-overlay, ${(0, $207acf722dcd432b$export$29a4f05edc054374)})`,
        d: "M3.3,1.9l2.8,2.8c0.2,0.2,0.2,0.5,0,0.7L5.4,6.1c-0.2,0.2-0.5,0.2-0.7,0L1.9,3.3c-0.2-0.2-0.2-0.5,0-0.7l0.7-0.7C2.8,1.7,3.1,1.7,3.3,1.9z"
    }));
    const $a141fe73cc435456$var$FocusIndicator = (0, ($parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, (0, ($parcel$interopDefault($eUqFw))).createElement("path", {
        fill: `var(--ds-icon-discovery, ${(0, $207acf722dcd432b$export$b48405b95304b5a1)})`,
        d: "M4,8 C1.790861,8 0,6.209139 0,4 C0,1.790861 1.790861,0 4,0 C6.209139,0 8,1.790861 8,4 C8,6.209139 6.209139,8 4,8 Z M4,6.66666667 C5.47275933,6.66666667 6.66666667,5.47275933 6.66666667,4 C6.66666667,2.52724067 5.47275933,1.33333333 4,1.33333333 C2.52724067,1.33333333 1.33333333,2.52724067 1.33333333,4 C1.33333333,5.47275933 2.52724067,6.66666667 4,6.66666667 Z M4,5.33333333 C3.26362033,5.33333333 2.66666667,4.73637967 2.66666667,4 C2.66666667,3.26362033 3.26362033,2.66666667 4,2.66666667 C4.73637967,2.66666667 5.33333333,3.26362033 5.33333333,4 C5.33333333,4.73637967 4.73637967,5.33333333 4,5.33333333 Z"
    }));
    const $a141fe73cc435456$var$OfflineIndicator = (0, ($parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, (0, ($parcel$interopDefault($eUqFw))).createElement("path", {
        fill: `var(--ds-text-subtlest, ${(0, $207acf722dcd432b$export$f563ee71e9ee74cd)})`,
        d: "M4,8 C6.209139,8 8,6.209139 8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
    }), (0, ($parcel$interopDefault($eUqFw))).createElement("path", {
        fill: `var(--ds-surface-overlay, ${(0, $207acf722dcd432b$export$1ce2d1575d444ceb)})`,
        d: "M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
    }));
    const $a141fe73cc435456$var$OnlineIndicator = (0, ($parcel$interopDefault($eUqFw))).createElement("circle", {
        fill: `var(--ds-icon-success, ${(0, $207acf722dcd432b$export$940e1f69e873f202)})`,
        cx: "4",
        cy: "4",
        r: "4"
    });
    function $a141fe73cc435456$var$getPresence(presence) {
        switch(presence){
            case 'busy':
                return $a141fe73cc435456$var$BusyIndicator;
            case 'focus':
                return $a141fe73cc435456$var$FocusIndicator;
            case 'offline':
                return $a141fe73cc435456$var$OfflineIndicator;
            case 'online':
                return $a141fe73cc435456$var$OnlineIndicator;
        }
    }
    const $a141fe73cc435456$var$AvatarPresence = ({ borderColor: borderColor, children: children, presence: presence })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $8ykqj.default), {
            bgColor: borderColor
        }, presence ? (0, ($parcel$interopDefault($eUqFw))).createElement("svg", {
            height: "100%",
            version: "1.1",
            viewBox: "0 0 8 8",
            width: "100%",
            xmlns: "http://www.w3.org/2000/svg"
        }, $a141fe73cc435456$var$getPresence(presence)) : children);
    var $a141fe73cc435456$export$2e2bcd8739ae039 = $a141fe73cc435456$var$AvatarPresence;
    const $a141fe73cc435456$export$972c5e90200fa0ef = ({ size: size, appearance: appearance, children: children, borderColor: borderColor, presence: presence, testId: testId })=>{
        const position = appearance === 'square' ? -4 : (0, $fe7tw.ICON_OFFSET)[size];
        return (0, ($parcel$interopDefault($eUqFw))).createElement("span", {
            "aria-hidden": "true",
            "data-testid": testId && `${testId}--presence`,
            style: {
                pointerEvents: 'none',
                position: 'absolute',
                bottom: `${position}px`,
                height: `${(0, $fe7tw.ICON_SIZES)[size]}px`,
                right: `${position}px`,
                width: `${(0, $fe7tw.ICON_SIZES)[size]}px`
            }
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($a141fe73cc435456$var$AvatarPresence, {
            borderColor: borderColor,
            presence: !children ? presence : undefined
        }, children));
    };
});
parcelRegister("8ykqj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5b3ad0211627d779$export$2e2bcd8739ae039);
    var $byn9U = parcelRequire("byn9U");
    var $fe7tw = parcelRequire("fe7tw");
    function $5b3ad0211627d779$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $5b3ad0211627d779$var$iconWrapperStyles = {
        name: "1kwqznv",
        styles: "display:flex;box-sizing:border-box;width:100%;height:100%;align-items:center;align-content:center;border-radius:var(--ds-border-radius-circle, 50%);overflow:hidden"
    };
    const $5b3ad0211627d779$var$IconWrapper = ({ bgColor: bgColor = `var(--ds-surface-overlay, ${0, $207acf722dcd432b$export$29a4f05edc054374})`, children: children })=>(0, $byn9U.jsx)("span", {
            css: $5b3ad0211627d779$var$iconWrapperStyles,
            role: "presentation",
            style: {
                border: `${(0, $fe7tw.BORDER_WIDTH)}px solid ${bgColor}`,
                backgroundColor: bgColor
            }
        }, children);
    var $5b3ad0211627d779$export$2e2bcd8739ae039 = $5b3ad0211627d779$var$IconWrapper;
});
parcelRegister("iNUWe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b7ca4d5c043fc402$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "StatusWrapper", ()=>$b7ca4d5c043fc402$export$8045894f255f9726);
    var $eUqFw = parcelRequire("eUqFw");
    var $fe7tw = parcelRequire("fe7tw");
    var $8ykqj = parcelRequire("8ykqj");
    const $b7ca4d5c043fc402$var$ApprovedIndicator = (0, ($parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, (0, ($parcel$interopDefault($eUqFw))).createElement("circle", {
        fill: `var(--ds-icon-success, ${(0, $207acf722dcd432b$export$a49394138f7b8e85)})`,
        cx: "4",
        cy: "4",
        r: "4"
    }), (0, ($parcel$interopDefault($eUqFw))).createElement("path", {
        fill: `var(--ds-surface-overlay, ${(0, $207acf722dcd432b$export$29a4f05edc054374)})`,
        d: "M2.47140452,3.52859548 C2.21105499,3.26824595 1.78894501,3.26824595 1.52859548,3.52859548 C1.26824595,3.78894501 1.26824595,4.21105499 1.52859548,4.47140452 L2.86192881,5.80473785 C3.12227834,6.06508738 3.54438833,6.06508738 3.80473785,5.80473785 L6.47140452,3.13807119 C6.73175405,2.87772166 6.73175405,2.45561167 6.47140452,2.19526215 C6.21105499,1.93491262 5.78894501,1.93491262 5.52859548,2.19526215 L3.33333333,4.39052429 L2.47140452,3.52859548 Z"
    }));
    const $b7ca4d5c043fc402$var$DeclinedIndicator = (0, ($parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, (0, ($parcel$interopDefault($eUqFw))).createElement("circle", {
        fill: `var(--ds-icon-danger, ${(0, $207acf722dcd432b$export$2010d0fb4295b346)})`,
        cx: "4",
        cy: "4",
        r: "4"
    }), (0, ($parcel$interopDefault($eUqFw))).createElement("path", {
        fill: `var(--ds-surface-overlay, ${(0, $207acf722dcd432b$export$29a4f05edc054374)})`,
        d: "M4.890661,4.0088336 L5.81806461,3.07802178 C6.06167933,2.83351177 6.06048933,2.43826992 5.81540668,2.19522442 C5.57032402,1.95217891 5.17415651,1.95336612 4.93054179,2.19787613 L4.00765946,3.12415007 L3.06906871,2.18377143 C2.82523777,1.93947602 2.42906937,1.93863765 2.18420182,2.18189887 C1.93933427,2.42516008 1.93849394,2.82040282 2.18232488,3.06469822 L3.12544091,4.00961077 L2.20275024,4.93569234 C1.95913552,5.18020236 1.96032551,5.5754442 2.20540817,5.81848971 C2.45049083,6.06153521 2.84665833,6.060348 3.09027306,5.81583799 L4.00844245,4.89429431 L4.9092123,5.79678001 C5.15304324,6.04107541 5.54921164,6.04191379 5.79407919,5.79865257 C6.03894674,5.55539135 6.03978708,5.16014862 5.79595614,4.91585321 L4.890661,4.0088336 Z"
    }));
    const $b7ca4d5c043fc402$var$LockedIndicator = (0, ($parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, (0, ($parcel$interopDefault($eUqFw))).createElement("circle", {
        fill: `var(--ds-text-subtlest, ${(0, $207acf722dcd432b$export$1ce2d1575d444ceb)})`,
        cx: "4",
        cy: "4",
        r: "4"
    }), (0, ($parcel$interopDefault($eUqFw))).createElement("path", {
        fill: `var(--ds-surface-overlay, ${(0, $207acf722dcd432b$export$c39c0fe0f26207ae)})`,
        d: "M4.13074827,1.21766493 L4.10368158,1.21766493 C3.36340745,1.21766493 2.76388015,1.80793503 2.76388015,2.5367787 L2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,2.54344089 C3.44054754,2.17901906 3.74031119,1.88388401 4.11044825,1.88388401 L4.1239816,1.88388401 C4.49411866,1.88388401 4.79388232,2.17901906 4.79388232,2.54344089 L4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,2.5367787 C5.47054971,1.80793503 4.8710224,1.21766493 4.13074827,1.21766493 M2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,3.88254123 L2.76388015,3.88254123 L2.76388015,3.21632216 Z M4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,3.88254123 L4.79388232,3.88254123 L4.79388232,3.21632216 Z M4.79401765,3.88254123 L3.44068287,3.88254123 L2.76401548,3.88254123 C2.39049508,3.88254123 2.08734809,4.18100738 2.08734809,4.54876031 L2.08734809,5.54808892 C2.08734809,6.10000287 2.53735205,6.54741753 3.09094491,6.54741753 L5.14375561,6.54741753 C5.69802683,6.54741753 6.14735243,6.10385072 6.14735243,5.54808892 L6.14735243,4.54876031 C6.14735243,4.18100738 5.84420544,3.88254123 5.47068504,3.88254123 L4.79401765,3.88254123 Z"
    }));
    function $b7ca4d5c043fc402$var$getStatus(status) {
        switch(status){
            case 'approved':
                return $b7ca4d5c043fc402$var$ApprovedIndicator;
            case 'declined':
                return $b7ca4d5c043fc402$var$DeclinedIndicator;
            case 'locked':
                return $b7ca4d5c043fc402$var$LockedIndicator;
        }
    }
    const $b7ca4d5c043fc402$var$AvatarStatus = ({ borderColor: borderColor, children: children, status: status })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $8ykqj.default), {
            bgColor: borderColor
        }, status ? (0, ($parcel$interopDefault($eUqFw))).createElement("svg", {
            height: "100%",
            version: "1.1",
            viewBox: "0 0 8 8",
            width: "100%",
            xmlns: "http://www.w3.org/2000/svg"
        }, $b7ca4d5c043fc402$var$getStatus(status)) : children);
    var $b7ca4d5c043fc402$export$2e2bcd8739ae039 = $b7ca4d5c043fc402$var$AvatarStatus;
    const $b7ca4d5c043fc402$export$8045894f255f9726 = ({ size: size, status: status, appearance: appearance, borderColor: borderColor, children: children, testId: testId })=>{
        const position = appearance === 'square' ? 0 : (0, $fe7tw.ICON_OFFSET)[size];
        return (0, ($parcel$interopDefault($eUqFw))).createElement("span", {
            "aria-hidden": "true",
            "data-testid": testId && `${testId}--status`,
            style: {
                position: 'absolute',
                height: `${(0, $fe7tw.ICON_SIZES)[size]}px`,
                right: `${position}px`,
                top: `${position}px`,
                width: `${(0, $fe7tw.ICON_SIZES)[size]}px`
            }
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($b7ca4d5c043fc402$var$AvatarStatus, {
            borderColor: borderColor,
            status: !children ? status : undefined
        }, children));
    };
});
parcelRegister("bsSWB", function(module, exports) {
    $parcel$export(module.exports, "getLinkProps", ()=>$79b5d5180a4f62b7$export$60113ebe1cf0ecf);
    $parcel$export(module.exports, "getButtonProps", ()=>$79b5d5180a4f62b7$export$cca6f1bef43616d3);
    $parcel$export(module.exports, "getCustomElement", ()=>$79b5d5180a4f62b7$export$83ee468102cdf04c);
    const $79b5d5180a4f62b7$export$60113ebe1cf0ecf = (href, target)=>({
            href: href,
            rel: target === '_blank' ? 'noopener noreferrer' : null,
            target: target
        });
    const $79b5d5180a4f62b7$export$cca6f1bef43616d3 = (onClick)=>({
            type: 'button',
            onClick: onClick
        });
    const $79b5d5180a4f62b7$export$83ee468102cdf04c = (isDisabled, href, onClick)=>{
        if (href && !isDisabled) return 'a';
        if (onClick || isDisabled) return 'button';
        return 'span';
    };
});
parcelRegister("h7bgU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3d038227ac89c6e1$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $iDwTy = parcelRequire("iDwTy");
    var $jGR8u = parcelRequire("jGR8u");
    var $fHiYa = parcelRequire("fHiYa");
    function $3d038227ac89c6e1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $3d038227ac89c6e1$var$baseStylesOld = (0, $fHiYa.xcss)({
        display: 'inline-flex',
        borderRadius: 'border.radius',
        blockSize: 'min-content',
        position: 'static',
        overflow: 'hidden'
    });
    const $3d038227ac89c6e1$var$styles = {
        container: {
            name: "1s8rs5f",
            styles: "display:inline-flex;box-sizing:border-box;position:static;block-size:min-content;border-radius:3px;overflow:hidden;padding-inline:var(--ds-space-050, 4px)"
        },
        background: {
            bold: {
                default: {
                    name: "1007ca",
                    styles: "background-color:#DDDEE1"
                },
                inprogress: {
                    name: "5nwhd8",
                    styles: "background-color:#8FB8F6"
                },
                moved: {
                    name: "1v45608",
                    styles: "background-color:#F9C84E"
                },
                new: {
                    name: "1ra4w2w",
                    styles: "background-color:#D8A0F7"
                },
                removed: {
                    name: "1y25gsq",
                    styles: "background-color:#FD9891"
                },
                success: {
                    name: "2bpbki",
                    styles: "background-color:#B3DF72"
                }
            },
            subtle: {
                default: {
                    name: "1v09iay",
                    styles: "background-color:var(--ds-background-neutral-subtle, #00000000)"
                },
                inprogress: {
                    name: "1v09iay",
                    styles: "background-color:var(--ds-background-neutral-subtle, #00000000)"
                },
                moved: {
                    name: "1v09iay",
                    styles: "background-color:var(--ds-background-neutral-subtle, #00000000)"
                },
                new: {
                    name: "1v09iay",
                    styles: "background-color:var(--ds-background-neutral-subtle, #00000000)"
                },
                removed: {
                    name: "1v09iay",
                    styles: "background-color:var(--ds-background-neutral-subtle, #00000000)"
                },
                success: {
                    name: "1v09iay",
                    styles: "background-color:var(--ds-background-neutral-subtle, #00000000)"
                }
            }
        },
        border: {
            subtle: {
                default: (0, $byn9U.css)({
                    border: `1px solid #B7B9BE`
                }),
                inprogress: (0, $byn9U.css)({
                    border: `1px solid #669DF1`
                }),
                moved: (0, $byn9U.css)({
                    border: `1px solid #FCA700`
                }),
                new: (0, $byn9U.css)({
                    border: `1px solid #C97CF4`
                }),
                removed: (0, $byn9U.css)({
                    border: `1px solid #F87168`
                }),
                success: (0, $byn9U.css)({
                    border: `1px solid #94C748`
                })
            }
        },
        text: {
            subtle: {
                name: "nws7uq",
                styles: "color:var(--ds-text, #172B4D)"
            },
            bold: {
                name: "14qj9ca",
                styles: "color:#292A2E"
            }
        }
    };
    const $3d038227ac89c6e1$var$textStyles = {
        name: "1bkq1y7",
        styles: "font-family:ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif;font-size:11px;font-style:normal;font-weight:var(--ds-font-weight-bold, 700);line-height:16px;overflow:hidden;text-overflow:ellipsis;text-transform:uppercase;white-space:nowrap"
    };
    const $3d038227ac89c6e1$var$Lozenge = (0, $eUqFw.memo)(({ children: children, testId: testId, isBold: isBold = false, appearance: appearance = 'default', maxWidth: maxWidth = 200, style: style })=>{
        const appearanceStyle = isBold ? 'bold' : 'subtle';
        const appearanceType = appearance in $3d038227ac89c6e1$var$styles.background[appearanceStyle] ? appearance : 'default';
        const maxWidthValue = typeof maxWidth === 'string' ? maxWidth : `${maxWidth}px`;
        const maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
        if ((0, $iDwTy.fg)('platform-component-visual-refresh')) return (0, $byn9U.jsx)("span", {
            style: {
                backgroundColor: style?.backgroundColor,
                maxWidth: maxWidthIsPc ? maxWidth : '100%'
            },
            css: [
                $3d038227ac89c6e1$var$styles.container,
                $3d038227ac89c6e1$var$styles.background[appearanceStyle][appearanceType],
                appearanceStyle === 'subtle' && $3d038227ac89c6e1$var$styles.border.subtle[appearanceType]
            ],
            "data-testid": testId
        }, (0, $byn9U.jsx)("span", {
            css: [
                $3d038227ac89c6e1$var$textStyles,
                $3d038227ac89c6e1$var$styles.text[appearanceStyle]
            ],
            style: {
                color: style?.color,
                maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`
            },
            "data-testid": testId && `${testId}--text`
        }, children));
        const appearanceTypeOld = appearance in $3d038227ac89c6e1$var$backgroundColorsOld[appearanceStyle] ? appearance : 'default';
        return (0, $byn9U.jsx)((0, $jGR8u.default), {
            as: "span",
            backgroundColor: $3d038227ac89c6e1$var$backgroundColorsOld[appearanceStyle][appearanceTypeOld],
            style: {
                backgroundColor: style?.backgroundColor,
                maxWidth: maxWidthIsPc ? maxWidth : '100%'
            },
            paddingInline: "space.050",
            xcss: $3d038227ac89c6e1$var$baseStylesOld,
            testId: testId
        }, (0, $byn9U.jsx)("span", {
            css: [
                $3d038227ac89c6e1$var$textStyles,
                $3d038227ac89c6e1$var$textColorsOld[appearanceStyle][appearanceType]
            ],
            style: {
                color: style?.color,
                maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`
            },
            "data-testid": testId && `${testId}--text`
        }, children));
    });
    $3d038227ac89c6e1$var$Lozenge.displayName = 'Lozenge';
    var $3d038227ac89c6e1$export$2e2bcd8739ae039 = $3d038227ac89c6e1$var$Lozenge;
    const $3d038227ac89c6e1$var$backgroundColorsOld = {
        bold: {
            default: 'color.background.neutral.bold',
            inprogress: 'color.background.information.bold',
            moved: 'color.background.warning.bold',
            new: 'color.background.discovery.bold',
            removed: 'color.background.danger.bold',
            success: 'color.background.success.bold'
        },
        subtle: {
            default: 'color.background.neutral',
            inprogress: 'color.background.information',
            moved: 'color.background.warning',
            new: 'color.background.discovery',
            removed: 'color.background.danger',
            success: 'color.background.success'
        }
    };
    const $3d038227ac89c6e1$var$textColorsOld = {
        bold: {
            default: {
                name: "1wvsb8v",
                styles: "color:var(--ds-text-inverse, #FFFFFF)"
            },
            inprogress: {
                name: "1wvsb8v",
                styles: "color:var(--ds-text-inverse, #FFFFFF)"
            },
            moved: {
                name: "tgubtb",
                styles: "color:var(--ds-text-warning-inverse, #172B4D)"
            },
            new: {
                name: "1wvsb8v",
                styles: "color:var(--ds-text-inverse, #FFFFFF)"
            },
            removed: {
                name: "1wvsb8v",
                styles: "color:var(--ds-text-inverse, #FFFFFF)"
            },
            success: {
                name: "1wvsb8v",
                styles: "color:var(--ds-text-inverse, #FFFFFF)"
            }
        },
        subtle: {
            default: {
                name: "kmxsjg",
                styles: "color:var(--ds-text-subtle, #42526E)"
            },
            inprogress: {
                name: "3j31nl",
                styles: "color:var(--ds-text-information, #0052CC)"
            },
            moved: {
                name: "1g2i1rp",
                styles: "color:var(--ds-text-warning, #974F0C)"
            },
            new: {
                name: "3juofh",
                styles: "color:var(--ds-text-discovery, #403294)"
            },
            removed: {
                name: "18zo14t",
                styles: "color:var(--ds-text-danger, #DE350B)"
            },
            success: {
                name: "1ychrch",
                styles: "color:var(--ds-text-success, #006644)"
            }
        }
    };
});
parcelRegister("4MFrg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$87d262cb447184e7$export$2e2bcd8739ae039);
    var $byn9U = parcelRequire("byn9U");
    var $7pdsy = parcelRequire("7pdsy");
    var $4oSDA = parcelRequire("4oSDA");
    var $h04Oa = parcelRequire("h04Oa");
    var $hcLBt = parcelRequire("hcLBt");
    function $87d262cb447184e7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $87d262cb447184e7$var$gridSize = (0, $h04Oa.gridSize)();
    const $87d262cb447184e7$var$borderRadius = (0, $h04Oa.borderRadius)();
    const $87d262cb447184e7$var$itemElemSpacing = $87d262cb447184e7$var$gridSize * 1.5;
    const $87d262cb447184e7$var$itemExpectedElemSize = $87d262cb447184e7$var$gridSize * 3;
    const $87d262cb447184e7$var$itemMinHeight = $87d262cb447184e7$var$gridSize * 5;
    const $87d262cb447184e7$var$skeletonItemElemSize = $87d262cb447184e7$var$gridSize * 2.5;
    const $87d262cb447184e7$var$itemElemSkeletonOffset = ($87d262cb447184e7$var$itemExpectedElemSize - $87d262cb447184e7$var$skeletonItemElemSize) / 2;
    const $87d262cb447184e7$var$skeletonTextBorderRadius = 100;
    const $87d262cb447184e7$var$skeletonContentHeight = 9;
    const $87d262cb447184e7$var$skeletonColor = `var(--ds-skeleton, ${(0, $207acf722dcd432b$export$8d43898f60b96a82)})`;
    const $87d262cb447184e7$var$skeletonStyles = (0, $byn9U.css)({
        display: 'flex',
        minHeight: $87d262cb447184e7$var$itemMinHeight,
        padding: `0 ${"var(--ds-space-250, 20px)"}`,
        alignItems: 'center',
        pointerEvents: 'none',
        '::after': {
            height: $87d262cb447184e7$var$skeletonContentHeight,
            backgroundColor: $87d262cb447184e7$var$skeletonColor,
            borderRadius: $87d262cb447184e7$var$skeletonTextBorderRadius,
            content: '""',
            marginBlockStart: 1
        }
    });
    const $87d262cb447184e7$var$defaultWidthStyles = {
        name: "sljcv5",
        styles: ":nth-of-type(1n)::after{flex-basis:70%;}:nth-of-type(2n)::after{flex-basis:50%;}:nth-of-type(3n)::after{flex-basis:60%;}:nth-of-type(4n)::after{flex-basis:90%;}:nth-of-type(5n)::after{flex-basis:35%;}:nth-of-type(6n)::after{flex-basis:77%;}"
    };
    const $87d262cb447184e7$var$customWidthStyles = {
        name: "nsk3fe",
        styles: "::after{flex-basis:var(--width);}"
    };
    const $87d262cb447184e7$var$beforeElementStyles = (0, $byn9U.css)({
        '::before': {
            width: $87d262cb447184e7$var$skeletonItemElemSize,
            height: $87d262cb447184e7$var$skeletonItemElemSize,
            flexShrink: 0,
            backgroundColor: $87d262cb447184e7$var$skeletonColor,
            content: '""',
            marginInlineEnd: $87d262cb447184e7$var$itemElemSpacing + $87d262cb447184e7$var$itemElemSkeletonOffset,
            marginInlineStart: "var(--ds-space-025, 2px)"
        }
    });
    const $87d262cb447184e7$var$avatarStyles = {
        name: "lz1zvf",
        styles: "::before{border-radius:100%;}"
    };
    const $87d262cb447184e7$var$iconStyles = (0, $byn9U.css)({
        '::before': {
            borderRadius: $87d262cb447184e7$var$borderRadius
        }
    });
    const $87d262cb447184e7$var$SkeletonItem = ({ hasAvatar: hasAvatar, hasIcon: hasIcon, isShimmering: isShimmering = false, testId: testId, width: width, cssFn: cssFn = (0, $4oSDA.default) })=>{
        (0, $7pdsy.propDeprecationWarning)("platform-pkg", 'cssFn', cssFn !== (0, $4oSDA.default), '');
        const UNSAFE_overrides = (0, $byn9U.css)(cssFn());
        return (0, $byn9U.jsx)((0, $hcLBt.default), {
            isShimmering: isShimmering
        }, ({ className: className })=>(0, $byn9U.jsx)("div", {
                className: className,
                style: {
                    '--width': width
                },
                css: [
                    $87d262cb447184e7$var$skeletonStyles,
                    (hasAvatar || hasIcon) && $87d262cb447184e7$var$beforeElementStyles,
                    hasAvatar && $87d262cb447184e7$var$avatarStyles,
                    hasIcon && $87d262cb447184e7$var$iconStyles,
                    width ? $87d262cb447184e7$var$customWidthStyles : $87d262cb447184e7$var$defaultWidthStyles,
                    UNSAFE_overrides
                ],
                "data-testid": testId
            }));
    };
    var $87d262cb447184e7$export$2e2bcd8739ae039 = $87d262cb447184e7$var$SkeletonItem;
});
parcelRegister("hcLBt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$51f8d2f592f528a8$export$2e2bcd8739ae039);
    var $byn9U = parcelRequire("byn9U");
    const $51f8d2f592f528a8$var$shimmerKeyframes = (0, $byn9U.keyframes)({
        from: {
            backgroundColor: `var(--ds-skeleton, ${(0, $207acf722dcd432b$export$8d43898f60b96a82)})`
        },
        to: {
            backgroundColor: `var(--ds-skeleton-subtle, ${(0, $207acf722dcd432b$export$920c0d5c49070351)})`
        }
    });
    const $51f8d2f592f528a8$var$shimmerStyles = (0, $byn9U.css)({
        '::before, ::after': {
            animationDirection: 'alternate',
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationName: `${$51f8d2f592f528a8$var$shimmerKeyframes}`,
            animationTimingFunction: 'linear',
            backgroundColor: `var(--ds-skeleton, ${(0, $207acf722dcd432b$export$8d43898f60b96a82)})`
        }
    });
    const $51f8d2f592f528a8$var$SkeletonShimmer = ({ children: children, isShimmering: isShimmering = false })=>{
        return (0, $byn9U.jsx)((0, $byn9U.ClassNames), null, ({ css: css })=>children({
                className: isShimmering ? css($51f8d2f592f528a8$var$shimmerStyles) : undefined
            }));
    };
    var $51f8d2f592f528a8$export$2e2bcd8739ae039 = $51f8d2f592f528a8$var$SkeletonShimmer;
});
parcelRegister("57Hsq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0bb929da74d843d3$export$2e2bcd8739ae039);
    var $iDwTy = parcelRequire("iDwTy");
    var $1e6Pr = parcelRequire("1e6Pr");
    var $5BDgX = parcelRequire("5BDgX");
    var $1VCZT = parcelRequire("1VCZT");
    var $gfKcO = parcelRequire("gfKcO");
    var $ahVol = parcelRequire("ahVol");
    const $0bb929da74d843d3$var$defaultColorMode = 'light';
    const $0bb929da74d843d3$var$defaultContrastMode = 'no-preference';
    const $0bb929da74d843d3$var$getThemeHtmlAttrs = ({ colorMode: colorMode = (0, $5BDgX.themeStateDefaults)['colorMode'], dark: dark = (0, $5BDgX.themeStateDefaults)['dark'], light: light = (0, $5BDgX.themeStateDefaults)['light'], contrastMode: contrastMode = (0, $5BDgX.themeStateDefaults)['contrastMode'], shape: shape = (0, $5BDgX.themeStateDefaults)['shape'], spacing: spacing = (0, $5BDgX.themeStateDefaults)['spacing'], typography: typography = (0, $5BDgX.themeStateDefaults)['typography'], UNSAFE_themeOptions: UNSAFE_themeOptions = (0, $5BDgX.themeStateDefaults)['UNSAFE_themeOptions'] } = {})=>{
        const themeAttribute = (0, $1VCZT.themeObjectToString)({
            dark: dark,
            light: light,
            shape: shape,
            spacing: spacing,
            typography: typography
        });
        let result = {
            [(0, $1e6Pr.THEME_DATA_ATTRIBUTE)]: themeAttribute,
            [(0, $1e6Pr.COLOR_MODE_ATTRIBUTE)]: colorMode === 'auto' ? $0bb929da74d843d3$var$defaultColorMode : colorMode
        };
        if ((0, $iDwTy.fg)('platform_increased-contrast-themes')) result = {
            ...result,
            [(0, $1e6Pr.CONTRAST_MODE_ATTRIBUTE)]: contrastMode === 'auto' ? $0bb929da74d843d3$var$defaultContrastMode : contrastMode
        };
        if (UNSAFE_themeOptions && (0, $gfKcO.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
            const optionString = JSON.stringify(UNSAFE_themeOptions);
            const uniqueId = (0, $ahVol.hash)(optionString);
            result[0, $1e6Pr.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
        }
        return result;
    };
    var $0bb929da74d843d3$export$2e2bcd8739ae039 = $0bb929da74d843d3$var$getThemeHtmlAttrs;
});
parcelRegister("gfKcO", function(module, exports) {
    $parcel$export(module.exports, "isValidBrandHex", ()=>$abf3918c0764ea01$export$53031ac1ecb71f44);
    $parcel$export(module.exports, "rgbToHex", ()=>$abf3918c0764ea01$export$34d09c4a771c46ef);
    $parcel$export(module.exports, "hexToRgbA", ()=>$abf3918c0764ea01$export$b36dbdb4f463f05c);
    $parcel$export(module.exports, "hexToRgb", ()=>$abf3918c0764ea01$export$5a544e13ad4e1fa5);
    $parcel$export(module.exports, "hexToHSL", ()=>$abf3918c0764ea01$export$47ea145a83f50dc0);
    $parcel$export(module.exports, "HSLToRGB", ()=>$abf3918c0764ea01$export$1ff93e992dd58bec);
    $parcel$export(module.exports, "relativeLuminanceW3C", ()=>$abf3918c0764ea01$export$e770b01b744f3745);
    $parcel$export(module.exports, "getContrastRatio", ()=>$abf3918c0764ea01$export$d061e26956a60b0a);
    $parcel$export(module.exports, "deltaE", ()=>$abf3918c0764ea01$export$e8ddad763b4bebf9);
    const $abf3918c0764ea01$export$53031ac1ecb71f44 = (hex)=>/^#[0-9A-F]{6}$/i.test(hex);
    const $abf3918c0764ea01$var$isValidHex = (hex)=>/^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);
    function $abf3918c0764ea01$export$34d09c4a771c46ef(r, g, b) {
        return '#' + (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
    }
    function $abf3918c0764ea01$export$1212645cf40ebf71(hex) {
        if (hex.length === 9) {
            const int = parseInt(hex.slice(7, 9), 16) / 255;
            return Number(parseFloat(int.toString()).toFixed(2));
        }
        return 1;
    }
    function $abf3918c0764ea01$export$b36dbdb4f463f05c(hex) {
        if (!$abf3918c0764ea01$var$isValidHex(hex)) throw new Error('Invalid HEX');
        let c;
        c = hex.substring(1).split('');
        if (c.length === 3) c = [
            c[0],
            c[0],
            c[1],
            c[1],
            c[2],
            c[2]
        ];
        c = '0x' + c.join('');
        return [
            c >> 16 & 255,
            c >> 8 & 255,
            c & 255,
            $abf3918c0764ea01$export$1212645cf40ebf71(hex)
        ];
    }
    function $abf3918c0764ea01$export$5a544e13ad4e1fa5(hex) {
        if (!$abf3918c0764ea01$var$isValidHex(hex)) throw new Error('Invalid HEX');
        let c;
        c = hex.substring(1).split('');
        if (c.length === 3) c = [
            c[0],
            c[0],
            c[1],
            c[1],
            c[2],
            c[2]
        ];
        c = '0x' + c.join('');
        return [
            c >> 16 & 255,
            c >> 8 & 255,
            c & 255
        ];
    }
    function $abf3918c0764ea01$export$47ea145a83f50dc0(hex) {
        if (!$abf3918c0764ea01$var$isValidHex(hex)) throw new Error('Invalid HEX');
        let r = 0, g = 0, b = 0;
        if (hex.length === 4) {
            r = '0x' + hex[1] + hex[1];
            g = '0x' + hex[2] + hex[2];
            b = '0x' + hex[3] + hex[3];
        } else if (hex.length === 7) {
            r = '0x' + hex[1] + hex[2];
            g = '0x' + hex[3] + hex[4];
            b = '0x' + hex[5] + hex[6];
        }
        r /= 255;
        g /= 255;
        b /= 255;
        let cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin, h = 0, s = 0, l = 0;
        if (delta === 0) h = 0;
        else if (cmax === r) h = (g - b) / delta % 6;
        else if (cmax === g) h = (b - r) / delta + 2;
        else h = (r - g) / delta + 4;
        h = Math.round(h * 60);
        if (h < 0) h += 360;
        l = (cmax + cmin) / 2;
        s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
        s = +(s * 100).toFixed(1);
        l = +(l * 100).toFixed(1);
        return [
            h,
            s,
            l
        ];
    }
    function $abf3918c0764ea01$export$1ff93e992dd58bec(h, s, l) {
        s /= 100;
        l /= 100;
        const k = (n)=>(n + h / 30) % 12;
        const a = s * Math.min(l, 1 - l);
        const f = (n)=>l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
        return [
            255 * f(0),
            255 * f(8),
            255 * f(4)
        ];
    }
    function $abf3918c0764ea01$export$e770b01b744f3745(r, g, b) {
        const RsRGB = r / 255;
        const GsRGB = g / 255;
        const BsRGB = b / 255;
        const R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
        const G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
        const B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
        const L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
        return L;
    }
    function $abf3918c0764ea01$export$d061e26956a60b0a(foreground, background) {
        if (!$abf3918c0764ea01$var$isValidHex(foreground) || !$abf3918c0764ea01$var$isValidHex(background)) throw new Error('Invalid HEX');
        const foregroundRgb = $abf3918c0764ea01$export$5a544e13ad4e1fa5(foreground);
        const backgroundRgb = $abf3918c0764ea01$export$5a544e13ad4e1fa5(background);
        const foregroundLuminance = $abf3918c0764ea01$export$e770b01b744f3745(foregroundRgb[0], foregroundRgb[1], foregroundRgb[2]);
        const backgroundLuminance = $abf3918c0764ea01$export$e770b01b744f3745(backgroundRgb[0], backgroundRgb[1], backgroundRgb[2]);
        var brightest = Math.max(foregroundLuminance, backgroundLuminance);
        var darkest = Math.min(foregroundLuminance, backgroundLuminance);
        return (brightest + 0.05) / (darkest + 0.05);
    }
    function $abf3918c0764ea01$export$e8ddad763b4bebf9(rgbA, rgbB) {
        let labA = $abf3918c0764ea01$var$rgbToLab(rgbA);
        let labB = $abf3918c0764ea01$var$rgbToLab(rgbB);
        let deltaL = labA[0] - labB[0];
        let deltaA = labA[1] - labB[1];
        let deltaB = labA[2] - labB[2];
        let c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
        let c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
        let deltaC = c1 - c2;
        let deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
        deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
        let sc = 1.0 + 0.045 * c1;
        let sh = 1.0 + 0.015 * c1;
        let deltaLKlsl = deltaL / 1.0;
        let deltaCkcsc = deltaC / sc;
        let deltaHkhsh = deltaH / sh;
        let i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
        return i < 0 ? 0 : Math.sqrt(i);
    }
    function $abf3918c0764ea01$var$rgbToLab(rgb) {
        let r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, x, y, z;
        r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
        g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
        b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
        x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
        y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.0;
        z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
        x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
        y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
        z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
        return [
            116 * y - 16,
            500 * (x - y),
            200 * (y - z)
        ];
    }
});
parcelRegister("ahVol", function(module, exports) {
    $parcel$export(module.exports, "hash", ()=>$07bbcefc6d63518a$export$d6af199866bfb566);
    const $07bbcefc6d63518a$export$d6af199866bfb566 = (str)=>{
        let hash = 0;
        for(let i = 0; i < str.length; i++){
            const char = str.charCodeAt(i);
            hash = (hash << 5) - hash + char;
            hash &= hash;
        }
        return new Uint32Array([
            hash
        ])[0].toString(36);
    };
});
parcelRegister("iMHir", function(module, exports) {
    $parcel$export(module.exports, "getThemePreferences", ()=>$d5d6880c50605038$export$dd6aeb7c823fc03d);
    $parcel$export(module.exports, "getThemeOverridePreferences", ()=>$d5d6880c50605038$export$5d76d7014f4a5d08);
    var $iDwTy = parcelRequire("iDwTy");
    var $5WsrD = parcelRequire("5WsrD");
    const $d5d6880c50605038$export$dd6aeb7c823fc03d = (themeState)=>{
        const { colorMode: colorMode, contrastMode: contrastMode, dark: dark, light: light, shape: shape, spacing: spacing, typography: typography } = themeState;
        const autoColorModeThemes = [
            light,
            dark
        ];
        const themePreferences = [];
        if (colorMode === 'auto') {
            if (contrastMode !== 'no-preference' && (0, $iDwTy.fg)('platform_increased-contrast-themes')) autoColorModeThemes.forEach((normalTheme)=>{
                const increasedContrastTheme = (0, $5WsrD.default)(normalTheme);
                if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
            });
            themePreferences.push(...autoColorModeThemes);
        } else {
            themePreferences.push(themeState[colorMode]);
            if (contrastMode !== 'no-preference' && (0, $iDwTy.fg)('platform_increased-contrast-themes')) {
                const increasedContrastTheme = (0, $5WsrD.default)(themeState[colorMode]);
                if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
            }
        }
        [
            shape,
            spacing,
            typography
        ].forEach((themeId)=>{
            if (themeId) themePreferences.push(themeId);
        });
        return [
            ...new Set(themePreferences)
        ];
    };
    const $d5d6880c50605038$export$5d76d7014f4a5d08 = (_themeState)=>{
        const themeOverridePreferences = [];
        return [
            ...new Set(themeOverridePreferences)
        ];
    };
});
parcelRegister("5WsrD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$114f683221a210df$export$2e2bcd8739ae039);
    var $5BDgX = parcelRequire("5BDgX");
    function $114f683221a210df$export$2e2bcd8739ae039(themeId) {
        return Object.entries((0, $5BDgX.default)).find(([, { increasesContrastFor: increasesContrastFor }])=>{
            return increasesContrastFor === themeId;
        })?.[1].id;
    }
});
parcelRegister("2sAUE", function(module, exports) {
    $parcel$export(module.exports, "loadAndAppendThemeCss", ()=>$b4f8eba4f4c15e66$export$26cd7ae85c7144e5);
    $parcel$export(module.exports, "loadThemeCss", ()=>$b4f8eba4f4c15e66$export$8a48286ed7df6720);
    $parcel$export(module.exports, "darkModeMediaQuery", ()=>$b4f8eba4f4c15e66$export$bb1e815119d30f8b);
    $parcel$export(module.exports, "moreContrastMediaQuery", ()=>$b4f8eba4f4c15e66$export$8662df6937d86fcb);
    var $iDwTy = parcelRequire("iDwTy");
    var $gqQd4 = parcelRequire("gqQd4");
    var $1e6Pr = parcelRequire("1e6Pr");
    const $b4f8eba4f4c15e66$export$26cd7ae85c7144e5 = async (themeId)=>{
        if (document.head.querySelector(`style[${(0, $1e6Pr.THEME_DATA_ATTRIBUTE)}="${themeId}"]:not([${(0, $1e6Pr.CUSTOM_THEME_ATTRIBUTE)}])`)) return;
        if (!themeId) return;
        const themeCss = await $b4f8eba4f4c15e66$export$8a48286ed7df6720(themeId);
        const style = document.createElement('style');
        style.textContent = themeCss;
        style.dataset.theme = themeId;
        document.head.appendChild(style);
    };
    const $b4f8eba4f4c15e66$export$8a48286ed7df6720 = async (themeId)=>{
        if ((themeId === 'light' || themeId === 'dark') && (0, $iDwTy.fg)('platform-component-visual-refresh')) themeId += '-brand-refresh';
        const { default: themeCss } = await (0, $gqQd4.default)[themeId]();
        return themeCss;
    };
    const $b4f8eba4f4c15e66$export$bb1e815119d30f8b = '(prefers-color-scheme: dark)';
    const $b4f8eba4f4c15e66$export$8662df6937d86fcb = '(prefers-contrast: more)';
});
parcelRegister("gqQd4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$85fcbf5453a51d88$export$2e2bcd8739ae039);
    const $85fcbf5453a51d88$var$themeImportsMap = {
        'light': ()=>(parcelRequire("ktAJT")),
        'light-future': ()=>(parcelRequire("d9vMG")),
        'light-increased-contrast': ()=>(parcelRequire("6udhe")),
        'dark': ()=>(parcelRequire("gqbZg")),
        'dark-future': ()=>(parcelRequire("kgWo8")),
        'dark-increased-contrast': ()=>(parcelRequire("bhuLz")),
        'legacy-light': ()=>(parcelRequire("fzp5C")),
        'legacy-dark': ()=>(parcelRequire("lkYIY")),
        'spacing': ()=>(parcelRequire("kWsKM")),
        'typography-adg3': ()=>(parcelRequire("kZWxh")),
        'shape': ()=>(parcelRequire("7J0j0")),
        'typography-modernized': ()=>(parcelRequire("9Glyd")),
        'typography-refreshed': ()=>(parcelRequire("99HCY")),
        'light-brand-refresh': ()=>(parcelRequire("eYBKm")),
        'dark-brand-refresh': ()=>(parcelRequire("eZeVz"))
    };
    var $85fcbf5453a51d88$export$2e2bcd8739ae039 = $85fcbf5453a51d88$var$themeImportsMap;
});
parcelRegister("ktAJT", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("gNSBY").then(()=>parcelRequire('74QHn'));
});
parcelRegister("d1Cng", function(module, exports) {
    "use strict";
    function $97b922b3683b5ed5$var$load(id) {
        return import((parcelRequire("2MVa4")).resolve(id));
    }
    module.exports = $97b922b3683b5ed5$var$load;
});
parcelRegister("2MVa4", function(module, exports) {
    $parcel$export(module.exports, "register", ()=>$207c67878e5e04f0$export$6503ec6e8aabbaf, (v)=>$207c67878e5e04f0$export$6503ec6e8aabbaf = v);
    $parcel$export(module.exports, "resolve", ()=>$207c67878e5e04f0$export$f7ad0328861e2f03, (v)=>$207c67878e5e04f0$export$f7ad0328861e2f03 = v);
    var $207c67878e5e04f0$export$6503ec6e8aabbaf;
    var $207c67878e5e04f0$export$f7ad0328861e2f03;
    "use strict";
    var $207c67878e5e04f0$var$mapping = new Map();
    function $207c67878e5e04f0$var$register(baseUrl, manifest) {
        for(var i = 0; i < manifest.length - 1; i += 2)$207c67878e5e04f0$var$mapping.set(manifest[i], {
            baseUrl: baseUrl,
            path: manifest[i + 1]
        });
    }
    function $207c67878e5e04f0$var$resolve(id) {
        var resolved = $207c67878e5e04f0$var$mapping.get(id);
        if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
        return new URL(resolved.path, resolved.baseUrl).toString();
    }
    $207c67878e5e04f0$export$6503ec6e8aabbaf = $207c67878e5e04f0$var$register;
    $207c67878e5e04f0$export$f7ad0328861e2f03 = $207c67878e5e04f0$var$resolve;
});
parcelRegister("d9vMG", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("a4U34").then(()=>parcelRequire('blKxS'));
});
parcelRegister("6udhe", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("dJvET").then(()=>parcelRequire('2tFaK'));
});
parcelRegister("gqbZg", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("5GmqK").then(()=>parcelRequire('33Hzr'));
});
parcelRegister("kgWo8", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("dvhh4").then(()=>parcelRequire('kWNau'));
});
parcelRegister("bhuLz", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("fGos4").then(()=>parcelRequire('k32mh'));
});
parcelRegister("fzp5C", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("hxiFk").then(()=>parcelRequire('3r7CU'));
});
parcelRegister("lkYIY", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("jFAaH").then(()=>parcelRequire('lswPe'));
});
parcelRegister("kWsKM", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("7k84S").then(()=>parcelRequire('5Rofb'));
});
parcelRegister("kZWxh", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("bNMeM").then(()=>parcelRequire('aYVaG'));
});
parcelRegister("7J0j0", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("4Cjvt").then(()=>parcelRequire('6mzGT'));
});
parcelRegister("9Glyd", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("aiZV2").then(()=>parcelRequire('03yQx'));
});
parcelRegister("99HCY", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("eYgZi").then(()=>parcelRequire('jl9fO'));
});
parcelRegister("eYBKm", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("dn2lA").then(()=>parcelRequire('dHMwi'));
});
parcelRegister("eZeVz", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("fpWOt").then(()=>parcelRequire('8QfML'));
});
parcelRegister("gv16e", function(module, exports) {
    $parcel$export(module.exports, "findMissingCustomStyleElements", ()=>$4edbf4759b2ef47c$export$bd1ac9300b0e885a);
    $parcel$export(module.exports, "limitSizeOfCustomStyleElements", ()=>$4edbf4759b2ef47c$export$e7ae172320e03461);
    $parcel$export(module.exports, "reduceTokenMap", ()=>$4edbf4759b2ef47c$export$e673f367da2ff23e);
    var $j3Zft = parcelRequire("j3Zft");
    var $1e6Pr = parcelRequire("1e6Pr");
    var $ahVol = parcelRequire("ahVol");
    function $4edbf4759b2ef47c$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
        const optionString = JSON.stringify(UNSAFE_themeOptions);
        const uniqueId = (0, $ahVol.hash)(optionString);
        const attrOfMissingCustomStyles = [];
        (mode === 'auto' ? [
            'light',
            'dark'
        ] : [
            mode
        ]).forEach((themeId)=>{
            const element = document.head.querySelector(`style[${(0, $1e6Pr.CUSTOM_THEME_ATTRIBUTE)}="${uniqueId}"][${(0, $1e6Pr.THEME_DATA_ATTRIBUTE)}="${themeId}"]`);
            if (element) document.head.appendChild(element);
            else attrOfMissingCustomStyles.push(themeId);
        });
        return attrOfMissingCustomStyles;
    }
    function $4edbf4759b2ef47c$export$e7ae172320e03461(sizeThreshold) {
        const styleTags = [
            ...Array.from(document.head.querySelectorAll(`style[${(0, $1e6Pr.CUSTOM_THEME_ATTRIBUTE)}][${(0, $1e6Pr.THEME_DATA_ATTRIBUTE)}]`))
        ];
        if (styleTags.length < sizeThreshold) return;
        styleTags.slice(0, styleTags.length - (sizeThreshold - 1)).forEach((element)=>element.remove());
    }
    function $4edbf4759b2ef47c$export$e673f367da2ff23e(tokenMap, themeRamp) {
        return Object.entries(tokenMap).reduce((acc, [key, value])=>{
            const cssVar = (0, $j3Zft.default)[key];
            return cssVar ? `${acc}\n  ${cssVar}: ${typeof value === 'string' ? value : themeRamp[value]};` : acc;
        }, '');
    }
});
parcelRegister("4lQeX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$86aa3f54f7b8a118$export$2e2bcd8739ae039);
    var $iDwTy = parcelRequire("iDwTy");
    var $5BDgX = parcelRequire("5BDgX");
    var $gfKcO = parcelRequire("gfKcO");
    var $6mLsk = parcelRequire("6mLsk");
    var $gv16e = parcelRequire("gv16e");
    var $iMHir = parcelRequire("iMHir");
    var $2sAUE = parcelRequire("2sAUE");
    const $86aa3f54f7b8a118$var$setGlobalTheme = async ({ colorMode: colorMode = (0, $5BDgX.themeStateDefaults)['colorMode'], contrastMode: contrastMode = (0, $5BDgX.themeStateDefaults)['contrastMode'], dark: dark = (0, $5BDgX.themeStateDefaults)['dark'], light: light = (0, $5BDgX.themeStateDefaults)['light'], shape: shape = (0, $5BDgX.themeStateDefaults)['shape'], spacing: spacing = (0, $5BDgX.themeStateDefaults)['spacing'], typography: typography = (0, $5BDgX.themeStateDefaults)['typography'], UNSAFE_themeOptions: UNSAFE_themeOptions = (0, $5BDgX.themeStateDefaults)['UNSAFE_themeOptions'] } = {}, themeLoader)=>{
        if (!(0, $iDwTy.fg)('platform_increased-contrast-themes')) {
            if (light === 'light-increased-contrast') light = 'light';
            if (dark === 'dark-increased-contrast') dark = 'dark';
        }
        const themeState = {
            colorMode: colorMode,
            contrastMode: contrastMode,
            dark: dark,
            light: light,
            shape: shape,
            spacing: spacing,
            typography: typography,
            UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
        };
        let themePreferences = (0, $iMHir.getThemePreferences)(themeState);
        const loadingStrategy = themeLoader ? themeLoader : (0, $2sAUE.loadAndAppendThemeCss);
        const loadingTasks = themePreferences.map(async (themeId)=>await loadingStrategy(themeId));
        if (!themeLoader && UNSAFE_themeOptions && (0, $gfKcO.isValidBrandHex)(UNSAFE_themeOptions?.brandColor)) {
            const mode = colorMode || (0, $5BDgX.themeStateDefaults)['colorMode'];
            const attrOfMissingCustomStyles = (0, $gv16e.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
            if (attrOfMissingCustomStyles.length > 0) loadingTasks.push((async ()=>{
                const { loadAndAppendCustomThemeCss: loadAndAppendCustomThemeCss } = await (parcelRequire("95X4x"));
                loadAndAppendCustomThemeCss({
                    colorMode: attrOfMissingCustomStyles.length === 2 ? 'auto' : attrOfMissingCustomStyles[0],
                    UNSAFE_themeOptions: UNSAFE_themeOptions
                });
            })());
        }
        await Promise.all(loadingTasks);
        const themeOverridePreferences = (0, $iMHir.getThemeOverridePreferences)(themeState);
        for (const themeId of themeOverridePreferences)await loadingStrategy(themeId);
        const autoUnbind = (0, $6mLsk.default)(themeState);
        return autoUnbind;
    };
    var $86aa3f54f7b8a118$export$2e2bcd8739ae039 = $86aa3f54f7b8a118$var$setGlobalTheme;
});
parcelRegister("6mLsk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$604552fda79778b9$export$2e2bcd8739ae039);
    var $iDwTy = parcelRequire("iDwTy");
    var $57Hsq = parcelRequire("57Hsq");
    var $9B9LF = parcelRequire("9B9LF");
    var $i4Kdo = parcelRequire("i4Kdo");
    function $604552fda79778b9$export$2e2bcd8739ae039(themeState) {
        if (themeState.colorMode === 'auto') {
            themeState.colorMode = (0, $9B9LF.default).getColorMode();
            (0, $9B9LF.default).bind();
        } else (0, $9B9LF.default).unbind();
        if ((0, $iDwTy.fg)('platform_increased-contrast-themes')) {
            if (themeState.contrastMode === 'auto') {
                themeState.contrastMode = (0, $i4Kdo.default).getContrastMode();
                (0, $i4Kdo.default).bind();
            } else (0, $i4Kdo.default).unbind();
        }
        const themeAttributes = (0, $57Hsq.default)(themeState);
        Object.entries(themeAttributes).forEach(([key, value])=>{
            document.documentElement.setAttribute(key, value);
        });
        return ()=>{
            (0, $9B9LF.default).unbind();
            if ((0, $iDwTy.fg)('platform_increased-contrast-themes')) (0, $i4Kdo.default).unbind();
        };
    }
});
parcelRegister("9B9LF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fcb283d56b067dcc$export$2e2bcd8739ae039);
    var $74BVL = parcelRequire("74BVL");
    var $1e6Pr = parcelRequire("1e6Pr");
    var $2sAUE = parcelRequire("2sAUE");
    const $fcb283d56b067dcc$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
    function $fcb283d56b067dcc$var$checkNativeListener(e) {
        const element = document.documentElement;
        element.setAttribute((0, $1e6Pr.COLOR_MODE_ATTRIBUTE), e.matches ? 'dark' : 'light');
    }
    const $fcb283d56b067dcc$var$darkModeMql = $fcb283d56b067dcc$var$isMatchMediaAvailable && window.matchMedia((0, $2sAUE.darkModeMediaQuery));
    class $fcb283d56b067dcc$var$ColorModeObserver {
        getColorMode() {
            if (!$fcb283d56b067dcc$var$darkModeMql) return 'light';
            return $fcb283d56b067dcc$var$darkModeMql?.matches ? 'dark' : 'light';
        }
        bind() {
            if ($fcb283d56b067dcc$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $74BVL.bind)($fcb283d56b067dcc$var$darkModeMql, {
                type: 'change',
                listener: $fcb283d56b067dcc$var$checkNativeListener
            });
        }
        unbind() {
            if (this.unbindThemeChangeListener) {
                this.unbindThemeChangeListener();
                this.unbindThemeChangeListener = null;
            }
        }
        constructor(){
            this.unbindThemeChangeListener = null;
        }
    }
    const $fcb283d56b067dcc$var$SingletonColorModeObserver = new $fcb283d56b067dcc$var$ColorModeObserver();
    var $fcb283d56b067dcc$export$2e2bcd8739ae039 = $fcb283d56b067dcc$var$SingletonColorModeObserver;
});
parcelRegister("i4Kdo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cefebcd023449224$export$2e2bcd8739ae039);
    var $74BVL = parcelRequire("74BVL");
    var $1e6Pr = parcelRequire("1e6Pr");
    var $2sAUE = parcelRequire("2sAUE");
    const $cefebcd023449224$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
    function $cefebcd023449224$var$checkNativeListener(e) {
        const element = document.documentElement;
        element.setAttribute((0, $1e6Pr.CONTRAST_MODE_ATTRIBUTE), e.matches ? 'more' : 'no-preference');
    }
    const $cefebcd023449224$var$contrastModeMql = $cefebcd023449224$var$isMatchMediaAvailable && window.matchMedia((0, $2sAUE.moreContrastMediaQuery));
    class $cefebcd023449224$var$ContrastModeObserver {
        getContrastMode() {
            if (!$cefebcd023449224$var$contrastModeMql) return 'no-preference';
            return $cefebcd023449224$var$contrastModeMql?.matches ? 'more' : 'no-preference';
        }
        bind() {
            if ($cefebcd023449224$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $74BVL.bind)($cefebcd023449224$var$contrastModeMql, {
                type: 'change',
                listener: $cefebcd023449224$var$checkNativeListener
            });
        }
        unbind() {
            if (this.unbindContrastChangeListener) {
                this.unbindContrastChangeListener();
                this.unbindContrastChangeListener = null;
            }
        }
        constructor(){
            this.unbindContrastChangeListener = null;
        }
    }
    const $cefebcd023449224$var$SingletonContrastModeObserver = new $cefebcd023449224$var$ContrastModeObserver();
    var $cefebcd023449224$export$2e2bcd8739ae039 = $cefebcd023449224$var$SingletonContrastModeObserver;
});
parcelRegister("95X4x", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("hBxVj").then(()=>parcelRequire('61Grw'));
});
parcelRegister("3qoTC", function(module, exports) {
    $parcel$export(module.exports, "NestedContext", ()=>$572b9cb6274c0e52$export$46b2c2071c8c725a);
    $parcel$export(module.exports, "useNestedContext", ()=>$572b9cb6274c0e52$export$f24166abe9ed712b);
    $parcel$export(module.exports, "useShouldNestedElementRender", ()=>$572b9cb6274c0e52$export$37e8646a1abfc3e6);
    var $eUqFw = parcelRequire("eUqFw");
    const $572b9cb6274c0e52$export$46b2c2071c8c725a = (0, $eUqFw.createContext)(undefined);
    const $572b9cb6274c0e52$export$f24166abe9ed712b = ()=>{
        const context = (0, $eUqFw.useContext)($572b9cb6274c0e52$export$46b2c2071c8c725a);
        if (!context) {
            let error = '';
            throw new Error(error);
        }
        return context;
    };
    const $572b9cb6274c0e52$export$37e8646a1abfc3e6 = ()=>{
        const context = (0, $eUqFw.useContext)($572b9cb6274c0e52$export$46b2c2071c8c725a);
        if (!context) return {
            shouldRender: true
        };
        return {
            shouldRender: context.currentStackId === context.parentId
        };
    };
});
parcelRegister("43e5f", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2f325df11134320e$var$_react = $2f325df11134320e$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $2f325df11134320e$var$_linkExternal = $2f325df11134320e$var$_interopRequireDefault((parcelRequire("kRtpf")));
    var $2f325df11134320e$var$_shortcut = $2f325df11134320e$var$_interopRequireDefault((parcelRequire("beysv")));
    function $2f325df11134320e$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $2f325df11134320e$var$LinkExternalIcon = (props)=>$2f325df11134320e$var$_react.default.createElement($2f325df11134320e$var$_linkExternal.default, Object.assign({
            LEGACY_fallbackIcon: $2f325df11134320e$var$_shortcut.default
        }, props));
    $2f325df11134320e$var$LinkExternalIcon.Name = 'LinkExternalIconMigration';
    var $2f325df11134320e$var$_default = module.exports.default = $2f325df11134320e$var$LinkExternalIcon;
});
parcelRegister("3Q69O", function(module, exports) {
    $parcel$export(module.exports, "WidthObserver", ()=>$34efc07905c1dce2$export$b2ad68b9bc407b80);
    var $eUqFw = parcelRequire("eUqFw");
    var $cdiTE = parcelRequire("cdiTE");
    const $34efc07905c1dce2$export$b2ad68b9bc407b80 = (0, ($parcel$interopDefault($eUqFw))).memo((props)=>{
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $cdiTE.WidthDetectorObserver), {
            setWidth: props.setWidth,
            offscreen: props.offscreen
        });
    });
    var $34efc07905c1dce2$export$2e2bcd8739ae039 = $34efc07905c1dce2$export$b2ad68b9bc407b80;
});
parcelRegister("cdiTE", function(module, exports) {
    $parcel$export(module.exports, "WidthDetectorObserver", ()=>$2053b235a6efbcab$export$ff983d2a2b6112ea);
    var $eUqFw = parcelRequire("eUqFw");
    var $Xq13a = parcelRequire("Xq13a");
    const $2053b235a6efbcab$export$ff983d2a2b6112ea = (0, ($parcel$interopDefault($eUqFw))).memo(({ setWidth: setWidth, offscreen: offscreen })=>{
        const [inViewRef, inView, target] = (0, $Xq13a.useInView)({
            threshold: 0
        });
        const observer = (0, ($parcel$interopDefault($eUqFw))).useRef(()=>{
            if (typeof window === 'undefined') return null;
            return new ResizeObserver((entries)=>{
                if (!Array.isArray(entries) || !entries.length) return;
                const { width: width } = entries[0].contentRect;
                setWidth(Math.round(width));
            });
        });
        (0, ($parcel$interopDefault($eUqFw))).useEffect(()=>{
            const { current: currentObserver } = observer;
            const resizeObserver = currentObserver();
            if (resizeObserver === null) return;
            if (target) {
                if (inView || offscreen) resizeObserver.observe(target);
                else resizeObserver.unobserve(target);
            }
            return ()=>{
                resizeObserver.disconnect();
            };
        }, [
            target,
            inView,
            offscreen
        ]);
        return (0, ($parcel$interopDefault($eUqFw))).createElement("div", {
            style: {
                display: 'block',
                width: '100%',
                position: 'absolute'
            },
            ref: inViewRef
        });
    });
});
parcelRegister("Xq13a", function(module, exports) {
    $parcel$export(module.exports, "useInView", ()=>$bbae618c31088dc8$export$2f62ee6831462844);
    var $eUqFw = parcelRequire("eUqFw");
    function $bbae618c31088dc8$export$2f62ee6831462844(options = {}) {
        const ref = (0, ($parcel$interopDefault($eUqFw))).useRef();
        const observerInstance = (0, ($parcel$interopDefault($eUqFw))).useRef();
        const [state, setState] = (0, ($parcel$interopDefault($eUqFw))).useState({
            inView: false,
            entry: undefined,
            target: undefined
        });
        const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
        const setRef = (0, ($parcel$interopDefault($eUqFw))).useCallback((node)=>{
            observerInstance.current = new IntersectionObserver((entries)=>{
                if (entries && entries.length) {
                    const intersection = entries[0];
                    const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                    if (intersectionRatio >= 0) {
                        const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                        let inView = intersectionRatio >= numericThreshold;
                        if (isIntersecting !== undefined) inView = inView && isIntersecting;
                        setState({
                            inView: inView,
                            entry: intersection,
                            target: node
                        });
                    }
                }
            }, {
                threshold: threshold,
                root: root,
                rootMargin: rootMargin
            });
            if (ref.current) observerInstance.current.unobserve(ref.current);
            if (node) observerInstance.current.observe(node);
            ref.current = node;
        }, [
            threshold,
            root,
            rootMargin
        ]);
        (0, ($parcel$interopDefault($eUqFw))).useEffect(()=>{
            return ()=>{
                if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
            };
        }, []);
        return [
            setRef,
            state.inView,
            state.target,
            state.entry
        ];
    }
});
parcelRegister("jGlqG", function(module, exports) {
    $parcel$export(module.exports, "JiraProductDiscoveryIcon", ()=>$fe77bf3b90491ec3$export$21bfbeb62fdcce8d);
    var $eUqFw = parcelRequire("eUqFw");
    var $fjjRQ = parcelRequire("fjjRQ");
    var $gT5pi = parcelRequire("gT5pi");
    var $fxki0 = parcelRequire("fxki0");
    var $3Dx41 = parcelRequire("3Dx41");
    const $fe77bf3b90491ec3$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
        let colors = {
            iconColor: iconColor
        };
        if (appearance) colors = (0, $fxki0.getColorsFromAppearance)(appearance, colorMode);
        return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M17.655 5.884a15.3 15.3 0 0 0 8.75 0c.257-.056.428.114.37.37-.826 2.985-.826 5.742 0 8.727.058.228-.113.427-.37.342a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.342.77-2.985.77-5.742 0-8.727-.086-.256.114-.426.342-.37m1.169 10.576v.483c0 2.246-1.568 3.894-3.506 3.894a3.474 3.474 0 0 1-3.477-3.496c0-1.933 1.567-3.468 3.762-3.468h.57V7.078c-.285-.028-.57-.028-.855-.028C9.618 7.05 5 11.655 5 17.37c0 5.713 4.617 10.29 10.318 10.29s10.346-4.605 10.346-10.29v-.91z"/>
    </svg>`;
    };
    const $fe77bf3b90491ec3$export$21bfbeb62fdcce8d = ({ appearance: appearance, label: label = 'Jira Product Discovery', size: size = (0, $gT5pi.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $gT5pi.defaultLogoParams).iconColor, textColor: textColor = (0, $gT5pi.defaultLogoParams).textColor })=>{
        const { colorMode: colorMode } = (0, $fjjRQ.default)();
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $3Dx41.default), {
            appearance: appearance,
            label: label,
            svg: $fe77bf3b90491ec3$var$svg({
                appearance: appearance,
                iconColor: iconColor
            }, colorMode),
            iconColor: iconColor,
            size: size,
            testId: testId,
            textColor: textColor
        });
    };
});
parcelRegister("fhC0U", function(module, exports) {
    $parcel$export(module.exports, "JiraServiceManagementIcon", ()=>$f97cd7168ad2e5e8$export$3c6158790f5e01c4);
    var $eUqFw = parcelRequire("eUqFw");
    var $fjjRQ = parcelRequire("fjjRQ");
    var $gT5pi = parcelRequire("gT5pi");
    var $fxki0 = parcelRequire("fxki0");
    var $3Dx41 = parcelRequire("3Dx41");
    const $f97cd7168ad2e5e8$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
        let colors = {
            iconColor: iconColor
        };
        if (appearance) colors = (0, $fxki0.getColorsFromAppearance)(appearance, colorMode);
        return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} d="M18.79 13.257h7.325c1.1 0 1.476 1.046.805 1.878L15.464 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H5.806c-1.1 0-1.476-1.046-.805-1.878L16.457 2.874c3.702 2.951 3.3 7.566.617 11z"/>
    </svg>`;
    };
    const $f97cd7168ad2e5e8$export$3c6158790f5e01c4 = ({ appearance: appearance, label: label = 'Jira Service Management', size: size = (0, $gT5pi.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $gT5pi.defaultLogoParams).iconColor, textColor: textColor = (0, $gT5pi.defaultLogoParams).textColor })=>{
        const { colorMode: colorMode } = (0, $fjjRQ.default)();
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $3Dx41.default), {
            appearance: appearance,
            label: label,
            svg: $f97cd7168ad2e5e8$var$svg({
                appearance: appearance,
                iconColor: iconColor
            }, colorMode),
            iconColor: iconColor,
            size: size,
            testId: testId,
            textColor: textColor
        });
    };
});
parcelRegister("3b8a6", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2508bafbd2c7600f$var$_react = $2508bafbd2c7600f$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $2508bafbd2c7600f$var$_chevronRight = $2508bafbd2c7600f$var$_interopRequireDefault((parcelRequire("8cNUp")));
    var $2508bafbd2c7600f$var$_chevronRight2 = $2508bafbd2c7600f$var$_interopRequireDefault((parcelRequire("bsCiU")));
    function $2508bafbd2c7600f$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $2508bafbd2c7600f$var$ChevronRightIcon = (props)=>$2508bafbd2c7600f$var$_react.default.createElement($2508bafbd2c7600f$var$_chevronRight.default, Object.assign({
            LEGACY_fallbackIcon: $2508bafbd2c7600f$var$_chevronRight2.default
        }, props));
    $2508bafbd2c7600f$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
    var $2508bafbd2c7600f$var$_default = module.exports.default = $2508bafbd2c7600f$var$ChevronRightIcon;
});
parcelRegister("FSQzJ", function(module, exports) {
    $parcel$export(module.exports, "HasCustomThemeContext", ()=>$4b1636a34f7d7cb9$export$d158fa15757a1890);
    $parcel$export(module.exports, "useHasCustomTheme", ()=>$4b1636a34f7d7cb9$export$abfcaeeca4ae7a55);
    var $eUqFw = parcelRequire("eUqFw");
    const $4b1636a34f7d7cb9$export$d158fa15757a1890 = (0, $eUqFw.createContext)(false);
    function $4b1636a34f7d7cb9$export$abfcaeeca4ae7a55() {
        return (0, $eUqFw.useContext)($4b1636a34f7d7cb9$export$d158fa15757a1890);
    }
});
parcelRegister("jOo2r", function(module, exports) {
    $parcel$export(module.exports, "themedLogoIcon", ()=>$309ce93adfc9b40d$export$24328117f1132113);
    $parcel$export(module.exports, "themedLogoText", ()=>$309ce93adfc9b40d$export$91b0830f8f4ab279);
    $parcel$export(module.exports, "NavLogo", ()=>$309ce93adfc9b40d$export$b6394419753329e);
    var $7JEyt = parcelRequire("7JEyt");
    var $eUqFw = parcelRequire("eUqFw");
    var $a5MxG = parcelRequire("a5MxG");
    var $FSQzJ = parcelRequire("FSQzJ");
    const $309ce93adfc9b40d$export$24328117f1132113 = '--ds-top-bar-logo-icon';
    const $309ce93adfc9b40d$export$91b0830f8f4ab279 = '--ds-top-bar-logo-text';
    const $309ce93adfc9b40d$var$navLogoStyles = {
        root: "_1e0c1txw _4cvr1h6o _4t3izwfg _2rkoiti9",
        icon: "_1e0c1txw _18zr1b66 _10y4glyw",
        logo: "_1e0cglyw _18zru2gc _10y41txw"
    };
    const $309ce93adfc9b40d$export$b6394419753329e = ({ href: href, logo: logo, icon: icon, onClick: onClick, label: label = 'Home' })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $a5MxG.default), {
            "aria-label": label,
            href: href,
            xcss: $309ce93adfc9b40d$var$navLogoStyles.root,
            onClick: onClick
        }, (0, ($parcel$interopDefault($eUqFw))).createElement("div", {
            className: (0, $7JEyt.default)([
                $309ce93adfc9b40d$var$navLogoStyles.icon
            ])
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($309ce93adfc9b40d$var$NavLogoRenderer, {
            logoOrIcon: icon
        })), (0, ($parcel$interopDefault($eUqFw))).createElement("div", {
            className: (0, $7JEyt.default)([
                $309ce93adfc9b40d$var$navLogoStyles.logo
            ])
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($309ce93adfc9b40d$var$NavLogoRenderer, {
            logoOrIcon: logo
        })));
    function $309ce93adfc9b40d$var$NavLogoRenderer({ logoOrIcon: LogoOrIcon }) {
        const hasCustomTheme = (0, $FSQzJ.useHasCustomTheme)();
        if (hasCustomTheme) return (0, ($parcel$interopDefault($eUqFw))).createElement(LogoOrIcon, {
            size: "small",
            label: "",
            iconColor: `var(${$309ce93adfc9b40d$export$24328117f1132113})`,
            textColor: `var(${$309ce93adfc9b40d$export$91b0830f8f4ab279})`
        });
        return (0, ($parcel$interopDefault($eUqFw))).createElement(LogoOrIcon, {
            size: "small",
            label: "",
            appearance: "brand"
        });
    }
});
parcelRegister("kWJMs", function(module, exports) {
    $parcel$export(module.exports, "themedButtonBackground", ()=>$8247e12e0875f303$export$b93b81aa41a8061a);
    $parcel$export(module.exports, "themedButtonBackgroundHovered", ()=>$8247e12e0875f303$export$96a2312c81489aa1);
    $parcel$export(module.exports, "themedButtonBackgroundPressed", ()=>$8247e12e0875f303$export$9db7a918ddfed23e);
    $parcel$export(module.exports, "themedButtonBorder", ()=>$8247e12e0875f303$export$2b00bded80635cbb);
    $parcel$export(module.exports, "themedButtonPrimaryText", ()=>$8247e12e0875f303$export$eca746d7c1a9cd6e);
    $parcel$export(module.exports, "themedButtonPrimaryBackground", ()=>$8247e12e0875f303$export$2c2bc298cddb8aca);
    $parcel$export(module.exports, "themedButtonPrimaryBackgroundHovered", ()=>$8247e12e0875f303$export$6b28e650669cd3c7);
    $parcel$export(module.exports, "themedButtonPrimaryBackgroundPressed", ()=>$8247e12e0875f303$export$1656be06aad539b9);
    $parcel$export(module.exports, "themedButtonSelectedText", ()=>$8247e12e0875f303$export$c26a897d419ef487);
    $parcel$export(module.exports, "themedButtonSelectedBackground", ()=>$8247e12e0875f303$export$4e50e625ccffdb13);
    $parcel$export(module.exports, "themedButtonSelectedBackgroundHovered", ()=>$8247e12e0875f303$export$55c84c90f36bda4d);
    $parcel$export(module.exports, "themedButtonSelectedBackgroundPressed", ()=>$8247e12e0875f303$export$c5c0213472126c08);
    $parcel$export(module.exports, "ThemedButton", ()=>$8247e12e0875f303$export$f67fb575035cc7d0);
    $parcel$export(module.exports, "ThemedIconButton", ()=>$8247e12e0875f303$export$d9c2d067feb61447);
    var $eUqFw = parcelRequire("eUqFw");
    var $7JEyt = parcelRequire("7JEyt");
    var $2Eyt5 = parcelRequire("2Eyt5");
    var $23gMr = parcelRequire("23gMr");
    var $cmipe = parcelRequire("cmipe");
    var $62Dwb = parcelRequire("62Dwb");
    const $8247e12e0875f303$export$b93b81aa41a8061a = '--ds-top-bar-button-background';
    const $8247e12e0875f303$export$96a2312c81489aa1 = '--ds-top-bar-button-background-hovered';
    const $8247e12e0875f303$export$9db7a918ddfed23e = '--ds-top-bar-button-background-pressed';
    const $8247e12e0875f303$export$2b00bded80635cbb = '--ds-top-bar-button-border';
    const $8247e12e0875f303$export$eca746d7c1a9cd6e = '--ds-top-bar-button-primary-text';
    const $8247e12e0875f303$export$2c2bc298cddb8aca = '--ds-top-bar-button-primary-background';
    const $8247e12e0875f303$export$6b28e650669cd3c7 = '--ds-top-bar-button-primary-background-hovered';
    const $8247e12e0875f303$export$1656be06aad539b9 = '--ds-top-bar-button-primary-background-pressed';
    const $8247e12e0875f303$export$c26a897d419ef487 = '--ds-top-bar-button-selected-text';
    const $8247e12e0875f303$export$4e50e625ccffdb13 = '--ds-top-bar-button-selected-background';
    const $8247e12e0875f303$export$55c84c90f36bda4d = '--ds-top-bar-button-selected-background-hovered';
    const $8247e12e0875f303$export$c5c0213472126c08 = '--ds-top-bar-button-selected-background-pressed';
    const $8247e12e0875f303$var$styles = {
        root: "_1e0c1txw _zulp1b66 _4cvr1h6o _1bah1h6o _11c81oud _4t3i5r7u _1rjcze3t _2rkosqtm _v5649dqc _kqswh2mm",
        border: "_aetrb3bt _14mj1kw7 _1tv3nqa1 _39yqe4h9 _18postnw _9v7aze3t",
        selected: "_syazw5ct _11q71qds _8l3m1yqz _19lcjrv1 _j6xtnh62",
        hasIconBefore: "_bozgu2gc",
        iconBefore: "_bozg1b66 _y4tiv77o _vwz4idpf",
        text: "_k48p1wq8",
        textButton: "_18zrutpp",
        iconButton: "_1bsb5r7u _18zrze3t _vwz4idpf"
    };
    const $8247e12e0875f303$var$appearanceStyles = {
        default: "_syaz1r31 _11q7pkxg _8l3maykr _19lc1rps _j6xtqtgh",
        subtle: "_syaz1r31 _11q7pkxg _19lc1rps _j6xtqtgh",
        primary: "_syaz15o7 _11q7esko _19lcp6hf _j6xt5sko"
    };
    const $8247e12e0875f303$var$BaseThemedButton = (0, $eUqFw.forwardRef)(function BaseThemedButton({ appearance: appearance = 'default', type: type, onClick: onClick, isSelected: isSelected, interactionName: interactionName, testId: testId, iconBefore: IconBefore, children: children }, ref) {
        const isTextButton = type === 'Button';
        const isIconButton = type === 'IconButton';
        const hasBorder = appearance === 'default' || isSelected;
        return $eUqFw.createElement((0, $23gMr.default), {
            ref: ref,
            xcss: (0, $2Eyt5.cx)($8247e12e0875f303$var$styles.root, isTextButton && $8247e12e0875f303$var$styles.textButton, isIconButton && $8247e12e0875f303$var$styles.iconButton, hasBorder && $8247e12e0875f303$var$styles.border, $8247e12e0875f303$var$appearanceStyles[appearance], isSelected && $8247e12e0875f303$var$styles.selected, IconBefore && $8247e12e0875f303$var$styles.hasIconBefore),
            onClick: onClick,
            interactionName: interactionName,
            testId: testId
        }, IconBefore && $eUqFw.createElement("span", {
            className: (0, $7JEyt.default)([
                $8247e12e0875f303$var$styles.iconBefore
            ])
        }, $eUqFw.createElement(IconBefore, {
            label: "",
            color: "currentColor"
        })), isTextButton ? $eUqFw.createElement("span", {
            className: (0, $7JEyt.default)([
                $8247e12e0875f303$var$styles.text
            ])
        }, children) : children);
    });
    const $8247e12e0875f303$export$f67fb575035cc7d0 = (0, $eUqFw.forwardRef)(function ThemedButton({ appearance: appearance = 'default', iconBefore: iconBefore, children: children, onClick: onClick, isSelected: isSelected, interactionName: interactionName, testId: testId }, ref) {
        return $eUqFw.createElement($8247e12e0875f303$var$BaseThemedButton, {
            type: "Button",
            ref: ref,
            appearance: appearance,
            onClick: onClick,
            interactionName: interactionName,
            testId: testId,
            iconBefore: iconBefore,
            isSelected: isSelected
        }, children);
    });
    const $8247e12e0875f303$export$d9c2d067feb61447 = (0, $eUqFw.forwardRef)(function ThemedIconButton({ appearance: appearance = 'default', icon: Icon, label: label, onClick: onClick, isSelected: isSelected, interactionName: interactionName, testId: testId }, ref) {
        return ($eUqFw.createElement((0, $cmipe.default), {
            content: label
        }, $eUqFw.createElement($8247e12e0875f303$var$BaseThemedButton, {
            ref: ref,
            onClick: onClick,
            type: "IconButton",
            appearance: appearance,
            interactionName: interactionName,
            testId: testId,
            isSelected: isSelected
        }, $eUqFw.createElement(Icon, {
            label: "",
            color: "currentColor"
        }), $eUqFw.createElement((0, $62Dwb.default), null, label))));
    });
});
parcelRegister("43iGG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2fcdd8c3d6c05ccc$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $3P7YC = parcelRequire("3P7YC");
    var $fHiYa = parcelRequire("fHiYa");
    function $2fcdd8c3d6c05ccc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $2fcdd8c3d6c05ccc$var$gridTemplateAreasVar = '--ds-grid--grid-template-areas';
    const $2fcdd8c3d6c05ccc$var$gridTemplateColumnsVar = '--ds-grid--grid-template-columns';
    const $2fcdd8c3d6c05ccc$var$gridTemplateRowsVar = '--ds-grid--grid-template-rows';
    const $2fcdd8c3d6c05ccc$var$justifyContentMap = {
        start: {
            name: "j1lm6p",
            styles: "justify-content:start"
        },
        center: {
            name: "f7ay7b",
            styles: "justify-content:center"
        },
        end: {
            name: "jab4lt",
            styles: "justify-content:end"
        },
        'space-between': {
            name: "2o6p8u",
            styles: "justify-content:space-between"
        },
        'space-around': {
            name: "46cjum",
            styles: "justify-content:space-around"
        },
        'space-evenly': {
            name: "16166rn",
            styles: "justify-content:space-evenly"
        },
        stretch: {
            name: "11z2bqs",
            styles: "justify-content:stretch"
        }
    };
    const $2fcdd8c3d6c05ccc$var$justifyItemsMap = {
        start: {
            name: "lno2ya",
            styles: "justify-items:start"
        },
        center: {
            name: "1wg53za",
            styles: "justify-items:center"
        },
        end: {
            name: "3f7lhf",
            styles: "justify-items:end"
        },
        stretch: {
            name: "16hnylu",
            styles: "justify-items:stretch"
        }
    };
    const $2fcdd8c3d6c05ccc$var$alignContentMap = {
        start: {
            name: "iqu4as",
            styles: "align-content:start"
        },
        center: {
            name: "13vy23x",
            styles: "align-content:center"
        },
        end: {
            name: "1fj2toh",
            styles: "align-content:end"
        },
        'space-between': {
            name: "1pem0lx",
            styles: "align-content:space-between"
        },
        'space-around': {
            name: "127p7gk",
            styles: "align-content:space-around"
        },
        'space-evenly': {
            name: "kcqjal",
            styles: "align-content:space-evenly"
        },
        stretch: {
            name: "1f8yzab",
            styles: "align-content:stretch"
        }
    };
    const $2fcdd8c3d6c05ccc$var$alignItemsMap = {
        start: {
            name: "yvwru5",
            styles: "align-items:start"
        },
        center: {
            name: "1h3rtzg",
            styles: "align-items:center"
        },
        baseline: {
            name: "fzr848",
            styles: "align-items:baseline"
        },
        end: {
            name: "uj5xqj",
            styles: "align-items:end"
        }
    };
    const $2fcdd8c3d6c05ccc$var$baseStyles = (0, $byn9U.css)({
        display: 'grid',
        boxSizing: 'border-box',
        gridTemplateAreas: `var(${$2fcdd8c3d6c05ccc$var$gridTemplateAreasVar})`,
        gridTemplateColumns: `var(${$2fcdd8c3d6c05ccc$var$gridTemplateColumnsVar})`,
        gridTemplateRows: `var(${$2fcdd8c3d6c05ccc$var$gridTemplateRowsVar})`
    });
    const $2fcdd8c3d6c05ccc$var$gridAutoFlowMap = {
        row: {
            name: "k3yepi",
            styles: "grid-auto-flow:row"
        },
        column: {
            name: "qu4z1d",
            styles: "grid-auto-flow:column"
        },
        dense: {
            name: "mgx7bc",
            styles: "grid-auto-flow:dense"
        },
        'row dense': {
            name: "1u50cee",
            styles: "grid-auto-flow:row dense"
        },
        'column dense': {
            name: "5ak4pc",
            styles: "grid-auto-flow:column dense"
        }
    };
    const $2fcdd8c3d6c05ccc$var$Grid = (0, $eUqFw.memo)((0, $eUqFw.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, templateAreas: gridTemplateAreas, templateRows: gridTemplateRows, templateColumns: gridTemplateColumns, xcss: xcss }, ref)=>{
        const Component = as || 'div';
        const resolvedStyles = (0, $fHiYa.parseXcss)(xcss);
        const style = (0, $eUqFw.useMemo)(()=>({
                [$2fcdd8c3d6c05ccc$var$gridTemplateAreasVar]: gridTemplateAreas ? gridTemplateAreas.map((str)=>`"${str}"`).join('\n') || 'initial' : 'initial',
                [$2fcdd8c3d6c05ccc$var$gridTemplateColumnsVar]: gridTemplateColumns || 'initial',
                [$2fcdd8c3d6c05ccc$var$gridTemplateRowsVar]: gridTemplateRows || 'initial'
            }), [
            gridTemplateAreas,
            gridTemplateColumns,
            gridTemplateRows
        ]);
        return (0, $byn9U.jsx)(Component, {
            id: id,
            role: role,
            style: style,
            className: resolvedStyles.static,
            css: [
                $2fcdd8c3d6c05ccc$var$baseStyles,
                gap && (0, $3P7YC.spaceStylesMap).gap[gap],
                columnGap && (0, $3P7YC.spaceStylesMap).columnGap[columnGap],
                rowGap && (0, $3P7YC.spaceStylesMap).rowGap[rowGap],
                alignItems && $2fcdd8c3d6c05ccc$var$alignItemsMap[alignItems],
                alignContent && $2fcdd8c3d6c05ccc$var$alignContentMap[alignContent],
                justifyContent && $2fcdd8c3d6c05ccc$var$justifyContentMap[justifyContent],
                autoFlow && $2fcdd8c3d6c05ccc$var$gridAutoFlowMap[autoFlow],
                resolvedStyles.emotion
            ],
            "data-testid": testId,
            ref: ref
        }, children);
    }));
    $2fcdd8c3d6c05ccc$var$Grid.displayName = 'Grid';
    var $2fcdd8c3d6c05ccc$export$2e2bcd8739ae039 = $2fcdd8c3d6c05ccc$var$Grid;
});
parcelRegister("h8PjN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1d1eec50fba4280d$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $iDwTy = parcelRequire("iDwTy");
    var $6rYyf = parcelRequire("6rYyf");
    var $75FXO = parcelRequire("75FXO");
    const $1d1eec50fba4280d$var$SpotlightTarget = ({ children: children, name: name })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $75FXO.TargetConsumer), null, (targetRef)=>targetRef ? (0, ($parcel$interopDefault($eUqFw))).createElement((0, $6rYyf.default), {
                name: name,
                hasNodeResolver: !(0, $iDwTy.fg)('platform_design_system_team_onboarding_noderesolve'),
                targetRef: targetRef
            }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, children)) : children);
    var $1d1eec50fba4280d$export$2e2bcd8739ae039 = $1d1eec50fba4280d$var$SpotlightTarget;
});
parcelRegister("6rYyf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7c52de81783d9fa4$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $lbDTY = parcelRequire("lbDTY");
    const $7c52de81783d9fa4$var$NodeResolverSpotlightTarget = ({ hasNodeResolver: hasNodeResolver, children: children, targetRef: targetRef, name: name })=>{
        const divRef = (0, $eUqFw.useRef)(null);
        (0, $eUqFw.useEffect)(()=>{
            if (!hasNodeResolver) targetRef(name)(divRef.current?.firstElementChild);
            return ()=>{
                !hasNodeResolver && targetRef(name)(undefined);
            };
        }, [
            hasNodeResolver,
            name,
            targetRef
        ]);
        if (hasNodeResolver) return (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($lbDTY))), {
            innerRef: targetRef(name)
        }, children);
        return (0, ($parcel$interopDefault($eUqFw))).createElement("span", {
            ref: divRef
        }, children);
    };
    var $7c52de81783d9fa4$export$2e2bcd8739ae039 = $7c52de81783d9fa4$var$NodeResolverSpotlightTarget;
});
parcelRegister("2o5dJ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $1bd1df5a10694dc0$var$_react = $1bd1df5a10694dc0$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $1bd1df5a10694dc0$var$_UNSAFE_baseNew = $1bd1df5a10694dc0$var$_interopRequireDefault((parcelRequire("ay9aj")));
    function $1bd1df5a10694dc0$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1bd1df5a10694dc0$var$StarStarredIcon = (props)=>$1bd1df5a10694dc0$var$_react.default.createElement($1bd1df5a10694dc0$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" d="M6 8.917 2.597 11.25l1.07-3.986L.75 4.834l3.792-.292L6 .75l1.458 3.792 3.792.291-2.917 2.43 1.07 3.987z"/><path fill="currentcolor" d="m6 8.917.424-.619L6 8.008l-.424.29zM2.597 11.25l-.724-.194a.75.75 0 0 0 1.148.813zm1.07-3.986.724.194.124-.463-.368-.307zM.75 4.834l-.058-.748A.75.75 0 0 0 .27 5.41zm3.792-.292.057.747.473-.036.17-.442zM6 .75l.7-.27a.75.75 0 0 0-1.4 0zm1.458 3.792-.7.269.17.442.473.036zm3.792.291.48.577a.75.75 0 0 0-.423-1.324zm-2.917 2.43-.48-.575-.368.307.124.463zm1.07 3.987-.424.618a.75.75 0 0 0 1.148-.812zM5.576 8.298l-3.403 2.334.848 1.236 3.403-2.333zm-2.254 3.146L4.39 7.458 2.942 7.07l-1.07 3.986zm.825-4.756L1.23 4.258.27 5.41l2.917 2.43zM.807 5.58 4.6 5.29l-.115-1.495-3.792.292zm4.435-.77L6.7 1.019 5.3.481 3.842 4.272zM5.3 1.019l1.458 3.792 1.4-.539L6.7.481zm2.1 4.27 3.793.292.114-1.495-3.791-.292zm3.37-1.032-2.917 2.43.96 1.153 2.917-2.43zM7.609 7.458l1.07 3.986 1.448-.388-1.07-3.986zm2.218 3.174L6.424 8.298l-.848 1.237 3.403 2.333z"/>`,
            type: 'utility'
        }, props));
    $1bd1df5a10694dc0$var$StarStarredIcon.displayName = 'StarStarredIcon';
    var $1bd1df5a10694dc0$var$_default = module.exports.default = $1bd1df5a10694dc0$var$StarStarredIcon;
});
parcelRegister("2sHM3", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $1cb026ef8e697642$var$_react = $1cb026ef8e697642$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $1cb026ef8e697642$var$_search = $1cb026ef8e697642$var$_interopRequireDefault((parcelRequire("cDj3C")));
    var $1cb026ef8e697642$var$_search2 = $1cb026ef8e697642$var$_interopRequireDefault((parcelRequire("2wRVM")));
    function $1cb026ef8e697642$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1cb026ef8e697642$var$SearchIcon = (props)=>$1cb026ef8e697642$var$_react.default.createElement($1cb026ef8e697642$var$_search.default, Object.assign({
            LEGACY_fallbackIcon: $1cb026ef8e697642$var$_search2.default
        }, props));
    $1cb026ef8e697642$var$SearchIcon.Name = 'SearchIconMigration';
    var $1cb026ef8e697642$var$_default = module.exports.default = $1cb026ef8e697642$var$SearchIcon;
});
parcelRegister("a6IG6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dd5e8ea82f7f7663$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $1UaYj = parcelRequire("1UaYj");
    var $fjjRQ = parcelRequire("fjjRQ");
    function $dd5e8ea82f7f7663$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $dd5e8ea82f7f7663$var$baseImageStyles = {
        name: "1hyxgad",
        styles: "max-width:100%;height:auto"
    };
    const $dd5e8ea82f7f7663$var$themedImageStyles = (0, $byn9U.css)({
        content: `var(--img-source)`,
        'html[data-color-mode=dark] &': {
            content: `var(--img-source-dark)`
        }
    });
    function $dd5e8ea82f7f7663$export$2e2bcd8739ae039({ src: src, srcDark: srcDark, alt: alt, testId: testId, ...props }) {
        const imgRef = (0, $eUqFw.useRef)(null);
        const providedColorMode = (0, $1UaYj.UNSAFE_useColorModeForMigration)();
        const { colorMode: observedColorMode } = (0, $fjjRQ.default)();
        const colorMode = providedColorMode || observedColorMode;
        (0, $eUqFw.useEffect)(()=>{
            if (imgRef === null || imgRef.current === null) return;
            if (srcDark && colorMode === 'dark') imgRef.current.src = srcDark;
            else if (src) imgRef.current.src = src;
        }, [
            src,
            srcDark,
            colorMode
        ]);
        return (0, $byn9U.jsx)("img", {
            alt: alt,
            "data-testid": testId,
            src: src,
            style: {
                '--img-source': `url(${src})`,
                '--img-source-dark': `url(${srcDark || src})`
            },
            css: [
                $dd5e8ea82f7f7663$var$baseImageStyles,
                $dd5e8ea82f7f7663$var$themedImageStyles
            ],
            ref: imgRef,
            ...props
        });
    }
});
parcelRegister("1UaYj", function(module, exports) {
    $parcel$export(module.exports, "UNSAFE_useColorModeForMigration", ()=>$117da549012fa168$export$ce91654eb9fea460);
    $parcel$export(module.exports, "useColorMode", ()=>$117da549012fa168$export$20f3076712c8dfa);
    $parcel$export(module.exports, "default", ()=>$117da549012fa168$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $74BVL = parcelRequire("74BVL");
    var $4lQeX = parcelRequire("4lQeX");
    const $117da549012fa168$var$defaultThemeSettings = {
        dark: 'dark',
        light: 'light',
        spacing: 'spacing'
    };
    const $117da549012fa168$var$ColorModeContext = (0, $eUqFw.createContext)(undefined);
    const $117da549012fa168$var$SetColorModeContext = (0, $eUqFw.createContext)(undefined);
    const $117da549012fa168$var$ThemeContext = (0, $eUqFw.createContext)(undefined);
    const $117da549012fa168$var$SetThemeContext = (0, $eUqFw.createContext)(undefined);
    function $117da549012fa168$export$ce91654eb9fea460() {
        const value = (0, $eUqFw.useContext)($117da549012fa168$var$ColorModeContext);
        return value;
    }
    function $117da549012fa168$export$20f3076712c8dfa() {
        const value = (0, $eUqFw.useContext)($117da549012fa168$var$ColorModeContext);
        if (!value) throw new Error('useColorMode must be used within AppProvider.');
        return value;
    }
    function $117da549012fa168$export$e2afe7397c3d11c7() {
        const value = (0, $eUqFw.useContext)($117da549012fa168$var$SetColorModeContext);
        if (!value) throw new Error('useSetColorMode must be used within AppProvider.');
        return value;
    }
    function $117da549012fa168$export$93d4e7f90805808f() {
        const value = (0, $eUqFw.useContext)($117da549012fa168$var$ThemeContext);
        if (!value) throw new Error('useTheme must be used within AppProvider.');
        return value;
    }
    function $117da549012fa168$export$501aa0dcd5527a48() {
        const value = (0, $eUqFw.useContext)($117da549012fa168$var$SetThemeContext);
        if (!value) throw new Error('useSetTheme must be used within AppProvider.');
        return value;
    }
    const $117da549012fa168$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
    const $117da549012fa168$var$prefersDarkModeMql = $117da549012fa168$var$isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined;
    function $117da549012fa168$var$getReconciledColorMode(colorMode) {
        if (colorMode === 'auto') return $117da549012fa168$var$prefersDarkModeMql?.matches ? 'dark' : 'light';
        return colorMode;
    }
    function $117da549012fa168$export$d8964aec282183a3({ children: children, defaultColorMode: defaultColorMode, defaultTheme: { dark: dark = 'dark', light: light = 'light', spacing: spacing = 'spacing', typography: typography, shape: shape } = $117da549012fa168$var$defaultThemeSettings }) {
        const [chosenColorMode, setChosenColorMode] = (0, $eUqFw.useState)(defaultColorMode);
        const [reconciledColorMode, setReconciledColorMode] = (0, $eUqFw.useState)($117da549012fa168$var$getReconciledColorMode(defaultColorMode));
        const [theme, setTheme] = (0, $eUqFw.useState)({
            dark: dark,
            light: light,
            spacing: spacing,
            typography: typography,
            shape: shape
        });
        const setColorMode = (0, $eUqFw.useCallback)((colorMode)=>{
            setChosenColorMode(colorMode);
            setReconciledColorMode($117da549012fa168$var$getReconciledColorMode(colorMode));
        }, []);
        const setPartialTheme = (0, $eUqFw.useCallback)((nextTheme)=>{
            setTheme((theme)=>({
                    ...theme,
                    ...nextTheme
                }));
        }, []);
        (0, $eUqFw.useEffect)(()=>{
            (0, $4lQeX.default)({
                ...theme,
                colorMode: reconciledColorMode
            });
        }, [
            theme,
            reconciledColorMode
        ]);
        (0, $eUqFw.useEffect)(()=>{
            if (!$117da549012fa168$var$prefersDarkModeMql) return;
            const unbindListener = (0, $74BVL.bind)($117da549012fa168$var$prefersDarkModeMql, {
                type: 'change',
                listener: (event)=>{
                    if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
                }
            });
            return unbindListener;
        }, [
            chosenColorMode
        ]);
        return (0, ($parcel$interopDefault($eUqFw))).createElement($117da549012fa168$var$ColorModeContext.Provider, {
            value: reconciledColorMode
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($117da549012fa168$var$SetColorModeContext.Provider, {
            value: setColorMode
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($117da549012fa168$var$ThemeContext.Provider, {
            value: theme
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($117da549012fa168$var$SetThemeContext.Provider, {
            value: setPartialTheme
        }, children))));
    }
    var $117da549012fa168$export$2e2bcd8739ae039 = $117da549012fa168$export$d8964aec282183a3;
});
parcelRegister("3Kfqr", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2ba1a22bc528b7da$var$_react = $2ba1a22bc528b7da$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $2ba1a22bc528b7da$var$_UNSAFE_baseNew = $2ba1a22bc528b7da$var$_interopRequireDefault((parcelRequire("ay9aj")));
    function $2ba1a22bc528b7da$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $2ba1a22bc528b7da$var$ProjectIcon = (props)=>$2ba1a22bc528b7da$var$_react.default.createElement($2ba1a22bc528b7da$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.25 10.25 3.5 8 1.25 5.75l.884-.884a1.25 1.25 0 0 1 .884-.366H7.25l2.384-2.384a1.25 1.25 0 0 1 .884-.366H13c.69 0 1.25.56 1.25 1.25v2.482c0 .332-.132.65-.366.884L11.5 8.75v4.232c0 .332-.132.65-.366.884l-.884.884L8 12.5l-2.25 2.25m-4.5 0 5-5"/><circle cx="11.375" cy="4.625" r="1.125" fill="currentcolor"/>`
        }, props));
    $2ba1a22bc528b7da$var$ProjectIcon.displayName = 'ProjectIcon';
    var $2ba1a22bc528b7da$var$_default = module.exports.default = $2ba1a22bc528b7da$var$ProjectIcon;
});
parcelRegister("7H1QU", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $599dfc6238192b55$var$_react = $599dfc6238192b55$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $599dfc6238192b55$var$_UNSAFE_baseNew = $599dfc6238192b55$var$_interopRequireDefault((parcelRequire("ay9aj")));
    function $599dfc6238192b55$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $599dfc6238192b55$var$WarningIcon = (props)=>$599dfc6238192b55$var$_react.default.createElement($599dfc6238192b55$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.702 9.137A1.25 1.25 0 0 1 10.612 11H1.388a1.25 1.25 0 0 1-1.09-1.863l4.614-8.2a1.25 1.25 0 0 1 2.178 0zM6.75 2.75V6.5h-1.5V2.75zm-.75 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`,
            type: 'utility'
        }, props));
    $599dfc6238192b55$var$WarningIcon.displayName = 'WarningIcon';
    var $599dfc6238192b55$var$_default = module.exports.default = $599dfc6238192b55$var$WarningIcon;
});
parcelRegister("aL9UF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e5e331974ddc51c3$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $a5MxG = parcelRequire("a5MxG");
    var $cmipe = parcelRequire("cmipe");
    var $foM3E = parcelRequire("foM3E");
    const $e5e331974ddc51c3$var$LinkIconButtonBase = ({ 'aria-label': preventedAriaLabel, 'aria-labelledby': ariaLabelledBy, analyticsContext: analyticsContext, appearance: appearance, autoFocus: autoFocus, href: href, icon: icon, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, isTooltipDisabled: isTooltipDisabled = true, label: label, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shape: shape, spacing: spacing, testId: testId, tooltip: tooltip, ...unsafeRest }, ref)=>{
        const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
        const baseProps = (0, $foM3E.default)({
            analyticsContext: analyticsContext,
            appearance: appearance,
            ariaLabelledBy: ariaLabelledBy,
            autoFocus: autoFocus,
            buttonType: 'link',
            icon: icon,
            interactionName: interactionName,
            isDisabled: isDisabled,
            isSelected: isSelected,
            label: label,
            onClick: onClick,
            onClickCapture: onClickCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onTouchEndCapture: onTouchEndCapture,
            onTouchStartCapture: onTouchStartCapture,
            ref: ref,
            shape: shape,
            spacing: spacing,
            testId: testId
        });
        if (!isTooltipDisabled) return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $cmipe.default), {
            content: tooltip?.content ?? label,
            testId: tooltip?.testId,
            position: tooltip?.position,
            delay: tooltip?.delay,
            onShow: tooltip?.onShow,
            onHide: tooltip?.onHide,
            mousePosition: tooltip?.mousePosition,
            analyticsContext: tooltip?.analyticsContext,
            strategy: tooltip?.strategy,
            tag: tooltip?.tag,
            truncate: tooltip?.truncate,
            component: tooltip?.component,
            hideTooltipOnClick: tooltip?.hideTooltipOnClick,
            hideTooltipOnMouseDown: tooltip?.hideTooltipOnMouseDown,
            ignoreTooltipPointerEvents: tooltip?.ignoreTooltipPointerEvents
        }, (triggerProps)=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $a5MxG.default), {
                ...saferRest,
                "aria-labelledby": baseProps['aria-labelledby'],
                testId: testId,
                componentName: "LinkIconButton",
                analyticsContext: analyticsContext,
                interactionName: interactionName,
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    saferRest.onMouseOver?.(e);
                },
                onMouseOut: (e)=>{
                    triggerProps.onMouseOut?.(e);
                    saferRest.onMouseOut?.(e);
                },
                onMouseMove: (e)=>{
                    triggerProps.onMouseMove?.(e);
                    saferRest.onMouseMove?.(e);
                },
                onMouseDown: (e)=>{
                    triggerProps.onMouseDown?.(e);
                    saferRest.onMouseDown?.(e);
                },
                onFocus: (e)=>{
                    triggerProps.onFocus?.(e);
                    saferRest.onFocus?.(e);
                },
                onBlur: (e)=>{
                    triggerProps.onBlur?.(e);
                    saferRest.onBlur?.(e);
                },
                onClick: (event, analyticsEvent)=>{
                    baseProps?.onClick?.(event, analyticsEvent);
                    triggerProps?.onClick?.(event);
                },
                ref: (ref)=>{
                    baseProps.ref(ref);
                    triggerProps?.ref?.(ref);
                },
                xcss: baseProps.xcss,
                onMouseDownCapture: baseProps.onMouseDownCapture,
                onMouseUpCapture: baseProps.onMouseUpCapture,
                onKeyDownCapture: baseProps.onKeyDownCapture,
                onKeyUpCapture: baseProps.onKeyUpCapture,
                onTouchStartCapture: baseProps.onTouchStartCapture,
                onTouchEndCapture: baseProps.onTouchEndCapture,
                onPointerDownCapture: baseProps.onPointerDownCapture,
                onPointerUpCapture: baseProps.onPointerUpCapture,
                onClickCapture: baseProps.onClickCapture,
                href: baseProps.isDisabled ? undefined : href,
                role: baseProps.isDisabled ? 'link' : undefined,
                "aria-disabled": baseProps.isDisabled === true ? true : undefined
            }, baseProps.children));
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $a5MxG.default), {
            ...saferRest,
            "aria-labelledby": baseProps['aria-labelledby'],
            ref: baseProps.ref,
            xcss: baseProps.xcss,
            onClick: baseProps.onClick,
            onMouseDownCapture: baseProps.onMouseDownCapture,
            onMouseUpCapture: baseProps.onMouseUpCapture,
            onKeyDownCapture: baseProps.onKeyDownCapture,
            onKeyUpCapture: baseProps.onKeyUpCapture,
            onTouchStartCapture: baseProps.onTouchStartCapture,
            onTouchEndCapture: baseProps.onTouchEndCapture,
            onPointerDownCapture: baseProps.onPointerDownCapture,
            onPointerUpCapture: baseProps.onPointerUpCapture,
            onClickCapture: baseProps.onClickCapture,
            testId: testId,
            href: baseProps.isDisabled ? undefined : href,
            role: baseProps.isDisabled ? 'link' : undefined,
            "aria-disabled": baseProps.isDisabled === true ? true : undefined,
            componentName: "LinkIconButton",
            analyticsContext: analyticsContext,
            interactionName: interactionName
        }, baseProps.children);
    };
    const $e5e331974ddc51c3$var$WithRef = (0, $eUqFw.forwardRef)($e5e331974ddc51c3$var$LinkIconButtonBase);
    const $e5e331974ddc51c3$var$LinkIconButton = (0, $eUqFw.memo)($e5e331974ddc51c3$var$WithRef);
    var $e5e331974ddc51c3$export$2e2bcd8739ae039 = $e5e331974ddc51c3$var$LinkIconButton;
});
parcelRegister("jwf8c", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$37028e13420e3d1f$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $fHiYa = parcelRequire("fHiYa");
    function $37028e13420e3d1f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $37028e13420e3d1f$var$baseStyles = {
        name: "1khn195",
        styles: "box-sizing:border-box"
    };
    const $37028e13420e3d1f$var$blockBleedMap = {
        'space.025': {
            name: "9w2fxh",
            styles: "margin-block:var(--ds-space-negative-025, -0.125rem)"
        },
        'space.050': {
            name: "1qhe0y6",
            styles: "margin-block:var(--ds-space-negative-050, -0.25rem)"
        },
        'space.100': {
            name: "s0o2nz",
            styles: "margin-block:var(--ds-space-negative-100, -0.5rem)"
        },
        'space.150': {
            name: "151e4o3",
            styles: "margin-block:var(--ds-space-negative-150, -0.75rem)"
        },
        'space.200': {
            name: "16sn062",
            styles: "margin-block:var(--ds-space-negative-200, -1rem)"
        }
    };
    const $37028e13420e3d1f$var$inlineBleedMap = {
        'space.025': {
            name: "16oxh68",
            styles: "margin-inline:var(--ds-space-negative-025, -0.125rem)"
        },
        'space.050': {
            name: "tdc6fz",
            styles: "margin-inline:var(--ds-space-negative-050, -0.25rem)"
        },
        'space.100': {
            name: "crujrn",
            styles: "margin-inline:var(--ds-space-negative-100, -0.5rem)"
        },
        'space.150': {
            name: "y28d58",
            styles: "margin-inline:var(--ds-space-negative-150, -0.75rem)"
        },
        'space.200': {
            name: "1vfkteg",
            styles: "margin-inline:var(--ds-space-negative-200, -1rem)"
        }
    };
    const $37028e13420e3d1f$var$Bleed = (0, ($parcel$interopDefault($eUqFw))).memo(({ children: children, testId: testId, inline: inline, block: block, all: all, xcss: xcss })=>{
        const resolvedStyles = (0, $fHiYa.parseXcss)(xcss);
        return (0, $byn9U.jsx)("div", {
            className: resolvedStyles.static,
            css: [
                $37028e13420e3d1f$var$baseStyles,
                (inline || all) && $37028e13420e3d1f$var$inlineBleedMap[inline || all],
                (block || all) && $37028e13420e3d1f$var$blockBleedMap[block || all],
                resolvedStyles.emotion
            ],
            "data-testid": testId
        }, children);
    });
    $37028e13420e3d1f$var$Bleed.displayName = 'Bleed';
    var $37028e13420e3d1f$export$2e2bcd8739ae039 = $37028e13420e3d1f$var$Bleed;
});
parcelRegister("eKHa6", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $abd6d79bf14110b8$var$_react = $abd6d79bf14110b8$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $abd6d79bf14110b8$var$_UNSAFE_baseNew = $abd6d79bf14110b8$var$_interopRequireDefault((parcelRequire("ay9aj")));
    function $abd6d79bf14110b8$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $abd6d79bf14110b8$var$TeamsIcon = (props)=>$abd6d79bf14110b8$var$_react.default.createElement($abd6d79bf14110b8$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M6 14.25H2c-.69 0-1.25-.56-1.25-1.25v-1.25a3 3 0 0 1 3-3h1.149a3 3 0 0 1 2.82 1.975l.563 1.55a3 3 0 0 0 2.82 1.975H14c.69 0 1.25-.56 1.25-1.25v-1.25a3 3 0 0 0-3-3H12c-1.625 0-2.125.25-2.125.25M6.25 4a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm8 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"/>`
        }, props));
    $abd6d79bf14110b8$var$TeamsIcon.displayName = 'TeamsIcon';
    var $abd6d79bf14110b8$var$_default = module.exports.default = $abd6d79bf14110b8$var$TeamsIcon;
});
parcelRegister("kx7fq", function(module, exports) {
    $parcel$export(module.exports, "JiraLogo", ()=>$f5cae2570eee003b$export$17d3acb0b4379d02);
    var $eUqFw = parcelRequire("eUqFw");
    var $fjjRQ = parcelRequire("fjjRQ");
    var $gT5pi = parcelRequire("gT5pi");
    var $fxki0 = parcelRequire("fxki0");
    var $3Dx41 = parcelRequire("3Dx41");
    const $f5cae2570eee003b$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
        let colors = {
            iconColor: iconColor,
            textColor: textColor
        };
        if (appearance) colors = (0, $fxki0.getColorsFromAppearance)(appearance, colorMode);
        return `<svg fill="none" height="32" viewBox="0 0 77 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M7.967 21.323H5.748C2.401 21.323 0 19.273 0 16.271h11.933c.618 0 1.018.44 1.018 1.062V29.34c-2.983 0-4.984-2.416-4.984-5.784zm5.894-5.967h-2.22c-3.346 0-5.747-2.013-5.747-5.015h11.932c.618 0 1.055.402 1.055 1.025v12.007c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.22c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.019.439 1.019 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z"/>
      <path fill="${colors.textColor}" d="M65.023 17.874c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM55.91 16.493v9.047h-2.577V10.207h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M46.224 6.159c0-1.165.767-1.84 1.84-1.84s1.84.675 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.49 19.381V10.207h2.638V25.54zm-6.427-5.95V5.393h2.76v14.015c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.246-3.312-.522v-2.668c.828.338 1.84.522 2.852.522 2.33 0 3.128-1.41 3.128-3.404"/>
    </svg>`;
    };
    const $f5cae2570eee003b$export$17d3acb0b4379d02 = ({ appearance: appearance, label: label = 'Jira', size: size = (0, $gT5pi.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $gT5pi.defaultLogoParams).iconColor, textColor: textColor = (0, $gT5pi.defaultLogoParams).textColor })=>{
        const { colorMode: colorMode } = (0, $fjjRQ.default)();
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $3Dx41.default), {
            appearance: appearance,
            label: label,
            iconColor: iconColor,
            size: size,
            svg: $f5cae2570eee003b$var$svg({
                appearance: appearance,
                iconColor: iconColor,
                textColor: textColor
            }, colorMode),
            testId: testId,
            textColor: textColor
        });
    };
});
parcelRegister("dx5z5", function(module, exports) {
    $parcel$export(module.exports, "JiraServiceManagementLogo", ()=>$1a2f6f2c6975c278$export$dabef2be6cd28c20);
    var $eUqFw = parcelRequire("eUqFw");
    var $fjjRQ = parcelRequire("fjjRQ");
    var $gT5pi = parcelRequire("gT5pi");
    var $fxki0 = parcelRequire("fxki0");
    var $3Dx41 = parcelRequire("3Dx41");
    const $1a2f6f2c6975c278$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
        let colors = {
            iconColor: iconColor,
            textColor: textColor
        };
        if (appearance) colors = (0, $fxki0.getColorsFromAppearance)(appearance, colorMode);
        return `<svg fill="none" height="32" viewBox="0 0 362 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} d="M14.124 13.257h7.325c1.1 0 1.475 1.046.804 1.878L10.798 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H1.138c-1.1 0-1.476-1.046-.805-1.878L11.79 2.874c3.703 2.951 3.3 7.566.617 11z" />
      <path fill=${colors.textColor} d="M357.074 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-7.327-4.231v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-26.152-7.912v8.525h-2.637V16.28c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.625-4.14 4.723v8.525h-2.637V10.208h2.637v2.514c.981-1.81 2.79-2.821 4.845-2.821 2.607 0 4.385 1.319 5.152 3.741.859-2.361 2.913-3.741 5.459-3.741 3.434 0 5.336 2.33 5.336 6.655v8.985h-2.638v-8.525c0-3.16-1.104-4.723-3.618-4.723-2.454 0-4.14 1.625-4.14 4.723m-22.921-4.723c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.577-7.943 7.238-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638V25.54zm-14.073-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-28.327 1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-31.445-11.009-2.76-7.482V25.54h-2.76V5.393h4.784l4.569 11.56 1.871 5.552 1.87-5.551 4.6-11.561h4.447V25.54h-2.76V7.263l-2.361 7.268-4.447 11.01h-2.668zm-21.511-2.238c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zm-15.094-2.148v2.362c-.92.49-2.33.705-3.741.705-5.459 0-8.004-3.312-8.004-8.004 0-4.63 2.545-7.942 8.004-7.942 1.38 0 2.453.184 3.649.736v2.453c-.981-.46-2.024-.736-3.465-.736-3.987 0-5.612 2.515-5.612 5.49s1.656 5.489 5.673 5.489c1.564 0 2.546-.215 3.496-.552M140.124 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S143.037 8 141.964 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-8.233 0h-3.527l-5.949-15.332h2.76l4.968 13.094 4.937-13.094h2.76zm-15.455-9.046v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-12.463-4.201c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zM95.024 19.99c0 3.496-2.085 5.857-7.084 5.857-3.894 0-5.704-.766-7.268-1.564v-2.821c1.87.981 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975s-1.104-2.73-4.937-3.65c-4.539-1.103-6.563-2.667-6.563-5.98 0-3.127 2.392-5.458 7.084-5.458 2.914 0 4.784.705 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.845 3.373 4.263 1.073 6.655 2.453 6.655 6.072m-34.001-2.116c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404" />
    </svg>`;
    };
    const $1a2f6f2c6975c278$export$dabef2be6cd28c20 = ({ appearance: appearance, label: label = 'Jira Service Management', size: size = (0, $gT5pi.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $gT5pi.defaultLogoParams).iconColor, textColor: textColor = (0, $gT5pi.defaultLogoParams).textColor })=>{
        const { colorMode: colorMode } = (0, $fjjRQ.default)();
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $3Dx41.default), {
            appearance: appearance,
            label: label,
            iconColor: iconColor,
            size: size,
            svg: $1a2f6f2c6975c278$var$svg({
                appearance: appearance,
                iconColor: iconColor,
                textColor: textColor
            }, colorMode),
            testId: testId,
            textColor: textColor
        });
    };
});
parcelRegister("df3oU", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $9a3f506259a647fd$var$_react = $9a3f506259a647fd$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $9a3f506259a647fd$var$_personAvatar = $9a3f506259a647fd$var$_interopRequireDefault((parcelRequire("9dxCg")));
    var $9a3f506259a647fd$var$_userAvatarCircle = $9a3f506259a647fd$var$_interopRequireDefault((parcelRequire("8xfk8")));
    function $9a3f506259a647fd$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $9a3f506259a647fd$var$PersonAvatarIcon = (props)=>$9a3f506259a647fd$var$_react.default.createElement($9a3f506259a647fd$var$_personAvatar.default, Object.assign({
            LEGACY_fallbackIcon: $9a3f506259a647fd$var$_userAvatarCircle.default
        }, props));
    $9a3f506259a647fd$var$PersonAvatarIcon.Name = 'PersonAvatarIconMigration';
    var $9a3f506259a647fd$var$_default = module.exports.default = $9a3f506259a647fd$var$PersonAvatarIcon;
});
parcelRegister("1LQO2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e3da027e82d6b7cc$export$2e2bcd8739ae039);
    var $byn9U = parcelRequire("byn9U");
    var $7pdsy = parcelRequire("7pdsy");
    var $4oSDA = parcelRequire("4oSDA");
    var $hcLBt = parcelRequire("hcLBt");
    function $e3da027e82d6b7cc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $e3da027e82d6b7cc$var$skeletonStyles = (0, $byn9U.css)({
        paddingBlock: "var(--ds-space-0, 0px)",
        paddingInline: "var(--ds-space-200, 16px)",
        '::after': {
            display: 'block',
            width: '30%',
            height: "var(--ds-space-100, 8px)",
            backgroundColor: `var(--ds-skeleton, ${(0, $207acf722dcd432b$export$8d43898f60b96a82)})`,
            borderRadius: 100,
            content: '""'
        }
    });
    const $e3da027e82d6b7cc$var$defaultWidthStyles = {
        name: "me8tg7",
        styles: "::after{width:30%;}"
    };
    const $e3da027e82d6b7cc$var$customWidthStyles = {
        name: "ms0ivw",
        styles: "::after{width:var(--width);}"
    };
    const $e3da027e82d6b7cc$var$SkeletonHeadingItem = ({ isShimmering: isShimmering = false, testId: testId, width: width, cssFn: cssFn = (0, $4oSDA.default) })=>{
        (0, $7pdsy.propDeprecationWarning)("platform-pkg", 'cssFn', cssFn !== (0, $4oSDA.default), '');
        const UNSAFE_overrides = (0, $byn9U.css)(cssFn(undefined));
        return (0, $byn9U.jsx)((0, $hcLBt.default), {
            isShimmering: isShimmering
        }, ({ className: className })=>(0, $byn9U.jsx)("div", {
                className: className,
                style: {
                    '--width': width
                },
                css: [
                    $e3da027e82d6b7cc$var$skeletonStyles,
                    width ? $e3da027e82d6b7cc$var$customWidthStyles : $e3da027e82d6b7cc$var$defaultWidthStyles,
                    UNSAFE_overrides
                ],
                "data-ds--menu--skeleton-heading-item": true,
                "data-testid": testId
            }));
    };
    var $e3da027e82d6b7cc$export$2e2bcd8739ae039 = $e3da027e82d6b7cc$var$SkeletonHeadingItem;
});
parcelRegister("2jnwp", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $1aef9a0f4a3ccee6$var$_react = $1aef9a0f4a3ccee6$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $1aef9a0f4a3ccee6$var$_settings = $1aef9a0f4a3ccee6$var$_interopRequireDefault((parcelRequire("6BgCA")));
    var $1aef9a0f4a3ccee6$var$_settings2 = $1aef9a0f4a3ccee6$var$_interopRequireDefault((parcelRequire("iu60k")));
    function $1aef9a0f4a3ccee6$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1aef9a0f4a3ccee6$var$SettingsIcon = (props)=>$1aef9a0f4a3ccee6$var$_react.default.createElement($1aef9a0f4a3ccee6$var$_settings.default, Object.assign({
            LEGACY_fallbackIcon: $1aef9a0f4a3ccee6$var$_settings2.default
        }, props));
    $1aef9a0f4a3ccee6$var$SettingsIcon.Name = 'SettingsIconMigration';
    var $1aef9a0f4a3ccee6$var$_default = module.exports.default = $1aef9a0f4a3ccee6$var$SettingsIcon;
});
parcelRegister("iGjL3", function(module, exports) {
    $parcel$export(module.exports, "JiraProductDiscoveryLogo", ()=>$e4eba21fe3efea4a$export$c49a2b642fe9eef4);
    var $eUqFw = parcelRequire("eUqFw");
    var $fjjRQ = parcelRequire("fjjRQ");
    var $gT5pi = parcelRequire("gT5pi");
    var $fxki0 = parcelRequire("fxki0");
    var $3Dx41 = parcelRequire("3Dx41");
    const $e4eba21fe3efea4a$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
        let colors = {
            iconColor: iconColor,
            textColor: textColor
        };
        if (appearance) colors = (0, $fxki0.getColorsFromAppearance)(appearance, colorMode);
        return `<svg fill="none" height="32" viewBox="0 0 318 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M12.655 5.218a15.3 15.3 0 0 0 8.75 0c.257-.057.428.114.37.37-.826 2.984-.826 5.742 0 8.727.058.227-.113.426-.37.341a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.341.77-2.985.77-5.743 0-8.727-.086-.256.114-.427.342-.37m1.169 10.575v.483c0 2.246-1.568 3.895-3.506 3.895a3.474 3.474 0 0 1-3.478-3.497c0-1.933 1.568-3.468 3.763-3.468h.57V6.412c-.285-.028-.57-.028-.855-.028C4.618 6.384 0 10.989 0 16.703s4.617 10.29 10.318 10.29 10.346-4.605 10.346-10.29v-.91z" />
      <path fill="${colors.textColor}" d="M308.551 24.559h-1.718l-5.55-14.352h2.821l4.907 13.125 4.906-13.125h2.822l-5.796 14.843c-1.718 4.385-2.699 6.654-6.594 6.654-1.318 0-2.054-.122-2.821-.429v-2.27c.889.277 1.901.369 2.668.369 2.147 0 3.097-1.472 4.355-4.815m-13.247-8.065v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.422-3.097 5.428-2.913v2.576c-3.374-.338-5.428.674-5.428 3.925m-12.464-4.202c-2.79 0-4.201 1.81-4.477 4.478h8.556c-.153-2.852-1.441-4.478-4.079-4.478m5.888 12.635c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.624 3.282 6.624 7.943v1.196h-11.193c.368 2.607 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-19.717.613h-3.527l-5.949-15.333h2.76l4.968 13.095 4.937-13.095h2.76zm-17.462.307c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.49 0 2.912 1.442 5.55 4.723 5.55 3.251 0 4.661-2.638 4.661-5.55 0-2.914-1.41-5.49-4.661-5.49M242.16 22.78v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-13.872-1.41c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.41-4.968-1.41-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.422 3.404.828 5.121 2.086 5.121 4.754M210.599 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.491 19.38V10.208h2.637v15.334zM198.344 8.03h-4.539v14.873h4.692c4.6 0 6.9-2.422 6.9-7.298 0-4.907-2.177-7.575-7.053-7.575m-7.299 17.51V5.394h7.422c6.532 0 9.69 4.078 9.69 10.12 0 6.102-3.189 10.028-9.69 10.028zm-13.411-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-6.66 1.993v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-27.843-3.588v-8.985h2.637v9.261c0 2.76 1.104 3.987 3.619 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637V25.54h-2.637v-2.514c-.982 1.809-2.791 2.821-4.846 2.821-3.526 0-5.55-2.423-5.55-6.655m-14.987-1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.667v-2.76c-.981 2.023-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005V3.798h2.637V25.54zm-20.698.306c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49 0 2.912 1.441 5.55 4.723 5.55 3.25 0 4.661-2.638 4.661-5.55 0-2.914-1.411-5.49-4.661-5.49m-13.776 4.14v9.047h-2.576V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-5.002-4.385c0 4.385-2.454 6.838-7.483 6.838h-4.017v6.594h-2.76V5.393h6.777c5.03 0 7.483 2.576 7.483 6.716m-7.79 4.2c3.558.124 4.938-1.563 4.938-4.14 0-2.452-1.38-4.14-4.938-4.14h-3.71v8.28zM61.69 17.874c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.931-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.24 0 3.957 1.012 4.877 3.006v-2.699h2.637V25.54zm-17.793-9.046v9.047H50V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.89 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.805 8 44.73 8s-1.84-.675-1.84-1.84m.491 19.38V10.208h2.638v15.334zm-6.428-5.949V5.393h2.76v14.014c0 3.71-1.625 6.256-5.428 6.256-1.441 0-2.545-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.331 0 3.128-1.41 3.128-3.404" />
    </svg>`;
    };
    const $e4eba21fe3efea4a$export$c49a2b642fe9eef4 = ({ appearance: appearance, label: label = 'Jira Product Discovery', size: size = (0, $gT5pi.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $gT5pi.defaultLogoParams).iconColor, textColor: textColor = (0, $gT5pi.defaultLogoParams).textColor })=>{
        const { colorMode: colorMode } = (0, $fjjRQ.default)();
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $3Dx41.default), {
            appearance: appearance,
            label: label,
            iconColor: iconColor,
            size: size,
            svg: $e4eba21fe3efea4a$var$svg({
                appearance: appearance,
                iconColor: iconColor,
                textColor: textColor
            }, colorMode),
            testId: testId,
            textColor: textColor
        });
    };
});
parcelRegister("jkUhm", function(module, exports) {
    $parcel$export(module.exports, "AtlassianNavigation", ()=>$d52ae1607ef13cfb$export$f66ccb39f60980e5);
    var $byn9U = parcelRequire("byn9U");
    var $9VkvA = parcelRequire("9VkvA");
    var $iDwTy = parcelRequire("iDwTy");
    var $etyk7 = parcelRequire("etyk7");
    var $5Ykgt = parcelRequire("5Ykgt");
    var $2NNOl = parcelRequire("2NNOl");
    var $xMdsB = parcelRequire("xMdsB");
    function $d52ae1607ef13cfb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $d52ae1607ef13cfb$var$containerStyles = (0, $byn9U.css)({
        display: 'flex',
        boxSizing: 'border-box',
        height: (0, $b156b847c373c90e$export$30fa7cc5f2690a43),
        position: 'relative',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexShrink: 0,
        borderBlockEnd: `1px solid ${`var(--ds-border, ${(0, $207acf722dcd432b$export$3e51e8f1440314ba)})`}`,
        paddingInlineEnd: "var(--ds-space-150, 12px)",
        paddingInlineStart: "var(--ds-space-150, 12px)"
    });
    const $d52ae1607ef13cfb$var$leftStyles = {
        name: "vtikxo",
        styles: "display:flex;min-width:0;height:inherit;align-items:center;flex-grow:1;& > *{flex-shrink:0;}"
    };
    const $d52ae1607ef13cfb$var$rightStyles = {
        name: "1mwlrd6",
        styles: "display:flex;align-items:center;flex-shrink:0;& > *{flex-shrink:0;margin-inline-end:var(--ds-space-050, 4px);}"
    };
    const $d52ae1607ef13cfb$var$noRightMarginStyles = {
        name: "1oo7nc3",
        styles: "margin-inline-end:0"
    };
    const $d52ae1607ef13cfb$var$analyticsData = {
        attributes: {
            navigationLayer: 'global'
        },
        componentName: 'atlassianNavigation'
    };
    const $d52ae1607ef13cfb$export$f66ccb39f60980e5 = (props)=>{
        const { label: label, primaryItems: primaryItems = [], renderAppSwitcher: AppSwitcher, renderCreate: create, renderHelp: Help, renderNotifications: Notifications, renderProductHome: ProductHome, renderProfile: Profile, renderSearch: Search, renderSignIn: SignIn, renderSettings: Settings, moreLabel: moreLabel = "\u2026", theme: theme = (0, $etyk7.defaultTheme), testId: testId } = props;
        return (0, $byn9U.jsx)((0, $5Ykgt.ThemeProvider), {
            value: theme
        }, (0, $byn9U.jsx)((0, $9VkvA.NavigationAnalyticsContext), {
            data: $d52ae1607ef13cfb$var$analyticsData
        }, (0, $byn9U.jsx)("header", {
            style: theme.mode.navigation,
            css: $d52ae1607ef13cfb$var$containerStyles,
            "data-testid": testId && `${testId}-header`,
            role: "banner",
            "data-vc": "atlassian-navigation"
        }, (0, $byn9U.jsx)("nav", {
            css: $d52ae1607ef13cfb$var$leftStyles,
            "aria-label": label
        }, AppSwitcher && (0, $byn9U.jsx)(AppSwitcher, null), ProductHome && (0, $byn9U.jsx)(ProductHome, null), (0, $iDwTy.fg)('platform.design-system-team.navigation-v2-no-jank_5yhbd') ? (0, $byn9U.jsx)((0, $xMdsB.PrimaryItemsContainer), {
            testId: testId,
            moreLabel: moreLabel,
            items: primaryItems,
            create: create,
            theme: theme
        }) : (0, $byn9U.jsx)((0, $2NNOl.PrimaryItemsContainer), {
            testId: testId,
            moreLabel: moreLabel,
            items: primaryItems,
            create: create,
            theme: theme
        })), (0, $byn9U.jsx)("div", {
            css: $d52ae1607ef13cfb$var$rightStyles,
            "data-testid": testId && `${testId}-secondary-actions`
        }, Search && (0, $byn9U.jsx)(Search, null), (0, $byn9U.jsx)("div", {
            role: "list",
            css: [
                $d52ae1607ef13cfb$var$rightStyles,
                $d52ae1607ef13cfb$var$noRightMarginStyles
            ],
            "data-vc": "atlassian-navigation-secondary-actions"
        }, Notifications && (0, $byn9U.jsx)(Notifications, null), Help && (0, $byn9U.jsx)(Help, null), Settings && (0, $byn9U.jsx)(Settings, null), SignIn && (0, $byn9U.jsx)(SignIn, null), Profile && (0, $byn9U.jsx)(Profile, null))))));
    };
    var $d52ae1607ef13cfb$export$2e2bcd8739ae039 = $d52ae1607ef13cfb$export$f66ccb39f60980e5;
});
const $b156b847c373c90e$export$30fa7cc5f2690a43 = 56;
const $b156b847c373c90e$export$4033a111ca79977d = 1280;
const $b156b847c373c90e$export$24ec62cee78b7042 = 1130;
const $b156b847c373c90e$export$d8bde68ac946124f = '--ds--ans--fbc';
const $b156b847c373c90e$export$73e44f54603a0964 = '--ds--ans--hbgc';
const $b156b847c373c90e$export$13f8aa8f663f4c99 = '--ds--ans--bgc';
const $b156b847c373c90e$export$d81606c1fc5119bc = '--ds--ans--c';
const $b156b847c373c90e$export$65f656ad520ea71 = '--ds--ans--bc';
parcelRegister("etyk7", function(module, exports) {
    $parcel$export(module.exports, "defaultTheme", ()=>$00e4a5892d623384$export$164de7ab8df77ef0);
    var $l8ip5 = parcelRequire("l8ip5");
    var $4Zowo = parcelRequire("4Zowo");
    const $00e4a5892d623384$export$eeee8619e1b91cb0 = (0, $4Zowo.generateTheme)({
        name: (0, $l8ip5.DEFAULT_THEME_NAME),
        backgroundColor: (0, $207acf722dcd432b$export$29a4f05edc054374),
        highlightColor: (0, $207acf722dcd432b$export$b3de0ae08da2ce64)
    });
    const $00e4a5892d623384$export$164de7ab8df77ef0 = $00e4a5892d623384$export$eeee8619e1b91cb0;
});
parcelRegister("l8ip5", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_THEME_NAME", ()=>$ddf24ee63960888f$export$2491e13b198e597d);
    $parcel$export(module.exports, "default", ()=>$ddf24ee63960888f$export$2e2bcd8739ae039);
    var $9fA8v = parcelRequire("9fA8v");
    const $ddf24ee63960888f$var$defaultTheme = {
        mode: {
            create: {
                active: {
                    color: `var(--ds-text-inverse, ${(0, $207acf722dcd432b$export$29a4f05edc054374)})`,
                    backgroundColor: `var(--ds-background-brand-bold-pressed, ${(0, $9fA8v.hexToRGBA)((0, $207acf722dcd432b$export$b3de0ae08da2ce64), 0.8)})`,
                    boxShadow: ''
                },
                default: {
                    color: `var(--ds-text-inverse, ${(0, $207acf722dcd432b$export$29a4f05edc054374)})`,
                    backgroundColor: `var(--ds-background-brand-bold, ${(0, $207acf722dcd432b$export$b3de0ae08da2ce64)})`,
                    boxShadow: ''
                },
                focus: {
                    color: `var(--ds-text-inverse, ${(0, $207acf722dcd432b$export$29a4f05edc054374)})`,
                    backgroundColor: '',
                    boxShadow: ''
                },
                hover: {
                    color: `var(--ds-text-inverse, ${(0, $207acf722dcd432b$export$29a4f05edc054374)})`,
                    backgroundColor: `var(--ds-background-brand-bold-hovered, ${(0, $9fA8v.hexToRGBA)((0, $207acf722dcd432b$export$b3de0ae08da2ce64), 0.9)})`,
                    boxShadow: ''
                },
                selected: {
                    color: '',
                    backgroundColor: '',
                    boxShadow: ''
                }
            },
            iconButton: {
                active: {
                    color: `var(--ds-text-subtle, ${(0, $207acf722dcd432b$export$b3de0ae08da2ce64)})`,
                    backgroundColor: `var(--ds-background-neutral-pressed, ${(0, $9fA8v.hexToRGBA)((0, $207acf722dcd432b$export$226de0355ed012f8), 0.6)})`,
                    boxShadow: ''
                },
                default: {
                    color: `var(--ds-text-subtle, ${(0, $207acf722dcd432b$export$7090862dc3038a9f)})`,
                    backgroundColor: 'transparent',
                    boxShadow: ''
                },
                focus: {
                    color: `var(--ds-text-subtle, ${(0, $207acf722dcd432b$export$7090862dc3038a9f)})`,
                    backgroundColor: '',
                    boxShadow: ''
                },
                hover: {
                    color: `var(--ds-text-subtle, ${(0, $207acf722dcd432b$export$b3de0ae08da2ce64)})`,
                    backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $9fA8v.hexToRGBA)((0, $207acf722dcd432b$export$226de0355ed012f8), 0.9)})`,
                    boxShadow: ''
                },
                selected: {
                    color: `var(--ds-text-selected, ${(0, $207acf722dcd432b$export$b3de0ae08da2ce64)})`,
                    backgroundColor: `var(--ds-background-selected, ${(0, $9fA8v.hexToRGBA)((0, $207acf722dcd432b$export$226de0355ed012f8), 0.6)})`,
                    boxShadow: ''
                },
                selectedHover: {
                    color: `var(--ds-text-selected, ${(0, $207acf722dcd432b$export$b3de0ae08da2ce64)})`,
                    backgroundColor: `var(--ds-background-selected-hovered, ${(0, $9fA8v.hexToRGBA)((0, $207acf722dcd432b$export$226de0355ed012f8), 0.6)})`,
                    boxShadow: ''
                }
            },
            navigation: {
                backgroundColor: `var(--ds-surface, ${(0, $207acf722dcd432b$export$29a4f05edc054374)})`,
                color: `var(--ds-text-subtlest, ${(0, $207acf722dcd432b$export$f563ee71e9ee74cd)})`
            },
            productHome: {
                backgroundColor: `var(--ds-text-brand, ${(0, $207acf722dcd432b$export$b3de0ae08da2ce64)})`,
                color: `var(--ds-text, ${(0, $207acf722dcd432b$export$ad0bacf983b7ddaa)})`,
                borderRight: `1px solid ${`var(--ds-border, ${(0, $9fA8v.hexToRGBA)((0, $207acf722dcd432b$export$f563ee71e9ee74cd), 0.3)})`}`,
                iconColor: '#357DE8'
            },
            primaryButton: {
                active: {
                    color: `var(--ds-text-subtle, ${(0, $207acf722dcd432b$export$b3de0ae08da2ce64)})`,
                    backgroundColor: `var(--ds-background-neutral-pressed, ${(0, $9fA8v.hexToRGBA)((0, $207acf722dcd432b$export$226de0355ed012f8), 0.7)})`,
                    boxShadow: ''
                },
                default: {
                    color: `var(--ds-text-subtle, ${(0, $207acf722dcd432b$export$7090862dc3038a9f)})`,
                    backgroundColor: 'transparent',
                    boxShadow: ''
                },
                focus: {
                    color: `var(--ds-text-subtle, ${(0, $207acf722dcd432b$export$7090862dc3038a9f)})`,
                    backgroundColor: '',
                    boxShadow: ''
                },
                hover: {
                    color: `var(--ds-text-subtle, ${(0, $207acf722dcd432b$export$b3de0ae08da2ce64)})`,
                    backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $9fA8v.hexToRGBA)((0, $207acf722dcd432b$export$226de0355ed012f8), 0.9)})`,
                    boxShadow: ''
                },
                selected: {
                    color: `var(--ds-text-selected, ${(0, $207acf722dcd432b$export$b3de0ae08da2ce64)})`,
                    backgroundColor: `var(--ds-background-selected, ${(0, $9fA8v.hexToRGBA)((0, $207acf722dcd432b$export$226de0355ed012f8), 0.7)})`,
                    boxShadow: '',
                    borderColor: `var(--ds-border-selected, ${(0, $207acf722dcd432b$export$b3de0ae08da2ce64)})`
                },
                selectedHover: {
                    color: `var(--ds-text-selected, ${(0, $207acf722dcd432b$export$b3de0ae08da2ce64)})`,
                    backgroundColor: `var(--ds-background-selected-hovered, ${(0, $9fA8v.hexToRGBA)((0, $207acf722dcd432b$export$226de0355ed012f8), 0.6)})`,
                    boxShadow: '',
                    borderColor: `var(--ds-border-selected, ${(0, $207acf722dcd432b$export$b3de0ae08da2ce64)})`
                }
            },
            search: {
                default: {
                    backgroundColor: `var(--ds-background-input, ${(0, $207acf722dcd432b$export$29a4f05edc054374)})`,
                    color: `var(--ds-text-subtlest, ${(0, $207acf722dcd432b$export$f563ee71e9ee74cd)})`,
                    borderColor: `var(--ds-border-input, ${(0, $207acf722dcd432b$export$d6447c357493214f)})`
                },
                focus: {
                    borderColor: `var(--ds-border-focused, ${(0, $207acf722dcd432b$export$215b7063051591f1)})`
                },
                hover: {
                    backgroundColor: `var(--ds-background-input-hovered, ${(0, $207acf722dcd432b$export$29a4f05edc054374)})`
                }
            },
            skeleton: {
                backgroundColor: `var(--ds-background-neutral, ${(0, $207acf722dcd432b$export$9fdfb749e33cdf97)})`,
                opacity: 1
            }
        }
    };
    const $ddf24ee63960888f$export$2491e13b198e597d = 'atlassian';
    var $ddf24ee63960888f$export$2e2bcd8739ae039 = $ddf24ee63960888f$var$defaultTheme;
});
parcelRegister("9fA8v", function(module, exports) {
    $parcel$export(module.exports, "hexToRGBA", ()=>$0bda979ecec388a0$export$7229be6d7219ee6a);
    $parcel$export(module.exports, "getBoxShadow", ()=>$0bda979ecec388a0$export$bba5a971afe05444);
    $parcel$export(module.exports, "generateTextColor", ()=>$0bda979ecec388a0$export$10a10e7cd1193377);
    $parcel$export(module.exports, "getContrastColor", ()=>$0bda979ecec388a0$export$77a1051494882576);
    var $taXj4 = parcelRequire("taXj4");
    const $0bda979ecec388a0$export$7229be6d7219ee6a = (hex, opacity = 1)=>{
        const rgba = {
            ...(0, $taXj4.default).convert(hex).rgb,
            a: opacity
        };
        return `rgba(${Object.values(rgba).join(', ')})`;
    };
    const $0bda979ecec388a0$export$bba5a971afe05444 = (color)=>`0 0 0 2px ${color}`;
    const $0bda979ecec388a0$var$hex = '[a-z0-9]';
    const $0bda979ecec388a0$var$shortHandHexColorPattern = new RegExp(`#(${$0bda979ecec388a0$var$hex})(${$0bda979ecec388a0$var$hex})(${$0bda979ecec388a0$var$hex})`, 'i');
    const $0bda979ecec388a0$var$repeat = (str, times)=>[
            ...Array(times)
        ].map(()=>str).join('');
    const $0bda979ecec388a0$var$isShortHexColor = (color)=>color && color.length === 4;
    const $0bda979ecec388a0$var$completeHexColor = (colors)=>{
        const hex = colors.map((color)=>$0bda979ecec388a0$var$repeat(color, 2)).join('');
        return `#${hex}`;
    };
    const $0bda979ecec388a0$var$completeTriplet = (colors)=>`#${$0bda979ecec388a0$var$repeat(colors[1], 6)}`;
    const $0bda979ecec388a0$var$isTriplet = (colors)=>colors[0] === colors[1] && colors[1] === colors[2];
    const $0bda979ecec388a0$export$db8d2130677f868c = (color)=>{
        if ($0bda979ecec388a0$var$isShortHexColor(color)) {
            const matches = color.match($0bda979ecec388a0$var$shortHandHexColorPattern);
            if (matches) {
                const colors = matches.slice(1, 4);
                if ($0bda979ecec388a0$var$isTriplet(colors)) return $0bda979ecec388a0$var$completeTriplet(colors);
                else return $0bda979ecec388a0$var$completeHexColor(colors);
            }
        }
        return color;
    };
    const $0bda979ecec388a0$export$10a10e7cd1193377 = (color)=>{
        const converted = $0bda979ecec388a0$export$db8d2130677f868c(color);
        return (0, $taXj4.default).contrastRatio(converted).hex;
    };
    const $0bda979ecec388a0$export$77a1051494882576 = (contrastValue, opacityValue, color)=>$0bda979ecec388a0$export$7229be6d7219ee6a((0, $taXj4.default).contrast(contrastValue, color).hex, opacityValue);
});
parcelRegister("4Zowo", function(module, exports) {
    $parcel$export(module.exports, "generateTheme", ()=>$a6064f06a799f258$export$2e4ecffaca289a18);
    var $l8ip5 = parcelRequire("l8ip5");
    var $9fA8v = parcelRequire("9fA8v");
    const $a6064f06a799f258$var$generateOpacityValue = (color)=>color === '#000000' ? 0.3 : 0.6;
    const $a6064f06a799f258$var$generateButtonCSSStates = (colors, buttonType)=>{
        const { backgroundColor: backgroundColor, color: color, highlightColor: highlightColor } = colors;
        const opacityValue = $a6064f06a799f258$var$generateOpacityValue(color);
        const isCreateButton = buttonType === 'create';
        return {
            active: {
                backgroundColor: isCreateButton ? (0, $9fA8v.hexToRGBA)(backgroundColor, 0.65) : (0, $9fA8v.getContrastColor)(0.3, opacityValue, backgroundColor),
                boxShadow: (0, $9fA8v.getBoxShadow)('transparent'),
                color: color
            },
            default: {
                backgroundColor: backgroundColor,
                boxShadow: (0, $9fA8v.getBoxShadow)('transparent'),
                color: color
            },
            focus: {
                boxShadow: 'none',
                color: color,
                backgroundColor: backgroundColor
            },
            hover: {
                backgroundColor: isCreateButton ? (0, $9fA8v.hexToRGBA)(backgroundColor, 0.8) : (0, $9fA8v.getContrastColor)(0.1, opacityValue, backgroundColor),
                boxShadow: (0, $9fA8v.getBoxShadow)('transparent'),
                color: color
            },
            selected: {
                color: color,
                backgroundColor: (0, $9fA8v.getContrastColor)(0.3, opacityValue, backgroundColor),
                borderColor: highlightColor,
                boxShadow: (0, $9fA8v.getBoxShadow)('transparent')
            },
            selectedHover: {
                color: color,
                backgroundColor: (0, $9fA8v.getContrastColor)(0.3, opacityValue, backgroundColor),
                borderColor: highlightColor,
                boxShadow: (0, $9fA8v.getBoxShadow)('transparent')
            }
        };
    };
    const $a6064f06a799f258$var$generateCreateButtonColors = (themeBackground, themeHighlight)=>({
            backgroundColor: themeHighlight,
            color: (0, $9fA8v.generateTextColor)(themeHighlight),
            highlightColor: themeHighlight
        });
    const $a6064f06a799f258$export$2e4ecffaca289a18 = (themeColors)=>{
        const { backgroundColor: backgroundColor, highlightColor: highlightColor, name: name } = themeColors;
        const color = (0, $9fA8v.generateTextColor)(backgroundColor);
        const colors = {
            ...themeColors,
            color: color
        };
        if (name === (0, $l8ip5.DEFAULT_THEME_NAME)) return 0, $l8ip5.default;
        return {
            mode: {
                create: $a6064f06a799f258$var$generateButtonCSSStates($a6064f06a799f258$var$generateCreateButtonColors(backgroundColor, highlightColor), 'create'),
                iconButton: $a6064f06a799f258$var$generateButtonCSSStates(colors, 'iconButton'),
                primaryButton: $a6064f06a799f258$var$generateButtonCSSStates(colors, 'primaryButton'),
                navigation: {
                    backgroundColor: backgroundColor,
                    color: color
                },
                productHome: {
                    color: color,
                    backgroundColor: highlightColor,
                    borderRight: `1px solid ${(0, $9fA8v.hexToRGBA)(color, 0.5)}`
                },
                search: {
                    default: {
                        backgroundColor: backgroundColor,
                        color: color,
                        borderColor: (0, $9fA8v.hexToRGBA)(color, 0.5)
                    },
                    focus: {
                        borderColor: (0, $9fA8v.hexToRGBA)(highlightColor, 0.8),
                        boxShadow: (0, $9fA8v.getBoxShadow)((0, $9fA8v.hexToRGBA)(highlightColor, 0.5))
                    },
                    hover: {
                        backgroundColor: (0, $9fA8v.getContrastColor)(0.1, $a6064f06a799f258$var$generateOpacityValue(color), backgroundColor),
                        color: color
                    }
                },
                skeleton: {
                    backgroundColor: color,
                    opacity: 0.08
                }
            }
        };
    };
    var $a6064f06a799f258$export$2e2bcd8739ae039 = $a6064f06a799f258$export$2e4ecffaca289a18;
});
parcelRegister("5Ykgt", function(module, exports) {
    $parcel$export(module.exports, "ThemeContext", ()=>$0a726ac788b473d8$export$2c657da244d00bd6);
    $parcel$export(module.exports, "ThemeProvider", ()=>$0a726ac788b473d8$export$d8964aec282183a3);
    var $eUqFw = parcelRequire("eUqFw");
    var $etyk7 = parcelRequire("etyk7");
    const $0a726ac788b473d8$export$2c657da244d00bd6 = (0, $eUqFw.createContext)((0, $etyk7.defaultTheme));
    const $0a726ac788b473d8$export$d8964aec282183a3 = $0a726ac788b473d8$export$2c657da244d00bd6.Provider;
});
parcelRegister("2NNOl", function(module, exports) {
    $parcel$export(module.exports, "PrimaryItemsContainer", ()=>$a62a4fd117aea765$export$43e704064d596a9e);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $23sYR = parcelRequire("23sYR");
    var $3Q69O = parcelRequire("3Q69O");
    var $4Jb7X = parcelRequire("4Jb7X");
    var $94VvY = parcelRequire("94VvY");
    function $a62a4fd117aea765$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $a62a4fd117aea765$var$containerStyles = (0, $byn9U.css)({
        display: 'flex',
        height: '100%',
        position: 'relative',
        alignItems: 'stretch',
        flexBasis: 0,
        flexGrow: 1,
        flexShrink: 0,
        '& > *': {
            margin: `0 ${"var(--ds-space-050, 4px)"}`,
            flexShrink: 0
        }
    });
    const $a62a4fd117aea765$var$widthObserverContainerStyles = {
        name: "o1tvrz",
        styles: "width:100%;min-width:1px;margin:0px;position:relative;flex-shrink:1"
    };
    const $a62a4fd117aea765$var$overflowItemsStyles = (0, $byn9U.css)({
        color: `var(--ds-text, ${(0, $207acf722dcd432b$export$ad0bacf983b7ddaa)})`
    });
    const $a62a4fd117aea765$export$43e704064d596a9e = ({ moreLabel: moreLabel, items: items, create: Create, theme: theme, testId: testId })=>{
        const [isMoreOpen, setIsMoreOpen] = (0, $eUqFw.useState)(false);
        const { updateWidth: updateWidth, visibleItems: visibleItems, overflowItems: overflowItems } = (0, $4Jb7X.useOverflowController)(items);
        const onMoreClick = (0, $eUqFw.useCallback)(()=>{
            setIsMoreOpen(!isMoreOpen);
        }, [
            isMoreOpen,
            setIsMoreOpen
        ]);
        const onMoreClose = (0, $eUqFw.useCallback)(()=>{
            setIsMoreOpen(false);
        }, []);
        const openOverflowMenu = (0, $eUqFw.useCallback)(()=>{
            setIsMoreOpen(true);
        }, []);
        const trigger = (0, $eUqFw.useCallback)((triggerProps)=>(0, $byn9U.jsx)((0, $94VvY.PrimaryDropdownButton), {
                onClick: onMoreClick,
                isSelected: isMoreOpen,
                testId: testId ? `${testId}-overflow-menu-trigger` : 'overflow-menu-trigger',
                ...triggerProps
            }, moreLabel), [
            moreLabel,
            onMoreClick,
            isMoreOpen,
            testId
        ]);
        const content = (0, $eUqFw.useCallback)(()=>(0, $byn9U.jsx)((0, $4Jb7X.OverflowProvider), {
                isVisible: false,
                openOverflowMenu: openOverflowMenu,
                closeOverflowMenu: onMoreClose
            }, (0, $byn9U.jsx)("div", {
                css: $a62a4fd117aea765$var$overflowItemsStyles
            }, overflowItems)), [
            overflowItems.length,
            openOverflowMenu,
            onMoreClose
        ]);
        return (0, $byn9U.jsx)("div", {
            css: $a62a4fd117aea765$var$containerStyles,
            "data-testid": testId && `${testId}-primary-actions`,
            role: "list"
        }, (0, $byn9U.jsx)((0, $4Jb7X.OverflowProvider), {
            isVisible: true,
            openOverflowMenu: openOverflowMenu,
            closeOverflowMenu: onMoreClose
        }, visibleItems), overflowItems.length > 0 && (0, $byn9U.jsx)((0, $23sYR.default), {
            shouldRenderToParent: true,
            placement: "bottom-start",
            content: content,
            isOpen: isMoreOpen,
            onClose: onMoreClose,
            trigger: trigger,
            testId: testId ? `${testId}-overflow-menu-popup` : 'overflow-menu-popup'
        }), Create && (0, $byn9U.jsx)(Create, null), (0, $byn9U.jsx)("div", {
            css: $a62a4fd117aea765$var$widthObserverContainerStyles
        }, (0, $byn9U.jsx)((0, $3Q69O.WidthObserver), {
            offscreen: true,
            setWidth: updateWidth
        })));
    };
});
parcelRegister("4Jb7X", function(module, exports) {
    $parcel$export(module.exports, "OverflowProvider", ()=>$1c046c43b1880c27$export$a3a2def3937905a0);
    $parcel$export(module.exports, "useOverflowStatus", ()=>$1c046c43b1880c27$export$3fcfc71fab3314f2);
    $parcel$export(module.exports, "useOverflowController", ()=>$1c046c43b1880c27$export$705aa66a39c35bf7);
    var $eUqFw = parcelRequire("eUqFw");
    var $a576Y = parcelRequire("a576Y");
    var $4oSDA = parcelRequire("4oSDA");
    const $1c046c43b1880c27$var$THROTTLE_INTERVAL = 64;
    const $1c046c43b1880c27$var$ITEM_APPROX_MINWIDTH = 70;
    const $1c046c43b1880c27$var$calculateHash = (w, n)=>w + '#' + n;
    const $1c046c43b1880c27$var$updateHashRef = (currentRef, value)=>{
        currentRef.unshift(value);
        currentRef.length = 3;
    };
    const $1c046c43b1880c27$var$OverflowContext = (0, $eUqFw.createContext)({
        isVisible: true,
        openOverflowMenu: (0, $4oSDA.default),
        closeOverflowMenu: (0, $4oSDA.default)
    });
    const $1c046c43b1880c27$export$a3a2def3937905a0 = ({ children: children, isVisible: isVisible, openOverflowMenu: openOverflowMenu, closeOverflowMenu: closeOverflowMenu })=>{
        const { Provider: Provider } = $1c046c43b1880c27$var$OverflowContext;
        const value = (0, $eUqFw.useMemo)(()=>({
                isVisible: isVisible,
                openOverflowMenu: openOverflowMenu,
                closeOverflowMenu: closeOverflowMenu
            }), [
            isVisible,
            openOverflowMenu,
            closeOverflowMenu
        ]);
        return (0, ($parcel$interopDefault($eUqFw))).createElement(Provider, {
            value: value
        }, children);
    };
    const $1c046c43b1880c27$export$3fcfc71fab3314f2 = ()=>(0, $eUqFw.useContext)($1c046c43b1880c27$var$OverflowContext);
    const $1c046c43b1880c27$export$705aa66a39c35bf7 = (nodes)=>{
        const items = (0, ($parcel$interopDefault($eUqFw))).Children.toArray(nodes);
        const [width, setWidth] = (0, $eUqFw.useState)(9999);
        const [itemsLimit, setItemsLimit] = (0, $eUqFw.useState)(items.length);
        const [forceEffectValue, triggerForceEffect] = (0, $eUqFw.useState)({});
        const itemsWidths = (0, $eUqFw.useRef)([]).current;
        const hashRef = (0, $eUqFw.useRef)([]);
        const throttleSetWidth = (0, $eUqFw.useCallback)((0, ($parcel$interopDefault($a576Y)))(setWidth, $1c046c43b1880c27$var$THROTTLE_INTERVAL), [
            setWidth
        ]);
        (0, $eUqFw.useEffect)(()=>{
            const lastItemWidth = itemsWidths[itemsLimit] || 0;
            const wasJustLimited = lastItemWidth < 0;
            const currentHash = $1c046c43b1880c27$var$calculateHash(width, itemsLimit);
            if (hashRef.current[0] === currentHash) {
                const t = setTimeout(()=>{
                    $1c046c43b1880c27$var$updateHashRef(hashRef.current, '');
                    triggerForceEffect({});
                }, $1c046c43b1880c27$var$THROTTLE_INTERVAL * 1.5);
                return ()=>clearTimeout(t);
            }
            if (wasJustLimited) {
                const partialWidth = Math.max(Math.min(width + lastItemWidth, $1c046c43b1880c27$var$ITEM_APPROX_MINWIDTH * 2), $1c046c43b1880c27$var$ITEM_APPROX_MINWIDTH);
                itemsWidths[itemsLimit] = partialWidth;
            }
            if (width < $1c046c43b1880c27$var$ITEM_APPROX_MINWIDTH * 0.9 && itemsLimit) {
                const nextHash = $1c046c43b1880c27$var$calculateHash(width, itemsLimit - 1);
                if (hashRef.current.indexOf(nextHash) === -1) {
                    setItemsLimit(itemsLimit - 1);
                    itemsWidths[itemsLimit - 1] = -(width || 1);
                    $1c046c43b1880c27$var$updateHashRef(hashRef.current, nextHash);
                }
                return;
            }
            const currentLastItemWidth = itemsWidths[itemsLimit] || 0;
            if (width - currentLastItemWidth > $1c046c43b1880c27$var$ITEM_APPROX_MINWIDTH * 1.1 && itemsLimit < items.length) {
                const nextHash = $1c046c43b1880c27$var$calculateHash(width, itemsLimit + 1);
                if (hashRef.current.indexOf(nextHash) === -1) {
                    setItemsLimit(itemsLimit + 1);
                    $1c046c43b1880c27$var$updateHashRef(hashRef.current, nextHash);
                }
                return;
            }
        }, [
            width,
            hashRef,
            itemsLimit,
            itemsWidths,
            forceEffectValue,
            items.length
        ]);
        return {
            visibleItems: items.slice(0, itemsLimit),
            overflowItems: items.slice(itemsLimit),
            updateWidth: throttleSetWidth
        };
    };
    var $1c046c43b1880c27$export$2e2bcd8739ae039 = (props)=>{};
});
parcelRegister("94VvY", function(module, exports) {
    $parcel$export(module.exports, "PrimaryDropdownButton", ()=>$ecd056c91ee2c9d6$export$bb3af89fb196520d);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $186Wd = parcelRequire("186Wd");
    var $eRXEa = parcelRequire("eRXEa");
    var $iDwTy = parcelRequire("iDwTy");
    var $jwf8c = parcelRequire("jwf8c");
    var $fHiYa = parcelRequire("fHiYa");
    var $r7sUT = parcelRequire("r7sUT");
    const $ecd056c91ee2c9d6$var$chevronIconStylesWithSpacingFixStyles = (0, $fHiYa.xcss)({
        marginInlineEnd: 'space.negative.050'
    });
    const $ecd056c91ee2c9d6$export$bb3af89fb196520d = (0, $eUqFw.forwardRef)((props, ref)=>{
        return (0, $byn9U.jsx)((0, $r7sUT.PrimaryButton), {
            iconAfter: (0, $iDwTy.fg)('platform-component-visual-refresh') ? (0, $byn9U.jsx)((0, ($parcel$interopDefault($eRXEa))), {
                label: "",
                color: "currentColor"
            }) : (0, $byn9U.jsx)((0, $jwf8c.default), {
                xcss: $ecd056c91ee2c9d6$var$chevronIconStylesWithSpacingFixStyles,
                inline: "space.100"
            }, (0, $byn9U.jsx)((0, ($parcel$interopDefault($186Wd))), {
                label: ""
            })),
            ref: ref,
            ...props
        });
    });
    var $ecd056c91ee2c9d6$export$2e2bcd8739ae039 = $ecd056c91ee2c9d6$export$bb3af89fb196520d;
});
parcelRegister("r7sUT", function(module, exports) {
    $parcel$export(module.exports, "PrimaryButton", ()=>$59f76cfb45f1238e$export$ac16a6a04d9b7c84);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $11GuH = parcelRequire("11GuH");
    var $cmipe = parcelRequire("cmipe");
    var $aUZbY = parcelRequire("aUZbY");
    var $1Y2kK = parcelRequire("1Y2kK");
    function $59f76cfb45f1238e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $59f76cfb45f1238e$var$VAR_BUTTON_SELECTED_COLOR = '--button-selected-color';
    const $59f76cfb45f1238e$var$VAR_BUTTON_SELECTED_BORDER_COLOR = '--button-selected-border-color';
    const $59f76cfb45f1238e$var$buttonBaseStyles = {
        name: "8cx1fx",
        styles: "display:flex;height:100%;position:relative;align-items:center;justify-content:center;flex-direction:column"
    };
    const $59f76cfb45f1238e$var$buttonHighlightedStyles = (0, $byn9U.css)({
        '&& > *': {
            color: `var(${$59f76cfb45f1238e$var$VAR_BUTTON_SELECTED_COLOR})`
        },
        '&:after': {
            height: 3,
            position: 'absolute',
            backgroundColor: `var(${$59f76cfb45f1238e$var$VAR_BUTTON_SELECTED_BORDER_COLOR})`,
            borderStartEndRadius: "var(--ds-border-radius-050, 1px)",
            borderStartStartRadius: "var(--ds-border-radius-050, 1px)",
            content: '""',
            insetBlockEnd: 0,
            insetInlineEnd: "var(--ds-space-050, 4px)",
            insetInlineStart: "var(--ds-space-050, 4px)"
        }
    });
    const $59f76cfb45f1238e$export$ac16a6a04d9b7c84 = (0, $eUqFw.forwardRef)((props, ref)=>{
        const { children: children, testId: testId, tooltip: tooltip, isSelected: isSelected, isHighlighted: isHighlighted, ...buttonProps } = props;
        const theme = (0, $aUZbY.useTheme)();
        const button = (0, $byn9U.jsx)("div", {
            style: {
                [$59f76cfb45f1238e$var$VAR_BUTTON_SELECTED_COLOR]: theme.mode.primaryButton.selected.color,
                [$59f76cfb45f1238e$var$VAR_BUTTON_SELECTED_BORDER_COLOR]: theme.mode.primaryButton.selected.borderColor
            },
            css: [
                $59f76cfb45f1238e$var$buttonBaseStyles,
                isHighlighted && $59f76cfb45f1238e$var$buttonHighlightedStyles
            ],
            role: "listitem",
            "data-vc": "primary-button"
        }, (0, $byn9U.jsx)((0, $11GuH.default), {
            appearance: "primary",
            testId: testId,
            ref: ref,
            isSelected: isSelected,
            theme: (0, $1Y2kK.getPrimaryButtonTheme)(theme),
            ...buttonProps
        }, children));
        if (tooltip) return (0, $byn9U.jsx)((0, $cmipe.default), {
            content: tooltip,
            hideTooltipOnClick: true
        }, button);
        return button;
    });
    var $59f76cfb45f1238e$export$2e2bcd8739ae039 = $59f76cfb45f1238e$export$ac16a6a04d9b7c84;
});
parcelRegister("aUZbY", function(module, exports) {
    $parcel$export(module.exports, "useTheme", ()=>$fdbcb01ce81505a3$export$93d4e7f90805808f);
    var $eUqFw = parcelRequire("eUqFw");
    var $5Ykgt = parcelRequire("5Ykgt");
    const $fdbcb01ce81505a3$export$93d4e7f90805808f = ()=>(0, $eUqFw.useContext)((0, $5Ykgt.ThemeContext));
});
parcelRegister("1Y2kK", function(module, exports) {
    $parcel$export(module.exports, "getPrimaryButtonTheme", ()=>$21e025165293c8d6$export$14dd6915caf431fe);
    const $21e025165293c8d6$export$14dd6915caf431fe = ({ mode: { primaryButton: primaryButton } })=>(current, props)=>{
            const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
            return {
                buttonStyles: {
                    ...buttonStyles,
                    ...primaryButton.default,
                    ...props.isSelected && primaryButton.selected,
                    fontWeight: "var(--ds-font-weight-medium, 500)",
                    padding: `0 ${"var(--ds-space-050, 4px)"}`,
                    marginLeft: 0,
                    marginRight: 0,
                    ':hover': props.isSelected ? primaryButton.selectedHover : primaryButton.hover,
                    ':focus': primaryButton.focus,
                    '&&': {
                        ...props.state === 'active' && primaryButton.active
                    }
                },
                spinnerStyles: spinnerStyles
            };
        };
});
parcelRegister("xMdsB", function(module, exports) {
    $parcel$export(module.exports, "PrimaryItemsContainer", ()=>$adc47ca8d82e26eb$export$43e704064d596a9e);
    var $eUqFw = parcelRequire("eUqFw");
    var $23sYR = parcelRequire("23sYR");
    var $jGR8u = parcelRequire("jGR8u");
    var $1AHzd = parcelRequire("1AHzd");
    var $fHiYa = parcelRequire("fHiYa");
    var $jijTN = parcelRequire("jijTN");
    var $hHxfS = parcelRequire("hHxfS");
    var $4Jb7X = parcelRequire("4Jb7X");
    var $94VvY = parcelRequire("94VvY");
    const $adc47ca8d82e26eb$var$containerWrapperStyles = (0, $fHiYa.xcss)({
        height: '100%'
    });
    const $adc47ca8d82e26eb$var$sharedContainerStyles = (0, $fHiYa.xcss)({
        height: '100%',
        alignItems: 'stretch',
        paddingInlineEnd: 'space.050',
        gap: 'space.100'
    });
    const $adc47ca8d82e26eb$var$smallContainerStyles = (0, $fHiYa.xcss)({
        [(0, $jijTN.media).above.sm]: {
            display: 'none'
        }
    });
    const $adc47ca8d82e26eb$var$mediumContainerStyles = (0, $fHiYa.xcss)({
        display: 'none',
        [(0, $jijTN.media).above.sm]: {
            display: 'flex'
        },
        [(0, $jijTN.media).above.lg]: {
            display: 'none'
        }
    });
    const $adc47ca8d82e26eb$var$largeContainerStyles = (0, $fHiYa.xcss)({
        display: 'none',
        [(0, $jijTN.media).above.lg]: {
            display: 'flex'
        }
    });
    const $adc47ca8d82e26eb$var$overflowItemsStyles = (0, $fHiYa.xcss)({
        color: 'color.text'
    });
    const $adc47ca8d82e26eb$var$MoreItemsPopup = ({ moreLabel: moreLabel, testId: testId, items: items })=>{
        const [isMoreOpen, setIsMoreOpen] = (0, $eUqFw.useState)(false);
        const onMoreClose = (0, $eUqFw.useCallback)(()=>setIsMoreOpen(false), []);
        const onMoreClick = (0, $eUqFw.useCallback)(()=>setIsMoreOpen((current)=>!current), []);
        const openOverflowMenu = (0, $eUqFw.useCallback)(()=>setIsMoreOpen(true), []);
        const trigger = (0, $eUqFw.useCallback)((triggerProps)=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $94VvY.PrimaryDropdownButton), {
                onClick: onMoreClick,
                isSelected: isMoreOpen,
                testId: testId ? `${testId}-overflow-menu-trigger` : 'overflow-menu-trigger',
                ...triggerProps
            }, moreLabel), [
            moreLabel,
            onMoreClick,
            isMoreOpen,
            testId
        ]);
        const content = (0, $eUqFw.useCallback)(()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $4Jb7X.OverflowProvider), {
                isVisible: false,
                openOverflowMenu: openOverflowMenu,
                closeOverflowMenu: onMoreClose
            }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
                xcss: $adc47ca8d82e26eb$var$overflowItemsStyles
            }, items)), [
            items,
            openOverflowMenu,
            onMoreClose
        ]);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $23sYR.default), {
            shouldRenderToParent: true,
            placement: "bottom-start",
            isOpen: isMoreOpen,
            onClose: onMoreClose,
            trigger: trigger,
            content: content,
            testId: testId ? `${testId}-overflow-menu-popup` : 'overflow-menu-popup'
        });
    };
    const $adc47ca8d82e26eb$export$43e704064d596a9e = (0, $eUqFw.memo)(({ moreLabel: moreLabel, items: items, create: Create, theme: theme, testId: testId })=>{
        const [isClient, setIsClient] = (0, $eUqFw.useState)(false);
        (0, $eUqFw.useEffect)(()=>{
            setIsClient(true);
        }, []);
        const mqSm = (0, $hHxfS.UNSAFE_useMediaQuery)('above.sm', (event)=>setIsAboveSm(event.matches));
        const [isAboveSm, setIsAboveSm] = (0, $eUqFw.useState)(mqSm?.matches);
        const mqLg = (0, $hHxfS.UNSAFE_useMediaQuery)('above.lg', (event)=>setIsAboveLg(event.matches));
        const [isAboveLg, setIsAboveLg] = (0, $eUqFw.useState)(mqLg?.matches);
        const filteredItems = (0, $eUqFw.useMemo)(()=>(0, ($parcel$interopDefault($eUqFw))).Children.toArray(items).filter((item)=>!!item), [
            items
        ]);
        const smallMaxItems = 0;
        const mediumMaxItems = 3;
        const largeMaxItems = 8;
        const navItems = (0, $eUqFw.useMemo)(()=>{
            return {
                small: {
                    navBarItems: [],
                    overflowItems: filteredItems
                },
                medium: {
                    navBarItems: filteredItems.slice(0, mediumMaxItems),
                    overflowItems: filteredItems.slice(mediumMaxItems, filteredItems.length)
                },
                large: {
                    navBarItems: filteredItems.slice(0, largeMaxItems),
                    overflowItems: filteredItems.slice(largeMaxItems, filteredItems.length)
                }
            };
        }, [
            filteredItems
        ]);
        const hydratedNavItems = (0, $eUqFw.useMemo)(()=>{
            if (isAboveLg) return navItems.large;
            if (isAboveSm && !isAboveLg) return navItems.medium;
            return navItems.small;
        }, [
            isAboveLg,
            isAboveSm,
            navItems.large,
            navItems.medium,
            navItems.small
        ]);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, isClient ? (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            role: "list",
            xcss: $adc47ca8d82e26eb$var$containerWrapperStyles
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $1AHzd.default), {
            testId: testId && `${testId}-primary-actions`,
            xcss: $adc47ca8d82e26eb$var$sharedContainerStyles
        }, hydratedNavItems.navBarItems, hydratedNavItems.overflowItems.length > 0 && (0, ($parcel$interopDefault($eUqFw))).createElement($adc47ca8d82e26eb$var$MoreItemsPopup, {
            moreLabel: moreLabel,
            items: hydratedNavItems.overflowItems,
            testId: testId
        }))) : (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            role: "list",
            xcss: $adc47ca8d82e26eb$var$containerWrapperStyles
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $1AHzd.default), {
            xcss: [
                $adc47ca8d82e26eb$var$sharedContainerStyles,
                $adc47ca8d82e26eb$var$smallContainerStyles
            ]
        }, filteredItems.length > smallMaxItems && (0, ($parcel$interopDefault($eUqFw))).createElement($adc47ca8d82e26eb$var$MoreItemsPopup, {
            moreLabel: moreLabel,
            testId: testId
        })), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $1AHzd.default), {
            xcss: [
                $adc47ca8d82e26eb$var$sharedContainerStyles,
                $adc47ca8d82e26eb$var$mediumContainerStyles
            ]
        }, navItems.medium.navBarItems, navItems.medium.overflowItems.length > 0 && (0, ($parcel$interopDefault($eUqFw))).createElement($adc47ca8d82e26eb$var$MoreItemsPopup, {
            moreLabel: moreLabel,
            testId: testId
        })), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $1AHzd.default), {
            xcss: [
                $adc47ca8d82e26eb$var$sharedContainerStyles,
                $adc47ca8d82e26eb$var$largeContainerStyles
            ]
        }, navItems.large.navBarItems, navItems.large.overflowItems.length > 0 && (0, ($parcel$interopDefault($eUqFw))).createElement($adc47ca8d82e26eb$var$MoreItemsPopup, {
            moreLabel: moreLabel,
            testId: testId
        }))), Create && (0, ($parcel$interopDefault($eUqFw))).createElement(Create, null));
    });
});
parcelRegister("deY64", function(module, exports) {
    $parcel$export(module.exports, "AppSwitcher", ()=>$a9c939ef1dd8c449$export$9923361bd43fa030);
    $parcel$export(module.exports, "AppSwitcherNav4", ()=>$a9c939ef1dd8c449$export$28833e0dfbd2ac80);
    var $eUqFw = parcelRequire("eUqFw");
    var $fJz5M = parcelRequire("fJz5M");
    var $6hBRO = parcelRequire("6hBRO");
    var $dX6S1 = parcelRequire("dX6S1");
    const $a9c939ef1dd8c449$export$9923361bd43fa030 = (0, $eUqFw.forwardRef)((props, ref)=>{
        const { tooltip: tooltip, ...iconButtonProps } = props;
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $dX6S1.IconButton), {
            icon: (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($6hBRO))), {
                label: typeof tooltip === 'string' ? tooltip : 'Switch apps'
            }),
            tooltip: tooltip,
            ref: ref,
            ...iconButtonProps
        });
    });
    const $a9c939ef1dd8c449$export$28833e0dfbd2ac80 = (0, $eUqFw.forwardRef)((props, ref)=>{
        const { tooltip: tooltip, ...iconButtonProps } = props;
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $dX6S1.IconButton), {
            icon: (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($fJz5M))), {
                label: typeof tooltip === 'string' ? tooltip : 'Switch apps',
                color: "var(--ds-icon, #44546F)"
            }),
            tooltip: tooltip,
            ref: ref,
            ...iconButtonProps
        });
    });
    var $a9c939ef1dd8c449$export$2e2bcd8739ae039 = (props)=>{};
});
parcelRegister("dX6S1", function(module, exports) {
    $parcel$export(module.exports, "IconButton", ()=>$e6f048d74e2cedef$export$c25acd513dcc8062);
    var $eUqFw = parcelRequire("eUqFw");
    var $11GuH = parcelRequire("11GuH");
    var $cmipe = parcelRequire("cmipe");
    var $aUZbY = parcelRequire("aUZbY");
    var $gceuZ = parcelRequire("gceuZ");
    const $e6f048d74e2cedef$export$c25acd513dcc8062 = (0, $eUqFw.forwardRef)((props, ref)=>{
        const { icon: icon, label: label, testId: testId, tooltip: tooltip, ...buttonProps } = props;
        const theme = (0, $aUZbY.useTheme)();
        const button = (0, ($parcel$interopDefault($eUqFw))).createElement((0, $11GuH.default), {
            appearance: "primary",
            "aria-label": label,
            testId: testId,
            iconBefore: icon,
            ref: ref,
            theme: (0, $gceuZ.getIconButtonTheme)(theme),
            ...buttonProps
        });
        if (tooltip) return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $cmipe.default), {
            content: tooltip,
            hideTooltipOnClick: true
        }, button);
        return button;
    });
});
parcelRegister("gceuZ", function(module, exports) {
    $parcel$export(module.exports, "getIconButtonTheme", ()=>$b401133023697a70$export$f32bddcb857301f3);
    const $b401133023697a70$export$f32bddcb857301f3 = ({ mode: { iconButton: iconButton } })=>(current, props)=>{
            const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
            return {
                buttonStyles: {
                    ...buttonStyles,
                    borderRadius: "var(--ds-border-radius-circle, 100%)",
                    display: 'flex',
                    margin: `0 ${"var(--ds-space-025, 2px)"}`,
                    padding: "var(--ds-space-050, 4px)",
                    height: 'auto',
                    fontWeight: "var(--ds-font-weight-medium, 500)",
                    ...iconButton.default,
                    ':hover': iconButton.hover,
                    ':focus': iconButton.focus,
                    '&&': {
                        ...props.state === 'active' && iconButton.active
                    },
                    ...props.state === 'selected' && iconButton.selected,
                    '> span': {
                        margin: 0
                    }
                },
                spinnerStyles: spinnerStyles
            };
        };
});
parcelRegister("yU8qG", function(module, exports) {
    $parcel$export(module.exports, "SkeletonSwitcherButton", ()=>$9507c17d2dc9749a$export$41b1bb24b7702cc2);
    $parcel$export(module.exports, "Nav4SkeletonSwitcherButton", ()=>$9507c17d2dc9749a$export$68afc1d9d20a7bd8);
    var $byn9U = parcelRequire("byn9U");
    var $fJz5M = parcelRequire("fJz5M");
    var $6hBRO = parcelRequire("6hBRO");
    var $ioJj7 = parcelRequire("ioJj7");
    var $aUZbY = parcelRequire("aUZbY");
    const $9507c17d2dc9749a$var$skeletonSwitcherButtonStyles = (0, $byn9U.css)({
        margin: 0,
        marginRight: "var(--ds-space-050, 4px)",
        padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`,
        border: 0,
        borderRadius: "var(--ds-border-radius-circle, 100%)",
        pointerEvents: 'none',
        ':focus, :active, :hover': {
            appearance: 'none',
            border: 0,
            outline: 0
        },
        '&:only-of-type': {
            marginRight: 0
        },
        '& > span': {
            lineHeight: 'normal'
        },
        '& > img': {
            width: 24,
            height: 24,
            borderRadius: "var(--ds-border-radius-circle, 100%)",
            verticalAlign: 'middle'
        }
    });
    const $9507c17d2dc9749a$export$41b1bb24b7702cc2 = ({ label: label = '', testId: testId })=>{
        const theme = (0, $aUZbY.useTheme)();
        return ((0, $byn9U.jsx)("button", {
            style: theme.mode.iconButton.default,
            "data-testid": testId,
            css: $9507c17d2dc9749a$var$skeletonSwitcherButtonStyles,
            type: "button"
        }, (0, $byn9U.jsx)((0, ($parcel$interopDefault($6hBRO))), {
            label: label
        })));
    };
    const $9507c17d2dc9749a$export$68afc1d9d20a7bd8 = ({ label: label = '', testId: testId })=>(0, $byn9U.jsx)((0, $ioJj7.SkeletonIconButton), null, (0, $byn9U.jsx)((0, ($parcel$interopDefault($fJz5M))), {
            label: label,
            color: "var(--ds-icon, #44546F)"
        }));
});
parcelRegister("ioJj7", function(module, exports) {
    $parcel$export(module.exports, "SkeletonIconButton", ()=>$b6c91624aaecf5bb$export$7b398af37f6177e);
    var $byn9U = parcelRequire("byn9U");
    var $aUZbY = parcelRequire("aUZbY");
    function $b6c91624aaecf5bb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $b6c91624aaecf5bb$var$skeletonIconButtonStyles = (0, $byn9U.css)({
        margin: 0,
        padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`,
        border: 0,
        borderRadius: "var(--ds-border-radius-circle, 100%)",
        pointerEvents: 'none',
        ':focus, :active, :hover': {
            appearance: 'none',
            border: 0,
            outline: 0
        },
        '& > span': {
            lineHeight: 'normal'
        },
        '& > img': {
            width: 24,
            height: 24,
            borderRadius: "var(--ds-border-radius-circle, 100%)",
            verticalAlign: 'middle'
        }
    });
    const $b6c91624aaecf5bb$var$buttonWrapperStyles = {
        name: "khzvr",
        styles: "margin-inline-end:var(--ds-space-050, 4px);&:only-of-type{margin-inline-end:0;}"
    };
    const $b6c91624aaecf5bb$export$7b398af37f6177e = ({ children: children, testId: testId })=>{
        const theme = (0, $aUZbY.useTheme)();
        return (0, $byn9U.jsx)("div", {
            role: "listitem",
            css: $b6c91624aaecf5bb$var$buttonWrapperStyles
        }, (0, $byn9U.jsx)("button", {
            style: theme.mode.iconButton.default,
            "data-testid": testId,
            css: $b6c91624aaecf5bb$var$skeletonIconButtonStyles,
            type: "button"
        }, children));
    };
});
parcelRegister("4iy42", function(module, exports) {
    $parcel$export(module.exports, "AppSwitcher", ()=>$5f7ca26f2d48a2a2$export$9923361bd43fa030);
    var $eUqFw = parcelRequire("eUqFw");
    var $fJz5M = parcelRequire("fJz5M");
    var $dHvJ4 = parcelRequire("dHvJ4");
    const $5f7ca26f2d48a2a2$var$toggleButtonTooltipOptions = {
        ignoreTooltipPointerEvents: true
    };
    const $5f7ca26f2d48a2a2$export$9923361bd43fa030 = (0, $eUqFw.forwardRef)(({ label: label = 'App switcher', onClick: onClick, onMouseEnter: onMouseEnter, interactionName: interactionName, isSelected: isSelected, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup }, ref)=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $dHvJ4.IconButton), {
            ref: ref,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHasPopup,
            icon: (0, ($parcel$interopDefault($fJz5M))),
            label: label,
            appearance: "subtle",
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            interactionName: interactionName,
            isTooltipDisabled: false,
            tooltip: $5f7ca26f2d48a2a2$var$toggleButtonTooltipOptions,
            isSelected: isSelected
        }));
});
parcelRegister("dHvJ4", function(module, exports) {
    $parcel$export(module.exports, "IconButton", ()=>$fe9a2dbf6727a284$export$c25acd513dcc8062);
    $parcel$export(module.exports, "Button", ()=>$fe9a2dbf6727a284$export$353f5b6fc5456de1);
    var $eUqFw = parcelRequire("eUqFw");
    var $7LEad = parcelRequire("7LEad");
    var $ipmlN = parcelRequire("ipmlN");
    var $kWJMs = parcelRequire("kWJMs");
    var $FSQzJ = parcelRequire("FSQzJ");
    const $fe9a2dbf6727a284$export$c25acd513dcc8062 = (0, $eUqFw.forwardRef)((props, ref)=>{
        const hasCustomTheme = (0, $FSQzJ.useHasCustomTheme)();
        const Component = hasCustomTheme ? (0, $kWJMs.ThemedIconButton) : (0, $ipmlN.default);
        return (0, ($parcel$interopDefault($eUqFw))).createElement(Component, {
            ref: ref,
            ...props
        });
    });
    const $fe9a2dbf6727a284$export$353f5b6fc5456de1 = (0, $eUqFw.forwardRef)((props, ref)=>{
        const hasCustomTheme = (0, $FSQzJ.useHasCustomTheme)();
        const Component = hasCustomTheme ? (0, $kWJMs.ThemedButton) : (0, $7LEad.default);
        return (0, ($parcel$interopDefault($eUqFw))).createElement(Component, {
            ref: ref,
            ...props
        });
    });
});
parcelRegister("h8DxO", function(module, exports) {
    $parcel$export(module.exports, "Notifications", ()=>$24ed44545e162ca5$export$36ba2f559d49a8f6);
    var $eUqFw = parcelRequire("eUqFw");
    var $6BrIh = parcelRequire("6BrIh");
    var $eOisq = parcelRequire("eOisq");
    var $dX6S1 = parcelRequire("dX6S1");
    const $24ed44545e162ca5$var$NOTIFICATIONS_BADGE_ID = 'atlassian-navigation-notification-count';
    const $24ed44545e162ca5$export$36ba2f559d49a8f6 = (0, $eUqFw.forwardRef)((props, ref)=>{
        const { badge: badge, tooltip: tooltip, ...iconButtonProps } = props;
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $eOisq.BadgeContainer), {
            id: $24ed44545e162ca5$var$NOTIFICATIONS_BADGE_ID,
            badge: badge,
            role: "listitem"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $dX6S1.IconButton), {
            icon: (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($6BrIh))), {
                label: typeof tooltip === 'string' ? tooltip : 'Notification Icon'
            }),
            tooltip: tooltip,
            ref: ref,
            "aria-describedby": $24ed44545e162ca5$var$NOTIFICATIONS_BADGE_ID,
            ...iconButtonProps
        }));
    });
    var $24ed44545e162ca5$export$2e2bcd8739ae039 = $24ed44545e162ca5$export$36ba2f559d49a8f6;
});
parcelRegister("eOisq", function(module, exports) {
    $parcel$export(module.exports, "BadgeContainer", ()=>$b456ab1234e00c36$export$f710265eb5a003da);
    var $byn9U = parcelRequire("byn9U");
    function $b456ab1234e00c36$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $b456ab1234e00c36$var$badgeContainerStyles = (0, $byn9U.css)({
        position: 'absolute',
        insetBlockStart: `${"var(--ds-space-negative-050, -4px)"}`,
        insetInlineEnd: `${"var(--ds-space-negative-025, -2px)"}`,
        pointerEvents: 'none'
    });
    const $b456ab1234e00c36$var$containerStyles = {
        name: "bjn8wh",
        styles: "position:relative"
    };
    const $b456ab1234e00c36$export$f710265eb5a003da = (props)=>{
        const { id: badgeId, badge: Badge, children: children, role: role } = props;
        return (0, $byn9U.jsx)("div", {
            css: $b456ab1234e00c36$var$containerStyles,
            role: role
        }, children, (0, $byn9U.jsx)("div", {
            css: $b456ab1234e00c36$var$badgeContainerStyles,
            id: badgeId,
            "aria-hidden": true
        }, (0, $byn9U.jsx)(Badge, null)));
    };
});
parcelRegister("hsJQh", function(module, exports) {
    $parcel$export(module.exports, "SkeletonNotificationButton", ()=>$a4a155f767469b27$export$a14f01df37978534);
    $parcel$export(module.exports, "Nav4SkeletonNotificationButton", ()=>$a4a155f767469b27$export$6df5583c56de301f);
    var $eUqFw = parcelRequire("eUqFw");
    var $crTNR = parcelRequire("crTNR");
    var $6BrIh = parcelRequire("6BrIh");
    var $ioJj7 = parcelRequire("ioJj7");
    const $a4a155f767469b27$export$a14f01df37978534 = ({ label: label = '' })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $ioJj7.SkeletonIconButton), null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($6BrIh))), {
            label: label
        }));
    const $a4a155f767469b27$export$6df5583c56de301f = ({ label: label = '' })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $ioJj7.SkeletonIconButton), null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($crTNR))), {
            label: label,
            color: "var(--ds-icon, #44546F)"
        }));
});
parcelRegister("ev1i6", function(module, exports) {
    $parcel$export(module.exports, "Notifications", ()=>$c26f184087f51429$export$36ba2f559d49a8f6);
    var $eUqFw = parcelRequire("eUqFw");
    var $crTNR = parcelRequire("crTNR");
    var $eJ2hD = parcelRequire("eJ2hD");
    var $dHvJ4 = parcelRequire("dHvJ4");
    const $c26f184087f51429$var$NOTIFICATIONS_BADGE_ID = 'atlassian-navigation-notification-count';
    const $c26f184087f51429$export$36ba2f559d49a8f6 = (0, $eUqFw.forwardRef)(({ badge: badge, onClick: onClick, label: label = 'Notifications', isSelected: isSelected, testId: testId, interactionName: interactionName }, forwardedRef)=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $eJ2hD.BadgeContainer), {
            id: $c26f184087f51429$var$NOTIFICATIONS_BADGE_ID,
            badge: badge,
            role: "listitem"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $dHvJ4.IconButton), {
            icon: (0, ($parcel$interopDefault($crTNR))),
            label: label,
            onClick: onClick,
            appearance: "subtle",
            isSelected: isSelected,
            ref: forwardedRef,
            isTooltipDisabled: false,
            testId: testId,
            interactionName: interactionName
        })));
});
parcelRegister("eJ2hD", function(module, exports) {
    $parcel$export(module.exports, "BadgeContainer", ()=>$ba30eb88c5280bec$export$f710265eb5a003da);
    var $eUqFw = parcelRequire("eUqFw");
    var $7JEyt = parcelRequire("7JEyt");
    const $ba30eb88c5280bec$var$styles = {
        root: "_kqswh2mm _1e0c1txw",
        badgeContainer: "_kqswstnw _o5721q9c _152tr5cr _1e02utpp _lcxvglyw"
    };
    const $ba30eb88c5280bec$export$f710265eb5a003da = ({ children: children, id: badgeId, badge: Badge, role: role })=>$eUqFw.createElement("div", {
            role: role,
            className: (0, $7JEyt.default)([
                $ba30eb88c5280bec$var$styles.root
            ])
        }, children, $eUqFw.createElement("div", {
            id: badgeId,
            "aria-hidden": true,
            className: (0, $7JEyt.default)([
                $ba30eb88c5280bec$var$styles.badgeContainer
            ])
        }, $eUqFw.createElement(Badge, null)));
});
parcelRegister("hJskN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1734ae815551ba94$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $iDwTy = parcelRequire("iDwTy");
    var $aUZbY = parcelRequire("aUZbY");
    var $b3cMP = parcelRequire("b3cMP");
    function $1734ae815551ba94$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $1734ae815551ba94$var$VAR_PRODUCT_HOME_COLOR_ACTIVE = '--product-home-color-active';
    const $1734ae815551ba94$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE = '--product-home-bg-color-active';
    const $1734ae815551ba94$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE = '--product-home-box-shadow-active';
    const $1734ae815551ba94$var$VAR_PRODUCT_HOME_COLOR_FOCUS = '--product-home-color-focus';
    const $1734ae815551ba94$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS = '--product-home-bg-color-focus';
    const $1734ae815551ba94$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS = '--product-home-box-shadow-focus';
    const $1734ae815551ba94$var$VAR_PRODUCT_HOME_COLOR_HOVER = '--product-home-color-hover';
    const $1734ae815551ba94$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER = '--product-home-bg-color-hover';
    const $1734ae815551ba94$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER = '--product-home-box-shadow-hover';
    const $1734ae815551ba94$var$productLogoStyles = (0, $byn9U.css)({
        display: 'flex',
        [`@media (max-width: ${(0, $b156b847c373c90e$export$4033a111ca79977d) - 0.1}px)`]: {
            display: 'none'
        }
    });
    const $1734ae815551ba94$var$customMaxHeightStyles = {
        name: "31vqaf",
        styles: "max-height:28px"
    };
    const $1734ae815551ba94$var$productIconStyles = (0, $byn9U.css)({
        display: 'flex',
        [`@media (min-width: ${0, $b156b847c373c90e$export$4033a111ca79977d}px)`]: {
            display: 'none'
        }
    });
    const $1734ae815551ba94$var$productHomeButtonStyles = (0, $byn9U.css)({
        display: 'flex',
        padding: "var(--ds-space-050, 4px)",
        alignItems: 'center',
        background: 'none',
        border: 0,
        borderRadius: "var(--ds-border-radius, 3px)",
        color: 'inherit',
        cursor: 'pointer',
        '&::-moz-focus-inner': {
            border: 0
        },
        '&:first-of-type': {
            marginInlineStart: 0
        },
        '&:hover': {
            backgroundColor: `var(${$1734ae815551ba94$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER})`,
            boxShadow: `var(${$1734ae815551ba94$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER})`,
            color: `var(${$1734ae815551ba94$var$VAR_PRODUCT_HOME_COLOR_HOVER})`
        },
        '&:active': {
            backgroundColor: `var(${$1734ae815551ba94$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE})`,
            boxShadow: `var(${$1734ae815551ba94$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE})`,
            color: `var(${$1734ae815551ba94$var$VAR_PRODUCT_HOME_COLOR_ACTIVE})`
        },
        '&:focus-visible': {
            backgroundColor: `var(${$1734ae815551ba94$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS})`,
            color: `var(${$1734ae815551ba94$var$VAR_PRODUCT_HOME_COLOR_FOCUS})`,
            outline: `2px solid ${`var(--ds-border-focused, ${(0, $207acf722dcd432b$export$215b7063051591f1)})`}`
        },
        'div&': {
            pointerEvents: 'none'
        },
        [`@media (max-width: ${(0, $b156b847c373c90e$export$4033a111ca79977d) - 0.1}px)`]: {
            margin: `0 ${"var(--ds-space-100, 8px)"}`
        },
        [`@media (min-width: ${0, $b156b847c373c90e$export$4033a111ca79977d}px)`]: {
            margin: `0 ${"var(--ds-space-200, 16px)"}`
        }
    });
    const $1734ae815551ba94$var$siteTitleStyles = {
        name: "1q75v0",
        styles: "display:flex;align-items:center;margin-inline-end:var(--ds-space-050, 4px);margin-inline-start:var(--ds-space-050, 4px);padding-inline-end:var(--ds-space-200, 16px)"
    };
    const $1734ae815551ba94$var$hideSiteTitleStyles = (0, $byn9U.css)({
        [`@media (max-width: ${(0, $b156b847c373c90e$export$4033a111ca79977d) - 0.1}px)`]: {
            display: 'none'
        }
    });
    const $1734ae815551ba94$var$CustomProductHome = (props)=>{
        const { iconAlt: iconAlt, iconUrl: iconUrl, logoAlt: logoAlt, logoUrl: logoUrl, href: href, onClick: onClick, siteTitle: siteTitle, onMouseDown: onMouseDown, testId: testId, logoMaxWidth: logoMaxWidth = 260, ...rest } = props;
        const theme = (0, $aUZbY.useTheme)();
        const primaryButton = theme.mode.primaryButton;
        const Tag = (0, $b3cMP.getTag)(onClick, href);
        const preventFocusRing = (event)=>{
            event.preventDefault();
            onMouseDown && onMouseDown(event);
        };
        const productHomeButtonDynamicStyles = {
            [$1734ae815551ba94$var$VAR_PRODUCT_HOME_COLOR_ACTIVE]: primaryButton.active.color,
            [$1734ae815551ba94$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE]: primaryButton.active.backgroundColor,
            [$1734ae815551ba94$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE]: primaryButton.active.boxShadow,
            [$1734ae815551ba94$var$VAR_PRODUCT_HOME_COLOR_FOCUS]: primaryButton.focus.color,
            [$1734ae815551ba94$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS]: primaryButton.focus.backgroundColor,
            [$1734ae815551ba94$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS]: primaryButton.focus.boxShadow,
            [$1734ae815551ba94$var$VAR_PRODUCT_HOME_COLOR_HOVER]: primaryButton.hover.color,
            [$1734ae815551ba94$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER]: primaryButton.hover.backgroundColor,
            [$1734ae815551ba94$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER]: primaryButton.hover.boxShadow
        };
        return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)(Tag, {
            href: href,
            style: productHomeButtonDynamicStyles,
            css: $1734ae815551ba94$var$productHomeButtonStyles,
            onClick: onClick,
            onMouseDown: preventFocusRing,
            "data-testid": testId && `${testId}-container`,
            ...rest
        }, logoUrl && (0, $byn9U.jsx)("img", {
            style: {
                maxWidth: logoMaxWidth
            },
            css: [
                $1734ae815551ba94$var$customMaxHeightStyles,
                $1734ae815551ba94$var$productLogoStyles
            ],
            src: logoUrl,
            alt: logoAlt,
            "data-testid": testId && `${testId}-logo`
        }), iconUrl && (0, $byn9U.jsx)("img", {
            style: {
                maxWidth: logoMaxWidth
            },
            css: [
                $1734ae815551ba94$var$customMaxHeightStyles,
                $1734ae815551ba94$var$productIconStyles
            ],
            src: iconUrl,
            alt: iconAlt,
            "data-testid": testId && `${testId}-icon`
        })), siteTitle && (0, $byn9U.jsx)("div", {
            style: {
                borderRight: theme.mode.productHome.borderRight
            },
            css: [
                $1734ae815551ba94$var$siteTitleStyles,
                (0, $iDwTy.getBooleanFF)('platform.design-system-team.navigation-v2-no-jank_5yhbd') && $1734ae815551ba94$var$hideSiteTitleStyles
            ],
            "data-testid": testId && `${testId}-site-title`
        }, siteTitle));
    };
    var $1734ae815551ba94$export$2e2bcd8739ae039 = $1734ae815551ba94$var$CustomProductHome;
});
parcelRegister("b3cMP", function(module, exports) {
    $parcel$export(module.exports, "getTag", ()=>$f9807600b41c7967$export$dad497fe1f6e27c0);
    const $f9807600b41c7967$export$dad497fe1f6e27c0 = (onClick, href)=>{
        if (href) return 'a';
        if (onClick) return 'button';
        return 'div';
    };
});
parcelRegister("i0xVE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8ee551c94a4f7fda$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $iDwTy = parcelRequire("iDwTy");
    var $aUZbY = parcelRequire("aUZbY");
    var $6vHjL = parcelRequire("6vHjL");
    var $b3cMP = parcelRequire("b3cMP");
    function $8ee551c94a4f7fda$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $8ee551c94a4f7fda$var$VAR_LOGO_MAX_WIDTH = '--logo-max-width';
    const $8ee551c94a4f7fda$var$VAR_PRODUCT_HOME_COLOR_ACTIVE = '--product-home-color-active';
    const $8ee551c94a4f7fda$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE = '--product-home-bg-color-active';
    const $8ee551c94a4f7fda$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE = '--product-home-box-shadow-active';
    const $8ee551c94a4f7fda$var$VAR_PRODUCT_HOME_COLOR_FOCUS = '--product-home-color-focus';
    const $8ee551c94a4f7fda$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS = '--product-home-bg-color-focus';
    const $8ee551c94a4f7fda$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS = '--product-home-box-shadow-focus';
    const $8ee551c94a4f7fda$var$VAR_PRODUCT_HOME_COLOR_HOVER = '--product-home-color-hover';
    const $8ee551c94a4f7fda$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER = '--product-home-bg-color-hover';
    const $8ee551c94a4f7fda$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER = '--product-home-box-shadow-hover';
    const $8ee551c94a4f7fda$var$productHomeButtonStyles = (0, $byn9U.css)({
        display: 'flex',
        padding: "var(--ds-space-050, 4px)",
        alignItems: 'center',
        background: 'none',
        border: 0,
        borderRadius: "var(--ds-border-radius, 3px)",
        color: 'inherit',
        cursor: 'pointer',
        '&::-moz-focus-inner': {
            border: 0
        },
        '&:first-of-type': {
            marginInlineStart: 0
        },
        '&:hover': {
            backgroundColor: `var(${$8ee551c94a4f7fda$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER})`,
            boxShadow: `var(${$8ee551c94a4f7fda$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER})`,
            color: `var(${$8ee551c94a4f7fda$var$VAR_PRODUCT_HOME_COLOR_HOVER})`
        },
        '&:active': {
            backgroundColor: `var(${$8ee551c94a4f7fda$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE})`,
            boxShadow: `var(${$8ee551c94a4f7fda$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE})`,
            color: `var(${$8ee551c94a4f7fda$var$VAR_PRODUCT_HOME_COLOR_ACTIVE})`
        },
        '&:focus-visible': {
            backgroundColor: `var(${$8ee551c94a4f7fda$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS})`,
            color: `var(${$8ee551c94a4f7fda$var$VAR_PRODUCT_HOME_COLOR_FOCUS})`,
            outline: `${"var(--ds-border-width-outline, 2px)"} solid ${"var(--ds-border-focused, #4C9AFF)"}`
        },
        'div&': {
            pointerEvents: 'none'
        },
        [`@media (max-width: ${(0, $b156b847c373c90e$export$4033a111ca79977d) - 0.1}px)`]: {
            margin: `0 ${"var(--ds-space-100, 8px)"}`
        },
        [`@media (min-width: ${0, $b156b847c373c90e$export$4033a111ca79977d}px)`]: {
            margin: `0 ${"var(--ds-space-200, 16px)"}`
        }
    });
    const $8ee551c94a4f7fda$var$productLogoStyles = (0, $byn9U.css)({
        display: 'flex',
        maxWidth: `var(${$8ee551c94a4f7fda$var$VAR_LOGO_MAX_WIDTH})`,
        '& > *': {
            maxHeight: 24
        },
        '& > span > svg': {
            maxWidth: `var(${$8ee551c94a4f7fda$var$VAR_LOGO_MAX_WIDTH})`
        },
        [`@media (max-width: ${(0, $b156b847c373c90e$export$4033a111ca79977d) - 0.1}px)`]: {
            display: 'none'
        }
    });
    const $8ee551c94a4f7fda$var$customMaxHeightStyles = {
        name: "31vqaf",
        styles: "max-height:28px"
    };
    const $8ee551c94a4f7fda$var$productIconStyles = (0, $byn9U.css)({
        display: 'flex',
        '& > *': {
            maxHeight: 24
        },
        [`@media (min-width: ${0, $b156b847c373c90e$export$4033a111ca79977d}px)`]: {
            display: 'none'
        }
    });
    const $8ee551c94a4f7fda$var$siteTitleStyles = {
        name: "1q75v0",
        styles: "display:flex;align-items:center;margin-inline-end:var(--ds-space-050, 4px);margin-inline-start:var(--ds-space-050, 4px);padding-inline-end:var(--ds-space-200, 16px)"
    };
    const $8ee551c94a4f7fda$var$featureFlaggedSiteTitleStyles = (0, $byn9U.css)({
        marginInlineEnd: "var(--ds-space-100, 8px)",
        [`@media (max-width: ${(0, $b156b847c373c90e$export$4033a111ca79977d) - 0.1}px)`]: {
            display: 'none'
        }
    });
    const $8ee551c94a4f7fda$var$ProductHome = ({ icon: Icon, logo: Logo, siteTitle: siteTitle, onClick: onClick, href: href, onMouseDown: onMouseDown, testId: testId, logoMaxWidth: logoMaxWidth = 260, ...rest })=>{
        const theme = (0, $aUZbY.useTheme)();
        const primaryButton = theme.mode.primaryButton;
        const { iconColor: iconColor = 'inherit', textColor: textColor = theme.mode.productHome.color } = theme.mode.productHome;
        const Tag = (0, $b3cMP.getTag)(onClick, href);
        const preventFocusRing = (e)=>{
            e.preventDefault();
            onMouseDown && onMouseDown(e);
        };
        const productHomeButtonDynamicStyles = (0, $6vHjL.stripEmptyProperties)({
            [$8ee551c94a4f7fda$var$VAR_PRODUCT_HOME_COLOR_ACTIVE]: primaryButton.active.color,
            [$8ee551c94a4f7fda$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE]: primaryButton.active.backgroundColor,
            [$8ee551c94a4f7fda$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE]: primaryButton.active.boxShadow,
            [$8ee551c94a4f7fda$var$VAR_PRODUCT_HOME_COLOR_FOCUS]: primaryButton.focus.color,
            [$8ee551c94a4f7fda$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS]: primaryButton.focus.backgroundColor,
            [$8ee551c94a4f7fda$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS]: primaryButton.focus.boxShadow,
            [$8ee551c94a4f7fda$var$VAR_PRODUCT_HOME_COLOR_HOVER]: primaryButton.hover.color,
            [$8ee551c94a4f7fda$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER]: primaryButton.hover.backgroundColor,
            [$8ee551c94a4f7fda$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER]: primaryButton.hover.boxShadow,
            [$8ee551c94a4f7fda$var$VAR_LOGO_MAX_WIDTH]: `${logoMaxWidth}px`
        });
        return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)(Tag, {
            style: productHomeButtonDynamicStyles,
            css: $8ee551c94a4f7fda$var$productHomeButtonStyles,
            href: href,
            onClick: onClick,
            onMouseDown: preventFocusRing,
            "data-testid": testId && `${testId}-container`,
            ...rest
        }, (0, $byn9U.jsx)("div", {
            css: [
                $8ee551c94a4f7fda$var$customMaxHeightStyles,
                $8ee551c94a4f7fda$var$productLogoStyles
            ],
            "data-testid": testId && `${testId}-logo`
        }, (0, $byn9U.jsx)(Logo, {
            iconColor: iconColor,
            textColor: textColor
        })), (0, $byn9U.jsx)("div", {
            css: [
                $8ee551c94a4f7fda$var$customMaxHeightStyles,
                $8ee551c94a4f7fda$var$productIconStyles
            ],
            "data-testid": testId && `${testId}-icon`
        }, (0, $byn9U.jsx)(Icon, {
            iconColor: iconColor
        }))), siteTitle && (0, $byn9U.jsx)("div", {
            style: {
                borderRight: theme.mode.productHome.borderRight
            },
            css: [
                $8ee551c94a4f7fda$var$siteTitleStyles,
                (0, $iDwTy.getBooleanFF)('platform.design-system-team.navigation-v2-no-jank_5yhbd') && $8ee551c94a4f7fda$var$featureFlaggedSiteTitleStyles
            ],
            "data-testid": testId && `${testId}-site-title`
        }, siteTitle));
    };
    var $8ee551c94a4f7fda$export$2e2bcd8739ae039 = $8ee551c94a4f7fda$var$ProductHome;
});
parcelRegister("6vHjL", function(module, exports) {
    $parcel$export(module.exports, "stripEmptyProperties", ()=>$00791f487418c177$export$e03bb5c7fd72635);
    function $00791f487418c177$export$e03bb5c7fd72635(obj) {
        return Object.entries(obj).reduce((acc, [key, value])=>{
            if (value !== null && value !== undefined && value !== '') acc[key] = value;
            return acc;
        }, {});
    }
});
parcelRegister("dRoYM", function(module, exports) {
    $parcel$export(module.exports, "Profile", ()=>$9473b8fc46604bb1$export$5120f2d0b8d4cab8);
    var $eUqFw = parcelRequire("eUqFw");
    var $dX6S1 = parcelRequire("dX6S1");
    const $9473b8fc46604bb1$export$5120f2d0b8d4cab8 = (0, $eUqFw.forwardRef)((props, ref)=>{
        const { label: labelProp, tooltip: tooltip } = props;
        const label = labelProp || (typeof tooltip === 'string' ? tooltip : 'Your profile and settings');
        return (0, ($parcel$interopDefault($eUqFw))).createElement("div", {
            role: "listitem"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $dX6S1.IconButton), {
            label: label,
            ref: ref,
            ...props
        }));
    });
    var $9473b8fc46604bb1$export$2e2bcd8739ae039 = (props)=>{};
});
parcelRegister("8a7hf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$308c61c115e18ee7$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $4oSDA = parcelRequire("4oSDA");
    var $85yy4 = parcelRequire("85yy4");
    var $268QM = parcelRequire("268QM");
    var $iDwTy = parcelRequire("iDwTy");
    var $e9qDP = parcelRequire("e9qDP");
    var $e0Fqb = parcelRequire("e0Fqb");
    var $f4ILk = parcelRequire("f4ILk");
    var $1aQis = parcelRequire("1aQis");
    var $2fFJv = parcelRequire("2fFJv");
    const $308c61c115e18ee7$var$DropdownItemRadio = ({ children: children, defaultSelected: defaultSelected, testId: testId, id: id, title: title, description: description, isDisabled: isDisabled, isSelected: isSelected, onClick: providedOnClick = (0, $4oSDA.default), shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, interactionName: interactionName, ...rest })=>{
        typeof $2fFJv;
        const [selected, setSelected] = (0, $e0Fqb.default)({
            id: id,
            isSelected: isSelected,
            defaultSelected: defaultSelected
        });
        const onClickHandler = (0, $eUqFw.useCallback)((event)=>{
            setSelected((selected)=>!selected);
            providedOnClick(event);
        }, [
            providedOnClick,
            setSelected
        ]);
        const itemRef = (0, $f4ILk.default)();
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $85yy4.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
            value: "none"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $268QM.default), {
            "aria-checked": selected,
            description: description,
            iconBefore: (0, ($parcel$interopDefault($eUqFw))).createElement((0, $e9qDP.default), {
                checked: selected
            }),
            id: id,
            isDisabled: isDisabled,
            isSelected: selected,
            onClick: onClickHandler,
            ref: itemRef,
            role: (0, $1aQis.default)() ? 'radio' : 'menuitemradio',
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            title: title,
            ...(0, $iDwTy.fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children));
    };
    var $308c61c115e18ee7$export$2e2bcd8739ae039 = $308c61c115e18ee7$var$DropdownItemRadio;
});
parcelRegister("e9qDP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$392f9c52cce9c38a$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $f680m = parcelRequire("f680m");
    const $392f9c52cce9c38a$var$RadioIcon = ({ checked: checked })=>{
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $f680m.default), {
            label: "",
            size: "medium",
            primaryColor: checked ? `var(--ds-background-selected-bold, ${0, $207acf722dcd432b$export$b3de0ae08da2ce64})` : `var(--ds-background-input, ${0, $207acf722dcd432b$export$e655ef011c4aa1a2})`,
            secondaryColor: checked ? `var(--ds-icon-inverse, ${0, $207acf722dcd432b$export$e655ef011c4aa1a2})` : 'transparent'
        }, (0, ($parcel$interopDefault($eUqFw))).createElement("g", {
            fillRule: "evenodd"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement("circle", {
            fill: "currentColor",
            cx: "12",
            cy: "12",
            r: "6",
            stroke: checked ? `var(--ds-border-selected, ${0, $207acf722dcd432b$export$b3de0ae08da2ce64})` : `var(--ds-border-input, ${0, $207acf722dcd432b$export$d6447c357493214f})`,
            strokeWidth: 1
        }), (0, ($parcel$interopDefault($eUqFw))).createElement("circle", {
            fill: "inherit",
            cx: "12",
            cy: "12",
            r: "2"
        })));
    };
    var $392f9c52cce9c38a$export$2e2bcd8739ae039 = $392f9c52cce9c38a$var$RadioIcon;
});
parcelRegister("e0Fqb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$54587fbe03efd285$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $kF2QL = parcelRequire("kF2QL");
    var $8OgO6 = parcelRequire("8OgO6");
    var $6FLTy = parcelRequire("6FLTy");
    function $54587fbe03efd285$var$useRadioState({ id: id, isSelected: isSelected, defaultSelected: defaultSelected }) {
        const { setGroupState: setGroupState, getGroupState: getGroupState } = (0, $eUqFw.useContext)((0, $8OgO6.SelectionStoreContext));
        const { id: group, radioGroupState: radioGroupState, selectRadioItem: selectRadioItem } = (0, $eUqFw.useContext)((0, $kF2QL.RadioGroupContext));
        const persistedIsSelected = radioGroupState[id];
        const [localIsSelected, setLocalIsSelected] = (0, $eUqFw.useState)(()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false);
        const setLocalState = (0, $eUqFw.useCallback)((newValue)=>{
            if (!persistedIsSelected) {
                const nextValue = newValue(persistedIsSelected);
                selectRadioItem(id, nextValue);
                setLocalIsSelected(nextValue);
            }
        }, [
            persistedIsSelected,
            id,
            selectRadioItem
        ]);
        (0, $eUqFw.useEffect)(()=>{
            setLocalIsSelected(()=>{
                const existing = radioGroupState[id];
                return existing !== undefined ? existing : defaultSelected || false;
            });
        }, [
            radioGroupState,
            group,
            id,
            defaultSelected
        ]);
        if (typeof isSelected === 'boolean') return [
            isSelected,
            ()=>false
        ];
        if (persistedIsSelected === undefined) {
            const existing = getGroupState(group);
            setGroupState(group, {
                ...(0, $6FLTy.default)(existing || {}),
                [id]: defaultSelected || false
            });
        }
        return [
            localIsSelected,
            setLocalState
        ];
    }
    var $54587fbe03efd285$export$2e2bcd8739ae039 = $54587fbe03efd285$var$useRadioState;
});
parcelRegister("kF2QL", function(module, exports) {
    $parcel$export(module.exports, "RadioGroupContext", ()=>$d22ee1ec8b705d89$export$a79eda4ff50e30b6);
    $parcel$export(module.exports, "default", ()=>$d22ee1ec8b705d89$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $4oSDA = parcelRequire("4oSDA");
    var $5aRS9 = parcelRequire("5aRS9");
    var $7wSSY = parcelRequire("7wSSY");
    var $b7seu = parcelRequire("b7seu");
    var $8OgO6 = parcelRequire("8OgO6");
    var $6FLTy = parcelRequire("6FLTy");
    const $d22ee1ec8b705d89$export$a79eda4ff50e30b6 = (0, $eUqFw.createContext)({
        id: '',
        radioGroupState: {},
        selectRadioItem: (0, $4oSDA.default)
    });
    const $d22ee1ec8b705d89$var$DropdownItemRadioGroup = ({ children: children, hasSeparator: hasSeparator, id: id, isList: isList, isScrollable: isScrollable, overrides: overrides, testId: testId, title: title, ...rest })=>{
        const { setGroupState: setGroupState, getGroupState: getGroupState } = (0, $eUqFw.useContext)((0, $8OgO6.SelectionStoreContext));
        const uid = (0, $5aRS9.useId)();
        const titleId = `dropdown-menu-item-radio-group-title-${uid}`;
        const [radioGroupState, setRadioGroupState] = (0, $eUqFw.useState)(()=>getGroupState(id));
        const selectRadioItem = (childId, value)=>{
            const newValue = {
                ...(0, $6FLTy.default)(getGroupState(id)),
                [childId]: value
            };
            setRadioGroupState(newValue);
            setGroupState(id, newValue);
        };
        return (0, ($parcel$interopDefault($eUqFw))).createElement($d22ee1ec8b705d89$export$a79eda4ff50e30b6.Provider, {
            value: {
                id: id,
                radioGroupState: radioGroupState,
                selectRadioItem: selectRadioItem
            }
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $7wSSY.default), {
            hasSeparator: hasSeparator,
            id: id,
            isList: isList,
            isScrollable: isScrollable,
            overrides: overrides,
            testId: testId,
            titleId: title ? titleId : undefined,
            ...rest
        }, title && (0, ($parcel$interopDefault($eUqFw))).createElement((0, $b7seu.default), {
            id: titleId,
            title: title
        }), children));
    };
    var $d22ee1ec8b705d89$export$2e2bcd8739ae039 = $d22ee1ec8b705d89$var$DropdownItemRadioGroup;
});
parcelRegister("6FLTy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$359040cde3b1a8fd$export$2e2bcd8739ae039);
    const $359040cde3b1a8fd$var$resetOptionsInGroup = (group)=>{
        return Object.keys(group || {}).reduce((accumulator, current)=>({
                ...accumulator,
                [current]: typeof group[current] === 'undefined' ? undefined : false
            }), {});
    };
    var $359040cde3b1a8fd$export$2e2bcd8739ae039 = $359040cde3b1a8fd$var$resetOptionsInGroup;
});
parcelRegister("1aQis", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5b6c73be9f6bad88$export$2e2bcd8739ae039);
    const $5b6c73be9f6bad88$var$canUseDOM = ()=>Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
    const $5b6c73be9f6bad88$var$isVoiceOverSupported = ()=>/Mac OS X/.test($5b6c73be9f6bad88$var$canUseDOM() ? navigator.userAgent : '');
    var $5b6c73be9f6bad88$export$2e2bcd8739ae039 = $5b6c73be9f6bad88$var$isVoiceOverSupported;
});
parcelRegister("hYcvQ", function(module, exports) {
    $parcel$export(module.exports, "Settings", ()=>$d043fff59ee1d0ff$export$c72f6eaae7b9adff);
    var $eUqFw = parcelRequire("eUqFw");
    var $iu60k = parcelRequire("iu60k");
    var $dX6S1 = parcelRequire("dX6S1");
    const $d043fff59ee1d0ff$export$c72f6eaae7b9adff = (0, $eUqFw.forwardRef)((props, ref)=>{
        const { tooltip: tooltip, ...iconButtonProps } = props;
        return (0, ($parcel$interopDefault($eUqFw))).createElement("div", {
            role: "listitem"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $dX6S1.IconButton), {
            icon: (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($iu60k))), {
                label: typeof tooltip === 'string' ? tooltip : 'Settings Icon'
            }),
            ref: ref,
            tooltip: tooltip,
            ...iconButtonProps
        }));
    });
    var $d043fff59ee1d0ff$export$2e2bcd8739ae039 = $d043fff59ee1d0ff$export$c72f6eaae7b9adff;
});
parcelRegister("bkTrY", function(module, exports) {
    $parcel$export(module.exports, "SkeletonSettingsButton", ()=>$0c8e0b89c79e5a92$export$914093d4d181ff4d);
    $parcel$export(module.exports, "Nav4SkeletonSettingsButton", ()=>$0c8e0b89c79e5a92$export$beac98f336d7b14f);
    var $eUqFw = parcelRequire("eUqFw");
    var $6BgCA = parcelRequire("6BgCA");
    var $iu60k = parcelRequire("iu60k");
    var $ioJj7 = parcelRequire("ioJj7");
    const $0c8e0b89c79e5a92$export$914093d4d181ff4d = ({ label: label = '' })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $ioJj7.SkeletonIconButton), null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($iu60k))), {
            label: label
        }));
    const $0c8e0b89c79e5a92$export$beac98f336d7b14f = ({ label: label = '' })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $ioJj7.SkeletonIconButton), null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($6BgCA))), {
            label: label,
            color: "var(--ds-icon, #44546F)"
        }));
});
parcelRegister("3VGd6", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2dc7701168edb947$var$_react = $2dc7701168edb947$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $2dc7701168edb947$var$_UNSAFE_baseNew = $2dc7701168edb947$var$_interopRequireDefault((parcelRequire("ay9aj")));
    function $2dc7701168edb947$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $2dc7701168edb947$var$AppsIcon = (props)=>$2dc7701168edb947$var$_react.default.createElement($2dc7701168edb947$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M12 9v6m-3-3h6M3 14.25h2c.69 0 1.25-.56 1.25-1.25v-2c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v2c0 .69.56 1.25 1.25 1.25Zm8-8h2c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25h-2c-.69 0-1.25.56-1.25 1.25v2c0 .69.56 1.25 1.25 1.25Zm-8 0h2c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v2c0 .69.56 1.25 1.25 1.25Z"/>`
        }, props));
    $2dc7701168edb947$var$AppsIcon.displayName = 'AppsIcon';
    var $2dc7701168edb947$var$_default = module.exports.default = $2dc7701168edb947$var$AppsIcon;
});
parcelRegister("iqZTp", function(module, exports) {
    $parcel$export(module.exports, "SignIn", ()=>$4378821bf3cdf2ff$export$b64708c6f1b3ed96);
    var $eUqFw = parcelRequire("eUqFw");
    var $22abr = parcelRequire("22abr");
    var $dX6S1 = parcelRequire("dX6S1");
    const $4378821bf3cdf2ff$export$b64708c6f1b3ed96 = (props)=>{
        const { tooltip: tooltip, ...iconButtonProps } = props;
        return (0, ($parcel$interopDefault($eUqFw))).createElement("div", {
            role: "listitem"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $dX6S1.IconButton), {
            icon: (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($22abr))), {
                label: typeof tooltip === 'string' ? tooltip : 'Sign-in Icon'
            }),
            tooltip: tooltip,
            ...iconButtonProps
        }));
    };
    var $4378821bf3cdf2ff$export$2e2bcd8739ae039 = $4378821bf3cdf2ff$export$b64708c6f1b3ed96;
});
parcelRegister("jyU3A", function(module, exports) {
    $parcel$export(module.exports, "ListItem", ()=>$3061417fd448e1da$export$a7b06bfba60a8a78);
    var $eUqFw = parcelRequire("eUqFw");
    function $3061417fd448e1da$var$_ListItem({ children: children, xcss: xcss }, ref) {
        return ($eUqFw.createElement("div", {
            role: "listitem",
            ref: ref,
            className: xcss
        }, children));
    }
    const $3061417fd448e1da$export$a7b06bfba60a8a78 = (0, $eUqFw.forwardRef)($3061417fd448e1da$var$_ListItem);
});
parcelRegister("42MUC", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2f1d4a40948bd2a8$var$_react = $2f1d4a40948bd2a8$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $2f1d4a40948bd2a8$var$_UNSAFE_baseNew = $2f1d4a40948bd2a8$var$_interopRequireDefault((parcelRequire("ay9aj")));
    function $2f1d4a40948bd2a8$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $2f1d4a40948bd2a8$var$EditionsIcon = (props)=>$2f1d4a40948bd2a8$var$_react.default.createElement($2f1d4a40948bd2a8$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m5.25 5.75 1.25-4m-1.25 4h5.5m-5.5 0H1m4.25 0L7.92 14h.16l2.67-8.25m-4.25-4H3.25l-2.5 4L8 14.25l7.25-8.5-2.5-4H9.5m-3 0h3m1.25 4-1.25-4m1.25 4h4.125"/>`
        }, props));
    $2f1d4a40948bd2a8$var$EditionsIcon.displayName = 'EditionsIcon';
    var $2f1d4a40948bd2a8$var$_default = module.exports.default = $2f1d4a40948bd2a8$var$EditionsIcon;
});
parcelRegister("gTL9X", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c4d65d561e4b93fe$var$_react = $c4d65d561e4b93fe$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $c4d65d561e4b93fe$var$_creditCard = $c4d65d561e4b93fe$var$_interopRequireDefault((parcelRequire("jyPwc")));
    var $c4d65d561e4b93fe$var$_creditcardFilled = $c4d65d561e4b93fe$var$_interopRequireDefault((parcelRequire("2R3Y3")));
    function $c4d65d561e4b93fe$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c4d65d561e4b93fe$var$CreditCardIcon = (props)=>$c4d65d561e4b93fe$var$_react.default.createElement($c4d65d561e4b93fe$var$_creditCard.default, Object.assign({
            LEGACY_fallbackIcon: $c4d65d561e4b93fe$var$_creditcardFilled.default
        }, props));
    $c4d65d561e4b93fe$var$CreditCardIcon.Name = 'CreditCardIconMigration';
    var $c4d65d561e4b93fe$var$_default = module.exports.default = $c4d65d561e4b93fe$var$CreditCardIcon;
});
parcelRegister("7bPPM", function(module, exports) {
    $parcel$export(module.exports, "SkeletonPrimaryButton", ()=>$f03c976ad6df48d1$export$4a3049f952d3f130);
    var $byn9U = parcelRequire("byn9U");
    var $aUZbY = parcelRequire("aUZbY");
    var $6vHjL = parcelRequire("6vHjL");
    function $f03c976ad6df48d1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $f03c976ad6df48d1$var$VAR_PRIMARY_BUTTON_BEFORE_HIGHLIGHTED_BACKGROUND_COLOR = '--primary-button-before-highlighted-background-color';
    const $f03c976ad6df48d1$var$VAR_PRIMARY_BUTTON_AFTER_DROPDOWN_BORDER_COLOR = '--primary-button-after-dropdown-border-color';
    const $f03c976ad6df48d1$var$primaryButtonSkeletonStyles = (0, $byn9U.css)({
        margin: `0 ${"var(--ds-space-075, 6px)"}`,
        padding: `0 ${"var(--ds-space-050, 4px)"}`,
        position: 'relative',
        appearance: 'none',
        border: 0,
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        fontWeight: "var(--ds-font-weight-medium, 500)",
        pointerEvents: 'none',
        ':focus, :active, :hover': {
            appearance: 'none',
            border: 0,
            outline: 0
        },
        '::-moz-focus-inner': {
            border: 0
        }
    });
    const $f03c976ad6df48d1$var$isHighlightedStyles = (0, $byn9U.css)({
        '&:before': {
            height: 3,
            position: 'absolute',
            backgroundColor: `var(${$f03c976ad6df48d1$var$VAR_PRIMARY_BUTTON_BEFORE_HIGHLIGHTED_BACKGROUND_COLOR})`,
            borderStartEndRadius: "var(--ds-border-radius-050, 1px)",
            borderStartStartRadius: "var(--ds-border-radius-050, 1px)",
            content: '""',
            insetBlockEnd: 0,
            insetInlineStart: "var(--ds-space-025, 2px)"
        }
    });
    const $f03c976ad6df48d1$var$isHighlightedAndDropdownButtonStyles = (0, $byn9U.css)({
        '&:before': {
            insetInlineEnd: -10
        }
    });
    const $f03c976ad6df48d1$var$isHighlightedNotDropdownButtonStyles = {
        name: "1sue5tp",
        styles: "&:before{inset-inline-end:var(--ds-space-025, 2px);}"
    };
    const $f03c976ad6df48d1$var$isDropdownButtonStyles = (0, $byn9U.css)({
        marginInlineEnd: 18,
        '&:after': {
            display: 'inline-block',
            width: 4,
            height: 4,
            position: 'absolute',
            borderBlockEnd: '2px solid',
            borderColor: `var(${$f03c976ad6df48d1$var$VAR_PRIMARY_BUTTON_AFTER_DROPDOWN_BORDER_COLOR})`,
            borderInlineEnd: '2px solid',
            borderRadius: "var(--ds-border-radius-050, 1px)",
            content: '""',
            insetBlockStart: 'calc(50% - 4px)',
            insetInlineStart: 'calc(100% - 3px)',
            marginInlineStart: "var(--ds-space-050, 4px)",
            transform: 'rotate(45deg) scale(1.05)',
            verticalAlign: 'middle'
        }
    });
    const $f03c976ad6df48d1$var$buttonWrapperStyles = {
        name: "rfxc55",
        styles: "display:flex;margin:0"
    };
    const $f03c976ad6df48d1$export$4a3049f952d3f130 = ({ isDropdownButton: isDropdownButton = false, isHighlighted: isHighlighted = false, text: text, children: children, testId: testId })=>{
        const theme = (0, $aUZbY.useTheme)();
        const primaryButton = theme.mode.primaryButton;
        const dynamicStyles = (0, $6vHjL.stripEmptyProperties)({
            ...primaryButton.default,
            ...isHighlighted && {
                color: primaryButton.selected.color
            },
            [$f03c976ad6df48d1$var$VAR_PRIMARY_BUTTON_BEFORE_HIGHLIGHTED_BACKGROUND_COLOR]: primaryButton.selected.borderColor,
            [$f03c976ad6df48d1$var$VAR_PRIMARY_BUTTON_AFTER_DROPDOWN_BORDER_COLOR]: isHighlighted ? primaryButton.default.borderColor : primaryButton.default.color
        });
        return (0, $byn9U.jsx)("div", {
            role: "listitem",
            css: $f03c976ad6df48d1$var$buttonWrapperStyles
        }, (0, $byn9U.jsx)("button", {
            type: "button",
            style: dynamicStyles,
            css: [
                $f03c976ad6df48d1$var$primaryButtonSkeletonStyles,
                isHighlighted && $f03c976ad6df48d1$var$isHighlightedStyles,
                isDropdownButton && $f03c976ad6df48d1$var$isDropdownButtonStyles,
                isHighlighted && (isDropdownButton ? $f03c976ad6df48d1$var$isHighlightedAndDropdownButtonStyles : $f03c976ad6df48d1$var$isHighlightedNotDropdownButtonStyles)
            ],
            "data-testid": testId
        }, text || children));
    };
});
parcelRegister("7yiEh", function(module, exports) {
    $parcel$export(module.exports, "Create", ()=>$9147c01233ee492d$export$8ade6fcbf3a7de5d);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $11GuH = parcelRequire("11GuH");
    var $8ek9z = parcelRequire("8ek9z");
    var $cmipe = parcelRequire("cmipe");
    var $aUZbY = parcelRequire("aUZbY");
    var $dX6S1 = parcelRequire("dX6S1");
    var $duxzN = parcelRequire("duxzN");
    const $9147c01233ee492d$var$wrapperStyles = (0, $byn9U.css)({
        display: 'flex',
        alignItems: 'center',
        '& [data-hide-on-smallscreens]': {
            [`@media (max-width: ${(0, $b156b847c373c90e$export$24ec62cee78b7042) - 1}px)`]: {
                display: 'none !important'
            }
        },
        '& [data-hide-on-largescreens]': {
            [`@media (min-width: ${0, $b156b847c373c90e$export$24ec62cee78b7042}px)`]: {
                display: 'none !important'
            }
        },
        '&&': {
            marginInlineStart: "var(--ds-space-150, 12px)"
        }
    });
    const $9147c01233ee492d$var$TooltipSwitch = ({ buttonTooltip: buttonTooltip, children: children })=>buttonTooltip ? (0, $byn9U.jsx)((0, $cmipe.default), {
            content: buttonTooltip,
            hideTooltipOnClick: true
        }, children) : (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, children);
    const $9147c01233ee492d$export$8ade6fcbf3a7de5d = ({ onClick: onClick, href: href, text: text, buttonTooltip: buttonTooltip, iconButtonTooltip: iconButtonTooltip, testId: testId, label: label })=>{
        const theme = (0, $aUZbY.useTheme)();
        return (0, $byn9U.jsx)("div", {
            css: $9147c01233ee492d$var$wrapperStyles,
            role: "listitem",
            "data-testid": "create-button-wrapper"
        }, (0, $byn9U.jsx)($9147c01233ee492d$var$TooltipSwitch, {
            buttonTooltip: buttonTooltip
        }, (0, $byn9U.jsx)((0, $11GuH.default), {
            id: "createGlobalItem",
            "aria-label": label,
            onClick: onClick,
            href: href,
            theme: (0, $duxzN.getCreateButtonTheme)(theme),
            testId: testId && `${testId}-button`,
            "data-hide-on-smallscreens": true
        }, text)), (0, $byn9U.jsx)((0, $dX6S1.IconButton), {
            id: "createGlobalItemIconButton",
            testId: testId && `${testId}-icon-button`,
            icon: (0, $byn9U.jsx)((0, ($parcel$interopDefault($8ek9z))), {
                label: text
            }),
            onClick: onClick,
            href: href,
            tooltip: iconButtonTooltip,
            theme: (0, $duxzN.getCreateButtonTheme)(theme),
            "aria-label": text,
            "data-hide-on-largescreens": true
        }));
    };
    var $9147c01233ee492d$export$2e2bcd8739ae039 = $9147c01233ee492d$export$8ade6fcbf3a7de5d;
});
parcelRegister("duxzN", function(module, exports) {
    $parcel$export(module.exports, "getCreateButtonTheme", ()=>$187cf4e7da50bf23$export$256eebed8e934f30);
    const $187cf4e7da50bf23$export$256eebed8e934f30 = ({ mode: { create: create } })=>(current, props)=>{
            const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
            return {
                buttonStyles: {
                    ...buttonStyles,
                    ...create.default,
                    margin: 0,
                    fontWeight: "var(--ds-font-weight-medium, 500)",
                    ':hover': create.hover,
                    ':focus': create.focus,
                    '&&': {
                        ...props.state === 'active' && create.active
                    }
                },
                spinnerStyles: spinnerStyles
            };
        };
});
parcelRegister("gCGMa", function(module, exports) {
    $parcel$export(module.exports, "SkeletonCreateButton", ()=>$af3e4974580d004c$export$e321b2260435e302);
    var $byn9U = parcelRequire("byn9U");
    var $aUZbY = parcelRequire("aUZbY");
    function $af3e4974580d004c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $af3e4974580d004c$var$skeletonCreateButtonStyles = (0, $byn9U.css)({
        height: 32,
        padding: `0 ${"var(--ds-space-150, 12px)"}`,
        alignSelf: 'center',
        border: 0,
        borderRadius: "var(--ds-border-radius, 3px)",
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        fontWeight: "var(--ds-font-weight-medium, 500)",
        pointerEvents: 'none',
        ':focus, :active, :hover': {
            appearance: 'none',
            border: 0,
            outline: 0
        },
        '&&': {
            marginInlineStart: "var(--ds-space-150, 12px)"
        }
    });
    const $af3e4974580d004c$var$buttonWrapperStyles = {
        name: "rfxc55",
        styles: "display:flex;margin:0"
    };
    const $af3e4974580d004c$export$e321b2260435e302 = ({ text: text, testId: testId })=>{
        const theme = (0, $aUZbY.useTheme)();
        return (0, $byn9U.jsx)("div", {
            role: "listitem",
            css: $af3e4974580d004c$var$buttonWrapperStyles
        }, (0, $byn9U.jsx)("button", {
            style: theme.mode.create.default,
            css: $af3e4974580d004c$var$skeletonCreateButtonStyles,
            "data-testid": testId,
            type: "button"
        }, text));
    };
});
parcelRegister("3eIaO", function(module, exports) {
    $parcel$export(module.exports, "CreateButton", ()=>$bac3cf928e3f3c62$export$6d3c345ce7c38fd9);
    var $eUqFw = parcelRequire("eUqFw");
    var $dDoXb = parcelRequire("dDoXb");
    var $dHvJ4 = parcelRequire("dHvJ4");
    const $bac3cf928e3f3c62$export$6d3c345ce7c38fd9 = ({ children: children, onClick: onClick, testId: testId, interactionName: interactionName })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $dHvJ4.Button), {
            appearance: "primary",
            iconBefore: (0, ($parcel$interopDefault($dDoXb))),
            onClick: onClick,
            testId: testId,
            interactionName: interactionName
        }, children);
});
parcelRegister("6BwOI", function(module, exports) {
    $parcel$export(module.exports, "Help", ()=>$13dbff32722cc36b$export$1be7516c0280bee8);
    var $eUqFw = parcelRequire("eUqFw");
    var $8F3fz = parcelRequire("8F3fz");
    var $aUZbY = parcelRequire("aUZbY");
    var $eOisq = parcelRequire("eOisq");
    var $dX6S1 = parcelRequire("dX6S1");
    const $13dbff32722cc36b$var$HELP_NOTIFICATION_BADGE_ID = 'atlassian-navigation-help-notification-count';
    const $13dbff32722cc36b$export$1be7516c0280bee8 = (0, $eUqFw.forwardRef)((props, ref)=>{
        const { badge: badge, tooltip: tooltip, ...iconButtonProps } = props;
        const { mode: { navigation: navigation } } = (0, $aUZbY.useTheme)();
        const button = (0, ($parcel$interopDefault($eUqFw))).createElement((0, $dX6S1.IconButton), {
            icon: (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($8F3fz))), {
                label: typeof tooltip === 'string' ? tooltip : 'Help Icon',
                secondaryColor: navigation.backgroundColor
            }),
            ref: ref,
            tooltip: tooltip,
            ...iconButtonProps
        });
        return badge ? (0, ($parcel$interopDefault($eUqFw))).createElement((0, $eOisq.BadgeContainer), {
            id: $13dbff32722cc36b$var$HELP_NOTIFICATION_BADGE_ID,
            badge: badge,
            role: "listitem"
        }, button) : (0, ($parcel$interopDefault($eUqFw))).createElement("div", {
            role: "listitem"
        }, button);
    });
    var $13dbff32722cc36b$export$2e2bcd8739ae039 = $13dbff32722cc36b$export$1be7516c0280bee8;
});
parcelRegister("gELYf", function(module, exports) {
    $parcel$export(module.exports, "SkeletonHelpButton", ()=>$5221b10055ad1206$export$9ee5d6e291d4e456);
    $parcel$export(module.exports, "Nav4SkeletonHelpButton", ()=>$5221b10055ad1206$export$c25bc9ca782b25f4);
    var $eUqFw = parcelRequire("eUqFw");
    var $aruFE = parcelRequire("aruFE");
    var $8F3fz = parcelRequire("8F3fz");
    var $ioJj7 = parcelRequire("ioJj7");
    var $aUZbY = parcelRequire("aUZbY");
    const $5221b10055ad1206$export$9ee5d6e291d4e456 = ({ label: label = '' })=>{
        const { mode: { navigation: navigation } } = (0, $aUZbY.useTheme)();
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $ioJj7.SkeletonIconButton), null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($8F3fz))), {
            label: label,
            secondaryColor: navigation.backgroundColor
        }));
    };
    const $5221b10055ad1206$export$c25bc9ca782b25f4 = ({ label: label = '' })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $ioJj7.SkeletonIconButton), null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($aruFE))), {
            label: label,
            color: "var(--ds-icon, #44546F)"
        }));
});
parcelRegister("laLSF", function(module, exports) {
    $parcel$export(module.exports, "Help", ()=>$459daac21b74945a$export$1be7516c0280bee8);
    var $eUqFw = parcelRequire("eUqFw");
    var $aruFE = parcelRequire("aruFE");
    var $eJ2hD = parcelRequire("eJ2hD");
    var $jyU3A = parcelRequire("jyU3A");
    var $dHvJ4 = parcelRequire("dHvJ4");
    const $459daac21b74945a$var$HELP_NOTIFICATION_BADGE_ID = 'atlassian-navigation-help-notification-count';
    const $459daac21b74945a$export$1be7516c0280bee8 = (0, $eUqFw.forwardRef)(({ badge: badge, onClick: onClick, label: label, isSelected: isSelected, testId: testId, interactionName: interactionName }, forwardedRef)=>{
        const button = (0, ($parcel$interopDefault($eUqFw))).createElement((0, $dHvJ4.IconButton), {
            icon: (0, ($parcel$interopDefault($aruFE))),
            label: label,
            onClick: onClick,
            appearance: "subtle",
            isSelected: isSelected,
            ref: forwardedRef,
            isTooltipDisabled: false,
            testId: testId,
            interactionName: interactionName
        });
        if (!badge) return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jyU3A.ListItem), null, button);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $eJ2hD.BadgeContainer), {
            id: $459daac21b74945a$var$HELP_NOTIFICATION_BADGE_ID,
            badge: badge,
            role: "listitem"
        }, button);
    });
});
const $9f48e301b76cfb15$export$70df29c238ba7306 = 'mediaCtx';
const $870798c86d5f3294$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
const $870798c86d5f3294$export$72f415121273627e = 'body > .atlaskit-portal-container';
const $870798c86d5f3294$export$13f57c02915787b3 = 'atlaskit-portal';
const $5c5a0adfb578e838$export$ed5835cc67e87f72 = 'akPortalMount';
const $5c5a0adfb578e838$export$80816bd900e5bd00 = 'akPortalUnmount';
const $394220419f57a1b4$export$a1562d08625f5d7e = 'ui';
const $394220419f57a1b4$export$947dac6c72b26f81 = 'track';
const $394220419f57a1b4$export$f1d537d508d2945a = 'screen';
const $394220419f57a1b4$export$12346a674644c156 = 'operational';
const $394220419f57a1b4$export$b055de0e665cb20c = 'unknown';
const $dfd6778c2091b723$export$d6830277b06edd6 = 'normal';
const $dfd6778c2091b723$export$4f8f13a66ae77bdd = '--color';
const $dfd6778c2091b723$export$e9244ec13bd422b5 = '--bg-color';
const $dfd6778c2091b723$export$97e78d9745006c11 = '--bg-color-hover';
const $dfd6778c2091b723$export$291d63757828f290 = '--bg-color-active';
$parcel$global.rlb("bYT2S");
